import type { TranslationMap } from './types';

// Spanish (Español) translations. Keys mirror en.ts; missing/
// English-identical values fall back to English via I18nContext.resolveEn().
const messages: TranslationMap = {
  'connections.header.companion':
    'Un compañero de escritorio flotante para ayuda rápida y siempre disponible.',
  'settings.assistant.desktopCompanion': 'Compañero de escritorio',
  'settings.assistant.desktopCompanionDesc':
    'Modo compañero siempre activo con acceso directo en la bandeja del sistema',
  'pages.settings.features.desktopCompanion': 'Acompañante de escritorio',
  'settings.companion.title': 'Compañero de escritorio',
  'settings.companion.session': 'Sesión',
  'settings.companion.activeLabel': 'Activo',
  'settings.companion.inactiveStatus': 'Inactivo',
  'settings.companion.stopping': 'Parando…',
  'settings.companion.stopSession': 'Detener sesión',
  'settings.companion.starting': 'Empezando…',
  'settings.companion.startSession': 'Iniciar sesión',
  'settings.companion.sessionId': 'ID de sesión',
  'settings.companion.turns': 'Turnos',
  'settings.companion.remaining': 'Restante',
  'settings.companion.configuration': 'Configuración',
  'settings.companion.hotkey': 'Atajo de teclado',
  'settings.companion.activationMode': 'Modo de activación',
  'settings.companion.sessionTtl': 'TTL de sesión',
  // Share cards (#5006).
  'share.button': 'Compartir',
  'share.modalTitle': 'Comparte este momento',
  'share.modalSubtitle': 'Publica lo que hizo tu agente en X o LinkedIn',
  'share.drafting': 'Diseñando tu tarjeta...',
  'share.cardAlt': 'Vista previa de la tarjeta para compartir',
  'share.imageError': 'No se pudo generar la imagen. Inténtalo de nuevo.',
  'share.captionLabel': 'Descripción',
  'share.captionPlaceholder': 'Escribe una descripción...',
  'share.privacyNote':
    'Solo se comparten el titular, la descripción, el nombre del agente y la marca. Tu chat, tu memoria y tus archivos siguen siendo privados.',
  'share.defaultHeadline': 'Mira lo que acaba de hacer mi agente de OpenHuman',
  'share.defaultAgentName': 'Mi agente',
  'share.defaultCaption': 'Mira lo que acaba de hacer mi agente de OpenHuman.',
  'share.captionWithHeadline': '{headline}. Hecho con mi agente de OpenHuman.',
  'share.linkedInHint': 'Descripción copiada. Pégala en tu publicación de LinkedIn.',
  'share.shareX': 'Compartir en X',
  'share.shareLinkedIn': 'Compartir en LinkedIn',
  'share.copyImage': 'Copiar imagen',
  'share.copiedImage': 'Imagen copiada',
  'share.copyCaption': 'Copiar descripción',
  'share.copiedCaption': 'Descripción copiada',
  'agentWorld.welcome.nav': 'Bienvenida',
  'agentWorld.welcome.eyebrow': 'TinyPlace',
  'agentWorld.welcome.title': 'Un mundo donde tus agentes se encuentran',
  'agentWorld.welcome.body':
    'TinyPlace es la capa social para agentes de IA: los tuyos pueden descubrir otros agentes, enviarles mensajes, aceptar recompensas y comerciar, todo en tu nombre. Entra en el mundo y descubre lo que hacen.',
  'agentWorld.welcome.ctaWorld': 'Entrar al mundo',
  'agentWorld.welcome.ctaFeed': 'Explorar el feed',
  'agentWorld.welcome.ctaDirectory': 'Buscar agentes',
  'agentWorld.welcome.featsLabel': 'Lo que ocurre aquí',
  'agentWorld.welcome.feat1Title': 'Conoce otros agentes',
  'agentWorld.welcome.feat1Body': 'Descubre agentes de toda la red y envíales mensajes.',
  'agentWorld.welcome.feat2Title': 'Acepta recompensas',
  'agentWorld.welcome.feat2Body': 'Tu agente puede ganar completando trabajos publicados.',
  'agentWorld.welcome.feat3Title': 'Comercia y transacciona',
  'agentWorld.welcome.feat3Body':
    'Pagos entre agentes respaldados por la wallet, con tu aprobación.',
  'brain.header.graph':
    'Cómo se conecta el conocimiento de tu agente: personas, temas y recuerdos.',
  'brain.header.goals': 'En qué está trabajando tu agente y por qué.',
  'brain.header.sources': 'Los datos de los que aprende tu agente.',
  'brain.header.sync': 'Mantén tu memoria al día y revisa lo que cambió.',
  'brain.header.subconscious': 'Pensamiento en segundo plano que se ejecuta mientras estás fuera.',
  'brain.welcome.nav': 'Bienvenida',
  'brain.welcome.eyebrow': 'Cerebro',
  'brain.welcome.title': 'La memoria de tu agente, mapeada',
  'brain.welcome.body':
    'Cerebro es donde tu agente guarda lo que sabe: las personas, conversaciones, fuentes y objetivos en los que se apoya para ayudarte con contexto real en lugar de empezar de cero cada vez.',
  'brain.welcome.ctaGraph': 'Abrir grafo de memoria',
  'brain.welcome.ctaGoals': 'Definir objetivos',
  'brain.welcome.ctaSources': 'Conectar fuentes',
  'brain.welcome.featsLabel': 'Lo que vive aquí',
  'brain.welcome.feat1Title': 'Grafo de memoria',
  'brain.welcome.feat1Body': 'Ve de un vistazo cómo se conectan personas, temas y mensajes.',
  'brain.welcome.feat2Title': 'Objetivos y enfoque',
  'brain.welcome.feat2Body': 'Dile a tu agente qué importa para que priorice el trabajo correcto.',
  'brain.welcome.feat3Title': 'Fuentes y sincronización',
  'brain.welcome.feat3Body': 'Conecta los datos de los que aprende tu agente y mantenlos frescos.',
  'feedback.header.title': 'Comentarios',
  'feedback.header.desc': 'Comparte ideas y vota lo que construimos a continuación.',
  'feedback.welcome.nav': 'Bienvenida',
  'feedback.welcome.main': 'Tablero de comentarios',
  'feedback.welcome.eyebrow': 'Comentarios',
  'feedback.welcome.title': 'Ayuda a definir lo que construimos',
  'feedback.welcome.body':
    'Cuéntanos qué funciona, qué falta y qué haría mejor a OpenHuman. Publica una idea, vota las de otros y observa cómo las mejores suben a lo más alto de nuestra hoja de ruta.',
  'feedback.welcome.ctaShare': 'Comparte una idea',
  'feedback.welcome.ctaBoard': 'Ver el tablero',
  'feedback.welcome.featsLabel': 'Lo que puedes hacer',
  'feedback.welcome.feat1Title': 'Comparte ideas',
  'feedback.welcome.feat1Body':
    'Errores, solicitudes de funciones, ideas sueltas: todo es bienvenido.',
  'feedback.welcome.feat2Title': 'Vota',
  'feedback.welcome.feat2Body': 'Vota lo que importa para que sepamos qué priorizar.',
  'feedback.welcome.feat3Title': 'Sigue el progreso',
  'feedback.welcome.feat3Body': 'Mira qué está planeado, en curso y ya publicado.',
  'connections.header.composio': 'Conecta las apps en las que tu agente puede actuar.',
  'connections.header.channels': 'Vincula las apps de chat donde vive tu comunidad.',
  'connections.header.mcp': 'Añade servidores MCP para ampliar las herramientas de tu agente.',
  'connections.header.skills': 'Instala y gestiona las habilidades del agente.',
  'connections.header.meetings': 'Conecta calendarios y deja que tu agente se una a las llamadas.',
  'connections.header.llm':
    'Configura proveedores de IA, modelos locales y el probador de chat del agente.',
  'connections.header.embeddings':
    'Elige el modelo de embeddings usado para la búsqueda en la memoria.',
  'connections.header.search': 'Configura la búsqueda web para tu agente.',
  'connections.header.wallet': 'El saldo de tu monedero local y tu frase de recuperación.',
  'connections.header.composioKey':
    'Añade una clave de API de Composio para desbloquear cientos de integraciones de apps.',
  'connections.llm.apiKeys': 'Claves de API y enrutamiento',
  'connections.welcome.nav': 'Bienvenida',
  'connections.welcome.eyebrow': 'Conexiones',
  'connections.welcome.title': 'Todo lo que usas, en un solo lugar',
  'connections.welcome.body':
    'Conecta tus apps de mensajería, correo, calendario y herramientas para que tu agente pueda leer el contexto y actuar en todas ellas, sin copiar y pegar entre una docena de pestañas. Tú controlas qué puede tocar.',
  'connections.welcome.ctaChannel': 'Conectar un canal',
  'connections.welcome.ctaApps': 'Conectar apps',
  'connections.welcome.ctaSkills': 'Explorar habilidades',
  'connections.welcome.featsLabel': 'Lo que puedes hacer aquí',
  'connections.welcome.feat1Title': 'Trae tus canales',
  'connections.welcome.feat1Body':
    'Slack, WhatsApp, Telegram, Gmail y más: vinculados en un par de clics.',
  'connections.welcome.feat2Title': 'Deja que tu agente actúe',
  'connections.welcome.feat2Body':
    'Lee, redacta y responde con todo el contexto de lo que esté conectado.',
  'connections.welcome.feat3Title': 'Mantén el control',
  'connections.welcome.feat3Body':
    'Concede o revoca el acceso por canal cuando quieras. Nada se ejecuta sin tu permiso.',
  'alerts.header.desc': 'Actividad del agente y todo lo que necesita tu atención.',
  'notifications.welcome.nav': 'Bienvenida',
  'notifications.welcome.main': 'Alertas',
  'notifications.welcome.eyebrow': 'Notificaciones',
  'notifications.welcome.title': 'Solo lo que de verdad te necesita',
  'notifications.welcome.body':
    'Un resumen tranquilo y valorado de lo que hicieron tus agentes y lo que requiere una decisión, para que lo importante salga a la luz y el ruido se quede fuera de tu camino.',
  'notifications.welcome.ctaView': 'Ver alertas',
  'notifications.welcome.featsLabel': 'Lo que verás',
  'notifications.welcome.feat1Title': 'Lo que te necesita',
  'notifications.welcome.feat1Body':
    'Decisiones y menciones que tus agentes marcaron para un humano.',
  'notifications.welcome.feat2Title': 'Actividad del agente',
  'notifications.welcome.feat2Body': 'Un registro continuo de lo que se ejecutó y lo que produjo.',
  'notifications.welcome.feat3Title': 'Filtrado por categoría',
  'notifications.welcome.feat3Body':
    'Mensajes, reuniones, recordatorios: organizados como piensas.',
  'rewards.header.desc': 'Tus puntos, rachas, referidos y beneficios.',
  'rewards.welcome.nav': 'Bienvenida',
  'rewards.welcome.main': 'Recompensas',
  'rewards.welcome.eyebrow': 'Recompensas',
  'rewards.welcome.title': 'Recibe recompensas por aparecer',
  'rewards.welcome.body':
    'Gana puntos a medida que usas OpenHuman e invitas a otros, mantén viva tu racha y canjea lo que hayas ganado, todo registrado en un solo lugar.',
  'rewards.welcome.ctaView': 'Ver recompensas',
  'rewards.welcome.featsLabel': 'Cómo funciona',
  'rewards.welcome.feat1Title': 'Gana puntos',
  'rewards.welcome.feat1Body': 'Las acciones diarias y los referidos suman con el tiempo.',
  'rewards.welcome.feat2Title': 'Mantén tu racha',
  'rewards.welcome.feat2Body': 'Aparece con regularidad para desbloquear bonos por racha.',
  'rewards.welcome.feat3Title': 'Canjea beneficios',
  'rewards.welcome.feat3Body': 'Convierte los puntos en cupones y recompensas.',
  'flows.welcome.nav': 'Bienvenida',
  'flows.welcome.main': 'Flujos de trabajo',
  'flows.welcome.eyebrow': 'Flujos de trabajo',
  'flows.welcome.title': 'Pon el trabajo rutinario en piloto automático',
  'flows.welcome.body':
    'Describe algo que haces una y otra vez (clasificación, seguimientos, resúmenes) y tu agente lo convierte en un flujo de trabajo que puede ejecutar de principio a fin, según un horario o cuando lo pidas.',
  'flows.welcome.ctaNew': 'Nuevo flujo de trabajo',
  'flows.welcome.ctaBrowse': 'Explorar flujos de trabajo',
  'flows.welcome.featsLabel': 'Lo que puedes automatizar',
  'flows.welcome.feat1Title': 'Descríbelo con palabras',
  'flows.welcome.feat1Body':
    'Di lo que quieres en lenguaje sencillo; el constructor redacta el flujo.',
  'flows.welcome.feat2Title': 'Ejecuta según un horario',
  'flows.welcome.feat2Body': 'Actívalo con un temporizador, un evento o un botón: tú decides.',
  'flows.welcome.feat3Title': 'Mantén a los humanos al tanto',
  'flows.welcome.feat3Body': 'Aprueba los pasos sensibles antes de que salga cualquier cosa.',
  // Privacy Mode selector (#4435): data-egress posture
  'privacy.mode.title': 'Modo de privacidad',
  'privacy.mode.description':
    'Controla cuántos de tus datos pueden salir de este dispositivo. Independiente del modo de acceso del agente.',
  'privacy.mode.localOnly': 'Solo local',
  'privacy.mode.localOnlyDesc':
    'Solo modelos en el dispositivo. Se bloquean las llamadas a modelos externos.',
  'privacy.mode.standard': 'Estándar',
  'privacy.mode.standardDesc': 'Equilibrado. Los modelos externos se usan según la configuración.',
  'privacy.mode.sensitive': 'Sensible',
  'privacy.mode.sensitiveDesc':
    'Cuidado adicional con datos sensibles. Pronto habrá más controles.',
  'privacy.mode.saved': 'Guardado',
  'privacy.mode.saveError': 'No se pudo actualizar el modo de privacidad.',
  'skills.recallCalendar.title': 'Calendario de Google',
  'skills.recallCalendar.description':
    'Unirse automáticamente a las llamadas de Google Meet con Recall.ai',
  // Core connection panel (GH-4396)
  'settings.core.title': 'Conexión del core',
  'settings.core.menuDesc': 'Usa el core local integrado o conéctate a un core remoto.',
  'settings.core.useRemoteToggle': 'Usar core remoto',
  'settings.core.useRemoteToggleDesc':
    'Conéctate a un core remoto por HTTP en lugar del core local integrado.',
  'settings.core.statusConnectedRemote': 'Conectado al core remoto',
  'settings.core.statusConnectedLocal': 'Conectado al core local',
  'settings.core.statusChecking': 'Comprobando la conexión…',
  'settings.core.statusAuthFailed': 'Accesible, pero el token fue rechazado',
  'settings.core.statusUnreachable': 'No se puede conectar con el core',
  'settings.core.recheck': 'Volver a comprobar',
  'settings.core.save': 'Guardar y reiniciar',
  'settings.core.applyRestartNote': 'Al guardar, OpenHuman se reinicia para volver a conectarse.',
  // Cross-host vault (#4278)
  'crossHostVault.title': 'El vault está en el host del core.',
  'crossHostVault.message':
    'Este vault de memoria se almacena en el host de openhuman-core ({os}). Solo se puede abrir o mostrar en esa máquina, no desde este dispositivo.',
  'conversations.toolFailure.whyLabel': 'Por qué',
  'conversations.toolFailure.nextLabel': 'Qué hacer a continuación',
  'conversations.toolFailure.missingPermission.cause':
    'OpenHuman aún no tiene permiso para hacer esto.',
  'conversations.toolFailure.missingPermission.next':
    'Concede el permiso que necesita y vuelve a intentarlo.',
  'conversations.toolFailure.missingApp.cause':
    'La app o el programa necesario para esta acción no está disponible.',
  'conversations.toolFailure.missingApp.next': 'Instala o abre la app y vuelve a intentarlo.',
  'conversations.toolFailure.serviceUnavailable.cause':
    'Un servicio que OpenHuman necesita no está disponible temporalmente.',
  'conversations.toolFailure.serviceUnavailable.next':
    'OpenHuman lo intentará de nuevo en breve; no hace falta hacer nada.',
  'conversations.toolFailure.badCredentials.cause':
    'Los datos de inicio de sesión guardados faltan o ya no son válidos.',
  'conversations.toolFailure.badCredentials.next':
    'Inicia sesión de nuevo o actualiza las credenciales y vuelve a intentarlo.',
  'conversations.toolFailure.blockedByPolicy.cause':
    'Esta acción está bloqueada por tu configuración de seguridad.',
  'conversations.toolFailure.blockedByPolicy.next':
    'Permítela en Configuración → Acceso del agente si quieres que se ejecute.',
  'conversations.toolFailure.modelConnection.cause':
    'OpenHuman no pudo conectarse con el modelo de IA.',
  'conversations.toolFailure.modelConnection.next':
    'Comprueba tu conexión o la configuración del modelo; OpenHuman lo reintentará.',
  'conversations.toolFailure.timeout.cause': 'La acción tardó demasiado y se detuvo.',
  'conversations.toolFailure.timeout.next':
    'OpenHuman lo intentará de nuevo, o puedes reintentarlo manualmente.',
  'conversations.toolFailure.denied.cause': 'Rechazaste esta acción.',
  'conversations.toolFailure.denied.next':
    'No hay nada que hacer: no se ejecutó. Vuelve a pedirlo si cambias de opinión.',
  'conversations.toolFailure.approvalExpired.cause':
    'La solicitud de aprobación caducó antes de que alguien respondiera.',
  'conversations.toolFailure.approvalExpired.next':
    'Vuelve a pedirlo para ejecutarlo: OpenHuman no lo reintentará por su cuenta.',
  'conversations.toolFailure.unknown.cause': 'Algo salió mal con esta acción.',
  'conversations.toolFailure.unknown.next':
    'Inténtalo de nuevo; si sigue fallando, ejecuta el diagnóstico desde Configuración.',
  'conversations.backgroundTasks.title': 'Tareas en segundo plano',
  'nav.feedback': 'Compartir opiniones',
  'feedback.board': 'Tablero de opiniones',
  'feedback.empty': 'Aún no hay opiniones. Sé el primero en compartir una idea.',
  'feedback.loadMore': 'Cargar más',
  'feedback.loadError': 'No se pudieron cargar las opiniones',
  'feedback.expand': 'Mostrar más',
  'feedback.collapse': 'Mostrar menos',
  'feedback.comments': 'comentarios',
  'feedback.viewIssue': 'Ver incidencia',
  'feedback.status.open': 'Abierta',
  'feedback.status.planned': 'Planificada',
  'feedback.status.completed': 'Completada',
  'feedback.status.closed': 'Cerrada',
  'feedback.type.feature': 'Función',
  'feedback.type.bug': 'Error',
  'feedback.sort.hot': 'Tendencia',
  'feedback.sort.top': 'Mejor valoradas',
  'feedback.sort.new': 'Nuevas',
  'feedback.filter.allTypes': 'Todos los tipos',
  'feedback.filter.allStatuses': 'Todos los estados',
  'feedback.vote.up': 'Votar a favor',
  'feedback.vote.down': 'Votar en contra',
  'feedback.submit.heading': 'Comparte tu opinión',
  'feedback.submit.subheading':
    'Sugiere una función o informa de un error. Los demás pueden votarla.',
  'feedback.submit.titlePlaceholder': 'Título',
  'feedback.submit.bodyPlaceholder': 'Describe tu idea o el problema que encontraste',
  'feedback.submit.action': 'Enviar',
  'feedback.submit.success': '¡Gracias! Tu opinión ya está en el tablero.',
  'feedback.submit.rejected': 'No se pudo publicar tu opinión.',
  'feedback.submit.error': 'Algo salió mal. Inténtalo de nuevo.',
  'feedback.admin.status': 'Estado',
  'feedback.admin.updateFailed': 'No se pudo actualizar el estado',
  'feedback.comments.empty': 'Aún no hay comentarios.',
  'feedback.comments.placeholder': 'Añadir un comentario',
  'feedback.comments.post': 'Publicar',
  'feedback.comments.loadError': 'No se pudieron cargar los comentarios',
  'feedback.comments.postError': 'No se pudo publicar el comentario',
  'feedback.comments.you': 'Tú',
  'conversations.backgroundTasks.titleWithCount': 'Tareas en segundo plano ({count})',
  'conversations.backgroundTasks.running': '{count} corriendo',
  'conversations.backgroundTasks.noneRunning': 'ninguno corriendo',
  'conversations.backgroundTasks.total': '{count} en total',
  'conversations.backgroundTasks.empty':
    'No hay tareas en segundo plano en este chat. Pídele al asistente que haga algo en segundo plano y aparecerá aquí.',
  'conversations.backgroundTasks.statusRunning': 'Running',
  'conversations.backgroundTasks.statusDone': 'Done',
  'conversations.backgroundTasks.statusFailed': 'Failed',
  'conversations.backgroundTasks.statusNeedsYou': 'te necesita',
  'conversations.backgroundTasks.statusCancelled': 'Cancelado',
  'conversations.backgroundTasks.toolCallOne': 'Llamada a herramienta {count}',
  'conversations.backgroundTasks.toolCallOther': 'Llamadas a herramientas {count}',
  'conversations.backgroundTasks.steps': 'Pasos {count}',
  'conversations.backgroundTasks.viewDetails': 'Ver detalles →',
  'conversations.backgroundTasks.close': 'Close',
  'conversations.backgroundTasks.sectionThisChat': 'En este chat',
  'conversations.backgroundTasks.sectionScheduled': 'Tareas programadas',
  'conversations.backgroundTasks.sectionSubconscious': 'Pensamiento subconsciente',
  'conversations.backgroundTasks.sectionMemory': 'Sincronizando memoria',
  'conversations.backgroundTasks.cronEmpty': 'No hay tareas programadas.',
  'conversations.backgroundTasks.cronUnnamed': 'Tarea sin título',
  'conversations.backgroundTasks.cronPaused': 'En pausa',
  'conversations.backgroundTasks.cronNext': 'Próxima {time}',
  'conversations.backgroundTasks.cronLast': 'Última ejecución {time}',
  'conversations.backgroundTasks.cronNever': 'Aún no se ha ejecutado',
  'conversations.backgroundTasks.cronSchedCron': 'Cron {expr}',
  'conversations.backgroundTasks.cronSchedEvery': 'Cada {duration}',
  'conversations.backgroundTasks.cronSchedAt': 'Una vez',
  'conversations.backgroundTasks.subOff': 'Desactivado',
  'conversations.backgroundTasks.subWorking': 'Trabajando…',
  'conversations.backgroundTasks.subIdle': 'Inactivo',
  'conversations.backgroundTasks.subLastRan': 'Última ejecución {time}',
  'conversations.backgroundTasks.subNeverRan': 'Aún no se ha ejecutado',
  'conversations.backgroundTasks.subTicks': '{count} ejecuciones',
  'conversations.backgroundTasks.subQueued': '{count} en cola',
  'conversations.backgroundTasks.memUpToDate': 'Todas las memorias actualizadas',
  'conversations.backgroundTasks.memIngesting': 'Indexando {title}',
  'conversations.backgroundTasks.memIngestingUntitled': 'Indexando memorias',
  'conversations.backgroundTasks.memQueued': '{count} en cola',
  'conversations.backgroundTasks.memProviderActive': 'Sincronizando ahora',
  'conversations.backgroundTasks.memProviderRecent': 'Sincronizado recientemente',
  'conversations.backgroundTasks.memProviderIdle': 'Inactivo',
  'nav.home': 'Inicio',
  'nav.chat': 'Charla',
  'nav.human': 'Humano',
  'nav.assistant': 'Asistente',
  'assistant.faceMode.on': 'Hablando con Tiny',
  'assistant.faceMode.off': 'Habla con Tiny',
  'assistant.faceMode.turnOn': 'Mostrar mascota',
  'assistant.faceMode.turnOff': 'Ocultar mascota',
  'nav.connections': 'Conexiones',
  'nav.memory': 'Inteligencia',
  'nav.alerts': 'Alertas',
  'nav.rewards': 'Recompensas',
  'nav.settings': 'Configuración',
  'nav.agentProfiles': 'Perfiles de agente',
  'nav.switchAgentProfile': 'Cambiar perfil de agente',
  'nav.defaultAgentProfile': 'Agente predeterminado',
  'nav.noAgentProfiles': 'No se encontraron perfiles de agente',
  'nav.activity': 'Actividad',
  'nav.brain': 'Cerebro',
  'nav.flows': 'Flujos de trabajo',
  'nav.workflowRuns': 'Ejecuciones de flujos',
  'nav.workflowDiscoveries': 'Descubrir flujos',
  'nav.orchestration': 'Orquestación',
  'orchestration.cloudUnreachable':
    'No se puede acceder al cerebro en la nube: mostrando la vista almacenada.',
  'orchPage.subtitle': 'Coordina tu agente principal',
  'orchPage.group.agent': 'Agente',
  'orchPage.group.network': 'Red',
  'orchPage.group.insights': 'Estadísticas',
  'orchPage.overview.nav': 'Grafo de agentes',
  'orchPage.overview.desc': 'Un mapa en vivo de tu agente y de los subagentes que coordina.',
  'orchPage.network.desc': 'Agentes pares a los que estás conectado, descubrimiento y uso.',
  'wallet.tabs.balance': 'Saldo de la cartera',
  'wallet.tabs.recovery': 'Recuperación',
  'wallet.ariaLabel': 'Vistas de la cartera',
  'orchPage.medulla.nav': 'Resumen',
  'orchPage.medulla.badge': 'Próximamente',
  'orchPage.medulla.title': 'Medulla',
  'orchPage.medulla.tagline': 'El modelo de orquestación de OpenHuman',
  'orchPage.medulla.body':
    'Medulla es el LLM propio de OpenHuman, diseñado para orquestar miles de agentes a la vez, con una ventana de contexto de 10 millones de tokens y una orquestación de coste radicalmente bajo.',
  'orchPage.medulla.featAgents': 'Miles de agentes',
  'orchPage.medulla.featContext': 'Contexto de 10M de tokens',
  'orchPage.medulla.featCost': 'Orquestación de bajo coste',
  'orchPage.medulla.subscriberTitle': 'Suscriptores de OpenHuman',
  'orchPage.medulla.subscriberNote':
    'Cuando Medulla se lance, será exclusivo para los suscriptores de OpenHuman.',
  'orchPage.medulla.subscriberCta': 'Consigue una suscripción',
  'orchPage.medulla.discordTitle': 'Únete al Discord',
  'orchPage.medulla.earlyAccess':
    '¿Quieres acceso anticipado? Únete a nuestro Discord y consigue una invitación.',
  'orchPage.medulla.cta': 'Únete a nuestro Discord',
  'orchPage.demo.banner': 'Este es un ejemplo de cómo se vería la orquestación a gran escala.',
  'orchPage.demo.device': 'Dispositivo',
  'orchPage.demo.taskRoute': 'Enrutar solicitud entrante',
  'orchPage.demo.taskSummarize': 'Resumir conversación',
  'orchPage.demo.taskEnrich': 'Enriquecer registro de contacto',
  'orchPage.demo.taskSchedule': 'Programar seguimiento',
  'orchPage.demo.taskDraft': 'Redactar respuesta',
  'orchPage.demo.taskSync': 'Sincronizar fuente de datos',
  'orchPage.demo.networkTitle': 'Agentes pares',
  'orchPage.demo.networkSummary': '{peers} conectados · {sessions} subagentes activos',
  'orchPage.demo.peer.connected': 'Conectado',
  'orchPage.demo.peer.connecting': 'Conectando',
  'orchPage.demo.peer.idle': 'Inactivo',
  'orchPage.demo.peerSessions': '{count} subagentes',
  'orchPage.demo.chat.user1': 'Coordina la campaña de difusión en todos mis canales.',
  'orchPage.demo.chat.assistant1':
    'Manos a la obra: iniciando 120 agentes en 2 dispositivos para ejecutar difusión, enriquecimiento y seguimientos en paralelo.',
  'orchPage.demo.chat.activity1': 'dispositivo 1 · 100 agentes enrutando 1284 conversaciones',
  'orchPage.demo.chat.activity2': 'dispositivo 2 · 20 agentes enriqueciendo 512 contactos',
  'orchPage.demo.chat.activity3': 'redactando 640 respuestas personalizadas',
  'orchPage.demo.chat.assistant2':
    'Listo. 120 agentes procesaron 1796 conversaciones en 38 segundos.',
  'orchPage.demo.chat.composerDisabled': 'El chat está disponible con acceso a Medulla',
  'orchPage.tasks.nav': 'Tareas',
  'orchPage.tasks.subtitle': 'El tablero de tareas global del orquestador',
  'orchPage.tasks.colPending': 'Pendiente',
  'orchPage.tasks.colActive': 'Activo',
  'orchPage.tasks.colBlocked': 'Bloqueado',
  'orchPage.tasks.colCompleted': 'Completado',
  'orchPage.overview.core': 'Núcleo del agente',
  'orchPage.overview.empty': 'Aún no hay subagentes para visualizar',
  'orchPage.agent.nav': 'Chat',
  'orchPage.agent.mainTab': 'Agente principal',
  'orchPage.agent.consciousTab': 'Consciente',
  'orchPage.agent.subconsciousTab': 'Subconsciente',
  'orchPage.agent.modeLabel': 'Mente del agente',
  'orchPage.agent.description': 'Chatea con el agente principal y observa su subconsciente',
  'orchPage.agent.viewSession': 'Ver sesión',
  'orchPage.sessions.railTitle': 'Agentes activos',
  'orchPage.sessions.empty': 'Aún no hay agentes activos',
  'orchPage.sessions.statusConnected': 'Conectado',
  'orchPage.sessions.statusDisconnected': 'Desconectado',
  'orchPage.sessions.statusWaiting': 'Esperando entrada',
  'orchPage.session.runtime': 'Tiempo de ejecución',
  'orchPage.session.directory': 'Directorio',
  'orchPage.session.runningOn': 'Ejecutándose en',
  'orchPage.connections.nav': 'Conexiones',
  'orchPage.connections.title': 'Agentes vinculados',
  'orchPage.connections.description':
    'Pares con los que se coordina tu agente: expande uno para ver tus sesiones con él',
  'orchPage.connections.empty': 'Aún no hay conexiones.',
  'orchPage.connections.emptyCta': 'Agregar una conexión',
  'orchPage.connections.statContacts': 'Conexiones',
  'orchPage.connections.statPending': 'Pendiente',
  'orchPage.connections.statSessions': 'Sesiones',
  'orchPage.connections.sessionCount': '{n} sesiones',
  'orchPage.connections.noSessions': 'Sin sesiones',
  'orchPage.connections.messageCount': '{n} mensajes',
  'orchPage.connections.back': 'Conexiones',
  'orchPage.connections.replyPlaceholder': 'Responder…',
  'orchPage.connections.initTitle': 'Inicializar un agente o una instancia',
  'orchPage.connections.initDesc':
    'Crea un nuevo subagente para trabajar contigo. Abre el chat del agente y describe el rol, el objetivo y las herramientas que debe usar: OpenHuman aprovisiona una instancia dedicada que puedes dirigir desde aquí.',
  'orchPage.connections.initCta': 'Empezar en el chat',
  'orchPage.connections.status.needsYou': 'Te necesita',
  'orchPage.connections.status.running': 'En ejecución',
  'orchPage.connections.status.idle': 'Inactivo',
  'orchPage.connections.status.done': 'Hecho',
  'orchPage.connections.status.error': 'Fallo',
  'orchPage.connections.pendingHint': 'Esperando aceptación',
  'orchPage.discover.nav': 'Descubrir',
  'orchPage.discover.linkAction': 'Agregar',
  'orchPage.discover.identityTitle': 'Tu visibilidad',
  'orchPage.discover.notDiscoverableGuide':
    'Registra un @handle para que otros agentes puedan encontrarte y escribirte.',
  'orchPage.discover.linkTitle': 'Vincular un nuevo agente',
  'orchPage.discover.linkDescription':
    'Pega un ID de agente para enviar una solicitud de conexión.',
  'orchPage.discover.noRequests': 'No hay solicitudes entrantes.',
  'orchPage.usage.nav': 'Uso',
  'orchPage.usage.connections': 'Conexiones',
  'orchPage.usage.balance': 'Saldo de crédito',
  'orchPage.usage.balanceHint': 'Promocional + recarga',
  'orchPage.usage.cycleSpend': 'Gasto del ciclo',
  'orchPage.usage.ofBudget': 'de',
  'orchPage.usage.inferenceCalls': 'Llamadas al modelo',
  'orchPage.usage.integrationCalls': 'Llamadas de integración',
  'orchPage.usage.tokensSaved': 'Tokens ahorrados',
  'orchPage.usage.saved': 'ahorrado',
  'orchPage.usage.footnote': 'El uso refleja tu ciclo de facturación actual.',
  'nav.agentWorld': 'Tiny Place',
  'nav.wallet': 'Cartera',
  'agentWorld.description':
    'Tiny.Place es una red social para agentes de IA. Usa OpenHuman para interactuar, encontrar y publicar trabajos, comerciar y crecer juntos.',
  'agentWorld.world': 'Mundo',
  'agentWorld.world.booting': 'Iniciando renderizador...',
  'agentWorld.world.initError': 'No se pudo iniciar el renderizador del mundo.',
  'agentWorld.world.retry': 'Reintentar',
  'agentWorld.world.title': 'Tiny Place',
  'agentWorld.world.description':
    'Únete a tiny.place para que tu agente coordine con otros agentes de la red: encontrar y publicar trabajos, comerciar, enviar mensajes y colaborar en recompensas.',
  'agentWorld.world.offlineBadge': 'Vista previa sin conexión',
  'agentWorld.world.offlineBadgeTitle':
    'Los agentes que se muestran aquí forman parte de una simulación local. La presencia en vivo y la sincronización del mundo llegarán pronto.',
  'agentWorld.world.room': 'Sala',
  'agentWorld.world.rooms.poker.name': 'Póker',
  'agentWorld.world.rooms.poker.description': 'Ocho asientos alrededor de una mesa de fieltro.',
  'agentWorld.world.rooms.court.name': 'Tribunal',
  'agentWorld.world.rooms.court.description': 'Estrado, jurado y galería.',
  'agentWorld.world.rooms.office.name': 'Oficina',
  'agentWorld.world.rooms.office.description': 'Cubículos, escritorios y una pizarra.',
  'agentWorld.world.rooms.home.name': 'Hogar',
  'agentWorld.world.rooms.home.description': 'Una sala acogedora con sofás y una alfombra.',
  'agentWorld.world.rooms.outside.name': 'Mundo',
  'agentWorld.world.rooms.outside.description': 'Una gran plaza abierta rodeada de edificios.',
  'agentWorld.feed': 'Noticias',
  'agentWorld.feed.loadMore': 'Cargar más',
  'agentWorld.feed.loadingMore': 'Cargando más…',
  'agentWorld.feed.loadMoreError': 'No se pudieron cargar más publicaciones. Inténtalo de nuevo.',
  'agentWorld.ledger': 'Libro mayor',
  'agentWorld.profileViewer.description': 'Perfil público',
  'agentWorld.profileViewer.agentCard': 'Tarjeta del agente',
  'agentWorld.profileViewer.loading': 'Cargando perfil…',
  'agentWorld.profileViewer.notFoundTitle': 'Perfil no encontrado',
  'agentWorld.profileViewer.notFoundBody':
    'Todavía no existe un perfil publicado para este identificador.',
  'agentWorld.profileViewer.errorTitle': 'No se pudo cargar el perfil',
  'agentWorld.profileViewer.follow': 'Seguir',
  'agentWorld.profileViewer.following': 'Siguiendo',
  'agentWorld.profileViewer.copyLink': 'Copiar enlace',
  'agentWorld.profileViewer.linkCopied': 'Enlace copiado',
  'agentWorld.profileViewer.skills': 'Habilidades',
  'agentWorld.profileViewer.verifiedAccounts': 'Cuentas verificadas',
  'agentWorld.profileViewer.handlesOwned': 'Identificadores en propiedad',
  'agentWorld.profileViewer.followers': 'seguidores',
  'agentWorld.profileViewer.followingCount': 'siguiendo',
  'agentWorld.profileViewer.joined': 'Se unió',
  'agentWorld.profileViewer.ownProfile': 'Este es tu perfil',
  'agentWorld.profileViewer.agentBadge': 'Agente',
  'agentWorld.profileViewer.humanBadge': 'Humano',
  'agentWorld.ledger.loadMore': 'Cargar más',
  'agentWorld.ledger.loadingMore': 'Cargando más…',
  'agentWorld.ledger.loadMoreError': 'No se pudieron cargar más transacciones. Inténtalo de nuevo.',
  'agentWorld.ledger.filterAsset': 'Activo',
  'agentWorld.ledger.filterAllAssets': 'Todos los activos',
  'agentWorld.ledger.direction': 'Dirección',
  'agentWorld.ledger.directionAll': 'Todas',
  'agentWorld.ledger.directionIn': 'Entrada',
  'agentWorld.ledger.directionOut': 'Salida',
  'agentWorld.ledger.copyTxId': 'Copiar ID de transacción',
  'agentWorld.ledger.copied': 'Copiado',
  'agentWorld.ledger.noMatch': 'Ninguna transacción coincide con estos filtros.',
  'agentWorld.ledger.noMatchHint': 'Prueba a ampliar o quitar los filtros.',
  'agentWorld.jobs': 'Trabajos',
  'agentWorld.bounties': 'Recompensas',
  'agentWorld.explore': 'Explorar',
  'agentWorld.directory': 'Directorio',
  'agentWorld.directory.empty': 'No se encontraron agentes',
  'agentWorld.directory.emptyHint': 'Aún no hay agentes registrados en el directorio.',
  'agentWorld.directory.searchLabel': 'Buscar agentes',
  'agentWorld.directory.searchPlaceholder': 'Busca agentes por identificador o nombre',
  'agentWorld.directory.noResults': 'Ningún agente coincide con tu búsqueda.',
  'agentWorld.directory.noResultsHint': 'Prueba con otro identificador o nombre.',
  'agentWorld.directory.loadMore': 'Cargar más',
  'agentWorld.directory.loadingMore': 'Cargando…',
  'agentWorld.directory.loadMoreError': 'No se pudieron cargar más agentes.',
  'agentWorld.directory.profile.verified': 'Verificado',
  'agentWorld.directory.profile.joined': 'Se unió',
  'agentWorld.directory.profile.noBio': 'Aún no hay biografía.',
  'agentWorld.directory.profile.skills': 'Habilidades',
  'agentWorld.directory.profile.loadError': 'No se pudo cargar el perfil completo.',
  'agentWorld.identities': 'Identidades',
  'agentWorld.profiles': 'Perfiles',
  'agentWorld.transferHandle.action': 'Transferir',
  'agentWorld.transferHandle.title': 'Transferir handle',
  'agentWorld.transferHandle.warning':
    'Transferir un handle es permanente y no se puede deshacer. El destinatario se convierte en su único propietario.',
  'agentWorld.transferHandle.recipientPlaceholder': '@handle del destinatario',
  'agentWorld.transferHandle.confirm': 'Transferir handle',
  'agentWorld.transferHandle.submitting': 'Transfiriendo…',
  'agentWorld.transferHandle.recipientRequired': 'Introduce el handle del destinatario.',
  'agentWorld.transferHandle.confirmLabel': 'Escribe el handle para confirmar',
  'agentWorld.transferHandle.confirmMismatch': 'El handle escrito no coincide.',
  'agentWorld.transferHandle.primaryLocked':
    'Un identificador principal no se puede transferir. Activa primero otro identificador.',
  'agentWorld.profile.edit': 'Editar perfil',
  'agentWorld.profile.displayName': 'Nombre visible',
  'agentWorld.profile.bio': 'Biografía',
  'agentWorld.profile.avatarEmail': 'Correo del avatar',
  'agentWorld.profile.avatarEmailHint': 'Se usa para obtener tu avatar de Gravatar.',
  'agentWorld.profile.save': 'Guardar',
  'agentWorld.profile.nameRequired': 'El nombre para mostrar no puede estar vacío.',
  'agentWorld.profile.cancel': 'Cancelar',
  'agentWorld.profile.saving': 'Guardando…',
  'agentWorld.profile.saveError': 'No se pudo guardar tu perfil. Inténtalo de nuevo.',
  'agentWorld.marketplace': 'Mercado',
  'agentWorld.messaging': 'Mensajes',
  'agentWorld.walletNotConfigured': 'Cartera no configurada',
  'agentWorld.copyAddress': 'Copiar dirección',
  'agentWorld.addressCopied': 'Copiada',
  'agentWorld.walletUnavailable': 'Cartera no disponible',
  'agentWorld.walletRetry': 'Reintentar cargar la cartera',
  // Agent World: Explore section live data
  'explore.networkOverview': 'Resumen de red',
  'explore.trendingCommunities': 'Comunidades en tendencia',
  'explore.activeJobs': 'Trabajos activos',
  'explore.featuredBounties': 'Recompensas destacadas',
  'explore.newAgents': 'Nuevos agentes',
  'explore.viewAll': 'Ver todo',
  'explore.noCommunities': 'Aún no hay comunidades',
  'explore.noJobs': 'No hay trabajos activos',
  'explore.noBounties': 'No hay recompensas abiertas',
  'explore.noAgents': 'No hay agentes registrados',
  'agentWorld.jobs.deadlineFuture': 'La fecha límite de la propuesta debe ser en el futuro',
  'nav.avatarMenu.account': 'Cuenta',
  'nav.avatarMenu.billing': 'Facturación',
  'nav.avatarMenu.rewards': 'Recompensas',
  'nav.avatarMenu.invites': 'Invitar a un amigo',
  'nav.avatarMenu.wallet': 'Cartera',

  // Brain: full-page memory knowledge-graph surface
  'brain.subtitle': 'Tu grafo de conocimiento, fuentes de memoria y controles.',
  'brain.tabs.memory': 'Memoria',
  'brain.tabs.subconscious': 'Subconsciente',
  'brain.tabs.graph': 'Gráfico',
  'brain.tabs.goals': 'Objetivos',
  'brain.goals.title': 'Objetivos a largo plazo',
  'brain.goals.description':
    'Los objetivos duraderos del agente para trabajar contigo. Edítalos aquí o deja que Reflexionar los actualice.',
  'brain.goals.reflect': 'Reflexionar',
  'brain.goals.reflecting': 'Reflexionando…',
  'brain.goals.reflectDone': 'Objetivos actualizados.',
  'brain.goals.add': 'Añadir',
  'brain.goals.addPlaceholder': 'Añade un objetivo a largo plazo…',
  'brain.goals.empty':
    'Aún no hay objetivos. Añade uno o usa Reflexionar para generarlos a partir del contexto reciente.',
  'brain.goals.editGoal': 'Editar objetivo',
  'brain.goals.deleteGoal': 'Eliminar objetivo',
  'brain.goals.actionError': 'Algo salió mal. Inténtalo de nuevo.',
  'brain.tabs.sources': 'Fuentes',
  'brain.tabs.sync': 'Sincronización',
  'brain.tabs.orchestration': 'Orquestación',
  'tinyplaceOrchestration.title': 'Relay de TinyPlace',
  'tinyplaceOrchestration.subtitle': 'Canales de agentes fijados y chats de sesiones de app',
  'tinyplaceOrchestration.refresh': 'Actualizar',
  'tinyplaceOrchestration.newInstance': 'Nueva instancia',
  'tinyplaceOrchestration.newInstanceSoon': 'Próximamente',
  'tinyplaceOrchestration.pinned': 'Fijados',
  'tinyplaceOrchestration.sessions': 'Sesiones',
  'tinyplaceOrchestration.contacts': 'Contactos',
  'tinyplaceOrchestration.noContacts': 'Aún no hay contactos.',
  'tinyplaceOrchestration.newSession': 'Nueva sesión',
  'tinyplaceOrchestration.otherSessions': 'Otras sesiones',
  'tinyplaceOrchestration.loading': 'Cargando chats de TinyPlace…',
  'tinyplaceOrchestration.paymentRequired': 'El acceso a TinyPlace requiere pago.',
  'tinyplaceOrchestration.failedToLoad': 'No se pudieron cargar los chats de TinyPlace',
  'tinyplaceOrchestration.noSessions': 'Aún no hay sesiones de app de TinyPlace.',
  'tinyplaceOrchestration.noMessages': 'Aún no hay mensajes en este chat.',
  'tinyplaceOrchestration.active': 'Activa',
  'tinyplaceOrchestration.inactive': 'Inactiva',
  'tinyplaceOrchestration.encryptedBody': 'Mensaje cifrado de TinyPlace',
  'tinyplaceOrchestration.unknownSender': 'Remitente desconocido',
  'tinyplaceOrchestration.master.title': 'Agente / humano',
  'tinyplaceOrchestration.master.subtitle': 'Chat maestro',
  'tinyplaceOrchestration.master.preview': 'Coordinación directa entre tú y OpenHuman.',
  'tinyplaceOrchestration.subconscious.title': 'Subconsciente',
  'tinyplaceOrchestration.subconscious.subtitle': 'Chats internos de agentes',
  'tinyplaceOrchestration.subconscious.preview':
    'Coordinación de agentes en segundo plano y bucles de memoria.',
  'tinyplaceOrchestration.session.subtitle': 'Sesión de app de TinyPlace',
  'tinyplaceOrchestration.pairing.linkLabel': 'Vincular sesión',
  'tinyplaceOrchestration.pairing.linkPlaceholder': 'Pega el ID del agente de sesión',
  'tinyplaceOrchestration.pairing.linkAction': 'Vincular',
  'tinyplaceOrchestration.pairing.requests': 'Solicitudes de contacto',
  'tinyplaceOrchestration.pairing.accept': 'Aceptar',
  'tinyplaceOrchestration.pairing.decline': 'Rechazar',
  'tinyplaceOrchestration.pairing.block': 'Bloquear',
  'tinyplaceOrchestration.pairing.linked': 'Vinculada',
  'tinyplaceOrchestration.pairing.pending': 'Pendiente',
  'tinyplaceOrchestration.pairing.unlinked': 'Sin vincular',
  'tinyplaceOrchestration.pairing.incoming': 'Entrantes',
  'tinyplaceOrchestration.pairing.outgoing': 'Salientes',
  'tinyplaceOrchestration.master.you': 'Tú',
  'tinyplaceOrchestration.composer.placeholder': 'Mensaje a OpenHuman…',
  'tinyplaceOrchestration.composer.send': 'Enviar',
  'tinyplaceOrchestration.composer.sendFailed': 'No se pudo enviar el mensaje',
  'tinyplaceOrchestration.steering.label': 'Dirección',
  'tinyplaceOrchestration.relay.staging': 'Staging',
  'tinyplaceOrchestration.relay.prod': 'Producción',
  'tinyplaceOrchestration.identity.loading': 'Cargando identidad…',
  'tinyplaceOrchestration.identity.noHandle': 'Aún sin @handle',
  'tinyplaceOrchestration.identity.copy': 'Copiar',
  'tinyplaceOrchestration.identity.copied': 'Copiado',
  'tinyplaceOrchestration.identity.discoverable': 'Detectable',
  'tinyplaceOrchestration.identity.undiscoverable': 'No detectable',
  'tinyplaceOrchestration.identity.undiscoverableHint':
    'Publica tu tarjeta de directorio y tu clave de cifrado para que otros agentes puedan escribirte.',
  'tinyplaceOrchestration.identity.makeDiscoverable': 'Hacer detectable',
  'tinyplaceOrchestration.identity.republish': 'Volver a publicar claves',
  'tinyplaceOrchestration.identity.publishing': 'Publicando…',
  'tinyplaceOrchestration.identity.publishFailed': 'Error al publicar: inténtalo de nuevo',
  'tinyplaceOrchestration.identity.card': 'Tarjeta de directorio',
  'tinyplaceOrchestration.identity.key': 'Clave de cifrado',
  'tinyplaceOrchestration.identity.published': 'Publicado',
  'tinyplaceOrchestration.identity.notPublished': 'No publicado',
  'tinyplaceOrchestration.roster.instances': 'Instancias',
  'tinyplaceOrchestration.roster.empty': 'Aún no hay instancias de agente',
  'tinyplaceOrchestration.roster.other': 'Otros',
  'tinyplaceOrchestration.status.running': 'En ejecución',
  'tinyplaceOrchestration.status.idle': 'Inactivo',
  'tinyplaceOrchestration.status.waitingApproval': 'Esperando aprobación',
  'tinyplaceOrchestration.status.errored': 'Con error',
  'tinyplaceOrchestration.status.stopped': 'Detenido',
  'tinyplaceOrchestration.attention.title': 'Te necesita',
  'tinyplaceOrchestration.attention.empty': 'Todo al día',
  'tinyplaceOrchestration.attention.unread': 'Mensajes sin leer',
  'tinyplaceOrchestration.attention.review': 'Revisar',
  'tinyplaceOrchestration.attention.open': 'Abrir',
  'tinyplaceOrchestration.attention.kind.approval': 'Aprobación',
  'tinyplaceOrchestration.attention.kind.needsInput': 'Necesita respuesta',
  'tinyplaceOrchestration.attention.kind.unread': 'Sin leer',
  'brain.empty':
    'Tu cerebro está vacío por ahora: conecta una fuente para empezar a construir tu memoria.',
  'brain.error': 'No se pudo cargar tu cerebro. Inténtalo de nuevo.',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.confirm': 'Confirmar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.create': 'Crear',
  'common.search': 'Buscar',
  'common.loading': 'cargando…',
  'sync.runs': 'sincronizaciones',
  'sync.totalCost': 'total',
  'sync.when': 'Cuándo',
  'sync.source': 'Origen',
  'sync.items': 'Elementos',
  'sync.tokens': 'Tokens',
  'sync.cost': 'Costo',
  'sync.duration': 'Duración',
  'sync.noAuditEntries': 'Aún no hay sincronizaciones registradas.',
  'sync.timeAgo.justNow': 'ahora mismo',
  'sync.timeAgo.minutes': 'hace {n} min',
  'sync.timeAgo.hours': 'hace {n} h',
  'sync.timeAgo.days': 'hace {n} d',
  'sync.status.success': 'Correcto',
  'sync.status.failed': 'Fallido',
  'common.error': 'error',
  'common.success': 'Éxito',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.finish': 'Finalizar',
  'common.close': 'Cerrar',
  'common.enabled': 'Activado',
  'common.disabled': 'Desactivado',
  'common.on': 'Activado',
  'common.off': 'Desactivado',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.ok': 'Entendido',
  'common.name': 'Nombre',
  'common.retry': 'Reintentar',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.learnMore': 'Más información',
  'common.seeAll': 'Ver',
  'common.dismiss': 'Descartar',
  'common.clear': 'Limpiar',
  'common.reset': 'Restablecer',
  'common.refresh': 'Actualizar',
  'common.export': 'Exportar',
  'common.import': 'Importar',
  'common.upload': 'Subir',
  'common.download': 'Descargar',
  'common.add': 'Agregar',
  'common.remove': 'Eliminar',
  'common.showMore': 'Ver más',
  'common.showLess': 'Ver menos',
  'common.submit': 'Enviar',
  'common.continue': 'Continuar',
  'common.comingSoon': 'Próximamente',
  'common.breadcrumb': 'Miga de pan',
  'common.beta': 'Beta',
  'common.betaDisclaimer':
    'Esta función está en beta. Puede cambiar o tener aspectos por pulir: tus comentarios nos ayudan a mejorarla.',
  'settings.general': 'generales',
  // Settings layman groups (Phase 4 IA revamp)
  'settings.groups.account': 'Cuenta',
  'settings.groups.assistant': 'Asistente',
  'settings.groups.privacySecurity': 'Privacidad y seguridad',
  'settings.groups.notifications': 'Notificaciones',
  'settings.groups.about': 'Acerca de',
  'settings.assistant.personality': 'Personalidad',
  'settings.personalityFace.title': 'Personalidad y cara',
  'settings.personalityFace.menuDesc': 'Ajusta el carácter de tu asistente y elige su cara',
  'settings.assistant.voice': 'Voz',
  'settings.assistant.voiceDesc': 'Configuración de voz a texto y texto a voz',
  'settings.assistant.faceMascot': 'Cara / Mascota',
  'settings.assistant.backgroundActivity': 'Subconsciente',
  'settings.assistant.backgroundActivityDesc':
    'Controla qué tan activo trabaja tu asistente en segundo plano',
  'settings.assistant.permissions': 'Permisos',
  'settings.assistant.permissionsDesc': 'Elige qué puede hacer el asistente y dónde puede trabajar',
  'settings.privacySecurity.privacy': 'Privacidad',
  'settings.privacySecurity.privacyDesc': 'Controla qué datos salen de tu ordenador',
  'settings.privacySecurity.security': 'Seguridad',
  'settings.privacySecurity.securityDesc': 'Sesiones y opciones de inicio de sesión',
  'settings.privacySecurity.approvalsHistory': 'Aprobaciones e historial',
  'settings.privacySecurity.approvalsHistoryDesc':
    'Revisa las decisiones de aprobación de herramientas recientes',
  'settings.notifications.menuTitle': 'Notificaciones',
  'settings.notifications.menuDesc': 'Bandeja de alertas y preferencias de notificaciones',
  'settings.devGroups.knowledgeMemory': 'Conocimiento y memoria',
  'settings.devGroups.agentsAutonomy': 'Agentes y autonomía',
  'settings.devGroups.modelsInference': 'Modelos e inferencia',
  'settings.devGroups.automationIntegrations': 'Automatización e integraciones',
  'settings.devGroups.toolsCapabilities': 'Herramientas y capacidades',
  'settings.devGroups.council': 'Consejo',
  'settings.analysisViews.title': 'Vistas de análisis',
  'settings.analysisViews.menuDesc':
    'Análisis del grafo de memoria: diagrama, centralidad, cohesión, asociaciones, frescura, línea de tiempo, rutas y espacios de nombres',
  'settings.buildInfo.title': 'Información de compilación/versión',
  'settings.buildInfo.menuDesc': 'Compilación de la app, versión y detalles de conexión del núcleo',
  'settings.tokenUsage.title': 'Tokens y coste',
  'settings.tokenUsage.menuDesc': 'Ajustes de compresión y cuántos tokens y dólares han ahorrado',
  'settings.tokenUsage.saving': 'Guardando…',
  'settings.tokenUsage.saved': 'Guardado',
  'settings.tokenUsage.savingsTitle': 'Ahorros',
  'settings.tokenUsage.attributedTo': 'Coste calculado para {model}',
  'settings.tokenUsage.tokensSaved': 'Tokens ahorrados',
  'settings.tokenUsage.costSaved': 'Coste ahorrado',
  'settings.tokenUsage.cacheOccupancy': 'Originales en caché',
  'settings.tokenUsage.compactions': 'Compactaciones',
  'settings.tokenUsage.overEvents': 'a lo largo de {count} compactaciones',
  'settings.tokenUsage.byCompressor': 'Por compresor',
  'settings.tokenUsage.refresh': 'Actualizar',
  'settings.tokenUsage.reset': 'Restablecer estadísticas',
  'settings.tokenUsage.compressionTitle': 'Compresión',
  'settings.tokenUsage.compressionDesc':
    'Compactación según el contenido de las salidas grandes de herramientas antes de que entren en el contexto del modelo.',
  'settings.tokenUsage.routerEnabled': 'Activar compresión',
  'settings.tokenUsage.routerEnabledDesc': 'Interruptor principal del enrutador de contenido.',
  'settings.tokenUsage.search': 'Resultados de búsqueda',
  'settings.tokenUsage.searchDesc':
    'Ordenar la salida de grep/búsqueda por relevancia, conservando las mejores coincidencias.',
  'settings.tokenUsage.code': 'Código fuente',
  'settings.tokenUsage.codeDesc': 'Conservar las firmas, plegar los cuerpos de las funciones.',
  'settings.tokenUsage.html': 'HTML',
  'settings.tokenUsage.htmlDesc': 'Eliminar el marcado para obtener texto legible.',
  'settings.tokenUsage.ml': 'Compresor de texto con ML',
  'settings.tokenUsage.mlDesc':
    'Modelo ModernBERT local para texto sin formato (requiere entorno de ejecución de Python).',
  'settings.tokenUsage.ccrTitle': 'Caché y recuperación (CCR)',
  'settings.tokenUsage.ccrDesc':
    'Los originales compactados se almacenan en caché para que el agente pueda recuperar el texto completo cuando lo necesite.',
  'settings.tokenUsage.ccrEnabled': 'Conservar originales para recuperación',
  'settings.tokenUsage.ccrEnabledDesc':
    'Descargar el original y añadir un marcador de recuperación para que no se pierda nada.',
  'settings.tokenUsage.ccrMinTokens': 'Tamaño mínimo para almacenar en caché',
  'settings.tokenUsage.ccrMinTokensDesc':
    'Almacenar en caché y compactar con pérdida solo los resultados estimados en esta cantidad de tokens o más.',
  'settings.tokenUsage.tokensUnit': 'tokens',
  'settings.tokenUsage.ccrDisk': 'Conservar la caché en disco',
  'settings.tokenUsage.ccrDiskDesc': 'Mantener los originales recuperables entre reinicios.',
  'settings.dataSync.title': 'Sincronización de datos',
  'settings.dataSync.menuDesc': 'Lo que sincroniza tu asistente: fuentes, actualidad y estado',
  'settings.dataSync.description':
    'Gestiona qué se sincroniza en la memoria de tu asistente: cada fuente conectada con su última sincronización, cuánto se ha sincronizado y si se está sincronizando ahora.',
  'settings.devGroups.diagnosticsLogs': 'Diagnósticos y registros',
  'settings.featuresAndAI': 'Funciones e IA',
  'settings.billingAndRewards': 'Facturación y recompensas',
  'settings.support': 'Soporte',
  'settings.advanced': 'Avanzado',
  'settings.dangerZone': 'Zona de peligro',
  'settings.account': 'Cuenta',
  'settings.accountDesc': 'Frase de recuperación, equipo, conexiones y privacidad',
  'settings.notifications': 'Notificaciones',
  'settings.notificationsDesc': 'No molestar y controles de notificación por cuenta',
  'settings.notifications.tabs.preferences': 'Preferencias',
  'settings.notifications.tabs.routing': 'Enrutamiento',
  'settings.features': 'Funciones',
  'settings.aiModels': 'IA y modelos',
  'settings.aiModelsDesc': 'Configuración de modelos de IA locales, descargas y proveedor LLM',
  'settings.ai': 'Configuración de IA',
  'settings.aiDesc':
    'Proveedores en la nube, modelos locales de Ollama y enrutamiento por carga de trabajo',
  'settings.billingUsage': 'Facturación y uso',
  'settings.billingUsageDesc': 'Plan de suscripción, créditos y métodos de pago',
  'settings.rewards': 'Recompensas',
  'settings.rewardsDesc': 'Referidos, cupones y créditos ganados',
  'settings.restartTour': 'Reiniciar tour',
  'settings.restartTourDesc': 'Reproduce el recorrido del producto desde el principio',
  'settings.about': 'Acerca de',
  'settings.aboutDesc': 'Versión de la app y actualizaciones de software',
  'settings.developerOptions': 'Avanzado',
  'settings.developerOptionsDesc':
    'Configuración de IA, canales de mensajería, herramientas, diagnósticos y paneles de depuración',
  'settings.developerDiagnostics': 'Desarrollador y Diagnóstico',
  'settings.developerDiagnosticsDesc':
    'Herramientas avanzadas de desarrollador, diagnóstico, memoria, agentes y paneles de depuración',
  'settings.developerMode.title': 'Modo desarrollador',
  'settings.developerMode.description':
    'Mostrar herramientas avanzadas de desarrollador y diagnóstico',
  'settings.developerMode.enabledByBuild': 'Siempre activo en compilaciones de desarrollo',
  'settings.clearAppData': 'Borrar datos de la app',
  'settings.clearAppDataDesc':
    'Cerrar sesión y eliminar permanentemente todos los datos locales de la app',
  'settings.logOut': 'Cerrar sesión',
  'settings.logOutDesc': 'Salir de tu cuenta',
  'settings.exitLocalSession': 'Salir de la sesión local',
  'settings.exitLocalSessionDesc': 'Volver a la pantalla de inicio de sesión',
  'settings.language': 'Idioma',
  'settings.navGroups.general': 'General',
  'settings.navGroups.assistant': 'Asistente',
  'settings.navGroups.data': 'Datos',
  'settings.navGroups.connections': 'Conexiones',
  'settings.navGroups.system': 'Sistema',
  'settings.betaBuild': 'Compilación beta: v{version}',
  'settings.languageDesc': 'Idioma de visualización de la interfaz de la app',
  'settings.alerts': 'Alertas',
  'settings.alertsDesc': 'Ver alertas recientes y actividad en tu bandeja',
  'settings.account.profile': 'Perfil',
  'settings.account.profileDesc': 'Nombre, correo electrónico y avatar',
  'settings.account.devices': 'Dispositivos',
  'settings.account.devicesDesc': 'Vincular y gestionar dispositivos móviles',
  'settings.account.teamMembers': 'Equipo y miembros',
  'settings.account.teamMembersDesc': 'Gestionar acceso al equipo y roles de miembros',
  'settings.account.dataMigration': 'Datos y migración',
  'settings.account.dataMigrationDesc': 'Importar memoria desde otro asistente',
  'settings.account.recoveryPhrase': 'Frase de recuperación',
  'settings.account.recoveryPhraseDesc': 'Ver y respaldar tu frase de recuperación de cuenta',
  'settings.account.team': 'Equipo',
  'settings.account.teamDesc': 'Administrar miembros del equipo y permisos',
  'settings.account.connections': 'Conexiones',
  'settings.account.connectionsDesc': 'Administrar cuentas y servicios vinculados',
  'settings.account.privacy': 'Privacidad',
  'settings.account.privacyDesc': 'Controla qué datos salen de tu computadora',
  'migration.title': 'Importar desde otro asistente',
  'migration.description':
    'Migra la memoria y las notas de otro asistente local a este espacio de trabajo. Empieza con una Vista previa para ver exactamente qué cambiará y luego pulsa Aplicar para copiar los datos. Tu memoria actual se respalda primero.',
  'migration.vendorLabel': 'Proveedor de origen',
  'migration.vendor.openclaw': 'OpenClaw',
  'migration.vendor.hermes': 'Hermes Agent',
  'migration.sourceLabel': 'Ruta del espacio de trabajo de origen (opcional)',
  'migration.sourcePlaceholder':
    'Déjalo en blanco para detectar automáticamente (p. ej. ~/.openclaw/workspace)',
  'migration.sourcePlaceholderHermes':
    'Dejar en blanco para detectar automáticamente (p. ej., ~/.hermes)',
  'migration.sourceHint':
    'Si está vacío, se usa la ubicación predeterminada del proveedor. Indica una ruta explícita si moviste el espacio de trabajo a otro sitio.',
  'migration.previewAction': 'Vista previa',
  'migration.previewRunning': 'Previsualizando…',
  'migration.applyAction': 'Aplicar importación',
  'migration.applyRunning': 'Importando…',
  'migration.applyDisclaimer':
    'Aplicar se desbloquea tras una Vista previa exitosa del mismo origen. La memoria actual se respalda antes de cualquier importación.',
  'migration.reportTitlePreview': 'Vista previa: aún no se importó nada',
  'migration.reportTitleApplied': 'Importación completa',
  'migration.report.source': 'Espacio de trabajo de origen',
  'migration.report.target': 'Espacio de trabajo de destino',
  'migration.report.fromSqlite': 'Desde SQLite (brain.db)',
  'migration.report.fromMarkdown': 'Desde Markdown',
  'migration.report.imported': 'Importado',
  'migration.report.skippedUnchanged': 'Omitido (sin cambios)',
  'migration.report.renamedConflicts': 'Renombrado por conflicto',
  'migration.report.warnings': 'Advertencias',
  'migration.report.previewHint':
    'Todavía no se importó ningún dato. Pulsa Aplicar importación para copiarlo.',
  'migration.report.appliedHint':
    'Las entradas importadas ya están en tu memoria. Vuelve a ejecutar Vista previa si quieres comparar de nuevo.',
  'migration.confirmImport.singular':
    '¿Importar {count} entrada al espacio de trabajo actual?\n\nOrigen: {source}\nDestino: {target}\n\nLa memoria existente se respaldará antes de la importación.',
  'migration.confirmImport.plural':
    '¿Importar {count} entradas al espacio de trabajo actual?\n\nOrigen: {source}\nDestino: {target}\n\nLa memoria existente se respaldará antes de la importación.',
  'settings.notifications.doNotDisturb': 'No molestar',
  'settings.notifications.doNotDisturbDesc':
    'Pausar todas las notificaciones por un período determinado',
  'settings.notifications.channelControls': 'Controles por canal',
  'settings.notifications.channelControlsDesc':
    'Configura las preferencias de notificación para cada canal',
  'settings.features.messaging': 'Mensajería',
  'settings.features.messagingDesc': 'Configuración de integración de canales y mensajería',
  'settings.features.tools': 'Herramientas',
  'settings.features.toolsDesc': 'Administrar herramientas e integraciones conectadas',
  'settings.ai.localSetup': 'Configuración de IA local',
  'settings.ai.localSetupDesc': 'Descargar y configurar modelos de IA locales',
  'settings.ai.llmProvider': 'Proveedor LLM',
  'settings.ai.llmProviderDesc': 'Elegir y configurar tu proveedor de IA',
  'clearData.title': 'Borrar datos de la app',
  'clearData.warning':
    'Esto cerrará tu sesión y eliminará permanentemente los datos locales de la app, incluyendo:',
  'clearData.bulletSettings': 'Configuración de la app y conversaciones',
  'clearData.bulletCache': 'Todos los datos de caché de integraciones locales',
  'clearData.bulletWorkspace': 'Datos del espacio de trabajo',
  'clearData.bulletOther': 'Todos los demás datos locales',
  'clearData.irreversible': 'Esta acción no se puede deshacer.',
  'clearData.clearing': 'Borrando datos de la app...',
  'clearData.failed': 'No se pudieron borrar los datos ni cerrar sesión. Inténtalo de nuevo.',
  'clearData.failedLogout': 'No se pudo cerrar sesión. Inténtalo de nuevo.',
  'clearData.failedPersist':
    'No se pudo borrar el estado persistido de la app. Inténtalo de nuevo.',
  'welcome.logoAlt': 'OpenHuman',
  'welcome.title': 'Bienvenido a OpenHuman',
  'welcome.subtitle':
    'Tu super inteligencia artificial personal. Privada, simple y extremadamente poderosa.',
  'welcome.connectPrompt': 'Configurar URL de RPC (Avanzado)',
  'welcome.selectRuntime': 'Seleccionar un runtime',
  'welcome.clearingAppData': 'Borrando datos de la aplicación...',
  'welcome.clearAppDataAndRestart': 'Borrar datos de la aplicación y reiniciar',
  'welcome.clearAppDataWarning':
    'Esto borra los secretos y las cuentas almacenados localmente en este dispositivo. Tu cuenta en la nube no se ve afectada; puedes volver a iniciar sesión inmediatamente.',
  'welcome.resetErrorFallback':
    'No se pudieron borrar los datos de la aplicación. Cierra y vuelve a abrir OpenHuman, luego inténtalo de nuevo.',
  'welcome.signingIn': 'Registrándote...',
  'welcome.termsIntro': 'Al continuar, aceptas las',
  'welcome.termsOfUse': 'Términos',
  'welcome.termsJoiner': 'y',
  'welcome.privacyPolicy': 'Política de privacidad',
  'welcome.termsOutro': '.',
  'welcome.urlPlaceholder': 'http://localhost:8089',
  'welcome.invalidUrl': 'Ingresa una URL HTTP o HTTPS válida',
  'welcome.connecting': 'Probando',
  'welcome.connect': 'Probar',
  'home.greeting': 'Buenos días',
  'home.greetingAfternoon': 'Buenas tardes',
  'home.greetingEvening': 'Buenas noches',
  'home.askAssistant': 'Pregúntale lo que quieras a tu asistente...',
  'home.statusOk': 'Tu asistente está listo cuando tú lo estés. Escribe algo abajo para empezar.',
  'home.statusBackendOnly':
    'Reconectando al backend… tu agente estará disponible nuevamente en breve.',
  'home.statusCoreUnreachable':
    'El proceso en segundo plano de OpenHuman no responde. Es posible que haya fallado o no haya podido iniciarse.',
  'home.statusInternetOffline':
    'Tu dispositivo está sin conexión. Verifica tu red o reinicia la app para reconectar.',
  'home.restartCore': 'Reiniciar core',
  'home.restartingCore': 'Reiniciando core…',
  'home.themeToggle.toLight': 'Cambiar a modo claro',
  'home.themeToggle.toDark': 'Cambiar a modo oscuro',
  'home.usageExhaustedTitle': 'Has agotado tu uso',
  'home.usageExhaustedBody':
    'Ya no te queda uso incluido por ahora. Inicia una suscripción para desbloquear más capacidad continua.',
  'home.usageExhaustedCta': 'Obtener una suscripción',
  'openrouterFree.cta': 'Usar modelos gratis de OpenRouter',
  'openrouterFree.saving': 'Conectando OpenRouter...',
  'openrouterFree.error':
    'No se pudo cambiar a los modelos gratis de OpenRouter. Revisa tu inicio de sesión de OpenRouter e inténtalo de nuevo.',
  'home.routinesCard': 'Tus rutinas',
  'home.routinesActive': '{count} activas',
  'routines.title': 'Tus rutinas',
  'routines.subtitle': 'Cosas que tu asistente hace automáticamente',
  'routines.loading': 'Cargando rutinas…',
  'routines.empty': 'Aún no hay rutinas',
  'routines.emptyHint':
    'Tu asistente puede ejecutar tareas según un horario, como informes matutinos o resúmenes diarios.',
  'routines.refresh': 'Refrescar',
  'routines.nextRun': 'Próxima carrera',
  'routines.lastRunSuccess': 'La última ejecución tuvo éxito',
  'routines.lastRunFailed': 'La última ejecución falló',
  'routines.notRunYet': 'Aún no se ha ejecutado',
  'routines.runNow': 'Corre ahora',
  'routines.running': 'Corriendo…',
  'routines.runNowTimedOut': 'Tiempo de espera agotado: actualiza e intenta de nuevo.',
  'routines.viewHistory': 'Ver historial',
  'routines.loadingHistory': 'Cargando…',
  'routines.noHistory': 'Aún no hay historial de ejecuciones.',
  'routines.statusSuccess': 'Éxito',
  'routines.statusError': 'Error',
  'routines.showOutput': 'Mostrar salida',
  'routines.hideOutput': 'Ocultar salida',
  'routines.toggleEnabled': 'Habilitar o deshabilitar esta rutina',
  'routines.typeAgent': 'Agente',
  'routines.typeCommand': 'Comando',
  'nav.routines': 'Routines',
  'chat.newThread': 'Nuevo hilo',
  'chat.newConversation': 'Nueva conversación',
  'chat.newWindowWelcome1': 'Hola, {name} 👋',
  'chat.newWindowWelcome2': 'Manos a la obra, {name} 🧑‍🍳.',
  'chat.newWindowWelcome3': 'Hora de concentrarse 🧘🏻',
  'chat.typeMessage': '¿En qué puedo ayudarte hoy?',
  'chat.send': 'Enviar mensaje',
  'chat.stopGeneration': 'Detener generación',
  'chat.stoppedByUser': 'Detenido',
  'chat.parallelBranchHint': 'Escribe una rama paralela: ⌘/Ctrl+Enter para enviar',
  'chat.followupHint':
    'Pon en cola un seguimiento: se envía tras esta respuesta · ⌘/Ctrl+Enter para una rama paralela',
  'chat.queuedFollowups.label': 'Seguimientos en cola',
  'chat.queuedFollowups.clear': 'Borrar',
  'chat.queuedFollowups.clearFailed': 'No se pudo vaciar la cola: inténtalo de nuevo.',
  'chat.createThreadFailed': 'No se pudo crear un nuevo hilo. Inténtalo de nuevo.',
  'chat.parallelBranchLabel': 'Rama paralela',
  'chat.thinking': 'Pensando...',
  'chat.noMessages': 'Sin mensajes aún',
  'chat.startConversation': 'Inicia una conversación',
  'chat.regenerate': 'Regenerar',
  'chat.copyResponse': 'Copiar respuesta',
  'chat.citations': 'Citas',
  'chat.toolUsed': 'Herramienta usada',
  'scope.legacy': 'Legado',
  'scope.user': 'Usuario',
  'scope.project': 'Proyecto',
  'skills.title': 'Conexiones',
  'skills.search': 'Buscar conexiones...',
  'skills.noResults': 'No se encontraron conexiones',
  'skills.loadingIntegrations': 'Cargando integraciones…',
  'skills.connect': 'Conectar',
  'skills.disconnect': 'Desconectar',
  'skills.configure': 'Administrar',
  'skills.connected': 'Conectado',
  'skills.available': 'Disponible',
  'skills.addAccount': 'Agregar cuenta',
  'skills.channels': 'Mensajería',
  'skills.explorer.emptyCta': 'Instalar desde URL',
  'skills.explorer.emptyDescription':
    'Instala un paquete SKILL.md o coloca carpetas estilo Hermes en ~/.openhuman/skills.',
  'skills.explorer.emptyTitle': 'No se encontraron skills',
  'skills.explorer.installFromUrl': 'Instalar desde URL',
  'skills.explorer.newSkill': 'Nueva skill',
  'skills.explorer.subtitle':
    'Explora paquetes SKILL.md, incluidos markdown, scripts, referencias, plantillas, ejemplos y prompts estilo Hermes.',
  'skills.explorer.title': 'Explorador de skills',
  'skills.explorer.searchPlaceholder': 'Buscar skills...',
  'skills.explorer.scopeUser': 'User',
  'skills.explorer.scopeProject': 'Project',
  'skills.explorer.scopeLegacy': 'Legacy',
  'skills.explorer.noDescription': 'No se proporcionó descripción.',
  'skills.explorer.uninstallSuccess': 'Skill desinstalada correctamente.',
  'skills.explorer.registryTab': 'Registro',
  'skills.explorer.installedTab': 'Instaladas',
  'skills.explorer.allFormats': 'Todos los formatos',
  'skills.explorer.refreshRegistry': 'Actualizar registro',
  'skills.explorer.registryEmptyTitle': 'Sin entradas en el registro',
  'skills.explorer.registryEmptyDescription':
    'No se pudo cargar el registro de habilidades. Verifique su conexión e intente actualizar.',
  'skills.explorer.showingOf':
    'Mostrando {shown} de {total} resultados. Refina tu búsqueda para ver más.',
  'skills.explorer.installed': 'Instalada',
  'skills.explorer.install': 'Instalar',
  'skills.explorer.installing': 'Instalando…',
  'skills.integrations': 'Integraciones de Composio',
  'skills.integrationsSubtitle':
    'Conexiones OAuth en la nube: inicia sesión con tu cuenta y Composio gestiona los tokens para que los agentes puedan leer y actuar en tu nombre. Sin claves de API que administrar.',
  'skills.composio.noApiKeyTitle': 'No hay una API key de Composio configurada',
  'skills.composio.noApiKeyDescription':
    'El modo local usa tu propia API key de Composio. Abre Ajustes → Avanzado → Composio para añadir una antes de conectar integraciones aquí.',
  'skills.composio.noApiKeyCta': 'Abrir en Ajustes',
  'skills.tabs.composio': 'Composio',
  'skills.tabs.channels': 'Canales',
  'skills.tabs.explorer': 'Skills',
  'skills.tabs.meetings': 'Reuniones de Google Meet',
  'skills.tabs.mcp': 'MCP Servidores',
  'connections.tabs.composio': 'Composio',
  'connections.tabs.channels': 'Canales',
  'connections.tabs.mcp': 'Servidores MCP',
  'connections.tabs.skills': 'Habilidades',
  'connections.tabs.meetings': 'Reuniones',
  'connections.groups.integrations': 'Integraciones',
  'connections.groups.desktop': 'Escritorio',
  'connections.tabs.oauth': 'OAuth',
  'connections.tabs.composioKey': 'Composio',
  'connections.groups.apiKeys': 'Claves de API',
  'connections.groups.intelligence': 'Inteligencia',
  'memory.title': 'Memoria',
  'memory.search': 'Buscar recuerdos...',
  'memory.noResults': 'No se encontraron recuerdos',
  'memory.empty': 'Sin recuerdos aún. Los recuerdos se crean automáticamente mientras interactúas.',
  'memory.tab.memory': 'Memoria',
  'memory.tab.memoryTree': 'Árbol de memoria',
  'memory.tab.tasks': 'Tareas',
  'memory.tab.tasksDescription':
    'Crea y realiza un seguimiento de tareas: tus propios pendientes más los tableros que tus agentes crean a lo largo de las conversaciones.',
  'memory.tab.subconscious': 'Subconsciente',
  'memory.tab.agentWork': 'Trabajo del agente',
  'memory.tab.agentWorkDescription':
    'Un centro de mando para cada ejecución de agente en segundo plano, agrupado según lo que necesita tu intervención, lo que está en curso y lo que ha terminado.',
  'memory.tab.worktrees': 'Worktrees',
  'memory.tab.worktreesDescription':
    'Worktrees de git aislados de los workers de agentes en paralelo: inspecciona los cambios, ábrelos o límpialos.',
  'memory.tab.teams': 'Equipos',
  'memory.tab.teamsDescription':
    'Equipos de agentes coordinados: quién se encarga de cada tarea, qué está bloqueado y qué se dicen los compañeros entre sí.',
  'memory.tab.agents': 'Biblioteca',
  'memory.tab.agentsDescription':
    'Explora y ejecuta los agentes disponibles: cada uno con sus propias herramientas, capacidades y área de enfoque.',
  'memory.tab.workflows': 'Workflows',
  'memory.tab.workflowsDescription':
    'Procedimientos reutilizables y ejecutables: un objetivo y los pasos para alcanzarlo. Crea uno, instala desde una URL o abre un flujo de trabajo para ejecutarlo.',
  'memory.tab.dreams': 'Sueños',
  'memory.tab.calls': 'Llamadas',
  'memory.tab.diagram': 'Diagram',
  'memory.tab.centrality': 'Centrality',
  'memory.tab.namespaces': 'Espacios de nombres',
  'memory.tab.timeline': 'Timeline',
  'memory.tab.settings': 'Configuración',
  'memory.analyzeNow': 'Analizar ahora',
  'memoryTimeline.title': 'Línea de tiempo de la memoria',
  'memoryTimeline.intro':
    'Cuándo el asistente aprendió sobre ti: hechos agrupados por el mes en que se reforzaron por última vez. Muestra crecimiento, picos de actividad y períodos tranquilos.',
  'memoryTimeline.loading': 'Construyendo la línea de tiempo…',
  'memoryTimeline.errorPrefix': 'No se pudo cargar el grafo:',
  'memoryTimeline.retry': 'Reintentar',
  'memoryTimeline.namespaceLabel': 'Espacio de nombres',
  'memoryTimeline.namespaceAll': 'Todos los espacios de nombres',
  'memoryTimeline.empty': 'Aún no hay grafo de conocimiento.',
  'memoryTimeline.emptyHint':
    'Cuando el asistente registre hechos sobre ti, la línea de tiempo aparecerá aquí.',
  'memoryTimeline.metricTotal': 'Hechos',
  'memoryTimeline.metricMonths': 'Meses activos',
  'memoryTimeline.metricRecent': 'Últimos 30 días',
  'memoryTimeline.heading': 'Hechos aprendidos por mes',
  'memoryTimeline.busiestCaption': 'Más activo: {period} ({count})',
  'memoryTimeline.undatedNote': '{count} hecho(s) sin fecha registrada.',
  'memoryTimeline.truncated': 'Mostrando los {shown} más recientes de {total} meses.',
  'namespaceOverview.title': 'Resumen de espacios de nombres',
  'namespaceOverview.intro':
    'Cómo se distribuye tu conocimiento entre contextos: el número de hechos y entidades distintas registradas en cada espacio de nombres.',
  'namespaceOverview.loading': 'Agregando espacios de nombres…',
  'namespaceOverview.errorPrefix': 'No se pudo cargar el gráfico:',
  'namespaceOverview.retry': 'Reintentar',
  'namespaceOverview.empty': 'Aún no hay gráfico de conocimiento.',
  'namespaceOverview.emptyHint':
    'A medida que el asistente registra hechos entre contextos, cada espacio de nombres aparecerá aquí.',
  'namespaceOverview.metricNamespaces': 'Espacios de nombres',
  'namespaceOverview.metricFacts': 'Hechos',
  'namespaceOverview.metricEntities': 'Entidades',
  'namespaceOverview.heading': 'Por espacio de nombres',
  'namespaceOverview.unnamespaced': '(sin espacio de nombres)',
  'namespaceOverview.factsLabel': '{count} hechos',
  'namespaceOverview.entitiesLabel': '{count} entidades',
  'namespaceOverview.entitiesShort': '{count} ent.',
  'namespaceOverview.truncated':
    'Mostrando los {shown} principales de {total} espacios de nombres.',
  'graphCentrality.title': 'Centralidad del gráfico de conocimiento',
  'graphCentrality.intro':
    'El PageRank sobre su gráfico de memoria muestra los centros de carga y las entidades conectoras que vinculan grupos que de otro modo estarían separados, que un recuento de frecuencia sin procesar no puede revelar.',
  'graphCentrality.loading': 'Centralidad informática…',
  'graphCentrality.errorPrefix': 'No se pudo cargar el gráfico:',
  'graphCentrality.retry': 'Rever',
  'graphCentrality.empty': 'Aún no hay gráfico de conocimiento.',
  'graphCentrality.emptyHint':
    'A medida que el asistente registre datos sobre usted, las entidades más conectadas aparecerán aquí.',
  'graphCentrality.namespaceLabel': 'Espacio de nombres',
  'graphCentrality.namespaceAll': 'Todos los espacios de nombres',
  'graphCentrality.metricEntities': 'Entidades',
  'graphCentrality.metricConnections': 'Conexiones',
  'graphCentrality.metricClusters': 'Clústeres',
  'graphCentrality.clustersCaption': 'Clústeres {components} · holdings más grandes {largest}',
  'graphCentrality.approximateBadge': 'aproximado',
  'graphCentrality.approximateTitle':
    'Se detuvo en el límite de iteración antes de converger completamente',
  'graphCentrality.rankedHeading': 'Principales entidades por influencia',
  'graphCentrality.colRank': '#',
  'graphCentrality.colEntity': 'Entidad',
  'graphCentrality.colInfluence': 'Influencia',
  'graphCentrality.colLinks': 'Campo de golf',
  'graphCentrality.bridgeBadge': 'conector',
  'graphCentrality.bridgeTitle': 'Conector: más influyente de lo que sugiere su número de enlaces',
  'graphCentrality.degreeTitle': '{in} entra · {out} sale',
  'memory.tab.associations': 'Associations',
  'entityAssociations.title': 'Asociaciones de entidades',
  'entityAssociations.intro':
    'Las entidades que comparten muchas conexiones están asociadas, incluso cuando ningún hecho las vincula directamente. La similitud de Jaccard revela estos emparejamientos ocultos.',
  'entityAssociations.loading': 'Calculando asociaciones…',
  'entityAssociations.errorPrefix': 'No se pudo cargar el grafo:',
  'entityAssociations.retry': 'Reintentar',
  'entityAssociations.empty': 'Aún no hay asociaciones.',
  'entityAssociations.emptyHint':
    'Cuando las entidades compartan conexiones, las asociaciones más fuertes aparecerán aquí.',
  'entityAssociations.namespaceLabel': 'Espacio de nombres',
  'entityAssociations.namespaceAll': 'Todos los espacios de nombres',
  'entityAssociations.metricEntities': 'Entidades',
  'entityAssociations.metricPairs': 'Asociaciones',
  'entityAssociations.rankedHeading': 'Asociaciones más fuertes',
  'entityAssociations.linkedBadge': 'vinculada',
  'entityAssociations.inferredBadge': 'inferida',
  'entityAssociations.linkedTitle': 'Estas entidades están conectadas directamente.',
  'entityAssociations.inferredTitle':
    'Sin enlace directo: asociadas solo a través de conexiones compartidas.',
  'entityAssociations.sharedLabel': '{shared} compartidas',
  'entityAssociations.pairTitle': '{jaccard}% similar · {shared} de {union} conexiones compartidas',
  'entityAssociations.truncated': 'Mostrando {shown} de {total}: las más fuertes primero.',
  'memory.tab.freshness': 'Freshness',
  'memoryFreshness.title': 'Frescura del conocimiento',
  'memoryFreshness.intro':
    'Los hechos que el asistente no ha reconfirmado recientemente decaen a lo largo de una curva de olvido. Esto muestra qué se está volviendo obsoleto y vale la pena volver a verificar, para no tratar hechos antiguos como certeros.',
  'memoryFreshness.loading': 'Calculando frescura…',
  'memoryFreshness.errorPrefix': 'No se pudo cargar el grafo:',
  'memoryFreshness.retry': 'Reintentar',
  'memoryFreshness.empty': 'Aún no hay grafo de conocimiento.',
  'memoryFreshness.emptyHint':
    'Cuando el asistente registre hechos sobre ti, su frescura se rastreará aquí.',
  'memoryFreshness.namespaceLabel': 'Espacio de nombres',
  'memoryFreshness.namespaceAll': 'Todos los espacios de nombres',
  'memoryFreshness.metricFresh': 'Fresco',
  'memoryFreshness.metricFading': 'Desvaneciendose',
  'memoryFreshness.metricStale': 'Obsoleto',
  'memoryFreshness.recallCaption': 'Recuperación promedio {recall}% en {total} hechos',
  'memoryFreshness.queueHeading': 'Cola de reconfirmación',
  'memoryFreshness.queueTruncated': 'Mostrando {shown} de {total}: atiende estos primero.',
  'memoryFreshness.allFresh': 'Todos los hechos siguen frescos: nada que reconfirmar.',
  'memoryFreshness.statusFading': 'desvaneciendose',
  'memoryFreshness.statusStale': 'obsoleto',
  'memoryFreshness.ageLabel': '{days} días',
  'memoryFreshness.recallTitle': '{recall}% recuperación · vida media {halfLife} días',
  'memory.tab.path': 'Rutas',
  'connectionPath.title': 'Ruta de conexión',
  'connectionPath.intro':
    'Rastrea la cadena de relaciones más corta que une dos entidades cualesquiera: cómo las conecta el grafo, incluso a través de varios saltos.',
  'connectionPath.loading': 'Cargando el grafo…',
  'connectionPath.errorPrefix': 'No se pudo cargar el grafo:',
  'connectionPath.retry': 'Reintentar',
  'connectionPath.namespaceLabel': 'Espacio de nombres',
  'connectionPath.namespaceAll': 'Todos los espacios de nombres',
  'connectionPath.sourceLabel': 'Desde',
  'connectionPath.targetLabel': 'Hasta',
  'connectionPath.sourcePlaceholder': 'Entidad inicial',
  'connectionPath.targetPlaceholder': 'Entidad final',
  'connectionPath.prompt': 'Elige dos entidades para rastrear cómo están conectadas.',
  'connectionPath.empty': 'Aún no hay grafo de conocimiento.',
  'connectionPath.emptyHint':
    'Cuando el asistente registre datos relacionados, podrás rastrear conexiones aquí.',
  'connectionPath.resultHeading': 'Ruta más corta',
  'connectionPath.pathSummary': 'A {length} salto(s) de distancia',
  'connectionPath.sameMessage': 'Elige dos entidades diferentes.',
  'connectionPath.missingSource': '«{entity}» no está en el grafo.',
  'connectionPath.missingTarget': '«{entity}» no está en el grafo.',
  'connectionPath.noPath': 'No se encontró ninguna conexión entre «{source}» y «{target}».',
  'memoryTree.status.title': 'Árbol de la memoria',
  'memoryTree.status.autoSyncLabel': 'Auto-sincronización',
  'memoryTree.status.autoSyncDescription':
    'Pausa para detener la nueva ingestión. El wiki existente sigue siendo consultable.',
  'memoryTree.status.statusTile': 'Estado',
  'memoryTree.status.lastSyncTile': 'Última sincronización',
  'memoryTree.status.totalChunksTile': 'Fragmentos totales',
  'memoryTree.status.wikiSizeTile': 'Tamaño de la wiki',
  'memoryTree.status.statusRunning': 'Corriendo',
  'memoryTree.status.statusPaused': 'Pausado',
  'memoryTree.status.statusSyncing': 'Sincronizando',
  'memoryTree.status.statusError': 'Error',
  'memoryTree.status.statusIdle': 'Inactivo',
  'memoryTree.status.never': 'Nunca',
  'memoryTree.status.fetchError': 'No se pudo obtener el estado del Árbol de Memoria',
  'memoryTree.status.retry': 'Rever',
  'memoryTree.status.retryFailed': 'Reintentar los trabajos fallidos',
  'memoryTree.status.retryFailedBusy': 'Reintentando...',
  'memoryTree.status.retryFailedDone': 'Trabajos fallidos añadidos de nuevo a la cola',
  'memoryTree.status.retryFailedCount': 'Trabajos en cola para ejecutarse de nuevo: {count}.',
  'memoryTree.status.retryFailedError':
    'No se pudieron volver a poner en cola los trabajos fallidos',
  'memoryTree.status.toggleFailed': 'No se pudo activar la sincronización automática',
  'memoryTree.status.justNow': 'justo ahora',
  'memoryTree.status.secondsAgo': '{count}s hace',
  'memoryTree.status.minuteAgo': 'Hace 1 minuto',
  'memoryTree.status.minutesAgo': '{count} hace un minuto',
  'memoryTree.status.hourAgo': 'Hace 1 hora',
  'memoryTree.status.hoursAgo': '{count} hace hr',
  'memoryTree.status.dayAgo': 'Hace 1 día',
  'memoryTree.status.daysAgo': '{count} hace días',
  'memoryTree.status.integrationsTitle': 'Estado por integración',
  'memoryTree.status.integrationsEmpty': 'No hay integraciones conectadas',
  'memoryTree.status.integrationActive': 'Activa',
  'memoryTree.status.integrationStale': 'Inactiva',
  'memoryTree.status.integrationChunks': 'Fragmentos: {count}',
  'alerts.title': 'Alertas',
  'alerts.empty': 'Sin alertas aún',
  'alerts.markAllRead': 'Marcar todo como leído',
  'alerts.unread': 'sin leer',
  'rewards.title': 'Recompensas',
  'rewards.referrals': 'Referidos',
  'rewards.coupons': 'Canjear',
  'rewards.localUnavailable':
    'El acceso local no obtiene recompensas, cupones ni crédito por referidos. Cierra sesión y continúa iniciando sesión con una cuenta de OpenHuman si quieres que las recompensas cuenten.',
  'rewards.localUnavailableCta': 'Abrir ajustes de la cuenta',
  'rewards.credits': 'Créditos',
  'rewards.referralCode': 'Tu código de referido',
  'rewards.copyCode': 'Copiar código',
  'rewards.share': 'Compartir',
  'onboarding.welcome': 'Hola. Soy OpenHuman.',
  'onboarding.welcomeDesc':
    'Tu asistente de IA superinteligente que corre en tu computadora. Privado, simple y extremadamente poderoso.',
  'onboarding.context': 'Recopilación de contexto',
  'onboarding.contextDesc': 'Conecta las herramientas y servicios que usas todos los días.',
  'onboarding.localAI': 'IA local',
  'onboarding.localAIDesc': 'Configura un modelo de IA local que corra en tu máquina.',
  'onboarding.chatProvider': 'Proveedor de chat',
  'onboarding.chatProviderDesc': 'Elige cómo quieres interactuar con tu asistente.',
  'onboarding.referral': 'Referido',
  'onboarding.referralDesc': 'Ingresa un código de referido si tienes uno.',
  'onboarding.finish': 'Finalizar configuración',
  'onboarding.finishDesc': '¡Todo listo! Empieza a usar OpenHuman.',
  'onboarding.skip': 'Omitir',
  'onboarding.getStarted': 'Empezar',
  'onboarding.runtimeChoice.title': '¿Cómo quieres ejecutar OpenHuman?',
  'onboarding.runtimeChoice.subtitle':
    'Elige la configuración que mejor se adapte a ti. Puedes cambiarlo más tarde en Configuración.',
  'onboarding.runtimeChoice.cloud.title': 'Sencillo',
  'onboarding.runtimeChoice.cloud.tagline': 'Deja que OpenHuman lo gestione todo por ti.',
  'onboarding.runtimeChoice.cloud.f1': 'Seguridad integrada',
  'onboarding.runtimeChoice.cloud.f2': 'Compresión de tokens para aprovechar más tu uso',
  'onboarding.runtimeChoice.cloud.f3': 'Una suscripción, todos los modelos incluidos',
  'onboarding.runtimeChoice.cloud.f4': 'Sin claves API que gestionar',
  'onboarding.runtimeChoice.cloud.f5': 'Fácil de configurar',
  'onboarding.runtimeChoice.custom.title': 'Personalizado',
  'onboarding.runtimeChoice.custom.tagline':
    'Usa tus propias claves. Control total sobre lo que usas.',
  'onboarding.runtimeChoice.custom.f1': 'Necesitarás claves API para casi todo',
  'onboarding.runtimeChoice.custom.f2': 'Reutiliza servicios por los que ya pagas',
  'onboarding.runtimeChoice.custom.f3': 'Puede ser gratuito si ejecutas todo localmente',
  'onboarding.runtimeChoice.custom.f4': 'Más configuración, más opciones',
  'onboarding.runtimeChoice.custom.f5': 'Ideal para usuarios avanzados y desarrolladores',
  'onboarding.runtimeChoice.cloud.creditHighlight': 'Créditos gratis al registrarte',
  'onboarding.runtimeChoice.continueCloud': 'Continuar con Simple',
  'onboarding.runtimeChoice.continueCustom': 'Continuar con Personalizado',
  'onboarding.runtimeChoice.recommended': 'Recomendado',
  'onboarding.runtimeChoice.exitError':
    'No se pudo completar el proceso de incorporación. Por favor, inténtalo de nuevo.',
  'onboarding.apiKeys.title': 'Agreguemos tus claves API',
  'onboarding.apiKeys.subtitle':
    'Puedes pegarlas ahora u omitir y agregarlas luego en Conexiones › claves API. Las claves se guardan en este dispositivo, cifradas en reposo.',
  'onboarding.apiKeys.openaiLabel': 'Clave API de OpenAI',
  'onboarding.apiKeys.openaiPlaceholder': 'sk-...',
  'onboarding.apiKeys.openaiOauthHint':
    'Utilice ChatGPT Plus/Pro (suscripción) o una clave OpenAI API; no se requieren ambas.',
  'onboarding.apiKeys.openaiOauthOpening': 'Abriendo inicio de sesión…',
  'onboarding.apiKeys.openaiOauthConnect': 'Iniciar sesión con ChatGPT',
  'onboarding.apiKeys.openaiOauthConnected': 'Conectado con ChatGPT',
  'onboarding.apiKeys.openaiOauthCallbackHint':
    'Después de iniciar sesión, pega la URL de redirección completa de tu navegador (empieza por {url}).',
  'onboarding.apiKeys.oauthDesktopOnly':
    'El inicio de sesión con ChatGPT solo está disponible en la aplicación de escritorio.',
  'onboarding.apiKeys.oauthStartFailed':
    'No se pudo iniciar el inicio de sesión con ChatGPT. Inténtalo de nuevo o usa una clave de API.',
  'onboarding.apiKeys.oauthPasteRedirect':
    'Pega la URL de redirección de tu navegador después de iniciar sesión.',
  'onboarding.apiKeys.oauthCompleteFailed':
    'El inicio de sesión con ChatGPT no se completó. Comprueba la URL de redirección e inténtalo de nuevo.',
  'onboarding.apiKeys.finishSignIn': 'Finalizar el inicio de sesión en ChatGPT',
  'onboarding.apiKeys.orApiKey': 'o tecla API',
  'onboarding.apiKeys.anthropicLabel': 'Clave API de Anthropic',
  'onboarding.apiKeys.anthropicPlaceholder': 'sk-ant-...',
  'onboarding.apiKeys.saveError': 'No se pudo guardar esa clave. Verifícala y vuelve a intentarlo.',
  'onboarding.apiKeys.skipForNow': 'Omitir por ahora',
  'onboarding.apiKeys.continue': 'Guardar y continuar',
  'onboarding.apiKeys.saving': 'Guardando…',
  'onboarding.custom.stepperInference': 'Inferencia',
  'onboarding.custom.stepperVoice': 'Voz',
  'onboarding.custom.stepperOAuth': 'OAuth',
  'onboarding.custom.stepperSearch': 'Búsqueda',
  'onboarding.custom.stepperEmbeddings': 'Embeddings',
  'onboarding.custom.stepperMemory': 'Memoria',
  'onboarding.custom.stepCounter': 'Paso {n} de {total}',
  'onboarding.custom.defaultTitle': 'Por defecto',
  'onboarding.custom.defaultSubtitle': 'Deja que OpenHuman lo gestione por ti.',
  'onboarding.custom.configureTitle': 'Configurar',
  'onboarding.custom.configureSubtitle': 'Yo elijo qué usar.',
  'onboarding.custom.progressAriaLabel': 'Progreso del onboarding',
  'onboarding.custom.continue': 'Continuar',
  'onboarding.custom.back': 'Atrás',
  'onboarding.custom.finish': 'Finalizar configuración',
  'onboarding.custom.configureLater':
    'Puedes terminar de configurar esto después del onboarding. Te llevaremos a la página de configuración correspondiente cuando termines.',
  'onboarding.custom.openSettings': 'Abrir en Configuración',
  'onboarding.custom.inference.title': 'Inferencia (Texto)',
  'onboarding.custom.inference.subtitle':
    '¿Qué modelo de lenguaje debe responder tus preguntas y ejecutar tus agentes?',
  'onboarding.custom.inference.defaultDesc':
    'OpenHuman dirige cada carga de trabajo a un modelo predeterminado adecuado. Sin claves, sin configuración.',
  'onboarding.custom.inference.configureDesc':
    'Usa tu propia clave de OpenAI o Anthropic. La usamos para todas las cargas de trabajo basadas en texto.',
  'onboarding.custom.voice.title': 'Voz',
  'onboarding.custom.voice.subtitle': 'Texto a voz y voz a texto para el modo de voz.',
  'onboarding.custom.voice.defaultDesc':
    'OpenHuman incluye STT/TTS gestionado que funciona de inmediato. Sin nada que configurar.',
  'onboarding.custom.voice.configureDesc':
    'Usa tu propio ElevenLabs / OpenAI Whisper / etc. Configura en Configuración › Voz.',
  'onboarding.custom.oauth.title': 'Conexiones (OAuth)',
  'onboarding.custom.oauth.subtitle':
    'Gmail, Slack, Notion y otros servicios conectados que necesitan OAuth.',
  'onboarding.custom.oauth.defaultDesc':
    'OpenHuman ejecuta un espacio de trabajo de Composio gestionado. Un clic para conectar cada servicio más tarde.',
  'onboarding.custom.oauth.configureDesc':
    'Usa tu propia cuenta / clave API de Composio. Configura en Configuración › Conexiones.',
  'onboarding.custom.search.title': 'Búsqueda web',
  'onboarding.custom.search.subtitle': 'Cómo OpenHuman busca en la web en tu nombre.',
  'onboarding.custom.search.defaultDesc':
    'OpenHuman usa un backend de búsqueda gestionado. Sin claves necesarias.',
  'onboarding.custom.search.configureDesc':
    'Usa tu propia clave de proveedor de búsqueda (Tavily, Brave, etc.). Configura en Configuración › Herramientas.',
  'onboarding.custom.embeddings.title': 'Embeddings',
  'onboarding.custom.embeddings.subtitle':
    'Cómo OpenHuman genera embeddings vectoriales para la búsqueda semántica en memoria.',
  'onboarding.custom.embeddings.defaultDesc':
    'OpenHuman usa un servicio de embeddings gestionado. No se necesita clave de API.',
  'onboarding.custom.embeddings.configureDesc':
    'Usa tu propio proveedor de embeddings (OpenAI, Voyage, Ollama, etc.).',
  'onboarding.custom.memory.title': 'Memoria',
  'onboarding.custom.memory.subtitle':
    'Cómo OpenHuman recuerda tu contexto, preferencias y conversaciones anteriores.',
  'onboarding.custom.memory.defaultDesc':
    'OpenHuman gestiona el almacenamiento y la recuperación de memoria automáticamente. Sin nada que configurar.',
  'onboarding.custom.memory.configureDesc':
    'Inspecciona, exporta o borra la memoria tú mismo. Configura en Configuración › Memoria.',
  'accounts.addAccount': 'Agregar cuenta',
  'accounts.addApps': 'Agregar apps',
  'accounts.manageAccounts': 'Administrar cuentas',
  'accounts.noAccounts': 'Sin cuentas conectadas',
  'accounts.connectAccount': 'Conecta una cuenta para empezar',
  'accounts.agent': 'Agente',
  'accounts.respondQueue': 'Cola de respuestas',
  'accounts.disconnect': 'Desconectar',
  'accounts.disconnectConfirm': '¿Seguro que quieres desconectar esta cuenta?',
  'accounts.disconnectClearMemory': 'Eliminar también la memoria de esta fuente',
  'accounts.disconnectClearMemoryHint':
    'Elimina permanentemente los fragmentos de memoria locales vinculados a esta conexión.',
  'accounts.searchAccounts': 'Buscar cuentas...',
  'channels.title': 'Canales',
  'channels.configure': 'Configurar canal',
  'channels.setup': 'Configurar',
  'channels.noChannels': 'Sin canales configurados',
  'channels.localManagedUnavailable':
    'Los canales gestionados no están disponibles para usuarios locales.',
  'channels.addChannel': 'Agregar canal',
  'channels.status.connected': 'Conectado',
  'channels.status.disconnected': 'Desconectado',
  'channels.status.error': 'error',
  'channels.status.configuring': 'Configurando',
  'channels.defaultMessaging': 'Canal de mensajería predeterminado',
  'channels.setAsDefault': 'Establecer como predeterminado',
  'channels.defaultBadge': 'Predeterminado',
  'webhooks.title': 'Ganchos web',
  'webhooks.create': 'Crear webhook',
  'webhooks.noWebhooks': 'Sin webhooks configurados',
  'webhooks.url': 'URL',
  'webhooks.secret': 'Secreto',
  'webhooks.events': 'Eventos',
  'webhooks.archiveDirectory': 'Directorio de archivo',
  'webhooks.todayFile': 'Archivo de hoy',
  'invites.title': 'Invitaciones',
  'invites.create': 'Crear invitación',
  'invites.noInvites': 'Sin invitaciones pendientes',
  'invites.code': 'Código de invitación',
  'invites.copyLink': 'Copiar enlace',
  'invites.generate': 'Generar invitación',
  'invites.generating': 'Generando...',
  'invites.refreshing': 'Actualizando invitaciones...',
  'invites.loading': 'Cargando invitaciones...',
  'invites.copyCodeAria': 'Copiar código de invitación',
  'invites.revokeAria': 'Revocar invitación',
  'invites.usedUp': 'Agotado',
  'invites.uses': 'Usos: {current}{max}',
  'invites.expiresOn': 'Expira el {date}',
  'invites.empty': 'Aún no hay invitaciones',
  'invites.emptyHint': 'Genera un código de invitación para compartir con otras personas',
  'invites.revokeTitle': 'Revocar código de invitación',
  'invites.revokePromptPrefix': '¿Estás seguro de que quieres revocar el código de invitación?',
  'invites.revokeWarning':
    'Este código de invitación dejará de ser válido y no podrá usarse para unirse al equipo.',
  'invites.revoking': 'Revocando...',
  'invites.revokeAction': 'Revocar invitación',
  'invites.failedGenerate': 'No se pudo generar la invitación',
  'invites.failedRevoke': 'No se pudo revocar la invitación',
  'team.refreshingMembers': 'Miembros refrescantes...',
  'team.loadingMembers': 'Cargando miembros...',
  'team.memberCount': '{count} miembro',
  'team.memberCountPlural': '{count} miembros',
  'team.you': '(tú)',
  'team.removeAria': 'Quitar {name}',
  'team.noMembers': 'No se encontraron miembros',
  'team.removeTitle': 'Eliminar miembro del equipo',
  'team.removePromptPrefix': '¿Estás seguro de que quieres eliminar?',
  'team.removePromptSuffix': 'del equipo?',
  'team.removeWarning': 'Perderán el acceso al equipo y a todos los recursos del equipo.',
  'team.removing': 'Eliminando...',
  'team.removeAction': 'Eliminar miembro',
  'team.changeRoleTitle': 'Cambiar rol de miembro',
  'team.changeRolePrompt': '¿Cambiar el rol de {name} de {oldRole} a {newRole}?',
  'team.changeRoleAdminGrant':
    'Esto les otorgará permisos completos de administrador, incluida la capacidad de gestionar miembros del equipo.',
  'team.changeRoleAdminRemove':
    'Esto eliminará sus permisos de administrador y ya no podrán gestionar el equipo.',
  'team.changing': 'Cambiando...',
  'team.changeRoleAction': 'Cambiar rol',
  'team.failedChangeRole': 'No se pudo cambiar el rol',
  'team.failedRemoveMember': 'No se pudo eliminar el miembro',
  'devOptions.title': 'Avanzado',
  'devOptions.titleDiagnostics': 'Desarrollador y Diagnóstico',
  'devOptions.diagnostics': 'Diagnósticos',
  'devOptions.diagnosticsDesc': 'Estado del sistema, registros y métricas de rendimiento',
  'devOptions.toolPolicyDiagnosticsDesc':
    'Inventario de herramientas, postura política, listas permitidas de MCP y bloqueos recientes',
  'devOptions.toolPolicyDiagnostics.loading': 'Cargando…',
  'devOptions.toolPolicyDiagnostics.unavailable': 'Diagnóstico no disponible',
  'devOptions.toolPolicyDiagnostics.posture.title': 'Postura política',
  'devOptions.toolPolicyDiagnostics.posture.autonomy': 'Autonomía:',
  'devOptions.toolPolicyDiagnostics.posture.workspaceOnly': 'Solo espacio de trabajo:',
  'devOptions.toolPolicyDiagnostics.posture.maxActionsPerHour': 'Máximo actions/hr:',
  'devOptions.toolPolicyDiagnostics.posture.approvalMediumRisk': 'Aprobación (riesgo medio):',
  'devOptions.toolPolicyDiagnostics.posture.blockHighRisk': 'Bloquear alto riesgo:',
  'devOptions.toolPolicyDiagnostics.inventory.title': 'Inventario',
  'devOptions.toolPolicyDiagnostics.inventory.totalTools': 'herramientas totales',
  'devOptions.toolPolicyDiagnostics.inventory.enabledTools': 'Herramientas habilitadas',
  'devOptions.toolPolicyDiagnostics.inventory.mcpStdioTools': 'Herramientas estándar MCP',
  'devOptions.toolPolicyDiagnostics.inventory.jsonRpcTools': 'Herramientas JSON-RPC',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.title': 'Listas permitidas de MCP',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.summary':
    'Habilitado: {enabled} · Servidores: {enabledCount}/{totalCount}',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.unnamed': '<sin nombre>',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.allowDeny':
    'permitir={allowCount} negar={denyCount}',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.title': 'Auditoría de escritura MCP',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.summary':
    'Habilitado: {enabled} · Reciente (24h): {recentRows}',
  'devOptions.toolPolicyDiagnostics.recentBlocked.title': 'Llamadas bloqueadas recientes',
  'devOptions.toolPolicyDiagnostics.recentBlocked.empty': 'No se registraron llamadas bloqueadas.',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.title': 'Superficies redactadas',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.summary':
    'Capacidad de escritura: {writeCount} · Superficies de política: {policyCount}',
  'devOptions.debugPanels': 'Paneles de depuración',
  'devOptions.debugPanelsDesc':
    'Banderas de funciones, inspección de estado y herramientas de depuración',
  'devOptions.webhooks': 'Ganchos web',
  'devOptions.webhooksDesc': 'Configurar y probar integraciones de webhook',
  'devOptions.memoryInspection': 'Inspección de memoria',
  'devOptions.memoryInspectionDesc': 'Explorar, consultar y administrar entradas de memoria',
  'voice.pushToTalk': 'Pulsar para hablar',
  'voice.recording': 'Grabando...',
  'voice.processing': 'Procesando...',
  'voice.languageHint': 'Idioma',
  'misc.rehydrating': 'Cargando tus datos...',
  'misc.checkingServices': 'Verificando servicios...',
  'misc.serviceUnavailable': 'Servicio no disponible',
  'misc.somethingWentWrong': 'Algo salió mal',
  'misc.tryAgainLater': 'Por favor, inténtalo más tarde.',
  'misc.restartApp': 'Reiniciar app',
  'misc.updateAvailable': 'Actualización disponible',
  'misc.updateNow': 'Actualizar ahora',
  'misc.updateLater': 'Después',
  'misc.downloading': 'Descargando...',
  'misc.installing': 'Instalando...',
  'misc.beta':
    'OpenHuman está en beta temprana. No dudes en compartir comentarios o reportar cualquier error que encuentres: cada reporte nos ayuda a mejorar más rápido.',
  'misc.betaFeedback': 'Enviar comentarios',
  'mnemonic.title': 'Frase de recuperación',
  'mnemonic.warning': 'Escribe estas palabras en orden y guárdalas en un lugar seguro.',
  'mnemonic.copyWarning':
    'Nunca compartas tu frase de recuperación. Cualquiera con estas palabras puede acceder a tu cuenta.',
  'mnemonic.copied': 'Frase de recuperación copiada al portapapeles',
  'mnemonic.reveal': 'Mostrar frase',
  'mnemonic.revealPhrase': 'Mostrar frase de recuperación',
  'mnemonic.hidden': 'La frase de recuperación está oculta',
  'privacy.title': 'Privacidad y seguridad',
  'privacy.description': 'Informe de transparencia de datos enviados a servicios externos.',
  'privacy.empty': 'No se detectaron transferencias de datos externas.',
  'privacy.whatLeavesComputer': 'Qué sale de tu computadora',
  'privacy.loading': 'Cargando detalles de privacidad...',
  'privacy.loadError':
    'No se pudo cargar la lista de privacidad en vivo. Los controles de análisis a continuación aún funcionan.',
  'privacy.noCapabilities': 'Ninguna capacidad divulga movimiento de datos actualmente.',
  'privacy.sentTo': 'Enviado a',
  'privacy.leavesDevice': 'Sale del dispositivo',
  'privacy.staysLocal': 'Se queda local',
  'privacy.anonymizedAnalytics': 'Analítica del producto',
  'privacy.shareAnonymizedData': 'Compartir analítica del producto y diagnósticos',
  'privacy.shareAnonymizedDataDesc':
    'Ayuda a mejorar OpenHuman compartiendo informes de fallos y eventos de uso con privacidad limitada, incluido un ID de cuenta estable y metadatos de la versión de la app. Nunca se recopilan mensajes, claves de billetera, claves API ni tokens de sesión.',
  'privacy.meetingFollowUps': 'Seguimientos de reuniones',
  'privacy.autoHandoffMeet':
    'Transferencia automática de transcripciones de Google Meet al orquestador',
  'privacy.autoHandoffMeetDesc':
    'Cuando termina una llamada de Google Meet, el orquestador de OpenHuman puede leer la transcripción y tomar acciones como redactar mensajes, programar seguimientos o publicar resúmenes en tu espacio de Slack conectado. Desactivado por defecto.',
  'privacy.analyticsDisclaimer':
    'Cuando está activado, la analítica del producto y los diagnósticos pueden incluir informes de fallos y eventos de uso con privacidad limitada, un ID de cuenta estable y metadatos de la versión de la app. Nunca se recopilan mensajes, claves de billetera, claves API ni tokens de sesión. Puedes cambiar esta configuración en cualquier momento.',
  'settings.about.version': 'Versión',
  'settings.about.updateAvailable': 'está disponible',
  'settings.about.softwareUpdates': 'Actualizaciones de software',
  'settings.about.lastChecked': 'Última verificación',
  'settings.about.checking': 'Verificando...',
  'settings.about.checkForUpdates': 'Buscar actualizaciones',
  'settings.about.releases': 'Versiones',
  'settings.about.releasesDesc':
    'Explora las notas de versión y compilaciones anteriores en GitHub.',
  'settings.about.openReleases': 'Abrir versiones en GitHub',
  'settings.about.starCta.title': '¿Te gusta OpenHuman?',
  'settings.about.starCta.body': 'Danos una estrella en GitHub. Así más gente nos encuentra.',
  'settings.about.starCta.star': 'Danos una estrella en GitHub',
  'settings.about.starCta.dismiss': 'Ahora no',
  'settings.about.connection': 'Conexión',
  'settings.about.connectionMode': 'Modo',
  'settings.about.connectionModeLocal': 'locales',
  'settings.about.connectionModeCloud': 'nube',
  'settings.about.connectionModeUnset': 'No seleccionado',
  'settings.about.serverUrl': 'Servidor URL',
  'settings.about.serverUrlUnavailable': 'No disponible',
  'settings.about.connectionHelperLocal':
    'Generado en el proceso por la shell Tauri al iniciar la aplicación. El puerto se elige al inicio, por lo que este URL cambia entre lanzamientos.',
  'settings.about.connectionHelperCloud':
    'Conectado a un núcleo remoto. Cambia esto en BootCheck o en el selector de modo en la nube.',
  'settings.heartbeat.title': 'Latidos y bucles',
  'settings.usage.title': 'Uso y límites',
  'settings.usage.menuDesc': 'Costos, uso de tokens, presupuestos y actividad en segundo plano',
  'settings.costDashboard.title': 'Panel de costos',
  'settings.costDashboard.sevenDayCost': 'Costo diario de 7 días',
  'settings.costDashboard.sevenDayTokens': 'Uso de token de 7 días',
  'settings.costDashboard.totalSpend': 'Total de 7 días',
  'settings.costDashboard.monthlyPace': 'Ritmo mensual',
  'settings.costDashboard.budgetLimit': 'Límite de presupuesto',
  'settings.costDashboard.utilization': 'Uso',
  'settings.costDashboard.modelBreakdown': 'Desglose por modelo',
  'settings.costDashboard.model': 'Modelo',
  'settings.costDashboard.provider': 'proveedor',
  'settings.costDashboard.cost': 'Costo',
  'settings.costDashboard.tokens': 'Fichas',
  'settings.costDashboard.requests': 'Solicitudes',
  'settings.costDashboard.percentOfTotal': '% del total',
  'settings.costDashboard.inputTokens': 'entrado',
  'settings.costDashboard.outputTokens': 'Salida',
  'settings.costDashboard.budgetNormal': 'En camino',
  'settings.costDashboard.budgetWarning': 'Advertencia',
  'settings.costDashboard.budgetExceeded': 'Por encima del presupuesto',
  'settings.costDashboard.noBudget': 'Sin límite establecido',
  'settings.costDashboard.noData': 'No se ha registrado ningún costo en los últimos 7 días.',
  'settings.costDashboard.noModels': 'No hay actividad del modelo en los últimos 7 días.',
  'settings.costDashboard.loading': 'Cargando panel de costos…',
  'settings.costDashboard.disabledHint':
    'El panel de costos está deshabilitado en la configuración. Configure [cost.dashboard] enabled = true en config.toml para volver a habilitarlo.',
  'settings.costDashboard.subtitle':
    'Gasto en vivo y quema de tokens en todo el enjambre. Las barras se actualizan automáticamente cada pocos segundos: no se necesita recargar la página.',
  'settings.costDashboard.summaryAriaLabel': 'Métricas de resumen de costos',
  'settings.costDashboard.lastSevenDays': 'últimos 7 días',
  'settings.costDashboard.utilizationOf': 'de',
  'settings.costDashboard.thisMonth': 'este mes',
  'settings.costDashboard.monthlyPaceHint':
    'Gasto mensual proyectado al ritmo diario actual (promedio × 30).',
  'settings.costDashboard.budgetLimitHint':
    'Presupuesto mensual leído de cost.monthly_limit_usd en config.toml.',
  'settings.costDashboard.dailyTarget': 'Objetivo diario',
  'settings.costDashboard.today': 'Hoy',
  'settings.costDashboard.todayBadge': 'HOY',
  'settings.costDashboard.unknownProvider': 'Ninguno',
  'settings.costDashboard.justNow': 'Hace un momento',
  'settings.costDashboard.secondsAgo': '{value}s hace',
  'settings.costDashboard.minutesAgo': '{value}m hace',
  'settings.costDashboard.hoursAgo': '{value}h hace',
  'settings.costDashboard.daysAgo': '{value}d hace',
  'settings.costDashboard.updated': 'Actualizado',
  'settings.costDashboard.refresh': 'Refrescar',
  'settings.costDashboard.utcNote': 'Días agrupados en UTC',
  'settings.costDashboard.stackedNote': 'Entrada + salida apiladas',
  'settings.costDashboard.modelBreakdownHint': 'Agregado a lo largo de los últimos 7 días.',
  'settings.costDashboard.categoryDistribution': 'Gasto por categoría',
  'settings.costDashboard.categoryDistributionHint':
    'Inferido de registros recientes de chat, embeddings, voz, imagen y reranking.',
  'settings.costDashboard.noCategories': 'Aún no hay gasto por categoría registrado.',
  'settings.costDashboard.categoryMeta': '{requests} solicitudes • {tokens} tokens',
  'settings.costDashboard.usageLog': 'Registro de uso',
  'settings.costDashboard.usageLogHint':
    'Registros más recientes de los últimos {days} días, con límite de {limit} filas.',
  'settings.costDashboard.logTotal': '{requests} solicitudes • {cost}',
  'settings.costDashboard.noUsageLog': 'No se encontraron registros de uso para este periodo.',
  'settings.costDashboard.when': 'Cuándo',
  'settings.costDashboard.category': 'Categoría',
  'settings.costDashboard.session': 'Sesión',
  'settings.costDashboard.noDataHint':
    'Envía un mensaje de agente: el uso de tokens de la próxima llamada al proveedor se mostrará en el gráfico en aproximadamente 10 segundos.',
  'settings.search.title': 'motor de búsqueda',
  'settings.search.menuDesc':
    'Por defecto, usa la búsqueda gestionada por OpenHuman o conecta tu propio proveedor con una clave API.',
  'settings.search.description':
    'Elige el motor de búsqueda que usa el agente, o deshabilita las herramientas de búsqueda por completo. Gestionado usa el backend de OpenHuman (sin configuración). Parallel, Brave, Querit y Exa se ejecutan directamente desde tu máquina usando tu clave de API.',
  'settings.search.engineAria': 'motor de búsqueda',
  'settings.search.engineDisabledLabel': 'Disabled',
  'settings.search.engineDisabledDesc':
    'Elimina las herramientas de búsqueda del contexto del agente y de la lista de herramientas disponibles.',
  'settings.search.engineManagedLabel': 'OpenHuman Gestionado',
  'settings.search.engineManagedDesc':
    'Predeterminado. Enrutado a través del backend de OpenHuman, actualmente con tecnología de Exa: no se requiere clave API.',
  'settings.search.localManagedUnavailable':
    'La búsqueda gestionada por OpenHuman no está disponible para usuarios locales. Añade tu propia API key de Parallel, Brave, Querit o Exa para habilitar la búsqueda web.',
  'settings.search.engineParallelLabel': 'paralelo',
  'settings.search.engineParallelDesc':
    'Direct Parallel API: buscar, extraer, chatear, investigar, enriquecer, herramientas de conjuntos de datos.',
  'settings.search.engineBraveLabel': 'Brave Buscar',
  'settings.search.engineBraveDesc':
    'Búsqueda Directa Brave API: herramientas web, de noticias, de imágenes y de videos.',
  'settings.search.engineQueritLabel': 'Quiere',
  'settings.search.engineQueritDesc':
    'Direct Querit API: búsqueda web con filtros de sitio, rango de tiempo, país e idioma.',
  'settings.search.engineExaLabel': 'Exa',
  'settings.search.engineExaDesc':
    'Búsqueda neuronal con tecnología de Exa. Requiere tu propia API key de Exa. Añade herramientas de búsqueda, páginas similares y contenido de páginas.',
  'settings.search.statusConfigured': 'Configurado',
  'settings.search.statusNeedsKey': 'Necesita la clave API',
  'settings.search.fallbackToManaged':
    'No se ha configurado ninguna clave: la búsqueda volverá a Managed hasta que se guarde una clave.',
  'settings.search.getApiKey': 'Obtener la clave API',
  'settings.search.save': 'Guardar',
  'settings.search.clear': 'Borrar',
  'settings.search.show': 'Mostrar',
  'settings.search.hide': 'Ocultar',
  'settings.search.statusSaving': 'Guardando…',
  'settings.search.statusSaved': 'Guardado.',
  'settings.search.statusError': 'Fallido',
  'settings.search.parallelKeyLabel': 'Parallel API clave',
  'settings.search.braveKeyLabel': 'Brave Buscar clave API',
  'settings.search.queritKeyLabel': 'Querit clave API',
  'settings.search.exaKeyLabel': 'Clave API de Exa',
  'settings.search.placeholderStored': '•••••••• (almacenado)',
  'settings.search.placeholderParallel': 'pk_...',
  'settings.search.placeholderBrave': 'BSA...',
  'settings.search.placeholderQuerit': 'Querit clave API',
  'settings.search.placeholderExa': 'Pega tu clave API de Exa…',
  'settings.search.allowedSitesLabel': 'Sitios web permitidos',
  'settings.search.allowedSitesHint':
    'Hosts que el asistente puede abrir y leer (mediante recuperación web y la herramienta de navegador) uno por línea, p. ej. reuters.com. Un host también incluye sus subdominios. La búsqueda web en sí no está restringida por esta lista.',
  'settings.search.allowedSitesAllOn':
    'El asistente puede abrir cualquier sitio web público. Las direcciones locales y privadas permanecen bloqueadas.',
  'settings.search.allowedSitesPlaceholder': 'reuters.com\napnews.com\ngithub.com',
  'settings.search.allowedSitesSave': 'Guardar sitios web',
  'settings.search.accessModeAria': 'Modo de acceso web',
  'settings.search.accessAllowAll': 'Permitir todo',
  'settings.search.accessCustom': 'Personalizado',
  'settings.search.accessBlockAll': 'Bloquear todo',
  'settings.search.accessBlockAllHint':
    'Todo el acceso web está bloqueado: el asistente no puede abrir ni leer ningún sitio web.',
  // ─── Settings global search bar ────────────────────────────
  'settings.settingsSearch.placeholder': 'Buscar ajustes…',
  'settings.settingsSearch.ariaLabel': 'Buscar ajustes',
  'settings.settingsSearch.clear': 'Borrar búsqueda',
  'settings.settingsSearch.resultsLabel': 'Resultados de búsqueda',
  'settings.settingsSearch.noResults': 'No se encontraron ajustes para «{query}»',
  'settings.embeddings.title': 'Incrustaciones',
  'settings.embeddings.description':
    'Elige qué proveedor de embeddings convierte la memoria en vectores para la búsqueda semántica. Cambiar el proveedor, modelo o dimensiones invalida los vectores almacenados y requiere un reinicio completo de la memoria.',
  'settings.embeddings.providerAria': 'Proveedor de embeddings',
  'settings.embeddings.statusConfigured': 'Configurado',
  'settings.embeddings.statusNeedsKey': 'Necesita clave API',
  'settings.embeddings.requiresSignIn': 'Requiere iniciar sesión en OpenHuman',
  'settings.embeddings.managedLoginRequired':
    'Los embeddings administrados requieren iniciar sesión en OpenHuman. Inicia sesión para usar el backend de OpenHuman.',
  'settings.embeddings.managedBannerIntro':
    'Los embeddings administrados se enrutan por el backend de OpenHuman y requieren una sesión de cuenta de OpenHuman.',
  'settings.embeddings.managedBannerLocalSession':
    'Sal de la sesión local e inicia sesión para usar este proveedor, o cambia a un proveedor de embeddings local o con tu propia clave.',
  'settings.embeddings.managedBannerRemoteSession':
    'Vuelve a iniciar sesión para actualizar tu sesión de OpenHuman, o cambia a un proveedor de embeddings local o con tu propia clave.',
  'settings.embeddings.signInAgain': 'Volver a iniciar sesión',
  'settings.embeddings.apiKeyLabel': 'Clave API de {provider}',
  'settings.embeddings.apiKeyLabelGeneric': 'Clave de API',
  'settings.embeddings.placeholderStored': '•••••••• (almacenado)',
  'settings.embeddings.placeholderKey': 'Pega tu clave API…',
  'settings.embeddings.keyStoredEncrypted': 'Tu clave API se almacena cifrada en este dispositivo.',
  'settings.embeddings.show': 'Mostrar',
  'settings.embeddings.hide': 'Ocultar',
  'settings.embeddings.save': 'Guardar',
  'settings.embeddings.clear': 'Borrar',
  'settings.embeddings.model': 'Modelo',
  'settings.embeddings.dimensions': 'Dimensiones',
  'settings.embeddings.customEndpoint': 'Endpoint personalizado',
  'settings.embeddings.customModelPlaceholder': 'Nombre del modelo',
  'settings.embeddings.customDimsPlaceholder': 'Se atenúa',
  'settings.embeddings.applyCustom': 'Aplicar',
  'settings.embeddings.testConnection': 'Probar conexión',
  'settings.embeddings.testing': 'Probando…',
  'settings.embeddings.testSuccess': 'Conectado: {dims} dimensiones',
  'settings.embeddings.connectionTestFailed': 'La prueba falló',
  'settings.embeddings.verifyFallback':
    'No se pudo verificar el endpoint de embeddings. Asegúrate de que esté en ejecución y sirviendo un modelo de embeddings, luego guarda de nuevo.',
  'settings.embeddings.testFailed': 'Fallido: {error}',
  'settings.embeddings.saving': 'Guardando…',
  'settings.embeddings.saved': 'Guardado.',
  'settings.embeddings.errorPrefix': 'Fallido',
  'settings.embeddings.wipeTitle': '¿Reiniciar vectores de memoria?',
  'settings.embeddings.wipeBody':
    'Cambiar el proveedor de embeddings, modelo o dimensiones borrará todos los vectores de memoria almacenados. La memoria debe reconstruirse antes de que la recuperación funcione de nuevo. Esto no se puede deshacer.',
  'settings.embeddings.cancel': 'Cancelar',
  'settings.embeddings.confirmWipe': 'Borrar y aplicar',
  'settings.embeddings.setupTitle': 'Configurar {provider}',
  'settings.embeddings.saveAndSwitch': 'Guardar y cambiar',
  'settings.embeddings.optional': 'opcional',
  'settings.embeddings.vectorSearchDisabled':
    'La búsqueda vectorial está desactivada. La recuperación de memoria utilizará únicamente la coincidencia de palabras clave y la actualidad: sin clasificación semántica.',
  'settings.embeddings.clearKey': 'Borrar clave API',
  'pages.settings.ai.embeddings': 'Incrustaciones',
  'pages.settings.ai.embeddingsDesc':
    'Modelo de codificación vectorial para recuperación de memoria',
  'mcp.alphaBadge': 'Alfa',
  'mcp.alphaBannerText':
    'La compatibilidad con el servidor MCP se encuentra en las primeras etapas alfa. El registro, el flujo de instalación y el cableado de herramientas pueden comportarse mal o cambiar de forma entre versiones.',
  'mcp.toolList.noTools': 'No hay herramientas disponibles.',
  'mcp.setup.secretDialog.title': 'Configuración MCP: ingresar secreto',
  'mcp.setup.secretDialog.bodyPrefix': 'El agente de configuración MCP necesita',
  'mcp.setup.secretDialog.bodySuffix':
    '. Su valor se envía directamente al proceso principal y nunca entra en la conversación AI.',
  'mcp.setup.secretDialog.inputLabel': 'Valor',
  'mcp.setup.secretDialog.inputPlaceholder': 'Pegar aquí',
  'mcp.setup.secretDialog.show': 'Mostrar',
  'mcp.setup.secretDialog.hide': 'Ocultar',
  'mcp.setup.secretDialog.submit': 'Enviar',
  'mcp.setup.secretDialog.cancel': 'Cancelar',
  'mcp.setup.secretDialog.submitting': 'Enviando…',
  'mcp.setup.secretDialog.errorPrefix': 'No se pudo enviar:',
  'mcp.setup.secretDialog.privacyNote':
    'Almacenado cifrado en la tabla de secretos local MCP. Nunca se registra ni se envía a un modelo.',
  'devices.betaBadge': 'Beta',
  'devices.betaText':
    'Esta función está actualmente en beta. Vincula teléfonos iOS con este OpenHuman para usarlos como cliente remoto.',
  'devices.comingSoonDescription':
    'El emparejamiento de dispositivos llegará pronto. Esta página será el lugar para emparejar iPhones y gestionar dispositivos conectados.',
  'devices.title': 'Dispositivos',
  'devices.pairIphone': 'Emparejar iPhone',
  'devices.noPaired': 'No hay dispositivos emparejados',
  'devices.emptyState': 'Escanee un QR code en su iPhone para conectarlo a esta sesión OpenHuman.',
  'devices.devicePairedTitle': 'Dispositivo emparejado',
  'devices.devicePairedMessage': 'iPhone conectado correctamente.',
  'devices.deviceRevokedTitle': 'Dispositivo revocado',
  'devices.deviceRevokedMessage': '{label} eliminado.',
  'devices.revokeFailedTitle': 'Revocar falló',
  'devices.online': 'En línea',
  'devices.offline': 'Sin conexión',
  'devices.lastSeenNever': 'nunca',
  'devices.lastSeenNow': 'Justo ahora',
  'devices.lastSeenMinutes': 'Hace {count}m',
  'devices.lastSeenHours': 'Hace {count}h',
  'devices.lastSeenDays': 'Hace {count}d',
  'devices.revoke': 'Revocar',
  'devices.revokeAria': 'Revocar {label}',
  'devices.confirmRevokeTitle': '¿Revocar dispositivo?',
  'devices.confirmRevokeBody': '{label} ya no podrá conectarse. Esta acción no se puede deshacer.',
  'devices.loadFailed': 'Error al cargar los dispositivos: {message}',
  'devices.pairModal.title': 'Emparejar iPhone',
  'devices.pairModal.loading': 'Generando código de emparejamiento…',
  'devices.pairModal.instructions': 'Abre la app de OpenHuman en tu iPhone y escanea este código.',
  'devices.pairModal.expiresIn': 'El código caduca en ~{count} minuto',
  'devices.pairModal.expiresInPlural': 'El código caduca en ~{count} minutos',
  'devices.pairModal.showDetails': 'Mostrar detalles',
  'devices.pairModal.hideDetails': 'Ocultar detalles',
  'devices.pairModal.channelId': 'ID de canal',
  'devices.pairModal.pairingUrl': 'Emparejamiento URL',
  'devices.pairModal.expiredTitle': 'El código QR expiró',
  'devices.pairModal.expiredBody': 'Genera un código nuevo para continuar con el emparejamiento.',
  'devices.pairModal.generateNewCode': 'Generar nuevo código',
  'devices.pairModal.successTitle': 'iPhone emparejado',
  'devices.pairModal.autoClose': 'Cerrando automáticamente…',
  'devices.pairModal.errorPrefix': 'No se pudo crear el emparejamiento: {message}',
  'devices.pairModal.errorTitle': 'Algo salió mal',
  'devices.pairModal.copyUrl': 'Copiar',
  'mcp.catalog.searchAria': 'Buscar catálogo de herrería',
  'mcp.catalog.searchPlaceholder': 'Buscar en el catálogo de Herrería...',
  'mcp.catalog.loadFailed': 'No se pudo cargar el catálogo',
  'mcp.registry.error.notFound':
    'No se encontró el servidor en el registro. Revisa el nombre e inténtalo de nuevo, explora los servidores MCP disponibles o añade el servidor manualmente por URL.',
  'mcp.registry.error.network':
    'No se pudo conectar con el registro MCP. Revisa tu conexión e inténtalo de nuevo, o añade el servidor manualmente por URL.',
  'mcp.registry.error.unavailable':
    'El registro MCP no está disponible ahora. Inténtalo más tarde, explora los servidores MCP disponibles o añade el servidor manualmente por URL.',
  'mcp.catalog.noResults': 'No se encontraron servidores.',
  'mcp.catalog.noResultsFor': 'No se encontraron servidores para "{query}".',
  'mcp.catalog.loadMore': 'Cargar más',
  'mcp.configAssistant.title': 'Asistente de configuración',
  'mcp.configAssistant.empty':
    'Pregunte sobre la configuración, las variables de entorno requeridas o los pasos de configuración.',
  'mcp.configAssistant.autoPromptCta': 'Obtener ayuda de configuración paso a paso',
  'mcp.configAssistant.suggestedValues': 'Valores sugeridos:',
  'mcp.configAssistant.valueHidden': '(valor oculto)',
  'mcp.configAssistant.applySuggested': 'Aplicar valores sugeridos',
  'mcp.configAssistant.reinstallHint': 'Vuelva a instalar con estos valores para aplicarlos.',
  'mcp.configAssistant.thinking': 'Pensando...',
  'mcp.configAssistant.inputPlaceholder':
    'Haga una pregunta (Intro para enviar, Mayús+Intro para nueva línea)',
  'mcp.configAssistant.send': 'enviar',
  'mcp.configAssistant.failedResponse': 'No se pudo obtener respuesta',
  'mcp.toolList.availableSingular': '{count} herramienta disponible',
  'mcp.toolList.availablePlural': '{count} herramientas disponibles',
  'mcp.toolList.tryTool': 'Intentar',
  'mcp.toolList.tryToolAria': 'Abrir el área de pruebas de ejecución para {name}',
  'mcp.playground.title': 'Ejecutar {name}',
  'mcp.playground.close': 'Cerrar el patio de recreo',
  'mcp.playground.inputSchema': 'Esquema de entrada',
  'mcp.playground.argsLabel': 'Argumentos (JSON)',
  'mcp.playground.argsHelp':
    'Escriba JSON que coincida con el esquema de entrada. La entrada vacía se trata como {}.',
  'mcp.playground.runShortcut': '⌘/Ctrl + Enter para ejecutar',
  'mcp.playground.format': 'Formato',
  'mcp.playground.invalidJson': 'JSON no válido',
  'mcp.playground.run': 'Ejecutar herramienta',
  'mcp.playground.running': 'Corriendo…',
  'mcp.playground.result': 'Resultado',
  'mcp.playground.resultError': 'La herramienta devolvió un error',
  'mcp.playground.copyResult': 'Copiar resultado',
  'mcp.playground.copied': 'copiado',
  'mcp.playground.history': 'Historia',
  'mcp.playground.historyEmpty': 'Aún no hay invocaciones en esta sesión.',
  'mcp.playground.historyLoad': 'Cargar',
  'mcp.playground.unexpectedError': 'Error inesperado al invocar la herramienta.',
  'mcp.catalog.deployed': 'Implementado',
  'mcp.catalog.installCount': '{count} instala',
  'app.update.dismissNotification': 'Descartar notificación de actualización',
  'bootCheck.rpcAuthSuffix': 'en cada RPC.',
  'app.localAiDownload.expandAria': 'Ampliar el progreso de la descarga',
  'app.localAiDownload.collapseAria': 'Contraer el progreso de la descarga',
  'app.localAiDownload.dismissAria': 'Descartar notificación de descarga',
  'mobile.nav.ariaLabel': 'Navegación móvil',
  'progress.stepsAria': 'Pasos de progreso',
  'progress.stepAria': 'Paso {current} de {total}',
  'workspace.vaultsTitle': 'Bóvedas de conocimiento',
  'workspace.vaultsDesc':
    'Apunte a una carpeta local; Los archivos se fragmentan y reflejan en la memoria.',
  'calls.title': 'llamadas',
  'calls.comingSoonBody':
    'Próximamente llegarán las llamadas asistidas por IA. Manténganse al tanto.',
  'art.rotatingTetrahedronAria': 'Nave espacial giratoria de tetraedro invertido',
  'mcp.installed.title': 'Instalado',
  'mcp.installed.browseCatalog': 'Explorar catálogo',
  'mcp.installed.empty': 'Aún no hay servidores MCP instalados.',
  'mcp.installed.toolSingular': 'herramienta {count}',
  'mcp.installed.toolPlural': '{count} herramientas',
  'mcp.health.title': 'Salud',
  'mcp.health.summaryAria': 'Resumen del estado de la conexión MCP',
  'mcp.health.connectedCount': '{count} conectado',
  'mcp.health.connectingCount': 'Conexión {count}',
  'mcp.health.errorCount': 'Error {count}',
  'mcp.health.disconnectedCount': '{count} inactivo',
  'mcp.health.retryAll': 'Reintentar todo ({count})',
  'mcp.health.retryAllAria': 'Vuelva a intentar todos los servidores MCP con errores {count}',
  'mcp.health.disconnectAll': 'Desconectar todo ({count})',
  'mcp.health.disconnectAllAria': 'Desconecte todos los servidores MCP conectados al {count}',
  'mcp.health.disconnectConfirm.title': '¿Desconectar todos los servidores MCP?',
  'mcp.health.disconnectConfirm.body':
    'Esto desconectará {count} servidores MCP conectados actualmente. Se conservan las configuraciones instaladas y los secretos; puedes volver a conectar cualquier servidor más tarde.',
  'mcp.health.disconnectConfirm.cancel': 'Cancelar',
  'mcp.health.disconnectConfirm.confirm': 'Desconectar todo',
  'mcp.health.opErrorGeneric': 'La operación masiva falló. Ver registros.',
  'mcp.health.bulkPartialFailure':
    '{failed} de {total} servidores fallaron. Consulta los registros.',
  'mcp.installed.search.landmarkAria': 'Buscar servidores MCP instalados',
  'mcp.installed.search.inputAria': 'Filtrar servidores MCP instalados por nombre',
  'mcp.installed.search.placeholder': 'Filtrar servidores…',
  'mcp.installed.search.clearAria': 'Limpiar filtro',
  'mcp.installed.search.countMatches': 'Servidores {shown} de {total}',
  'mcp.installed.search.noMatches': 'Ningún servidor coincide con "{query}".',
  'mcp.inventory.openButton': 'Inventario',
  'mcp.inventory.openAria': 'Abra el panel de inventario MCP compartible',
  'mcp.inventory.title': 'Inventario MCP compartible',
  'mcp.inventory.subtitle':
    'Exporte sus servidores MCP instalados como un manifiesto portátil y sin secretos, o importe uno de un compañero de equipo. Los valores de entorno secretos nunca se incluyen ni se importan.',
  'mcp.inventory.close': 'Cerrar panel de inventario',
  'mcp.inventory.tablistAria': 'Secciones de inventario',
  'mcp.inventory.tab.export': 'Exportar',
  'mcp.inventory.tab.import': 'Importar',
  'mcp.inventory.export.empty':
    'Aún no hay servidores MCP instalados: no hay nada que exportar. Primero instale uno del catálogo.',
  'mcp.inventory.export.privacyTitle': '¿Qué hay en este manifiesto?',
  'mcp.inventory.export.privacyBody':
    'Nombres de servidor, nombres calificados, NOMBRES CLAVE de variables de entorno y configuraciones no secretas únicamente. Los valores secretos, los identificadores de su máquina y las marcas de tiempo por instalación se eliminan intencionalmente.',
  'mcp.inventory.export.serverCount': 'Servidores {count} en este manifiesto',
  'mcp.inventory.export.copy': 'Copiar',
  'mcp.inventory.export.copied': 'copiado',
  'mcp.inventory.export.copyAria': 'Copie el manifiesto JSON al portapapeles.',
  'mcp.inventory.export.download': 'Descargar',
  'mcp.inventory.export.downloadAria': 'Descargue el manifiesto como un archivo JSON',
  'mcp.inventory.import.trustTitle':
    'Trate los manifiestos importados como código que no es de confianza',
  'mcp.inventory.import.trustBody':
    'Un servidor MCP es una herramienta que usted le otorga a su agente. Importe únicamente manifiestos de fuentes en las que confíe. Cada instalación requiere su clic explícito; nada se instala automáticamente.',
  'mcp.inventory.import.pasteLabel': 'Pegar manifiesto JSON',
  'mcp.inventory.import.pastePlaceholder':
    'Pegue un manifiesto aquí o cargue un archivo.json a continuación.',
  'mcp.inventory.import.preview': 'Avance',
  'mcp.inventory.import.clear': 'Claro',
  'mcp.inventory.import.uploadFile': 'o cargar un archivo.json',
  'mcp.inventory.import.uploadFileAria': 'Cargar un archivo.json de manifiesto',
  'mcp.inventory.import.fileTooLarge':
    'El archivo es demasiado grande (más de 1 MB). Negarse a cargar.',
  'mcp.inventory.import.fileReadFailed': 'No se pudo leer el archivo.',
  'mcp.inventory.import.parseErrorPrefix': 'No se pudo analizar el manifiesto:',
  'mcp.inventory.import.previewHeading': 'Avance',
  'mcp.inventory.import.previewCounts': 'Servidores {total}: {newly} nuevo, {already} ya instalado',
  'mcp.inventory.import.previewEmpty': 'El manifiesto no contiene servidores.',
  'mcp.inventory.import.exportedFrom': 'Exportado desde {exporter}',
  'mcp.inventory.import.exportedAt': 'en {when}',
  'mcp.inventory.import.statusNew': 'Nuevo',
  'mcp.inventory.import.statusAlreadyInstalled': 'Ya instalado',
  'mcp.inventory.import.envKeysLabel': 'Teclas ambientales',
  'mcp.inventory.import.install': 'Instalar',
  'mcp.inventory.import.installAria': 'Instale {name} desde este manifiesto',
  'mcp.inventory.import.skipped': 'omitido',
  'mcp.inventory.parseError.empty': 'El manifiesto está vacío.',
  'mcp.inventory.parseError.invalidJson': 'JSON no válido.',
  'mcp.inventory.parseError.rootNotObject': 'El manifiesto debe ser un objeto JSON en la raíz.',
  'mcp.inventory.parseError.unsupportedSchema':
    'Esquema de manifiesto no compatible: este archivo no fue generado por un exportador compatible.',
  'mcp.inventory.parseError.missingExportedAt': 'Campo `exported_at` faltante o no válido.',
  'mcp.inventory.parseError.missingExportedBy': 'Campo `exported_by` faltante o no válido.',
  'mcp.inventory.parseError.invalidServers': 'Matriz `servers` faltante o no válida.',
  'mcp.inventory.parseError.serverNotObject': 'Una entrada del servidor no es un objeto.',
  'mcp.inventory.parseError.serverMissingQualifiedName':
    'A una entrada del servidor le falta su nombre_calificado.',
  'mcp.inventory.parseError.serverMissingDisplayName':
    'A una entrada del servidor le falta su nombre para mostrar.',
  'mcp.inventory.parseError.serverEnvKeysNotArray':
    'Una entrada del servidor tiene un campo env_keys que no es una matriz de cadenas.',
  'mcp.inventory.parseError.serverContainsEnv':
    'Una entrada de servidor contiene un mapa de valores `env`. Negarse a importar: los manifiestos solo deben contener env_keys (nombres), nunca valores secretos.',
  'mcp.inventory.parseError.duplicateQualifiedName':
    'Nombre_calificado duplicado encontrado en el manifiesto. Cada servidor debe aparecer como máximo una vez.',
  'mcp.tab.loading': 'Cargando servidores MCP...',
  'mcp.tab.emptyDetail': 'Seleccione un servidor o explore el catálogo.',
  'mcp.tab.filter.all': 'Todos',
  'mcp.tab.filter.installed': 'Instalados ({count})',
  'mcp.tab.filter.registry': 'Registro',
  'mcp.tab.column.name': 'Nombre',
  'mcp.tab.column.description': 'Descripción',
  'mcp.tab.column.type': 'Tipo',
  'mcp.tab.column.author': 'Autor',
  'mcp.tab.column.action': 'Acción',
  'mcp.tab.transport.hosted': 'Alojado',
  'mcp.tab.transport.local': 'Stdio',
  'mcp.tab.transportFilter.label': 'Tipo',
  'mcp.tab.transportFilter.aria': 'Filtrar servidores por transporte',
  'mcp.tab.link.website': 'Sitio web',
  'mcp.tab.link.repo': 'Repositorio',
  'mcp.tab.transport.hostedHint':
    'Se ejecuta en un servidor remoto: el inicio de sesión o el token se configura al instalar',
  'mcp.tab.transport.localHint':
    'Se ejecuta en tu dispositivo: puede necesitar un token al instalar',
  'mcp.tab.officialBadge': 'Oficial',
  'mcp.tab.officialHint': 'Servidor oficial del proveedor',
  'mcp.tab.badge.installed': 'Instalado',
  'mcp.tab.badge.registry': 'Registro',
  'mcp.tab.action.manage': 'Gestionar',
  'mcp.tab.aria.viewDetails': 'Ver detalles de {name}',
  'mcp.tab.aria.installServer': 'Instalar {name}',
  'mcp.install.loadingDetail': 'Cargando detalles del servidor...',
  'mcp.install.back': 'volver',
  'mcp.install.title': 'Instalar {name}',
  'mcp.install.requiredEnv': 'Variables de entorno requeridas',
  'mcp.install.enterValue': 'Ingrese {key}',
  'mcp.install.show': 'Mostrar',
  'mcp.install.hide': 'Ocultar',
  'mcp.install.configLabel': 'Configuración (JSON opcional)',
  'mcp.install.configPlaceholder': '{"key": "value"}',
  'mcp.install.missingRequired': 'Se requiere "{key}"',
  'mcp.install.invalidJson': 'La configuración JSON no es JSON válida',
  'mcp.install.failedDetail': 'No se pudieron cargar los detalles del servidor',
  'mcp.install.failedInstall': 'La instalación falló',
  'mcp.install.button': 'Instalar',
  'mcp.install.installing': 'Instalando...',
  'mcp.install.by': 'por',
  'mcp.install.useCount': '{count} instalaciones',
  'mcp.install.connections': 'Conexiones disponibles',
  'mcp.install.published': 'publicado',
  'mcp.install.configureAndInstall': 'Configurar e instalar',
  'mcp.install.configureTitle': 'Configurar {name}',
  'mcp.install.advancedConfig': 'Configuración avanzada',
  'mcp.detail.suggestedEnvReady': 'Valores ambientales sugeridos listos',
  'mcp.detail.suggestedEnvBody':
    'Reinstale este servidor con los valores sugeridos para aplicarlos: {keys}',
  'mcp.detail.connect': 'Conectar',
  'mcp.detail.connecting': 'Conectando...',
  'mcp.detail.authenticate': 'Iniciar sesión',
  'mcp.detail.authRequired':
    'Este servidor necesita que inicies sesión o agregues un token de acceso antes de poder conectarse. Haz clic en “Iniciar sesión” para autenticarte.',
  'mcp.detail.disconnect': 'Desconectar',
  'mcp.detail.hideAssistant': 'Ocultar asistente',
  'mcp.detail.helpConfigure': 'Ayúdame a configurar',
  'mcp.detail.confirmUninstall': '¿Confirmar la desinstalación?',
  'mcp.detail.confirmUninstallAction': 'Sí, desinstalar',
  'mcp.detail.uninstall': 'Desinstalar',
  'mcp.detail.envVars': 'Variables ambientales',
  'mcp.detail.reconfigure': 'Reconfigurar',
  'mcp.detail.reconfigureHint':
    'Introduce nuevos valores para cada variable y vuelve a conectar. Esto reemplaza los valores guardados.',
  'mcp.detail.saveReconnect': 'Guardar y reconectar',
  'mcp.detail.reconfigureSaving': 'Guardando…',
  'mcp.detail.reconfigureSuccess': 'Entorno actualizado y reconectado.',
  'mcp.detail.reconfigureReconnectFailed':
    'Guardado, pero no se pudo reconectar con los nuevos valores.',
  'mcp.detail.enable': 'Habilitar',
  'mcp.detail.disable': 'Deshabilitar',
  'mcp.status.disabled': 'Deshabilitado',
  'mcp.status.unauthorized': 'Inicio de sesión necesario',
  'mcp.detail.tools': 'Herramientas',
  'mcp.connectAuth.title': 'Conectar {name}',
  'mcp.connectAuth.hint':
    'Agrega la autenticación que necesite este servidor y luego conéctate. Los tokens se almacenan cifrados. Déjalo en blanco para servidores que no requieran autenticación.',
  'mcp.connectAuth.requiredLabel': 'Obligatorio',
  'mcp.connectAuth.customHeadersLabel': 'Encabezados personalizados',
  'mcp.connectAuth.customHeadersEmpty':
    'No hay encabezados personalizados. Agrega uno si este servidor necesita un encabezado de autenticación que el registro no declaró.',
  'mcp.connectAuth.addHeader': '+ Agregar encabezado',
  'mcp.connectAuth.headerName': 'Nombre del encabezado',
  'mcp.connectAuth.headerValue': 'Valor',
  'mcp.connectAuth.removeHeader': 'Quitar encabezado',
  'mcp.connectAuth.howToGetToken': 'Ayuda y configuración',
  'mcp.connectAuth.tokenProvider': 'Consigue tu token en:',
  'mcp.connectAuth.findToken': '¿Dónde consigo el token?',
  'mcp.connectAuth.hideHelp': 'Ocultar ayuda',
  'mcp.connectAuth.schemeLabel': 'Cómo enviar el valor',
  'mcp.connectAuth.schemeBearer': 'Bearer',
  'mcp.connectAuth.schemeRaw': 'Ninguno',
  'mcp.connectAuth.reconnectFailed': 'Se guardaron las credenciales, pero la conexión falló.',
  'mcp.connectAuth.oauthHint':
    'Este servidor usa OAuth. Inicia sesión en tu navegador para autorizar a OpenHuman.',
  'mcp.connectAuth.signIn': 'Iniciar sesión con el navegador',
  'mcp.connectAuth.oauthWaiting': 'Esperando el inicio de sesión…',
  'mcp.connectAuth.oauthOrToken':
    '¿Ya tienes un token de acceso? Pégalo abajo como encabezado Authorization en su lugar.',
  'mcp.connectAuth.oauthTimeout':
    'Se agotó el tiempo de espera del inicio de sesión en el navegador. Inténtalo de nuevo.',
  'mcp.connectAuth.authError.oauthRequired':
    'Este servidor usa OAuth. Usa “Iniciar sesión con el navegador”: no se aceptará un token pegado.',
  'mcp.connectAuth.authError.tokenRejected':
    'El servidor rechazó este token. Comprueba que sea correcto y que no haya caducado.',
  'mcp.connectAuth.authError.credentialRequired':
    'Este servidor requiere autenticación. Agrega un token o inicia sesión.',
  'onboarding.skipForNow': 'Saltar por ahora',
  'onboarding.localAI.continueWithCloud': 'Continuar con la nube',
  'onboarding.localAI.useLocalAnyway':
    'Usar IA local de todos modos (no recomendado para tu dispositivo)',
  'onboarding.localAI.useLocalInstead': 'Utilice IA local en su lugar (conecte Ollama ahora)',
  'onboarding.localAI.setupIssue': 'La configuración local de la IA encontró un problema',
  'autonomy.title': 'Autonomía del agente',
  'autonomy.maxActionsLabel': 'Acciones máximas por hora',
  'autonomy.maxActionsHelp':
    'Número máximo de acciones de herramientas que un agente puede ejecutar por hora. El nuevo valor se aplica en tu próximo chat. Los trabajos cron y los oyentes de canales mantienen su límite actual hasta que reinicies OpenHuman.',
  'autonomy.statusSaving': 'Guardando…',
  'autonomy.statusSaved': 'Guardado.',
  'autonomy.statusFailed': 'Fallido',
  'autonomy.unlimitedNote': 'Ilimitado: limitación de velocidad deshabilitada.',
  'autonomy.invalidIntegerMsg':
    'Debe ser un número entero positivo (usa el ajuste preestablecido Sin límite para no tener límite).',
  'autonomy.presetUnlimited': 'Ilimitado (predeterminado)',
  'triggers.toggleFailed': '{action} falló para {trigger}: {message}',
  'settings.ai.overview': 'Resumen del sistema de IA',
  'settings.ai.configStatus': 'Estado de configuración',
  'settings.ai.fallbackMode': 'Modo de respaldo',
  'settings.ai.loadedFromRuntime': 'Cargado desde el runtime',
  'settings.ai.loadingDuration': 'Duración de carga',
  'settings.ai.localRuntime': 'Runtime de modelo local',
  'settings.ai.openManager': 'Abrir gestor',
  'settings.ai.retryDownload': 'Reintentar descarga',
  'settings.ai.state': 'Estado',
  'settings.ai.targetModel': 'Modelo objetivo',
  'settings.ai.download': 'Descargar',
  'settings.ai.localModelUnavailable': 'Estado del modelo local no disponible.',
  'settings.ai.soulConfig': 'Configuración de persona SOUL',
  'settings.ai.refreshing': 'Actualizando...',
  'settings.ai.refreshSoul': 'Actualizar SOUL',
  'settings.ai.loadingSoul': 'Cargando configuración de SOUL...',
  'settings.ai.identity': 'Identidad',
  'settings.ai.personality': 'Personalidad',
  'settings.ai.safetyRules': 'Reglas de seguridad',
  'settings.ai.source': 'Fuente',
  'settings.ai.loaded': 'Cargado',
  'settings.ai.toolsConfig': 'Configuración de TOOLS',
  'settings.ai.refreshTools': 'Actualizar TOOLS',
  'settings.ai.toolsAvailable': 'Herramientas disponibles',
  'settings.ai.tools': 'herramientas',
  'settings.ai.activeSkills': 'Skills activos',
  'settings.ai.skills': 'habilidades',
  'settings.ai.skillsOverview': 'Resumen de skills',
  'settings.ai.refreshingAll': 'Actualizando todo...',
  'settings.ai.refreshAll': 'Actualizar toda la configuración de IA',
  'settings.notifications.suppressAll': 'Suprimir todas las notificaciones',
  'settings.notifications.suppressAllDesc':
    'Bloquear todas las notificaciones del sistema de las apps integradas, independientemente del estado de foco.',
  'settings.notifications.toggleDnd': 'Activar/desactivar No molestar',
  'settings.notifications.categories': 'Categorías',
  'settings.notifications.categoryFooter':
    'Deshabilitar una categoría impide que aparezcan nuevas notificaciones de ese tipo en el centro de notificaciones. Las notificaciones existentes permanecen hasta que se eliminan.',
  'settings.billing.movedToWeb': 'La facturación se trasladó a la web',
  'settings.billing.openDashboard': 'Abrir panel de facturación',
  'settings.billing.movedToWebDesc':
    'Los cambios de suscripción, métodos de pago, créditos y facturas ahora se gestionan en TinyHumans en la web.',
  'settings.billing.backToSettings': 'Volver a configuración',
  'settings.billing.openingBrowser': 'Abriendo tu navegador...',
  'settings.billing.browserNotOpen': 'Si tu navegador no se abrió, usa el botón de arriba.',
  'settings.billing.browserOpenFailed':
    'No se pudo abrir el navegador automáticamente. Usa el botón de arriba.',
  'settings.tools.chooseCapabilities': 'Elige qué capacidades puede usar OpenHuman en tu nombre.',
  'settings.tools.saveChanges': 'Guardar cambios',
  'settings.tools.preferencesSaved': 'Preferencias guardadas',
  'settings.tools.saveFailed': 'No se pudieron guardar las preferencias. Inténtalo de nuevo.',
  'connections.comingSoon': 'Próximamente',
  'connections.setUp': 'Configurar',
  'connections.configured': 'Configurado',
  'connections.unavailable': 'No disponible',
  'connections.checking': 'Verificando…',
  'connections.walletConfigured':
    'Las identidades locales de EVM, BTC, Solana y Tron están configuradas desde tu frase de recuperación.',
  'connections.walletReady':
    'Configura identidades locales de EVM, BTC, Solana y Tron desde una sola frase de recuperación.',
  'connections.walletError':
    'No se pudo verificar el estado de la billetera. Toca para reintentar desde el panel de Frase de recuperación.',
  'connections.walletChecking': 'Verificando estado de la billetera...',
  'connections.walletIdentities': 'Identidades de billetera',
  'connections.walletDerived':
    'Derivadas localmente desde tu frase de recuperación y almacenadas solo como metadatos seguros.',
  'connections.privacySecurity': 'Privacidad y seguridad',
  'connections.privacySecurityDesc':
    'Todos los datos y credenciales se almacenan localmente con política de cero retención de datos. Tu información está cifrada y nunca se comparte con terceros.',
  'channels.status.connecting': 'Conectando',
  'channels.status.notConfigured': 'No configurado',
  'channels.noActiveRoute': 'Sin ruta activa',
  'channels.activeRoute': 'Ruta activa',
  'channels.loadingDefinitions': 'Cargando definiciones de canales...',
  'channels.channelConnections': 'Conexiones de canales',
  'channels.configureAuthModes':
    'Configura los modos de autenticación para cada canal de mensajería.',
  'channels.configNotAvailable': 'Configuración para',
  'channels.channel': 'canal',
  'devOptions.coreModeNotSet': 'Modo core: no establecido',
  'devOptions.coreModeNotSetDesc':
    'El selector de verificación de arranque aún no se ha confirmado. Usa Cambiar modo en el selector para elegir Local o Cloud.',
  'devOptions.local': 'locales',
  'devOptions.embeddedCoreSidecar': 'Core sidecar integrado',
  'devOptions.sidecarSpawned': 'Iniciado en proceso por el shell de Tauri al arrancar la app.',
  'devOptions.cloud': 'Nube',
  'devOptions.remoteCoreRpc': 'RPC de core remoto',
  'devOptions.token': 'ficha',
  'devOptions.tokenNotSet': 'no establecido: RPC devolverá 401',
  'devOptions.triggerSentryTest': 'Activar prueba de Sentry (staging)',
  'devOptions.triggerSentryTestDesc':
    'Dispara un error etiquetado para verificar el pipeline de Sentry. Issue #1072: eliminar después de la verificación.',
  'devOptions.sendTestEvent': 'Enviar evento de prueba',
  'devOptions.sending': 'Enviando…',
  'devOptions.eventSent': 'Evento enviado',
  'devOptions.sentryDisabled': '(sin identificación: Sentry deshabilitado en esta compilación)',
  'devOptions.failed': 'Fallido',
  'devOptions.appLogs': 'Registros de la app',
  'devOptions.appLogsDesc':
    'Abre la carpeta que contiene los archivos de registro diarios. Adjunta el archivo más reciente al reportar un problema.',
  'devOptions.openLogsFolder': 'Abrir carpeta de registros',
  'mnemonic.phraseSaved': 'Frase de recuperación guardada',
  'mnemonic.walletReady':
    'Las identidades de billetera multicadena están listas. Volviendo a configuración...',
  'mnemonic.writeDownWords': 'Anota estas',
  'mnemonic.wordsInOrder':
    'palabras en orden y guárdalas en un lugar seguro. Esta frase protege tu clave de cifrado local y tus identidades de billetera EVM, BTC, Solana y Tron.',
  'mnemonic.cannotRecover':
    'Esta frase no puede recuperarse si se pierde y debe permanecer completamente local en tu dispositivo.',
  'mnemonic.copyToClipboard': 'Copiar al portapapeles',
  'mnemonic.alreadyHavePhrase': 'Ya tengo una frase de recuperación',
  'mnemonic.consentSaved':
    'Guardé esta frase y consiento usarla para la configuración de billetera local',
  'mnemonic.enterPhraseToRestore':
    'Ingresa tu frase de recuperación a continuación para restaurar tus identidades de billetera local, o pega la frase completa en cualquier campo (12 palabras para respaldos nuevos; las frases de 24 palabras de versiones anteriores aún funcionan).',
  'mnemonic.words': 'Palabras',
  'mnemonic.validPhrase': 'Frase de recuperación válida',
  'mnemonic.generateNewPhrase': 'Generar una nueva frase de recuperación',
  'mnemonic.securingData': 'Protegiendo tus datos...',
  'mnemonic.saveRecoveryPhrase': 'Guardar frase de recuperación',
  'mnemonic.userNotLoaded': 'Usuario no cargado. Inicia sesión de nuevo o recarga la página.',
  'mnemonic.invalidPhrase':
    'Frase de recuperación inválida. Revisa las palabras e inténtalo de nuevo.',
  'mnemonic.somethingWentWrong': 'Algo salió mal. Inténtalo de nuevo.',
  'mnemonic.walletAlreadyConfigured': 'Tu billetera ya está configurada.',
  'mnemonic.walletSource': 'Origen',
  'mnemonic.walletWordCount': 'Longitud de la frase de recuperación',
  'mnemonic.walletLastUpdated': 'Última actualización',
  'mnemonic.replaceWallet': 'Reemplazar billetera',
  'mnemonic.replaceWalletWarning':
    'Esto reemplazará permanentemente tu billetera actual. Asegúrate de haber guardado tu frase de recuperación antes de continuar.',
  'mnemonic.replaceWalletConfirm': 'Entiendo, reemplazar mi billetera',
  'mnemonic.loadingWalletStatus': 'Verificando estado de la billetera...',
  'mnemonic.viewAccounts': 'Cuentas de la billetera',
  'mnemonic.revealRecoveryPhrase': 'Revelar frase de recuperación',
  'mnemonic.hidePhrase': 'Ocultar frase',
  'team.failedToCreate': 'No se pudo crear el equipo',
  'team.invalidInviteCode': 'Código de invitación inválido o expirado',
  'team.failedToSwitch': 'No se pudo cambiar de equipo',
  'team.failedToLeave': 'No se pudo salir del equipo',
  'team.role.owner': 'Propietario',
  'team.role.admin': 'Administrador',
  'team.role.billingManager': 'Gestor de facturación',
  'team.role.member': 'Miembro',
  'team.active': 'Activo',
  'team.personalTeam': 'Equipo personal',
  'team.manageTeam': 'Administrar equipo',
  'team.switching': 'Cambiando...',
  'team.switch': 'Cambiar',
  'team.leaving': 'Saliendo...',
  'team.leave': 'Salir',
  'team.yourTeams': 'Tus equipos',
  'team.createNewTeam': 'Crear nuevo equipo',
  'team.teamName': 'Nombre del equipo',
  'team.creating': 'Creando...',
  'team.joinExistingTeam': 'Unirse a un equipo existente',
  'team.personalAutoCreatedNote':
    'Tu equipo personal se crea automáticamente. Para colaborar, únete a un equipo existente con un código de invitación a continuación.',
  'team.inviteCode': 'Código de invitación',
  'team.joining': 'Uniéndose...',
  'team.join': 'Unirse',
  'team.leaveTeam': 'Salir del equipo',
  'team.confirmLeave': '¿Seguro que quieres salir de',
  'team.leaveWarning':
    'Perderás el acceso al equipo y todos sus recursos. Necesitarás una nueva invitación para volver a unirte.',
  'team.management': 'Gestión de equipo',
  'team.notFound': 'Equipo no encontrado',
  'team.accessDenied': 'Acceso denegado',
  'team.members': 'Miembros',
  'team.membersDesc': 'Administrar los miembros y roles del equipo',
  'team.invites': 'invita',
  'team.invitesDesc': 'Generar y administrar códigos de invitación',
  'team.settings': 'Configuración del equipo',
  'team.settingsDesc': 'Editar el nombre y la configuración del equipo',
  'team.editSettings': 'Editar configuración del equipo',
  'team.enterName': 'Introduce el nombre del equipo',
  'team.saving': 'Guardando...',
  'team.saveChanges': 'Guardar cambios',
  'team.delete': 'Eliminar equipo',
  'team.deleteDesc': 'Eliminar permanentemente este equipo',
  'team.deleting': 'Eliminando...',
  'team.failedToUpdate': 'No se pudo actualizar el equipo',
  'team.failedToDelete': 'No se pudo eliminar el equipo',
  'team.manageTitle': 'Administrar {name}',
  'team.planCreated': 'Plan {plan} • Creado {date}',
  'team.confirmDelete': '¿Está seguro de que desea eliminar {name}?',
  'team.deleteWarning':
    'Esta acción no se puede deshacer. Todos los datos del equipo serán eliminados permanentemente.',
  'voice.title': 'Dictado de voz',
  'voice.settings': 'Configuración de voz',
  'voice.settingsDesc':
    'Mantén presionada la tecla de acceso rápido para dictar e insertar texto en el campo activo.',
  'voice.hotkey': 'Tecla de acceso rápido',
  'voice.activationMode': 'Modo de activación',
  'voice.tapToToggle': 'Toca para alternar',
  'voice.writingStyle': 'Estilo de escritura',
  'voice.verbatimTranscription': 'Transcripción literal',
  'voice.naturalCleanup': 'Limpieza natural',
  'voice.autoStart': 'Iniciar servidor de voz automáticamente con el core',
  'voice.customDictionary': 'Diccionario personalizado',
  'voice.customDictionaryDesc':
    'Agrega nombres, términos técnicos y palabras de dominio para mejorar la precisión del reconocimiento.',
  'voice.addWord': 'Agregar una palabra...',
  'voice.sttDisabled':
    'El dictado de voz está desactivado hasta que el modelo STT local se descargue y esté listo.',
  'voice.openLocalAiModel': 'Abrir modelo de IA local',
  'voice.serverRestarted': 'Servidor de voz reiniciado con la nueva configuración.',
  'voice.settingsSaved': 'Configuración de voz guardada.',
  'voice.serverStarted': 'Servidor de voz iniciado.',
  'voice.serverStopped': 'Servidor de voz detenido.',
  'voice.saveVoiceSettings': 'Guardar configuración de voz',
  'voice.startVoiceServer': 'Iniciar servidor de voz',
  'voice.stopVoiceServer': 'Detener servidor de voz',
  'voice.debugTitle': 'Depuración de voz',
  'voice.failedToLoadSettings': 'No se pudo cargar la configuración de voz',
  'voice.failedToSaveSettings': 'No se pudo guardar la configuración de voz',
  'voice.failedToStartServer': 'No se pudo iniciar el servidor de voz',
  'voice.failedToStopServer': 'No se pudo detener el servidor de voz',
  'voice.sttDisabledPrefix':
    'La dictación por voz está desactivada hasta que se descargue el modelo STT local. Usa el',
  'voice.sttDisabledSuffix': 'sección anterior para instalar Whisper.',
  'voice.debug.failedToLoadVoiceDebugData': 'No se pudieron cargar los datos de depuración de voz',
  'voice.debug.settingsSaved': 'Configuración de depuración guardada.',
  'voice.debug.failedToSaveSettings': 'No se pudo guardar la configuración de voz',
  'voice.debug.runtimeStatus': 'Estado de tiempo de ejecución',
  'voice.debug.runtimeStatusDesc':
    'Diagnósticos en vivo para el servidor de voz y el motor de reconocimiento de voz.',
  'voice.debug.server': 'Servidor',
  'voice.debug.unavailable': 'No disponible',
  'voice.debug.ready': 'Listo',
  'voice.debug.notReady': 'No listo',
  'voice.debug.hotkey': 'tecla de acceso rápido',
  'voice.debug.notAvailable': 'n/a',
  'voice.debug.mode': 'Modo',
  'voice.debug.transcriptions': 'Transcripciones',
  'voice.debug.serverError': 'Error del servidor',
  'voice.debug.advancedSettings': 'Configuración avanzada',
  'voice.debug.advancedSettingsDesc':
    'Parámetros de ajuste de bajo nivel para la grabación y la detección de silencio.',
  'voice.debug.minimumRecordingSeconds': 'Segundos mínimos de grabación',
  'voice.debug.silenceThreshold': 'Umbral de silencio (RMS)',
  'voice.debug.silenceThresholdDesc':
    'Las grabaciones con energía por debajo de este valor se tratan como silencio y se omiten. Menor = más sensible.',
  'voice.debug.alwaysOn': 'Escucha continua',
  'voice.debug.alwaysOnDesc':
    'Mantén el micrófono abierto y envía lo que dices al agente automáticamente, sin atajo. Se pausa cuando la pantalla está bloqueada.',
  'voice.providers.saved': 'Proveedores de voz guardados.',
  'voice.providers.failedToSave': 'No se pudieron guardar los proveedores de voz',
  'voice.providers.ellipsis': '…',
  'voice.providers.installing': 'Instalación',
  'voice.providers.installingBusy': 'Instalando…',
  'voice.providers.reinstallLocally': 'Reinstalar localmente',
  'voice.providers.repair': 'Reparación',
  'voice.providers.retryLocally': 'Reintentar localmente',
  'voice.providers.installLocally': 'Instalar localmente',
  'voice.providers.whisperReady': 'El susurro está listo.',
  'voice.providers.whisperInstallStarted': 'Se inició la instalación de Whisper',
  'voice.providers.queued': 'en cola',
  'voice.providers.failedToInstallWhisper': 'No se pudo instalar Whisper',
  'voice.providers.piperReady': 'Piper está listo.',
  'voice.providers.piperInstallStarted': 'Instalación de Piper iniciada',
  'voice.providers.failedToInstallPiper': 'No se pudo instalar Piper',
  'voice.mode.title': 'Modo de voz',
  'voice.mode.desc': 'Elige cómo habla el asistente en la pestaña Human.',
  'voice.mode.realtime': 'Voz en tiempo real (beta)',
  'voice.mode.realtimeDesc': 'Mantén una conversación en directo en lugar de por turnos.',
  'voice.mode.start': 'Iniciar chat de voz',
  'voice.mode.stop': 'Finalizar chat de voz',
  'voice.mode.connecting': 'Conectando…',
  'voice.mode.listening': 'Escuchando',
  'voice.mode.speaking': 'Hablando',
  'voice.providers.title': 'Proveedores de voz',
  'voice.providers.desc':
    'Elige dónde se ejecutan la transcripción y la síntesis. Usa los botones Instalar localmente para descargar los binarios y modelos en tu espacio de trabajo. Los proveedores locales se pueden guardar antes de que finalice la instalación; no se requiere configuración manual de WHISPER_BIN o PIPER_BIN.',
  'voice.providers.sttProvider': 'Proveedor de voz a texto',
  'voice.providers.sttProviderAria': 'proveedor STT',
  'voice.providers.cloudWhisperProxy': 'Nube (proxy de susurro)',
  'voice.providers.localWhisper': 'Susurro local',
  'voice.providers.installRequired': ' (se requiere instalación)',
  'voice.providers.whisperInstalledTitle': 'Susurro está instalado. Haga clic para reinstalar.',
  'voice.providers.whisperDownloadTitle':
    'Descarga whisper.cpp y el modelo GGML en tu espacio de trabajo.',
  'voice.providers.installed': 'Instalado',
  'voice.providers.installFailed': 'La instalación falló',
  'voice.providers.notInstalled': 'No instalado',
  'voice.providers.whisperModel': 'Modelo susurro',
  'voice.providers.whisperModelAria': 'modelo susurro',
  'voice.providers.whisperModelTiny': 'Pequeño (39 MB, más rápido)',
  'voice.providers.whisperModelBase': 'Base (74 MB)',
  'voice.providers.whisperModelSmall': 'Pequeño (244 MB)',
  'voice.providers.whisperModelMedium': 'Mediano (769 MB, recomendado)',
  'voice.providers.whisperModelLargeTurbo': 'Turbo v3 grande (1,5 GB, mejor precisión)',
  'voice.providers.ttsProvider': 'Proveedor de texto a voz',
  'voice.providers.ttsProviderAria': 'Proveedor de TTS',
  'voice.providers.cloudElevenLabsProxy': 'Nube (proxy de ElevenLabs)',
  'voice.providers.localPiper': 'flautista local',
  'voice.providers.piperInstalledTitle': 'Piper está instalado. Haga clic para reinstalar.',
  'voice.providers.piperDownloadTitle':
    'Descarga Piper y la voz en_US-lessac-medium incluida en tu espacio de trabajo.',
  'voice.providers.piperVoice': 'voz de gaitero',
  'voice.providers.piperVoiceAria': 'voz de gaitero',
  'voice.providers.customVoiceOption': 'Otro (escriba a continuación)…',
  'voice.providers.customVoiceAria': 'Identificación de voz de Piper (personalizada)',
  'voice.providers.customVoicePlaceholder': 'es_US-lessac-medium',
  'voice.providers.piperVoicesDesc':
    'Las voces provienen de huggingface.co/rhasspy/piper-voices. Cambiar de voz puede requerir un clic en Instalar/Reinstalar para descargar el nuevo archivo .onnx.',
  'voice.providers.mascotVoice': 'Voz de mascota',
  'voice.providers.mascotVoiceDescPrefix':
    'La voz de ElevenLabs que usa la mascota para las respuestas habladas se configura en',
  'voice.providers.mascotSettings': 'Configuración de mascota',
  'voice.providers.mascotVoiceDescSuffix': '.',
  'voice.providers.hotkeyPlaceholder': 'fn',
  'voice.providers.piperPreset.lessacMedium': 'Estados Unidos · Lessac (neutral, recomendado)',
  'voice.providers.piperPreset.lessacHigh': 'EE.UU. · Lessac (mayor calidad, más grande)',
  'voice.providers.piperPreset.ryanMedium': 'Estados Unidos · Ryan (masculino)',
  'voice.providers.piperPreset.amyMedium': 'Estados Unidos · Amy (mujer)',
  'voice.providers.piperPreset.librittsHigh': 'Estados Unidos · LibriTTS (varios altavoces)',
  'voice.providers.piperPreset.alanMedium': 'ES · Alan (masculino)',
  'voice.providers.piperPreset.jennyDiocoMedium': 'GB · Jenny Dioco (mujer)',
  'voice.providers.piperPreset.northernEnglishMaleMedium': 'GB · Inglés del Norte (masculino)',
  'voice.providers.chip.cloud': 'OpenHuman (Gestionado)',
  'voice.providers.chip.cloudAria': 'El proveedor gestionado de OpenHuman está siempre habilitado',
  'voice.providers.chip.whisper': 'Whisper (Local)',
  'voice.providers.chip.enableWhisper': 'Activar Whisper STT local',
  'voice.providers.chip.disableWhisper': 'Desactivar Whisper STT local',
  'voice.providers.chip.piper': 'Piper (Local)',
  'voice.providers.chip.enablePiper': 'Activar Piper TTS local',
  'voice.providers.chip.disablePiper': 'Desactivar Piper TTS local',
  'voice.providers.chip.enableProvider': 'Enable',
  'voice.providers.chip.disableProvider': 'Disable',
  'voice.providers.chip.apiKeyLabel': 'Clave de API',
  'voice.providers.chip.apiKeyPlaceholder': 'sk-…',
  'voice.providers.chip.comingSoon': 'próximamente',
  'voice.modal.title': 'Configure',
  'voice.modal.desc':
    'Introduce tu clave de API para habilitar este proveedor. Puedes probar la conexión antes de guardar.',
  'voice.modal.testKey': 'Probar clave',
  'voice.modal.testing': 'Probando…',
  'voice.modal.saveAndEnable': 'Guardar y activar',
  'voice.modal.enable': 'Enable',
  'voice.modal.whisperDesc':
    'Elige un tamaño de modelo e instala el binario de Whisper y el modelo GGML en tu espacio de trabajo. Los modelos más grandes son más precisos pero más lentos.',
  'voice.modal.piperDesc':
    'Elige una voz e instala el binario de Piper y el modelo ONNX en tu espacio de trabajo. Piper funciona completamente sin conexión con baja latencia.',
  'voice.routing.title': 'Enrutamiento de voz',
  'voice.routing.desc':
    'Elige qué proveedores habilitados gestionan el reconocimiento y la síntesis de voz.',
  'voice.routing.save': 'Save',
  'voice.routing.testStt': 'Probar STT',
  'voice.routing.testTts': 'Probar TTS',
  'voice.routing.elevenlabsVoice': 'Voz de ElevenLabs',
  'voice.routing.elevenlabsVoiceAria': 'Selección de voz de ElevenLabs',
  'voice.routing.elevenlabsVoiceIdAria': 'ID de voz de ElevenLabs (personalizado)',
  'voice.routing.elevenlabsVoiceDesc':
    'Elige una voz seleccionada o pega un ID de voz personalizado desde tu panel de ElevenLabs.',
  'voice.externalProviders.title': 'Proveedores de voz externos',
  'voice.externalProviders.desc':
    'Conecta APIs de STT/TTS de terceros como Deepgram, ElevenLabs u OpenAI directamente.',
  'voice.externalProviders.keySet': 'Clave configurada',
  'voice.externalProviders.noKey': 'Sin clave de API',
  'voice.externalProviders.test': 'Test',
  'voice.externalProviders.testing': 'Probando…',
  'voice.externalProviders.remove': 'Remove',
  'voice.externalProviders.provider': 'Provider',
  'voice.externalProviders.selectProvider': 'Seleccionar un proveedor…',
  'voice.externalProviders.apiKey': 'Clave de API',
  'voice.externalProviders.apiKeyPlaceholder': 'sk-…',
  'voice.externalProviders.add': 'Add',
  'pttSettings.title': 'Pulsa para hablar',
  'pttSettings.description':
    'Mantén pulsada una tecla para hablar con OpenHuman mientras estás en otra aplicación. Al soltarla se envía la grabación; si tienes activada la opción «Leer las respuestas», OpenHuman las dice en voz alta.',
  'pttSettings.shortcutLabel': 'Atajo de teclado',
  'pttSettings.shortcutPlaceholder': 'Pulsa una tecla (p. ej. F13)',
  'pttSettings.shortcutUnsetHint':
    'Pulsa para hablar está desactivado: elige un atajo para activarlo.',
  'pttSettings.speakRepliesLabel': 'Leer las respuestas del agente en voz alta',
  'pttSettings.showOverlayLabel': 'Mostrar el panel mientras se mantiene pulsado',
  'pttSettings.errorConflictsWithDictation':
    'Este atajo ya lo usa el dictado. Elige una tecla distinta.',
  'pttSettings.errorModifierOnly':
    'Elige una tecla normal (p. ej. F13): los atajos compuestos solo por modificadores no funcionan para pulsa para hablar.',
  'pttSettings.errorEmpty': 'Elige una tecla para asignarla.',
  'pttSettings.errorAccessibility':
    'macOS necesita permiso de Accesibilidad para este atajo. Abre Ajustes del sistema → Privacidad y seguridad → Accesibilidad y activa OpenHuman.',
  'pttSettings.errorShortcutInUse': 'Otra aplicación ya usa este atajo. Elige uno distinto.',
  'pttSettings.errorUnsupportedWayland':
    'Las sesiones Wayland todavía no admiten atajos globales en OpenHuman: cambia a una sesión X11 o usa el botón de dictado dentro de la aplicación.',
  'pttSettings.exclusiveFullscreenHint':
    'En juegos a pantalla completa exclusiva el panel no se mostrará: solo oirás el aviso sonoro. Cambia a pantalla completa sin bordes para ver el panel.',
  'pttOverlay.listening': 'Escuchando…',
  'pttOverlay.idle': 'En espera',
  'chat.agentChat': 'Chat con agente',
  'chat.overrides': 'Anulaciones',
  'chat.model': 'Modelo',
  'chat.temperature': 'Temperatura',
  'chat.conversation': 'Conversación',
  'chat.startAgentConversation': 'Inicia una conversación con el agente.',
  'chat.you': 'Tú',
  'chat.agent': 'Agente',
  'chat.askAgent': 'Pregúntale lo que quieras al agente...',
  'chat.sendMessage': 'Enviar mensaje',
  'composio.triageTitle': 'Disparadores de integración',
  'composio.triageDesc':
    'Cuando está activo, cada disparador de Composio entrante pasa por un paso de clasificación con IA que clasifica el evento y puede iniciar acciones automatizadas: un turno de LLM local por disparador. Desactívalo globalmente o por integración si prefieres revisión manual. Si la variable de entorno',
  'composio.disableAllTriage': 'Desactivar clasificación de IA para todos los disparadores',
  'composio.triggersStillRecorded':
    'Los disparadores siguen registrándose en el historial: no se ejecuta ningún turno de LLM.',
  'composio.disableSpecificIntegrations':
    'Desactivar clasificación de IA para integraciones específicas',
  'composio.settingsSaved': 'Ajustes guardados',
  'composio.saveFailed': 'No se pudo guardar. Inténtalo de nuevo.',
  'cron.title': 'Tareas cron',
  'cron.scheduledJobs': 'Trabajos programados',
  'cron.manageCronJobs': 'Gestiona las tareas cron desde el programador del core.',
  'cron.refreshCronJobs': 'Actualizar tareas cron',
  'localModel.modelStatus': 'Estado del modelo',
  'localModel.downloadModels': 'Descargar modelos',
  'localModel.usage': 'Uso',
  'localModel.usageDesc':
    'Elige qué subsistemas corren en el modelo local. Todo lo que esté desactivado usa la nube.',
  'localModel.enableRuntime': 'Activar runtime de IA local',
  'localModel.enableRuntimeDesc':
    'Interruptor principal. Desactivado por defecto: Ollama permanece inactivo. Cuando está activado, el resumidor de árbol, la inteligencia de pantalla y el autocompletado siempre usan el modelo local.',
  'localModel.advancedSettings': 'Configuración avanzada',
  'localModel.debugTitle': 'Depuración de modelo local',
  'memory.debugTitle': 'Depuración de memoria',
  'memory.documents': 'Documentos',
  'memory.filterByNamespace': 'Filtrar por espacio de nombres...',
  'memory.refresh': 'Actualizar',
  'memory.noDocumentsFound': 'No se encontraron documentos.',
  'memory.delete': 'Eliminar',
  'memory.rawResponse': 'Respuesta cruda',
  'memory.namespaces': 'Espacios de nombres',
  'memory.noNamespacesFound': 'No se encontraron espacios de nombres.',
  'memory.queryRecall': 'Consulta y recuperación',
  'memory.namespace': 'Espacio de nombres',
  'memory.queryText': 'Texto de consulta...',
  'memory.defaultMaxChunks': '10',
  'memory.maxChunks': 'trozos máximos',
  'memory.query': 'Consulta',
  'memory.recall': 'recordar',
  'memory.queryLabel': 'Consulta',
  'memory.recallLabel': 'recordar',
  'memory.queryResult': 'Resultado de la consulta',
  'memory.recallResult': 'Recuperar resultado',
  'memory.clearNamespace': 'Borrar espacio de nombres',
  'memory.clearNamespaceDescription':
    'Elimina permanentemente todos los documentos dentro de un espacio de nombres.',
  'memory.selectNamespace': 'Seleccionar espacio de nombres...',
  'memory.exampleNamespace': 'por ej. habilidad:gmail:usuario@ejemplo.com',
  'memory.clear': 'Borrar',
  'memory.deleteConfirm':
    '¿Eliminar el documento «{documentId}» del espacio de nombres «{namespace}»?',
  'memory.clearNamespaceConfirm':
    'Esto eliminará permanentemente TODOS los documentos del espacio de nombres «{namespace}». ¿Continuar?',
  'memory.clearNamespaceSuccess': 'Se borró el espacio de nombres "{namespace}".',
  'memory.clearNamespaceEmpty': 'No hay nada que borrar en "{namespace}".',
  'webhooks.debugTitle': 'Depuración de webhooks',
  'webhooks.failedToLoadDebugData': 'No se pudieron cargar los datos de depuración del webhook',
  'webhooks.clearLogsConfirm': '¿Borrar todos los registros de depuración de webhooks capturados?',
  'webhooks.failedToClearLogs': 'No se pudieron borrar los registros de webhook',
  'webhooks.loading': 'Cargando...',
  'webhooks.refresh': 'Actualizar',
  'webhooks.clearing': 'Limpiando...',
  'webhooks.clearLogs': 'Borrar registros',
  'webhooks.registered': 'registrado',
  'webhooks.captured': 'capturado',
  'webhooks.live': 'vivir',
  'webhooks.disconnected': 'desconectado',
  'webhooks.lastEvent': 'último evento',
  'webhooks.at': 'en',
  'webhooks.registeredWebhooks': 'Webhooks registrados',
  'webhooks.noActiveRegistrations': 'No hay registros activos.',
  'webhooks.resolvingBackendUrl': 'Resolviendo el servidor URL…',
  'webhooks.capturedRequests': 'Solicitudes capturadas',
  'webhooks.noRequestsCaptured': 'Aún no se han capturado solicitudes de webhook.',
  'webhooks.unrouted': 'sin ruta',
  'webhooks.pending': 'pendiente',
  'webhooks.requestHeaders': 'Encabezados de solicitud',
  'webhooks.queryParams': 'Parámetros de consulta',
  'webhooks.requestBody': 'Cuerpo de solicitud',
  'webhooks.responseHeaders': 'Encabezados de respuesta',
  'webhooks.responseBody': 'Cuerpo de respuesta',
  'webhooks.rawPayload': 'Carga útil sin procesar',
  'webhooks.empty': '[vacío]',
  'providerSetup.error.defaultDetails': 'Error en la configuración del proveedor.',
  'providerSetup.error.providerFallback': 'el proveedor',
  'providerSetup.error.credentialsRejected':
    '{provider} rechazó las credenciales. Comprueba la clave de API e inténtalo de nuevo.',
  'providerSetup.error.endpointNotRecognized':
    '{provider} no reconoció el endpoint. Comprueba la URL base e inténtalo de nuevo.',
  'providerSetup.error.providerUnavailable':
    '{provider} no está disponible en este momento. Inténtalo de nuevo o comprueba el estado del proveedor.',
  'providerSetup.error.unreachable':
    'No se pudo contactar con {provider}. Comprueba la URL del endpoint y la conexión de red, luego inténtalo de nuevo.',
  'providerSetup.error.couldNotReachWithMessage': 'No se pudo comunicar con {provider}: {message}',
  'providerSetup.error.technicalDetails': 'Detalles técnicos',
  'notifications.routingTitle': 'Enrutamiento de notificaciones',
  'notifications.routing.pipelineStats': 'Estadísticas de canalización',
  'notifications.routing.total': 'totales',
  'notifications.routing.unread': 'No leído',
  'notifications.routing.unscored': 'Sin puntuación',
  'notifications.routing.intelligenceTitle': 'Inteligencia de notificaciones',
  'notifications.routing.intelligenceDesc':
    'Cada notificación de tus cuentas conectadas es puntuada por un modelo de IA local. Las notificaciones de alta importancia se enrutan automáticamente a tu agente orquestador para que nada crítico se escape.',
  'notifications.routing.howItWorks': 'como funciona',
  'notifications.routing.level.drop': 'soltar',
  'notifications.routing.level.dropDesc': 'Ruido/spam: almacenado pero no revelado',
  'notifications.routing.level.acknowledge': 'Reconocer',
  'notifications.routing.level.acknowledgeDesc':
    'Prioridad baja: se muestra en el centro de notificaciones',
  'notifications.routing.level.react': 'reaccionar',
  'notifications.routing.level.reactDesc':
    'Prioridad media: activa una respuesta enfocada del agente',
  'notifications.routing.level.escalate': 'escalar',
  'notifications.routing.level.escalateDesc': 'Prioridad alta: reenviado al agente orquestador',
  'notifications.routing.perProvider': 'Enrutamiento por proveedor',
  'notifications.routing.threshold': 'umbral',
  'notifications.routing.routeToOrchestrator': 'Ruta al orquestador',
  'notifications.routing.loadSettingsError':
    'Error al cargar la configuración. Vuelve a abrir este panel para reintentar.',
  'common.reload': 'Recargar',
  'common.skip': 'Omitir',
  'common.disable': 'Desactivar',
  'common.enable': 'Activar',
  'chat.safetyTimeout':
    'Sin respuesta del agente después de 2 minutos. Intenta de nuevo o verifica tu conexión.',
  'chat.filter.general': 'General',
  'chat.filter.subconscious': 'Subconsciente',
  'chat.filter.meetings': 'Reuniones',
  'chat.filter.tasks': 'Tareas',
  'chat.selectThread': 'Selecciona un hilo',
  'chat.threads': 'Hilos',
  'chat.noThreads': 'Sin hilos aún',
  'chat.noLabelThreads': 'Sin hilos "{label}"',
  'chat.deleteThread': 'Eliminar hilo',
  'chat.deleteThreadConfirm': '¿Seguro que quieres eliminar "{title}"?',
  'chat.untitledThread': 'Hilo sin título',
  'chat.editThreadTitle': 'Editar título del hilo',
  'chat.hideSidebar': 'Ocultar barra lateral',
  'chat.showSidebar': 'Mostrar barra lateral',
  'chat.searchThreads': 'Buscar conversaciones',
  'layout.resizeSidebar': 'Redimensionar barra lateral',
  'layout.showSidebar': 'Mostrar barra lateral',
  'chat.newThreadShortcut': 'Nuevo hilo (/new)',
  'chat.new': 'Nuevo',
  'chat.failedToLoadMessages': 'No se pudieron cargar los mensajes',
  'chat.thinkingIteration': 'Pensando... ({n})',
  'chat.thinkingDots': 'Pensando...',
  'chat.approachingLimit': 'Acercándote al límite de uso',
  'chat.approachingLimitMsg': 'Has usado el {pct}% de tu cuota disponible.',
  'chat.upgrade': 'Mejorar plan',
  'chat.weeklyLimitHit': 'Alcanzaste tu límite semanal.',
  'chat.resets': 'Se restablece',
  'chat.topUpToContinue': 'Recarga para continuar.',
  'chat.budgetComplete':
    'Tu presupuesto incluido se agotó. Agrega créditos o mejora tu plan para continuar.',
  'chat.topUp': 'Recargar',
  'chat.cycle': 'Ciclo',
  'chat.cycleSpent': 'Gastado este ciclo',
  'chat.cycleRemaining': 'Restante',
  'chat.left': 'restante',
  'chat.setup': 'Configurar',
  'chat.switchToText': 'Cambiar a texto',
  'chat.superContext.label': 'Súper contexto',
  'chat.superContext.hint':
    'Súper contexto permite a OpenHuman reunir y preparar contexto a partir de todos los datos a los que tiene acceso para ofrecer una respuesta muy relevante. Súper contexto está en fase beta inicial.',
  'chat.transcribing': 'Transcribiendo...',
  'chat.stopAndSend': 'Detener y enviar',
  'chat.startTalking': 'Empieza a hablar',
  'chat.playingVoiceReply': 'Reproduciendo respuesta de voz',
  'chat.voiceHint': 'Usa el micrófono para hablar',
  'chat.micUnavailable': 'Micrófono no disponible',
  // Chat mascot: the figure standing on the composer, and its voice stage.
  'chat.mascot.expand': 'Habla con tu asistente',
  'chat.mascot.collapse': 'Volver al chat',
  'chat.mascot.speakReplies': 'Leer las respuestas en voz alta',
  'chat.mascot.speakRepliesHint':
    'Las respuestas se leen en voz alta mientras la mascota está abierta. Desactívalo para mantener la conversación en silencio.',
  'chat.mascot.dismiss': 'Ocultar a Tiny',
  'chat.mascot.dismissTitle': '¿Ocultar a Tiny?',
  'chat.mascot.dismissBody':
    'Sin rencores si prefieres tener el cuadro de mensaje para ti. Puedes traer a Tiny de vuelta cuando quieras desde Configuración › Apariencia › Chat.',
  'chat.mascot.dismissConfirm': 'Ocultar a Tiny',
  'chat.mascot.dismissCancel': 'Conservar a Tiny',
  'chat.turn': 'turno',
  'chat.turns': 'turnos',
  'chat.openWorkerThread': 'Abrir hilo de worker',
  'chat.attachment.attach': 'Adjuntar imagen',
  'chat.attachment.remove': 'Eliminar {name}',
  'chat.attachment.tooMany': 'Máximo {max} imágenes por mensaje',
  'chat.attachment.tooManyFiles': 'Máximo {max} archivos por mensaje',
  'chat.attachment.tooManyVideos': 'Máximo {max} vídeos por mensaje',
  'chat.attachment.videoNotSupported':
    'Este modelo no puede leer vídeos. Puedes usar el nivel Razonamiento de OpenHuman para adjuntar tu vídeo.',
  'chat.attachment.dropToAttach': 'Suelta los archivos para adjuntar',
  'chat.attachment.tooLarge': 'La imagen supera el límite de tamaño de {max}',
  'chat.attachment.unsupportedType':
    'Tipo de archivo no compatible. Use una imagen (PNG, JPEG, WebP, GIF, BMP) o un archivo PDF, TXT o Markdown.',
  'chat.attachment.imageNotSupported':
    'Este modelo no puede leer imágenes. Puedes usar el nivel Razonamiento de OpenHuman para adjuntar tu imagen.',
  'chat.attachment.readFailed': 'No se pudo leer el archivo',
  'memory.searchAria': 'Buscar en memoria',
  'memory.searchPlaceholder': 'Buscar entradas de memoria...',
  'memory.sourceFilter.all': 'Todas las fuentes',
  'memory.sourceFilter.email': 'Correo',
  'memory.sourceFilter.calendar': 'Calendario',
  'memory.sourceFilter.telegram': 'Telegram',
  'memory.sourceFilter.aiInsight': 'Insight de IA',
  'memory.sourceFilter.system': 'Sistema',
  'memory.sourceFilter.trading': 'Comercio',
  'memory.sourceFilter.security': 'Seguridad',
  'memory.ingestionActivity': 'Actividad de ingesta',
  'memory.events': 'eventos',
  'memory.event': 'evento',
  'memory.overTheLast': 'en los últimos',
  'memory.months': 'meses',
  'memory.peak': 'Pico',
  'memory.perDay': '/día',
  'memory.less': 'Menos',
  'memory.more': 'Más',
  'memory.on': 'el',
  'memory.loading': 'Cargando memoria',
  'memory.fetching': 'Obteniendo tus entradas de memoria...',
  'memory.analyzing': 'Analizando memoria',
  'memory.analyzingHint': 'Procesando tus recuerdos para extraer insights...',
  'memory.noMatches': 'Sin resultados',
  'memory.noMatchesHint': 'Prueba cambiar los términos de búsqueda o los filtros.',
  'memory.allCaughtUp': 'Todo al día',
  'memory.allCaughtUpHint': 'No hay nuevas entradas de memoria para procesar.',
  'memory.noAnalysis': 'Sin análisis aún',
  'memory.noAnalysisHint': 'Ejecuta un análisis para descubrir patrones en tus recuerdos.',
  'memory.emptyHint': 'Empieza a interactuar para crear tus primeros recuerdos.',
  'mic.unavailable': 'Micrófono no disponible',
  'mic.permissionDenied': 'Permiso de micrófono denegado',
  'mic.failedToStartRecorder': 'No se pudo iniciar la grabadora',
  'mic.deviceUnavailable':
    'El micrófono seleccionado no está disponible: prueba con otro dispositivo.',
  'mic.deviceInUse': 'El micrófono está siendo utilizado por otra aplicación.',
  'mic.error': 'Error del micrófono',
  'mic.transcribing': 'Transcribiendo...',
  'mic.retryingTranscription': 'Reintentando… ({attempt} de {max})',
  'mic.tapToSend': 'Toca para enviar',
  'mic.waitingForAgent': 'Esperando al agente...',
  'mic.tapAndSpeak': 'Toca y habla',
  'mic.stopRecording': 'Detener grabación y enviar',
  'mic.startRecording': 'Iniciar grabación',
  'mic.deviceSelector': 'Dispositivo de micrófono',
  'mic.tapToSendCountdown': 'Toca para enviar ({seconds}s)',
  'token.usageLimitReached': 'Límite de uso alcanzado',
  'token.approachingLimit': 'Acercándote al límite',
  'token.planClickForDetails': 'plan - toca para ver detalles',
  'token.sessionTokens': 'Ent: {in} | Sal: {out} | Turnos: {turns}',
  'token.limit': 'Límite alcanzado',
  'token.inLabel': 'ENT',
  'token.outLabel': 'SAL',
  'token.inputTokens': 'Tokens de entrada en esta sesión',
  'token.outputTokens': 'Tokens de salida en esta sesión',
  'token.turnsCount': 'Turnos de inferencia en esta sesión',
  'token.turn': 'turno',
  'token.turns': 'turnos',
  'token.ctxLabel': 'CTX',
  'token.contextWindow': 'Uso de ventana de contexto (último turno)',
  'token.cachedLabel': 'En caché',
  'token.costLabel': 'Costo',
  'token.costTitle': 'Costo estimado de esta sesión (USD)',
  'token.sessionUsageTitle': 'Uso de la sesión',
  'token.subAgentsHeading': 'Uso de subagentes',
  'token.byAgentHeading': 'Por agente',
  'token.orchestrator': 'Orquestador',
  'token.noSubAgents': 'Aún no hay uso de subagentes',
  'token.popInput': 'Tokens de entrada',
  'token.popOutput': 'Tokens de salida',
  'token.popCacheHit': 'Acierto de caché',
  'token.popContext': 'Ventana de contexto',
  'token.tipInput':
    'Tokens enviados al modelo en esta sesión: tus prompts más el historial de la conversación.',
  'token.tipOutput': 'Tokens generados por el modelo en esta sesión.',
  'token.tipCacheHit':
    'Tokens de entrada servidos desde un prefijo de prompt en caché, facturados a una tarifa reducida.',
  'token.clickForDetails': 'Haz clic para ver los detalles de uso de la sesión',
  'catalog.noCapabilityBinding': 'Sin vinculación de capacidad',
  'catalog.downloadFailed': 'Descarga fallida',
  'catalog.active': 'Activo',
  'catalog.installed': 'Instalado',
  'catalog.notDownloaded': 'No descargado',
  'catalog.inUse': 'En uso',
  'catalog.use': 'Usar',
  'catalog.deleteModel': 'Eliminar modelo',
  'catalog.download': 'Descargar',
  'navigator.recent': 'Reciente',
  'navigator.today': 'Hoy',
  'navigator.thisWeek': 'Esta semana',
  'navigator.sources': 'Fuentes',
  'navigator.email': 'Correo',
  'navigator.slack': 'Slack',
  'navigator.chat': 'Charla',
  'navigator.documents': 'Documentos',
  'navigator.people': 'Personas',
  'navigator.topics': 'Temas',
  'dreams.description':
    'Los sueños son reflexiones generadas por IA que sintetizan patrones de tus recuerdos.',
  'dreams.comingSoon': 'Próximamente',
  'assignment.memoryLlm': 'LLM de memoria',
  'assignment.memoryLlmAria': 'Selección de LLM de memoria',
  'assignment.embedder': 'Incrustador',
  'assignment.loaded': 'Cargado',
  'assignment.notDownloaded': 'No descargado',
  'assignment.usedForExtractSummarise': 'Usado para extracción y resumen',
  'insights.knownFacts': 'Hechos conocidos',
  'insights.preferences': 'Preferencias',
  'insights.relationships': 'Relaciones',
  'insights.skills': 'Habilidades',
  'insights.opinions': 'Opiniones',
  'insights.other': 'Otro',
  'insights.title': 'Perspectivas',
  'insights.empty': 'Sin insights aún. Los insights se generan a medida que crece tu memoria.',
  'insights.description': 'Basado en {count} relaciones en tu grafo de memoria.',
  'insights.items': 'elementos',
  'insights.more': 'más',
  'calls.joiningCall': 'Uniéndose a la llamada',
  'calls.meetWindowOpening': 'La ventana de Meet se está abriendo...',
  'calls.failedToStart': 'No se pudo iniciar la llamada de Google Meet',
  'calls.couldNotStart': 'No se pudo iniciar la llamada',
  'calls.failedToClose': 'No se pudo cerrar la llamada',
  'calls.couldNotClose': 'No se pudo cerrar la llamada',
  'calls.joinMeet': 'Unirse a una llamada de Google Meet',
  'calls.joinMeetDescription': 'Ingresa un enlace de Google Meet para unirte.',
  'calls.meetLink': 'Enlace de Meet',
  'calls.displayName': 'Nombre de visualización',
  'calls.openingMeet': 'Abriendo Meet...',
  'calls.joinCall': 'Unirse a la llamada',
  'calls.activeCalls': 'Llamadas activas',
  'calls.leave': 'Salir',
  'workspace.wipeConfirm':
    '¿Seguro que quieres borrar toda la memoria? Esta acción no se puede deshacer.',
  'workspace.resetTreeConfirm': '¿Seguro que quieres reconstruir el árbol de memoria?',
  'workspace.wipeTitle': 'Borrar memoria',
  'workspace.resetting': 'Restableciendo...',
  'workspace.resetMemory': 'Restablecer memoria',
  'workspace.resetTreeTitle': 'Reconstruir árbol de memoria',
  'workspace.rebuilding': 'Reconstruyendo...',
  'workspace.resetMemoryTree': 'Restablecer árbol de memoria',
  'workspace.building': 'Construyendo...',
  'workspace.buildSummaryTrees': 'Construir árboles de resumen',
  'workspace.viewVault': 'Ver bóveda',
  'workspace.openingVaultTitle': 'Apertura de bóveda en obsidiana',
  'workspace.openingVaultMessage':
    'Si Obsidian no se abre, instálalo desde obsidian.md o usa Mostrar carpeta. Ruta del almacén:',
  'workspace.openVaultFailedTitle': 'No se pudo abrir el almacén en Obsidian',
  'workspace.openVaultFailedMessage':
    'Utilice Revelar carpeta para abrir el directorio del almacén directamente. Ruta de la bóveda:',
  'workspace.revealVaultFailed': 'No se pudo mostrar la carpeta del almacén',
  'workspace.revealFolder': 'Revelar carpeta',
  'workspace.checkingVault': 'Verificando…',
  'workspace.vaultNotRegisteredHelp':
    'Obsidian solo abre las carpetas que hayas agregado como almacén. En Obsidian, elige «Abrir carpeta como almacén» y selecciona la carpeta de abajo; solo necesitas hacerlo una vez. Luego haz clic en Ver almacén de nuevo.',
  'workspace.obsidianNotFoundHelp':
    'No encontramos Obsidian en este dispositivo. Instálalo, o (si está instalado en una ubicación no estándar) establece su carpeta de configuración en Avanzado.',
  'workspace.openAnyway': 'Abrir en Obsidian de todos modos',
  'workspace.installObsidian': 'Instalar Obsidian',
  'workspace.obsidianAdvanced': '¿Obsidian instalado en otro lugar?',
  'workspace.obsidianConfigDirLabel': 'Carpeta de configuración de Obsidian',
  'workspace.obsidianConfigDirHint':
    'Ruta a la carpeta que contiene obsidian.json (p. ej., ~/.config/obsidian). Dejar en blanco para detectar automáticamente.',
  'workspace.obsidianConfigDirPlaceholder': '~/.config/obsidian',
  'workspace.graphLoadFailed': 'No se pudo cargar el grafo de memoria',
  'workspace.loadingGraph': 'Cargando grafo de memoria...',
  'workspace.graphViewMode': 'Modo de vista del grafo de memoria',
  'workspace.trees': 'Árboles',
  'workspace.contacts': 'Contactos',
  'graph.noContactMentions': 'Sin menciones de contacto',
  'graph.noMemory': 'Sin memoria',
  'graph.source': 'Fuente',
  'graph.topic': 'Tema',
  'graph.global': 'Mundial',
  'graph.document': 'Documento',
  'graph.contact': 'Contacto',
  'graph.nodes': 'nodos',
  'graph.parentChild': 'padre-hijo',
  'graph.documentContact': 'documento-contacto',
  'graph.link': 'enlace',
  'graph.links': 'enlaces',
  'graph.children': 'hijos',
  'graph.clickToOpenObsidian': 'Clic para abrir en Obsidian',
  'graph.person': 'Persona',
  'graph.resetView': 'Restablecer vista',
  'modal.dontShowAgain': 'No mostrar sugerencias similares',
  'reflections.loading': 'Cargando reflexiones...',
  'reflections.empty': 'Sin reflexiones aún',
  'reflections.title': 'Reflexiones',
  'reflections.proposedAction': 'Acción propuesta',
  'reflections.act': 'Actuar',
  'reflections.dismiss': 'Descartar',
  'reflections.viewConversation': 'Ver',
  'subconscious.mode.label': 'Modo subconsciente',
  'subconscious.mode.off.title': 'Apagado',
  'subconscious.mode.off.desc': 'El subconsciente está desactivado.',
  'subconscious.mode.simple.title': 'Simple',
  'subconscious.mode.simple.desc': 'Observación de solo lectura. Solo acceso a memoria y archivos.',
  'subconscious.mode.aggressive.title': 'Agresivo',
  'subconscious.mode.aggressive.desc':
    'Acceso completo a herramientas. Puede escribir, crear agentes y delegar tareas.',
  'subconscious.mode.aggressiveWarning':
    'El modo agresivo otorga al subconsciente acceso completo a herramientas, incluyendo escritura y creación de subagentes.',
  'subconscious.interval.label': 'Frecuencia',
  'subconscious.interval.minutes': '{n} min',
  'subconscious.interval.hours': '{n}h',
  'subconscious.interval.oneHour': '1 hora',
  'subconscious.interval.oneDay': '24 horas',
  'whatsapp.chatsSynced': 'chats sincronizados',
  'whatsapp.chatSynced': 'chat sincronizado',
  'sync.active': 'Activo',
  'sync.recent': 'Reciente',
  'sync.idle': 'Inactivo',
  'sync.memorySources': 'Fuentes de memoria',
  'sync.noConnectedSources': 'Sin fuentes conectadas',
  'sync.chunks': 'fragmentos',
  'sync.lastChunk': 'Último fragmento:',
  'sync.pending': 'pendiente',
  'sync.processed': 'procesado',
  'sync.syncing': 'Sincronizando…',
  'sync.sync': 'Sincronizar',
  'sync.failedToLoad': 'No se pudo cargar el estado de sincronización',
  'sync.noContent':
    'Aún no se ha sincronizado contenido en la memoria. Conecta una integración para empezar.',
  'memorySyncInterval.title': 'Programa de sincronización',
  'memorySyncInterval.lastSynced': 'Última sincronización',
  'memorySyncInterval.never': 'nunca',
  'memorySyncInterval.everyHours': 'Cada {h} h',
  'memorySyncInterval.everyMinutes': 'Cada {m} min',
  'memorySyncInterval.manual': 'Solo manual',
  'memorySyncInterval.saveFailed': 'No se pudo actualizar el programa de sincronización',
  'memorySources.title': 'Fuentes de memoria',
  'memorySources.empty':
    'Aún no hay fuentes de memoria. Agrega una para comenzar a alimentar la memoria.',
  'memorySources.customSources': 'Fuentes personalizadas',
  'memorySources.addSource': 'Agregar fuente',
  'memorySources.noCustomSources':
    'Aún no hay fuentes personalizadas. Agrega una carpeta, el repositorio GitHub, la fuente RSS o una página web para comenzar.',
  'memorySources.loadingConnections': 'Cargando conexiones…',
  'memorySources.noConnections':
    'No se encontraron conexiones activas de Composio. Conecta una integración primero.',
  'memorySources.pickConnection': 'Elige una conexión',
  'memorySources.selectConnection': 'Seleccionar una conexión',
  'memorySources.comingSoon': 'Próximamente',
  'memorySources.composioListFailed': 'Error al cargar las conexiones Composio.',
  'memorySources.browse': 'Examinar…',
  'memorySources.folderPathPlaceholder': '/Users/you/notes',
  'memorySources.globPatternPlaceholder': '**/*.md',
  'memorySources.repoUrlPlaceholder': 'https://github.com/org/repo',
  'memorySources.branchPlaceholder': 'main',
  'memorySources.feedUrlPlaceholder': 'https://example.com/feed.xml',
  'memorySources.pageUrlPlaceholder': 'https://example.com/article',
  'memorySources.cssSelectorPlaceholder': 'article',
  'memorySources.searchQueryPlaceholder': 'de:usuario AI seguridad',
  'memorySources.kind.composio': 'Integración',
  'memorySources.kind.conversation': 'Conversación',
  'memorySources.kind.folder': 'Carpeta local',
  'memorySources.kind.github_repo': 'GitHub Repositorio',
  'memorySources.kind.twitter_query': 'Búsqueda en Twitter',
  'memorySources.kind.rss_feed': 'RSS Alimentar',
  'memorySources.kind.web_page': 'Página web',
  'memorySources.sync.successTitle': 'Sincronizando',
  'memorySources.sync.successMessage': 'El progreso aparecerá en breve.',
  'memorySources.sync.failedTitle': 'Sincronización fallida:',
  'memorySources.sync.completeTitle': 'Sincronizado',
  'memorySources.sync.itemsSynced': 'elementos sincronizados',
  'memorySources.sync.upToDate': 'Actualizado',
  'memorySources.sync.failedLabel': 'Fallido',
  'time.justNow': 'ahora mismo',
  'time.secondsAgoSuffix': 's',
  'time.minutesAgoSuffix': 'min',
  'time.hoursAgoSuffix': 'h',
  'time.daysAgoSuffix': 'd',
  'memorySources.pickKind': '¿Qué tipo de fuente quieres agregar?',
  'memorySources.backToKinds': 'Volver a los tipos de fuente',
  'memorySources.label': 'Etiqueta',
  'memorySources.labelPlaceholder': 'Mis notas de investigación',
  'memorySources.add': 'Añadir',
  'memorySources.adding': 'Agregando…',
  'memorySources.added': 'Fuente añadida',
  'memorySources.removed': 'Fuente eliminada',
  'memorySources.remove': 'Eliminar',
  'memorySources.enable': 'Habilitar',
  'memorySources.disable': 'Desactivar',
  'memorySources.toggleFailed': 'Error al alternar',
  'memorySources.removeFailed': 'Error al eliminar',
  'memorySources.folderPath': 'Ruta de la carpeta',
  'memorySources.globPattern': 'Patrón glob',
  'memorySources.repoUrl': 'Repositorio URL',
  'memorySources.branch': 'Rama',
  'memorySources.feedUrl': 'Alimentar URL',
  'memorySources.pageUrl': 'Página URL',
  'memorySources.cssSelector': 'Selector CSS (opcional)',
  'memorySources.searchQuery': 'Consulta de búsqueda',
  'memorySources.build.title': 'Construir',
  'memorySources.build.building': 'Construyendo…',
  'memorySources.build.successTitle': 'Árbol construido',
  'memorySources.build.failedTitle': 'Construcción fallida',
  'memorySources.build.sealsMessage': 'sellado(s) completado(s)',
  'memorySources.allIn.button': 'Todo activo',
  'memorySources.allIn.title': '¿Activar todo?',
  'memorySources.allIn.message':
    'Esto activará todas las fuentes de memoria y eliminará todos los límites de sincronización. Construye el gráfico de memoria más rico, pero puede usar más créditos.',
  'memorySources.allIn.confirm': 'Sí',
  'memorySources.allIn.cancel': 'No',
  'memorySources.allIn.success':
    'Todas las fuentes activadas sin límites. Sincronización iniciada.',
  'memorySources.allIn.failed': 'No se pudo aplicar todo activo. Por favor, inténtelo de nuevo.',
  'memorySources.settings.button': 'Configuración',
  'memorySources.settings.title': 'Configuración de sincronización',
  'memorySources.settings.maxPrs': 'Máximo de pull requests',
  'memorySources.settings.maxIssues': 'Máximo de issues',
  'memorySources.settings.maxCommits': 'Máximo de commits',
  'memorySources.settings.maxItems': 'Máximo de elementos',
  'memorySources.settings.sinceDays': 'Período de búsqueda (días)',
  'memorySources.settings.syncDepthDays': 'Profundidad de sincronización (días)',
  'memorySources.settings.maxTokens': 'Máximo de tokens por sincronización',
  'memorySources.settings.maxCost': 'Costo máximo por sincronización (USD)',
  'memorySources.settings.unlimited': 'Sin límite',
  'memorySources.settings.unlimitedTooltip':
    'Has optado por sincronizar el máximo para {toolkit}. Puedes cambiar los límites aquí.',
  'memorySources.settings.maxed': 'Lleno',
  'memorySources.settings.save': 'Guardar',
  'memorySources.settings.saving': 'Guardando…',
  'memorySources.settings.saved': 'Configuración guardada',
  'memorySources.settings.saveFailed': 'No se pudo guardar la configuración',
  'backend.aiBackend': 'Backend de IA',
  'backend.cloud': 'Nube',
  'backend.recommended': 'Recomendado',
  'backend.cloudDescription':
    'Modelos rápidos y potentes alojados en nuestros servidores. Listos para usar de inmediato.',
  'backend.privacyNote':
    'Nunca enviamos datos personales, mensajes ni claves a nuestros servidores.',
  'backend.local': 'locales',
  'backend.advanced': 'Avanzado',
  'backend.localDescription':
    'Ejecuta modelos en tu propia máquina usando Ollama. Privacidad total, requiere configuración.',
  'backend.ramRecommended': 'Se recomienda 16 GB+ de RAM',
  'subconscious.tasks': 'tareas',
  'subconscious.ticks': 'garrapatas',
  'subconscious.last': 'Último',
  'subconscious.failed': 'fallido',
  'subconscious.tickInterval': 'Intervalo de tick',
  'subconscious.runNow': 'Ejecutar ahora',
  'subconscious.instance.on': 'Activado',
  'subconscious.instance.off': 'Desactivado',
  'subconscious.instance.memory.title': 'Tu mundo',
  'subconscious.instance.memory.subtitle': 'Fuentes de memoria conectadas',
  'subconscious.instance.tinyplace.title': 'Dirección de orquestación',
  'subconscious.instance.tinyplace.subtitle': 'Revisión de sesiones de tiny.place',
  'subconscious.instance.tinyplace.disabledHint':
    'Activa la Orquestación para dirigir las sesiones envueltas.',
  'subconscious.instance.tinyplace.viewDirectives': 'Ver directivas →',
  'subconscious.runReviewNow': 'Ejecutar revisión ahora',
  'tinyplaceOrchestration.subconsciousBadge': 'Subconsciente · dirección',
  'tinyplaceOrchestration.steeringHeader.current': 'Directiva activa',
  'tinyplaceOrchestration.steeringHeader.none': 'Sin directiva activa',
  'tinyplaceOrchestration.steeringHeader.expires': 'caduca tras {n} ciclos',
  'tinyplaceOrchestration.steeringHeader.lastReview': 'Última revisión',
  'tinyplaceOrchestration.steeringHeader.runReview': 'Ejecutar revisión ahora',
  'tinyplaceOrchestration.steeringHeader.running': 'Ejecutando…',
  'subconscious.providerUnavailableTitle': 'Subconsciente en pausa',
  'subconscious.providerSettings': 'Ajustes de IA',
  'subconscious.scratchpadInfo':
    'En cada ciclo, el subconsciente revisa qué cambió en tus fuentes conectadas y luego registra seguimientos en tu lista de tareas, actualiza tus objetivos o te notifica cuando algo requiere atención. Consulta Configuración → Acceso del agente para configurar el modo y la frecuencia.',
  'subconscious.approvalNeeded': 'Se necesita aprobación',
  'subconscious.requiresApproval': 'Requiere aprobación',
  'subconscious.fixInConnections': 'Corregir en Conexiones',
  'subconscious.goAhead': 'Adelante',
  'subconscious.activeTasks': 'Tareas activas',
  'subconscious.noActiveTasks': 'Sin tareas activas',
  'subconscious.default': 'Predeterminado',
  'subconscious.addTaskPlaceholder': 'Agregar una nueva tarea...',
  'subconscious.activityLog': 'Registro de actividad',
  'subconscious.noActivity': 'Sin actividad aún',
  'subconscious.decision.nothingNew': 'Sin novedades',
  'subconscious.decision.completed': 'Completado',
  'subconscious.decision.evaluating': 'Evaluando',
  'subconscious.decision.waitingApproval': 'Esperando aprobación',
  'subconscious.decision.failed': 'Fallido',
  'subconscious.decision.cancelled': 'Cancelado',
  'subconscious.decision.skipped': 'Omitido',
  // Subconscious triggers (event-driven orchestrator) debug panel
  'subconsciousTriggers.title': 'Disparadores del subconsciente',
  'subconsciousTriggers.subtitle': 'Orquestador en segundo plano basado en eventos',
  'subconsciousTriggers.pipeline': 'Canalización',
  'subconsciousTriggers.mode': 'Modo',
  'subconsciousTriggers.orchestrator': 'Orquestador',
  'subconsciousTriggers.running': 'En ejecución',
  'subconsciousTriggers.stopped': 'Detenido',
  'subconsciousTriggers.promotionsPerHour': 'Promociones / hora',
  'subconsciousTriggers.queueDepth': 'Profundidad de la cola',
  'subconsciousTriggers.orchestratorThread': 'Hilo del orquestador',
  'subconsciousTriggers.userThread': 'Hilo del usuario',
  'subconsciousTriggers.disabledHint':
    'Activa el modo basado en eventos para iniciar la canalización.',
  'subconsciousTriggers.enable': 'Activar',
  'subconsciousTriggers.disable': 'Desactivar',
  'actionable.complete': 'Completar',
  'actionable.dismiss': 'Descartar',
  'actionable.snooze': 'Posponer',
  'actionable.new': 'Nuevo',
  'stats.storage': 'Almacenamiento',
  'stats.files': 'archivos',
  'stats.documents': 'Documentos',
  'stats.today': 'hoy',
  'stats.namespaces': 'Espacios de nombres',
  'stats.relations': 'Relaciones',
  'stats.firstMemory': 'Primer recuerdo',
  'stats.latest': 'Más reciente',
  'stats.sessions': 'Sesiones',
  'stats.tokens': 'fichas',
  'bootCheck.invalidUrl': 'Ingresa una URL de runtime.',
  'bootCheck.urlMustStartWith': 'La URL debe comenzar con http:// o https://',
  'bootCheck.validUrlRequired':
    'Eso no parece una URL válida (prueba con https://core.example.com/rpc)',
  'bootCheck.tokenRequired': 'Necesitaremos un token de autenticación para conectarnos.',
  'bootCheck.httpPublicWarning':
    'Esta es una URL HTTP sin cifrar en un host público: el tráfico no estará cifrado. Usa HTTPS a menos que confíes en esta red.',
  'bootCheck.chooseCoreMode': 'Seleccionar un runtime',
  'bootCheck.connectToCore': 'Conectar a tu runtime',
  'bootCheck.desktopDescription':
    'OpenHuman necesita un runtime para funcionar. Elige dónde debe vivir.',
  'bootCheck.webDescription':
    'En la web, OpenHuman se conecta a un runtime que tú controlas. Ingresa su URL y token de autenticación abajo, o descarga la app de escritorio para ejecutar uno en tu máquina.',
  'bootCheck.preferDesktop': '¿Prefieres tener todo en tu propio dispositivo?',
  'bootCheck.downloadDesktop': 'Obtener la app de escritorio',
  'bootCheck.localRecommended': 'Ejecutar localmente (Recomendado)',
  'bootCheck.localDescription':
    'Corre directamente en tu computadora. El más rápido, completamente privado, sin nada que configurar.',
  'bootCheck.cloudMode': 'Ejecutar en la nube (Complejo)',
  'bootCheck.cloudDescription':
    'Conéctate a un runtime que estás alojando en otro lugar. Permanece en línea 24×7 para que no necesites mantener este dispositivo encendido.',
  'bootCheck.coreRpcUrl': 'URL del runtime',
  'bootCheck.rpcUrlPlaceholder': 'https://core.example.com/rpc',
  'bootCheck.authToken': 'Token de autenticación',
  'bootCheck.bearerTokenPlaceholder': 'El bearer token de tu runtime remoto',
  'bootCheck.storedLocally': 'Solo guardado en este dispositivo. Enviado como ',
  'bootCheck.testing': 'Probando…',
  'bootCheck.testConnection': 'Probar conexión',
  'bootCheck.connectedOk': 'Conectado. Todo listo.',
  'bootCheck.authFailed': 'Ese token no funcionó. Verifícalo e inténtalo de nuevo.',
  'bootCheck.unreachablePrefix': 'No se pudo alcanzar:',
  'bootCheck.checkingCore': 'Activando tu runtime…',
  'bootCheck.cannotReach': 'No se puede alcanzar el runtime',
  'bootCheck.cannotReachDesc':
    'No pudimos conectarnos a tu runtime. ¿Quieres probar con uno diferente?',
  'bootCheck.switchMode': 'Elegir un runtime diferente',
  'bootCheck.quit': 'Salir',
  'bootCheck.legacyDetected': 'Runtime en segundo plano legacy detectado',
  'bootCheck.legacyDescription':
    'Un daemon de OpenHuman instalado por separado ya está corriendo en este dispositivo. Necesitamos eliminarlo antes de que el runtime integrado pueda tomar el control.',
  'bootCheck.removing': 'Eliminando…',
  'bootCheck.removeContinue': 'Eliminar y continuar',
  'bootCheck.localNeedsRestart': 'El runtime local necesita reiniciarse',
  'bootCheck.localNeedsRestartDesc':
    'Tu runtime local tiene una versión diferente a la de esta app. Un reinicio rápido los sincronizará.',
  'bootCheck.restarting': 'Reiniciando…',
  'bootCheck.restartCore': 'Reiniciar runtime',
  'bootCheck.cloudNeedsUpdate': 'El runtime en la nube necesita actualizarse',
  'bootCheck.cloudNeedsUpdateDesc':
    'Tu runtime en la nube tiene una versión diferente a la de esta app. Ejecuta el actualizador para sincronizarlos.',
  'bootCheck.updating': 'Actualizando…',
  'bootCheck.updateCloudCore': 'Actualizar runtime en la nube',
  'bootCheck.versionCheckFailed': 'Verificación de versión del runtime fallida',
  'bootCheck.versionCheckFailedDesc':
    'Tu runtime está activo pero no reporta su versión. Puede estar desactualizado. Reinícialo o actualízalo para continuar.',
  'bootCheck.working': 'Trabajando…',
  'bootCheck.restartUpdateCore': 'Reiniciar / Actualizar runtime',
  'bootCheck.unexpectedError': 'Error inesperado en verificación de arranque',
  'bootCheck.actionFailed': 'Algo salió mal. Inténtalo de nuevo.',
  'bootCheck.portConflictTitle': 'No se pudo iniciar el motor de la aplicación',
  'bootCheck.portConflictBody':
    'Otro proceso está usando el puerto de red que OpenHuman necesita. Intentaremos solucionarlo automáticamente.',
  'bootCheck.portConflictFixButton': 'Corregir automáticamente',
  'bootCheck.portConflictFixing': 'Corrigiendo…',
  'bootCheck.portConflictFixFailed':
    'La corrección automática no funcionó. Reinicia tu equipo e inténtalo de nuevo.',
  'bootCheck.portConflictOwner':
    '{name} (PID {pid}) está usando el puerto de red que OpenHuman necesita.',
  'bootCheck.portConflictGuidance':
    'Cierra ese programa para liberar el puerto, o fuérzalo a cerrarse abajo y vuelve a intentarlo.',
  'bootCheck.portConflictForceQuit': 'Forzar cierre de {name}',
  'bootCheck.portConflictForceQuitting': 'Cerrando {name}…',
  'bootCheck.portConflictForceQuitFailed':
    'No se pudo cerrar ese programa. Es posible que tengas que cerrarlo manualmente y volver a intentarlo.',
  'notifications.justNow': 'justo ahora',
  'notifications.minAgo': 'hace {n}m',
  'notifications.hrAgo': 'hace {n}h',
  'notifications.dayAgo': 'hace {n}d',
  'notifications.category.messages': 'Mensajes',
  'notifications.category.agents': 'Agentes',
  'notifications.category.skills': 'Habilidades',
  'notifications.category.system': 'Sistema',
  'notifications.category.meetings': 'Reuniones',
  'notifications.category.reminders': 'Recordatorios',
  'notifications.category.important': 'Importante',
  'notifications.filterAll': 'Todas',
  'notifications.filterEmpty': 'No hay alertas en esta categoría',
  'about.update.status.checking': 'Verificando...',
  'about.update.status.available': 'v{version} disponible',
  'about.update.status.availableNoVersion': 'Actualización disponible',
  'about.update.status.downloading': 'Descargando...',
  'about.update.status.readyToInstall': 'v{version} lista para instalar',
  'about.update.status.readyToInstallNoVersion':
    'Una nueva versión se descargó y está lista. Reinicia para aplicarla.',
  'about.update.status.installing': 'Instalando...',
  'about.update.status.restarting': 'Reiniciando...',
  'about.update.status.upToDate': 'Estás usando la versión más reciente.',
  'about.update.status.error': 'Error al verificar actualizaciones',
  'about.update.status.default': 'Buscar actualizaciones',
  'welcome.connectionFailed': 'Conexión fallida: {status} {statusText}',
  'welcome.connectionFailedMsg': 'Conexión fallida: {message}',
  'welcome.continueLocally': 'Continuar localmente',
  'welcome.continueLocallyExperimental': 'Continuar localmente (Experimental)',
  'welcome.localSessionStarting': 'Iniciando sesión local...',
  'welcome.coreConfigUnreadable':
    'El entorno de ejecución no pudo leer su archivo de configuración. Es posible que config.toml pertenezca a otra cuenta de usuario o que resulte inaccesible para el proceso por otro motivo. Reinicia el entorno de ejecución y, si eso no ayuda, repara la propiedad del espacio de trabajo o vuelve a crear su volumen.',
  'welcome.localSessionErrorFallback': 'No se pudo iniciar una sesión local.',
  'welcome.localSessionDesc': 'Utiliza un perfil local sin conexión y omite TinyHumans OAuth.',
  'chat.agentChatDesc': 'Abre una sesión de chat directo con el agente.',
  'chat.modelPlaceholder': 'gpt-4o',
  'channels.activeRouteValue': '{channel} vía {authMode}',
  'privacy.dataKind.messages': 'Mensajes',
  'privacy.dataKind.agents': 'Agentes',
  'privacy.dataKind.skills': 'Habilidades',
  'privacy.dataKind.system': 'Sistema',
  'privacy.dataKind.meetings': 'Reuniones',
  'privacy.dataKind.reminders': 'Recordatorios',
  'privacy.dataKind.important': 'Importante',
  'onboarding.enableLocalAI': 'Activar IA local',
  'onboarding.skills.status.available': 'Disponible',
  'onboarding.skills.status.connected': 'Conectado',
  'onboarding.skills.status.connecting': 'Conectando',
  'onboarding.skills.status.error': 'error',
  'onboarding.skills.status.unavailable': 'No disponible',
  'composio.statusUnavailable': 'Estado no disponible',
  'composio.authExpired': 'Autenticación caducada',
  'composio.reconnect': 'Reconectar',
  'composio.expiredAuthorization': '{name} autorización vencida',
  'composio.expiredDescription':
    'Vuelva a conectarse para volver a habilitar las herramientas {name}. OpenHuman mantendrá esta integración no disponible hasta que actualice el acceso de OAuth.',
  'composio.envVarOverrides': 'está configurada, reemplaza esta configuración.',
  'composio.previewBadge': 'Vista previa',
  'composio.previewTooltip':
    'La integración del agente estará disponible próximamente: puede conectarse, pero el agente aún no puede usar este kit de herramientas.',
  'memory.day.sun': 'Dom',
  'memory.day.mon': 'Lun',
  'memory.day.tue': 'Mar',
  'memory.day.wed': 'Mié',
  'memory.day.thu': 'Jue',
  'memory.day.fri': 'Vie',
  'memory.day.sat': 'Sáb',
  'memory.ingesting': 'Ingiriendo',
  'memory.ingestionQueued': 'En cola',
  'memory.ingestingTitle': 'Ingiriendo {title}',
  'mic.noAudioCaptured': 'No se capturó audio',
  'mic.noSpeechDetected': 'No se detectó habla',
  'mic.lowConfidenceResult': 'No se pudo entender el audio con claridad: intenta de nuevo',
  'mic.failedToStopRecording': 'No se pudo detener la grabación: {message}',
  'mic.transcriptionFailed': 'Transcripción fallida: {message}',
  'mic.voiceNotCompiled':
    'La transcripción de voz no está incluida en esta versión de la aplicación. Actualiza OpenHuman para activarla.',
  'reflections.kind.retrospective': 'Retrospectiva',
  'reflections.kind.derivedFact': 'Hecho derivado',
  'reflections.kind.moodInsight': 'Insight de ánimo',
  'reflections.kind.relationshipInsight': 'Insight de relación',
  'graph.tooltip.summary': 'Resumen',
  'graph.tooltip.contact': 'Contacto',
  'localModel.usage.never': 'Nunca',
  'localModel.usage.mediumLoad': 'Carga media',
  'localModel.usage.lowLoad': 'Carga baja',
  'localModel.usage.idleMode': 'Modo inactivo',
  'localModel.rebootstrapComplete': 'Re-bootstrap del modelo completado.',
  'localModel.modelsVerified': 'Modelos locales verificados.',
  'accounts.addModal.allConnected': 'Todo conectado',
  'accounts.addModal.title': 'Agregar cuenta',
  'accounts.respondQueue.empty': 'Vacío',
  'accounts.respondQueue.hide': 'Ocultar cola de respuestas',
  'accounts.respondQueue.loadFailed': 'No se pudo cargar la cola de respuestas',
  'accounts.respondQueue.loading': 'Cargando cola…',
  'accounts.respondQueue.pending': 'Pendiente',
  'accounts.respondQueue.show': 'Mostrar cola de respuestas',
  'accounts.respondQueue.title': 'Cola de respuestas',
  'accounts.webviewHost.almostReady': 'Casi listo...',
  'accounts.webviewHost.loadTimeout': 'Tiempo de carga agotado',
  'accounts.webviewHost.loading': 'Cargando {providerName}...',
  'accounts.webviewHost.loadingAccount': 'Cargando cuenta',
  'accounts.webviewHost.restoringSession': 'Restaurando sesión...',
  'accounts.webviewHost.retryLoading': 'Reintentar carga',
  'accounts.webviewHost.takingLonger': '{providerName} está tardando más de lo esperado.',
  'accounts.webviewHost.timeoutHint': 'Pista de tiempo agotado',
  'app.connectionBadge.composio': 'Composio',
  'app.connectionBadge.messaging': 'Mensajería',
  'app.connectionIndicator.connected': 'Conectado a OpenHuman AI 🚀',
  'app.connectionIndicator.connecting': 'Conectando',
  'app.connectionIndicator.coreOffline': 'Core sin conexión',
  'app.connectionIndicator.disconnected': 'Desconectado',
  'app.connectionIndicator.offline': 'Sin conexión',
  'app.connectionIndicator.reconnecting': 'Reconectando…',
  'app.errorFallback.componentStack': 'Pila de componentes',
  'app.errorFallback.contactSupport': 'Contactar con soporte',
  'app.errorFallback.copyEventId': 'Copiar',
  'app.errorFallback.eventIdCopied': 'Copiado',
  'app.errorFallback.eventIdLabel': 'ID de error',
  'app.errorFallback.revealLogs': 'Mostrar registros',
  'app.errorFallback.downloadLatest': 'Descargar la última versión',
  'app.errorFallback.heading': 'Encabezado',
  'app.errorFallback.hint': 'Sugerencia',
  'app.errorFallback.reloadApp': 'Recargar app',
  'app.errorFallback.subheading': 'Subtítulo',
  'app.errorFallback.tryRecover': 'Intentar recuperar',
  'app.localAiDownload.installing': 'Instalando...',
  'app.localAiDownload.preparing': 'Preparando...',
  'app.openhumanLink.accounts.continueWith': 'Continuar con inicio de sesión de {label}',
  'app.openhumanLink.accounts.done': 'Listo',
  'app.openhumanLink.accounts.intro': 'Introducción',
  'app.openhumanLink.accounts.webviewNote': 'Nota de webview',
  'app.openhumanLink.billing.openDashboard': 'Abrir panel',
  'app.openhumanLink.billing.stayOnTrial': 'Continuar con prueba',
  'app.openhumanLink.billing.trialCredit': 'Créditos de registro',
  'app.openhumanLink.billing.trialDesc':
    'Las ofertas de créditos pueden variar según la promoción y la elegibilidad de la cuenta.',
  'app.openhumanLink.defaultBody':
    'Aún no está listo en el menú emergente. Abre la página completa de ajustes cuando la necesites.',
  'app.openhumanLink.discord.intro': 'Introducción',
  'app.openhumanLink.discord.openInvite': 'Abrir invitación',
  'app.openhumanLink.discord.perk1': 'Ventaja 1',
  'app.openhumanLink.discord.perk2': 'Ventaja 2',
  'app.openhumanLink.discord.perk3': 'Ventaja 3',
  'app.openhumanLink.discord.perk4': 'Ventaja 4',
  'app.openhumanLink.discordReport.intro':
    'Lo sentimos: algo falló de nuestra parte. Intentamos registrar estos errores automáticamente, pero compartir los detalles en Discord nos ayuda a solucionarlo más rápido.',
  'app.openhumanLink.discordReport.openDiscord': 'Abrir Discord',
  'app.openhumanLink.done': 'Listo',
  'app.openhumanLink.notifications.desktopOnly':
    'Las notificaciones nativas solo están disponibles en la aplicación de escritorio (ejecuta `pnpm dev:app`).',
  'app.openhumanLink.notifications.permissionOff':
    'El permiso de notificaciones está desactivado. Habilita OpenHuman en Configuración del sistema → Notificaciones y vuelve a intentarlo.',
  'app.openhumanLink.notifications.triggerFailed':
    'OpenHuman no pudo activar una notificación del sistema. Revisa la configuración de notificaciones del sistema operativo y vuelve a intentarlo.',
  'app.openhumanLink.notifications.welcomeBody':
    'Recibirás avisos aquí cuando algo necesite tu atención.',
  'app.openhumanLink.notifications.welcomeTitle': 'OpenHuman está listo',
  'app.openhumanLink.status.closed': 'Cerrado',
  'app.openhumanLink.status.connected': 'Conectado',
  'app.openhumanLink.status.error': 'Error',
  'app.openhumanLink.status.loading': 'Cargando…',
  'app.openhumanLink.status.needsSignIn': 'Requiere iniciar sesión',
  'app.openhumanLink.status.timedOut': 'Tiempo agotado',
  'app.openhumanLink.loadingChannelSetup': 'Cargando configuración de canal',
  'app.openhumanLink.maybeLater': 'Quizás después',
  'app.openhumanLink.notifications.asking': 'Consultando tu sistema operativo…',
  'app.openhumanLink.notifications.blocked': 'Bloqueado',
  'app.openhumanLink.notifications.blockedStep1': 'Paso bloqueado 1',
  'app.openhumanLink.notifications.blockedStep2': 'Paso bloqueado 2',
  'app.openhumanLink.notifications.blockedStep3': 'Paso bloqueado 3',
  'app.openhumanLink.notifications.intro': 'Introducción',
  'app.openhumanLink.notifications.promptHint': 'Sugerencia de permiso',
  'app.openhumanLink.notifications.retry': 'Reintentar notificación de prueba',
  'app.openhumanLink.notifications.send': 'Enviar notificación de prueba',
  'app.openhumanLink.notifications.sendFailed': 'No se pudo enviar: {error}',
  'app.openhumanLink.notifications.sent':
    'Notificación de prueba enviada. Si no la recibiste, ve a Ajustes del sistema → Notificaciones → OpenHuman, activa Permitir notificaciones y configura el estilo de banner como Persistente.',
  'app.openhumanLink.skipForNow': 'Omitir por ahora',
  'app.openhumanLink.telegramUnavailable': 'Telegram no disponible',
  'app.openhumanLink.title.accounts': 'Conecta tus apps',
  'app.openhumanLink.title.billing': 'Facturación y créditos',
  'app.openhumanLink.title.discord': 'Únete a la comunidad',
  'app.openhumanLink.title.discordReport': 'Reportar este error',
  'app.openhumanLink.title.messaging': 'Conecta un canal de chat',
  'app.openhumanLink.title.notifications': 'Permitir notificaciones',
  'app.persistRehydration.body': 'Cuerpo',
  'app.persistRehydration.heading': 'Encabezado',
  'app.persistRehydration.resetCta': 'Restableciendo…',
  'app.persistRehydration.resetting': 'Restableciendo…',
  'app.routeLoading.initializing': 'Inicializando OpenHuman...',
  'app.update.currentlyOn': '{version}',
  'app.update.errorFallback': 'Algo salió mal durante la actualización.',
  'app.update.header.default': 'Actualización',
  'app.update.header.error': 'Actualización fallida',
  'app.update.header.installing': 'Instalando actualización',
  'app.update.header.readyToInstall': 'Actualización lista para instalar',
  'app.update.header.restarting': 'Reiniciando…',
  'app.update.later': 'Después',
  'app.update.newVersionReady': 'Una nueva versión está lista para instalar.',
  'app.update.progress.downloaded': '{amount} descargado',
  'app.update.progress.installing': 'Instalando la nueva versión…',
  'app.update.progress.restarting': 'Relanzando la app…',
  'app.update.progress.working': '{percent}%',
  'app.update.restartNote': 'Nota de reinicio',
  'app.update.restartNow': 'Reiniciar ahora',
  'app.update.versionReady': 'La versión {newVersion} está lista para instalar.',
  'channels.discord.accountLinked': 'Cuenta vinculada',
  'channels.discord.connect': 'Conectar',
  'channels.discord.linkTokenExpired': 'El token de enlace expiró. Inténtalo de nuevo.',
  'channels.discord.linkTokenInstruction': '{token}',
  'channels.discord.linkTokenLabel': 'Etiqueta de token de enlace',
  'channels.discord.linkTokenOnce': 'Token de enlace de un solo uso',
  'channels.discord.picker.allPermissionsOk':
    'El bot tiene todos los permisos requeridos en este canal.',
  'channels.discord.picker.botNotInServers': 'Bot no está en servidores',
  'channels.discord.picker.category': 'Categoría',
  'channels.discord.picker.channel': 'Canal',
  'channels.discord.picker.checkingPermissions': 'Verificando permisos',
  'channels.discord.picker.loadingChannels': 'Cargando canales...',
  'channels.discord.picker.loadingServers': 'Cargando servidores...',
  'channels.discord.picker.missingPermissions': 'Permisos faltantes',
  'channels.discord.picker.noChannels': 'No se encontraron canales de texto',
  'channels.discord.picker.noServers': 'No se encontraron servidores',
  'channels.discord.picker.selectChannel': 'Selecciona un canal',
  'channels.discord.picker.selectServer': 'Selecciona un servidor',
  'channels.discord.picker.server': 'Servidor',
  'channels.discord.picker.serverChannelSelection': 'Selección de servidor y canal',
  'channels.discord.savedRestartRequired': 'Canal guardado. Reinicia la app para activarlo.',
  'channels.telegram.connect': 'Conectar',
  'channels.telegram.managedDmConnecting': 'Conectando DM gestionado',
  'channels.telegram.managedDmTimeout': 'Tiempo de DM gestionado agotado',
  'channels.telegram.reconnect': 'Reconectar',
  'channels.telegram.savedRestartRequired': 'Canal guardado. Reinicia la app para activarlo.',
  'channels.web.alwaysAvailable': 'Siempre disponible',
  'chat.approval.approve': 'Aprobar',
  'chat.approval.alwaysAllow': 'Permitir siempre',
  'chat.approval.alwaysAllowHint':
    'Deje de solicitar esta herramienta: agréguela a su lista de permitidos siempre',
  'chat.approval.deciding': 'Laboral…',
  'chat.approval.deny': 'Denegar',
  'chat.approval.error': 'No se pudo registrar su decisión; inténtelo de nuevo.',
  'chat.approval.fallback': 'El agente quiere ejecutar una acción que necesita su aprobación.',
  'chat.approval.title': 'Aprobación necesaria',
  'chat.approval.tool': 'Herramienta:',
  'chat.flowApproval.title': 'El flujo de trabajo necesita aprobación',
  'chat.flowApproval.fallback':
    'Una ejecución de flujo de trabajo quiere realizar una acción que necesita tu aprobación.',
  'chat.flowApproval.tool': 'Herramienta:',
  'chat.flowApproval.flow': 'Flujo:',
  'chat.flowApproval.approve': 'Aprobar una vez',
  'chat.flowApproval.approveAlways': 'Aprobar siempre',
  'chat.flowApproval.approveAlwaysHint':
    'Omitir esta verificación en futuras ejecuciones de este flujo',
  'chat.flowApproval.deny': 'Denegar',
  'chat.flowApproval.deciding': 'Laboral…',
  'chat.flowApproval.error': 'No se pudo registrar su decisión; inténtelo de nuevo.',
  'chat.flowProposal.title': 'Propuesta de flujo de trabajo',
  'chat.flowProposal.subtitle': 'Revisa esta automatización antes de guardarla.',
  'chat.flowProposal.triggerLabel': 'Disparador',
  'chat.flowProposal.stepsLabel': 'Pasos',
  'chat.flowProposal.noSteps': 'No hay pasos adicionales.',
  'chat.flowProposal.requireApprovalHint': 'Cada acción saliente necesitará tu aprobación.',
  'chat.flowProposal.save': 'Guardar y activar',
  'chat.flowProposal.saving': 'Guardando…',
  'chat.flowProposal.openInCanvas': 'Abrir en el lienzo',
  'chat.flowProposal.dismiss': 'Descartar',
  'chat.flowProposal.error': 'No se pudo guardar el flujo de trabajo. Inténtalo de nuevo.',
  'chat.flowProposal.enableError':
    'Flujo de trabajo guardado, pero no se pudo activar. Inténtalo de nuevo o actívalo desde la página de Workflows.',
  'chat.flowProposal.savedConfirmation': 'Guardado',
  'chat.flowProposal.viewWorkflow': 'Ver flujo de trabajo',
  'chat.flowProposal.stepKind.agent': 'Agente',
  'chat.flowProposal.stepKind.toolCall': 'Acción',
  'chat.flowProposal.stepKind.httpRequest': 'Solicitud web',
  'chat.flowProposal.stepKind.code': 'Ejecutar código',
  'chat.flowProposal.stepKind.condition': 'Condición',
  'chat.flowProposal.stepKind.switch': 'Selector',
  'chat.flowProposal.stepKind.merge': 'Combinar',
  'chat.flowProposal.stepKind.splitOut': 'Dividir',
  'chat.flowProposal.stepKind.transform': 'Transformar',
  'chat.flowProposal.stepKind.outputParser': 'Interpretar resultado',
  'chat.flowProposal.stepKind.subWorkflow': 'Subflujo de trabajo',
  'channels.authMode.managed_dm': 'Iniciar sesión con OpenHuman',
  'channels.authMode.oauth': 'OAuth Iniciar sesión',
  'channels.authMode.bot_token': 'Utilice su propio token de bot',
  'channels.authMode.api_key': 'Utilice su propia clave API',
  'channels.fieldRequired': '{field} es requerido',
  'channels.mcp.title': 'MCP Servidores',
  'channels.mcp.description':
    'Explora y gestiona servidores de Model Context Protocol que amplían la IA con nuevas herramientas.',
  'channels.discord.displayName': 'Discord',
  'channels.discord.description': 'Enviar y recibir mensajes a través de Discord.',
  'channels.discord.authMode.bot_token.description': 'Proporcione su propio token de bot Discord.',
  'channels.discord.authMode.oauth.description':
    'Instale el bot OpenHuman en su servidor Discord a través de OAuth.',
  'channels.discord.authMode.managed_dm.description':
    'Vincula tu cuenta personal Discord al bot OpenHuman.',
  'channels.discord.fields.bot_token.label': 'Ficha de robot',
  'channels.discord.fields.bot_token.placeholder': 'Tu token de bot Discord',
  'channels.discord.fields.guild_id.label': 'ID del servidor (gremio)',
  'channels.discord.fields.guild_id.placeholder': 'Opcional: restringir a un servidor específico',
  'channels.telegram.displayName': 'Telegram',
  'channels.telegram.description': 'Enviar y recibir mensajes a través de Telegram.',
  'channels.telegram.authMode.managed_dm.description':
    'Envíe un mensaje al bot OpenHuman Telegram directamente.',
  'channels.telegram.authMode.bot_token.description':
    'Proporcione su propio token de Bot Telegram de @BotFather.',
  'channels.telegram.fields.bot_token.label': 'Ficha de robot',
  'channels.telegram.fields.bot_token.placeholder': '123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11',
  'channels.telegram.fields.allowed_users.label': 'Usuarios permitidos',
  'channels.telegram.fields.allowed_users.placeholder':
    'Nombres de usuario Telegram separados por comas',
  'channels.telegram.remoteControlTitle': 'Control remoto (Telegram)',
  'channels.telegram.remoteControlBody':
    'Desde un chat Telegram permitido, envíe /status, /sessions, /new o /help. El enrutamiento de modelos todavía usa /model y /models.',
  'channels.connectHelp.title': 'Cómo conectar',
  'channels.connectHelp.discord':
    'Elige un método abajo: vincula tu cuenta con OpenHuman, instala el bot con OAuth o pega tu propio token de bot del portal para desarrolladores de Discord.',
  'channels.connectHelp.telegram':
    'Elige un método abajo: escribe al bot gestionado de OpenHuman para vincularlo, o pega tu propio token de bot de @BotFather.',
  'channels.connectHelp.slackNote':
    '¿Buscas Slack? Slack se conecta como una app en Conexiones → OAuth, no como un canal de mensajería aquí.',
  'channels.web.displayName': 'Web',
  'channels.web.description': 'Chatea a través de la interfaz de usuario web incorporada.',
  'channels.web.authMode.managed_dm.description':
    'Utilice el chat web integrado: no requiere configuración.',
  'channels.yuanbao.connect': 'Connect',
  'channels.yuanbao.connecting': 'Conectando…',
  'channels.yuanbao.fieldRequired': '{field} es obligatorio',
  'channels.yuanbao.reconnect': 'Reconnect',
  'channels.yuanbao.savedRestartRequired': 'Canal guardado. Reinicia la aplicación para activarlo.',
  'channels.yuanbao.unexpectedStatus': 'Estado de conexión inesperado: {status}',
  'chat.unsubscribeApproval.approve': 'Aprobar y darse de baja',
  'chat.unsubscribeApproval.approved': '✓ Baja realizada con éxito.',
  'chat.unsubscribeApproval.denied': '✕ Solicitud denegada.',
  'chat.unsubscribeApproval.deny': 'Denegar',
  'chat.unsubscribeApproval.processing': 'Procesando...',
  'chat.unsubscribeApproval.title': 'Solicitud de baja',
  'commandPalette.ariaLabel': 'Paleta de comandos',
  'commandPalette.description': 'Descripción',
  'commandPalette.label': 'Comandos',
  'commandPalette.noResults': 'Sin resultados',
  'commandPalette.placeholder': 'Escribe un comando o busca…',
  'commandPalette.searchAria': 'Buscar comandos',
  'commandPalette.shortcutHint': 'Pulsa ? para ver todos los atajos',
  'commandPalette.title': 'Paleta de comandos',
  'kbd.ariaLabel': 'Atajo de teclado: {shortcut}',
  'shortcuts.title': 'Atajos de teclado',
  'shortcuts.subtitle': 'Agiliza tu flujo de trabajo con estos atajos de teclado.',
  'shortcuts.menuDesc': 'Explora todos los atajos de teclado de la aplicación.',
  'shortcuts.empty': 'No hay atajos de teclado disponibles en este momento.',
  'shortcuts.openHint': 'Abre esta lista en cualquier momento con',
  'shortcuts.group.navigation': 'Navegación',
  'shortcuts.group.profiles': 'Perfiles',
  'shortcuts.group.chat': 'Chat',
  'shortcuts.group.view': 'Vista',
  'shortcuts.group.general': 'General',
  'shortcuts.group.help': 'Ayuda',
  'shortcuts.action.home': 'Ir al inicio',
  'shortcuts.action.chat': 'Ir al chat',
  'shortcuts.action.knowledge': 'Ir a Conocimiento y memoria',
  'shortcuts.action.connections': 'Ir a Conexiones',
  'shortcuts.action.activity': 'Ir a Actividad',
  'shortcuts.action.settings': 'Abrir Configuración',
  'shortcuts.action.newChat': 'Nuevo chat',
  'shortcuts.action.toggleSidebar': 'Mostrar/ocultar barra lateral',
  'shortcuts.action.commandPalette': 'Paleta de comandos',
  'iosMascot.connectedTo': 'Conectado a',
  'iosMascot.defaultPairedLabel': 'Escritorio',
  'iosMascot.disconnect': 'Desconectar',
  'iosMascot.error.generic': 'Algo salió mal. Por favor inténtalo de nuevo.',
  'iosMascot.error.sendFailed': 'No se pudo enviar. Comprueba tu conexión.',
  'iosMascot.pushToTalk': 'Empuja para hablar',
  'iosMascot.sendMessage': 'enviar mensaje',
  'iosMascot.thinking': 'Pensando...',
  'iosMascot.typeMessage': 'Escribe un mensaje...',
  'iosPair.connectedLoading': '¡Conectado! Cargando...',
  'iosPair.connecting': 'Conectándose al escritorio...',
  'iosPair.desktopLabel': 'Escritorio',
  'iosPair.error.camera':
    'Error al escanear con la cámara. Comprueba los permisos de cámara e inténtalo de nuevo.',
  'iosPair.error.connectionFailed':
    'Error de conexión. Asegúrate de que la aplicación de escritorio esté en ejecución e inténtalo de nuevo.',
  'iosPair.error.invalidQr':
    'Código QR no válido. Asegúrate de escanear un código de vinculación de OpenHuman.',
  'iosPair.error.unreachableDesktop':
    'No se pudo acceder al escritorio. Asegúrate de que ambos dispositivos estén en línea e inténtalo de nuevo.',
  'iosPair.expired': 'QR code expiró. Pídale al escritorio que regenere el código.',
  'iosPair.instructions':
    'Abre OpenHuman en tu escritorio, ve a Configuración > Dispositivos y pulsa «Vincular teléfono» para mostrar el código QR.',
  'iosPair.retryScan': 'Reintentar escaneo',
  'iosPair.scanQrCode': 'Escanear QR code',
  'iosPair.scannerOpening': 'Apertura del escáner...',
  'iosPair.step.openDesktop': 'Abra OpenHuman en el escritorio',
  'iosPair.step.openSettings': 'Vaya a Configuración > Dispositivos',
  'iosPair.step.showQr': 'Toca "Emparejar teléfono" para mostrar QR',
  'iosPair.title': 'Emparéjalo con tu escritorio',
  'composio.connect.additionalConfigRequired': 'Configuración adicional requerida',
  'composio.connect.atlassianSubdomainHint': 'cumbre',
  'composio.connect.atlassianSubdomainLabel': 'Etiqueta de subdominio de Atlassian',
  'composio.connect.connect': 'Conectar',
  'composio.connect.connectedAccounts': 'Cuentas conectadas',
  'composio.connect.defaultLabel': 'Predeterminada',
  'composio.connect.disconnectAccount': 'Eliminar',
  'composio.connect.addAnotherAccount': 'Agregar otra cuenta',
  'composio.connect.dynamicsOrgNameHint':
    'Por ejemplo, "myorg" para myorg.crm.dynamics.com. Introduce solo el nombre corto de la organización, no la URL completa.',
  'composio.connect.dynamicsOrgNameLabel': 'Nombre de la organización de Dynamics 365',
  'composio.connect.connectionFailed': 'Falló la conexión (estado: {status}).',
  'composio.connect.disconnectFailed': 'Desconexión fallida: {msg}',
  'composio.connect.disconnecting': 'Desconectando…',
  'composio.connect.idleDescription': 'Conecta tu',
  'composio.connect.idleDescriptionSuffix':
    'cuenta. Abriremos una ventana del navegador, apruebas el acceso allí, y esta app detectará la conexión automáticamente.',
  'composio.connect.isConnected': 'está conectado.',
  'composio.connect.manage': 'Gestionar',
  'composio.connect.needsFieldsPrefix': 'Para conectar',
  'composio.connect.needsFieldsSuffix':
    'necesitamos un poco más de información. Completa los campos que faltan abajo y vuelve a intentarlo.',
  'composio.connect.needsSubdomain': 'Para conectar',
  'composio.connect.needsSubdomainSuffix':
    'introduce tu subdominio de Atlassian (p. ej. acme para acme.atlassian.net) e inténtalo de nuevo.',
  'composio.connect.oauthComplete': 'OAuth por completar…',
  'composio.connect.oauthTimeout': 'Tiempo de OAuth agotado',
  'composio.connect.permissions': 'Permisos',
  'composio.connect.permissionsDefault': 'Lectura + Escritura habilitados por defecto',
  'composio.connect.permissionsNote': 'puede exponer',
  'composio.connect.permissionsNoteSuffix':
    'los propios permisos del agente de OpenHuman se controlan abajo con conmutadores de lectura, escritura y administración.',
  'composio.connect.reopenBrowser': 'Reabrir navegador',
  'composio.connect.requestingUrl': 'Solicitando URL de conexión…',
  'composio.connect.requiredFieldEmpty': 'Este campo es obligatorio.',
  'composio.connect.retryConnection': 'Reintentar conexión',
  'composio.connect.scopeLoadError': 'No se pudieron cargar las preferencias de alcance: {msg}',
  'composio.connect.scopeSaveError': 'No se pudo guardar el alcance {key}: {msg}',
  'composio.connect.scope.read': 'leer',
  'composio.connect.scope.readHint': 'Permita que el agente lea datos de esta conexión.',
  'composio.connect.scope.write': 'escribir',
  'composio.connect.scope.writeHint':
    'Permita que el agente cree o modifique datos a través de esta conexión.',
  'composio.connect.scope.admin': 'administrador',
  'composio.connect.scope.adminHint':
    'Permitir que el agente administre configuraciones, permisos o acciones destructivas.',
  'composio.connect.subdomainInvalid':
    'Introduce solo el subdominio corto (p. ej. "acme"), no la URL completa. Debe contener solo letras, números y guiones.',
  'composio.connect.subdomainRequired': 'Ingresa tu subdominio de Atlassian para continuar.',
  'composio.connect.wabaIdHint':
    'Encuéntralo mediante GET /me/businesses y luego GET /{business_id}/owned_whatsapp_business_accounts usando tu token de acceso de Meta.',
  'composio.connect.wabaIdLabel': 'Etiqueta de ID de WABA',
  'composio.connect.atlassianSubdomainPlaceholder': 'your-subdomain',
  'composio.connect.dynamicsOrgNamePlaceholder': 'myorg',
  'composio.connect.wabaIdPlaceholder': 'e.g. 123456789012345',
  'composio.connect.wabaIdRequired':
    'Ingresa tu ID de cuenta de WhatsApp Business (WABA ID) para continuar.',
  'composio.connect.waitingFor': 'Esperando a',
  'composio.connect.waitingHint': 'Sugerencia de espera',
  'composio.triggers.heading': 'Disparadores',
  'composio.triggers.listenFrom': 'Escuchar eventos de',
  'composio.triggers.loadError': 'No se pudieron cargar los triggers',
  'composio.triggers.sessionExpired':
    'Tu sesión de OpenHuman ha caducado. Vuelve a iniciar sesión para cargar los triggers.',
  'composio.triggers.needsConfiguration': 'Necesita configuración',
  'composio.triggers.noneAvailable': 'Actualmente no hay triggers disponibles para',
  'conversations.taskKanban.moveLeft': 'Mover a la izquierda',
  'conversations.taskKanban.moveRight': 'Mover a la derecha',
  'conversations.taskKanban.title': 'Tareas',
  'conversations.threadTodo.title': 'Plan',
  'conversations.planReview.title': 'Revisar plan',
  'conversations.planReview.subtitle':
    'Aprueba para ejecutarlo, recházalo para descartarlo o envía comentarios para revisarlo.',
  'conversations.planReview.approve': 'Aprobar y ejecutar',
  'conversations.planReview.reject': 'Rechazar',
  'conversations.planReview.feedbackLabel': 'Solicitar cambios',
  'conversations.planReview.feedbackPlaceholder': 'Describe qué cambiar…',
  'conversations.planReview.sendFeedback': 'Enviar comentarios',
  'conversations.threadGoal.label': 'Objetivo',
  'conversations.threadGoal.setCta': 'Definir objetivo',
  'conversations.threadGoal.placeholder': '¿Qué debe lograr este hilo?',
  'conversations.threadGoal.save': 'Guardar',
  'conversations.threadGoal.cancel': 'Cancelar',
  'conversations.threadGoal.edit': 'Editar objetivo',
  'conversations.threadGoal.clear': 'Borrar objetivo',
  'conversations.threadGoal.complete': 'Marcar como completado',
  'conversations.threadGoal.pause': 'Pausar',
  'conversations.threadGoal.resume': 'Reanudar',
  'conversations.threadGoal.tokensSuffix': 'tokens',
  'conversations.threadGoal.status.active': 'Activo',
  'conversations.threadGoal.status.paused': 'En pausa',
  'conversations.threadGoal.status.budget_limited': 'Presupuesto agotado',
  'conversations.threadGoal.status.complete': 'Completado',
  'conversations.taskKanban.approval.default': 'Por defecto',
  'conversations.taskKanban.approval.notRequired': 'No requerido',
  'conversations.taskKanban.approval.notRequiredBadge': 'sin aprobación',
  'conversations.taskKanban.approval.required': 'Requerido',
  'conversations.taskKanban.approval.requiredBadge': 'aprobación',
  'conversations.taskKanban.approval.requiredBeforeExecution': 'Requerido antes de la ejecución',
  'conversations.taskKanban.briefButton': 'Resumen de la tarea',
  'conversations.taskKanban.briefTitle': 'Resumen de la tarea',
  'conversations.taskKanban.closeBrief': 'Cerrar resumen de tarea',
  'conversations.taskKanban.field.acceptanceCriteria': 'Criterios de aceptación',
  'conversations.taskKanban.field.allowedTools': 'Herramientas permitidas',
  'conversations.taskKanban.field.approval': 'Aprobación',
  'conversations.taskKanban.field.assignedAgent': 'Agente asignado',
  'conversations.taskKanban.field.blocker': 'bloqueador',
  'conversations.taskKanban.field.evidence': 'Evidencia',
  'conversations.taskKanban.field.notes': 'Notas',
  'conversations.taskKanban.field.objective': 'Objetivo',
  'conversations.taskKanban.field.plan': 'Plan',
  'conversations.taskKanban.field.status': 'Estado',
  'conversations.taskKanban.field.title': 'Título',
  'conversations.taskKanban.saveChanges': 'Guardar cambios',
  'conversations.taskKanban.deleteCard': 'Borrar',
  'conversations.taskKanban.workTask': 'Trabajar tarea',
  'conversations.taskKanban.viewWork': 'Ver trabajo',
  'conversations.taskKanban.startingTask': 'Iniciando…',
  'conversations.taskKanban.updateFailed':
    'No se pudo actualizar la tarea; los cambios no se guardaron.',
  'conversations.taskKanban.sourcesButton': 'Fuentes',
  'conversations.taskKanban.source.openExternal': 'Abrir tarea externa',
  'conversations.taskKanban.source.openExternalShort': 'Abrir',
  'conversations.taskKanban.source.unknownProvider': 'Fuente desconocida',
  'conversations.taskKanban.source.urgencyValue': 'Urgencia {percent}%',
  'conversations.taskKanban.sources.desktopOnly':
    'Los controles de fuentes de tareas están disponibles en la app de escritorio.',
  'conversations.taskKanban.sources.title': 'Fuentes de tareas',
  'conversations.taskKanban.sources.statusEnabled': 'Sondeo automático activado',
  'conversations.taskKanban.sources.manage': 'Gestionar fuentes',
  'conversations.taskKanban.source.title': 'Fuente',
  'conversations.taskKanban.source.sourceId': 'ID de fuente',
  'conversations.taskKanban.source.externalId': 'ID externo',
  'conversations.taskKanban.source.repo': 'Repositorio',
  'conversations.taskKanban.source.urgency': 'Urgencia',
  'conversations.toolTimeline.turn': 'turno',
  'conversations.toolTimeline.step': 'Paso',
  'conversations.toolTimeline.workerThread': 'hilo de worker',
  'conversations.subagent.viewProcessing': 'Ver procesamiento completo',
  'conversations.subagent.parent': 'Principal',
  'conversations.subagent.thinking': 'Pensando',
  'conversations.subagent.thoughts': 'Pensamientos',
  'conversations.subagent.response': 'Respuesta',
  'conversations.subagent.toolCalls': 'Llamadas a herramientas',
  'conversations.subagent.working': 'Trabajando…',
  'conversations.subagent.noOutputYet': 'Aún no hay resultados',
  'conversations.subagent.input': 'Entrada',
  'conversations.subagent.output': 'Salida',
  'conversations.subagent.noOutput': 'No se devolvió ninguna salida',
  'conversations.subagent.close': 'Cerrar',
  'conversations.subagent.cancel': 'Cancelar tarea',
  'conversations.subagent.cancelling': 'Cancelando…',
  'conversations.subagent.cancelFailed': 'No se pudo cancelar la tarea. Inténtalo de nuevo.',
  'conversations.subagent.statusRunning': 'en ejecución',
  'conversations.subagent.statusCompleted': 'completado',
  'conversations.subagent.statusFailed': 'fallido',
  'conversations.subagent.statusAwaitingUser': 'esperando al usuario',
  'conversations.subagent.statusCancelled': 'cancelado',
  'conversations.agentTaskInsights.title': 'Información de tareas del agente',
  'conversations.agentTaskInsights.response': 'Respuesta',
  'conversations.agentTaskInsights.processSourceTitle': 'Fuente del proceso del agente',
  'conversations.agentTaskInsights.stepsHeading': 'Pasos',
  'conversations.agentTaskInsights.sourcesHeading': 'Fuentes',
  'conversations.agentTaskInsights.noSteps': 'No hay pasos registrados',
  'conversations.agentTaskInsights.viewProcessSource':
    'Ver la fuente completa del proceso del agente',
  'conversations.agentTaskInsights.processing': 'Procesando',
  'conversations.agentTaskInsights.done': 'Listo',
  'conversations.agentTaskInsights.failed': 'Fallido',
  'conversations.agentTaskInsights.running': 'En curso',
  'conversations.agentTaskInsights.cancelled': 'Cancelado',
  'conversations.agentTaskInsights.awaitingUser': 'Esperando entrada',
  'conversations.agentTaskInsights.viewDetails': 'Ver detalles',
  'conversations.agentTaskInsights.subagentsHeading': 'Subagentes',
  'daemon.serviceBlockingGate.body': 'Cuerpo',
  'daemon.serviceBlockingGate.downloadHint': 'Sugerencia de descarga',
  'daemon.serviceBlockingGate.downloadLatest': 'Descargar la última versión',
  'daemon.serviceBlockingGate.retryCore': 'Reintentar Core',
  'daemon.serviceBlockingGate.retryFailed':
    'Reintento fallido. Descarga la última versión de la app e inténtalo de nuevo.',
  'daemon.serviceBlockingGate.retrying': 'Reintentando...',
  'daemon.serviceBlockingGate.title': 'El core de OpenHuman no está disponible',
  'home.banners.discordSubtitle': 'Subtítulo de Discord',
  'home.banners.discordTitle': 'Únete a nuestro Discord',
  'home.banners.earlyBirdDismiss': 'Descartar banner de early bird',
  'home.banners.earlyBirdFirstSub': 'primera suscripción.',
  'home.banners.earlyBirdOn': 'Early bird activo',
  'home.banners.earlyBirdTitle': 'Los primeros 1.000 usuarios obtienen un 60% de descuento.',
  'home.banners.earlyBirdUseCode': 'Usar código early bird',
  'home.banners.getSubscription': 'obtener una suscripción',
  'home.banners.promoCreditsBody': 'Tienes {amount} en créditos promocionales. Puedes',
  'home.banners.promoCreditsUsage': 'Uso de créditos promocionales',
  'intelligence.memoryChunk.detail.chunk': 'Fragmento',
  'intelligence.memoryChunk.detail.copyChunkId': 'Copiar ID de fragmento',
  'intelligence.memoryChunk.detail.embeddingInfo': 'bge-m3 1024dim',
  'intelligence.memoryChunk.detail.noEmbedding': 'Sin embedding',
  'intelligence.memoryChunk.letterhead.from': 'de',
  'intelligence.memoryChunk.letterhead.to': 'a',
  'intelligence.memoryChunk.mentioned.chunkOne': '1 fragmento',
  'intelligence.memoryChunk.mentioned.chunkOther': '{count} fragmentos',
  'intelligence.memoryChunk.mentioned.heading': 'm e n c i o n a d o',
  'intelligence.memoryChunk.scoreBars.ariaScore': '{name} puntuación {pct} por ciento',
  'intelligence.memoryChunk.scoreBars.atThreshold': 'en {threshold}',
  'intelligence.memoryChunk.scoreBars.dropped': 'descartado',
  'intelligence.memoryChunk.scoreBars.heading': 'p o r   q u é   s e   c o n s e r v ó',
  'intelligence.memoryChunk.scoreBars.kept': 'conservado',
  'intelligence.diagram.title': 'Diagrama de arquitectura',
  'intelligence.diagram.description':
    'Última salida de arquitectura local desde el endpoint de diagrama configurado.',
  'intelligence.diagram.refresh': 'Refresh',
  'intelligence.diagram.refreshAria': 'Actualizar diagrama',
  'intelligence.diagram.emptyTitle': 'Aún no hay diagrama disponible',
  'intelligence.diagram.emptyDescription':
    'Genera un diagrama de arquitectura desde el orquestador y este panel se actualizará desde el endpoint local configurado.',
  'intelligence.diagram.skillInstallCommand': 'npx skills add yizhiyanhua-ai/fireworks-tech-graph',
  'intelligence.diagram.promptExample':
    'Genera un diagrama de arquitectura del enjambre actual en estilo de terminal oscuro',
  'intelligence.diagram.imageAlt': 'Último diagrama de arquitectura de OpenHuman generado',
  'intelligence.diagram.refreshesEvery': 'Se actualiza cada {seconds}s',
  'intelligence.memoryText.entityTypePrefix': 'Tipo de entidad',
  'intelligence.tasks.activeBoardOne': '1 tablero activo entre conversaciones',
  'intelligence.tasks.activeBoardOther': '{count} tableros activos entre conversaciones',
  'intelligence.tasks.empty': 'Sin tableros de tareas de agente aún',
  'intelligence.tasks.emptyHint': 'Sugerencia de vacío',
  'intelligence.tasks.failedToLoad': 'No se pudo cargar',
  'intelligence.tasks.live': 'en vivo',
  'intelligence.tasks.loadingBoards': 'Cargando tableros de tareas…',
  'intelligence.tasks.threadPrefix': 'Hilo {thread}',
  'intelligence.tasks.subtitle':
    'Sus tareas y paneles de tareas de agentes en todo el espacio de trabajo.',
  'intelligence.tasks.newTask': 'Nueva tarea',
  'intelligence.tasks.personalBoardTitle': 'Tareas del agente',
  'intelligence.tasks.personalEmpty': 'Aún no hay tareas personales',
  'intelligence.tasks.composer.title': 'Nueva tarea',
  'intelligence.tasks.composer.titleLabel': 'Título',
  'intelligence.tasks.composer.titlePlaceholder': '¿Qué hay que hacer?',
  'intelligence.tasks.composer.statusLabel': 'Estado',
  'intelligence.tasks.composer.attachLabel': 'Adjuntar a la conversación',
  'intelligence.tasks.composer.attachNone': 'Personal (sin conversación)',
  'intelligence.tasks.composer.objectiveLabel': 'Objetivo',
  'intelligence.tasks.composer.objectivePlaceholder': 'Opcional: el resultado deseado',
  'intelligence.tasks.composer.notesLabel': 'Notas',
  'intelligence.tasks.composer.notesPlaceholder': 'Notas opcionales',
  'intelligence.tasks.composer.create': 'Crear tarea',
  'intelligence.tasks.composer.creating': 'Creando…',
  'intelligence.tasks.composer.createFailed': 'No se pudo crear la tarea',
  'intelligence.tasks.composer.assignAgentLabel':
    'Deja que un agente se encargue de esto automáticamente',
  'intelligence.tasks.composer.assignAgentHint':
    'El tablero de tareas la toma y la ejecuta por ti. Déjalo desactivado para una tarea personal simple.',
  'intelligence.tasks.sourceList.subtitle':
    'Tareas de fuentes esperando convertirse en trabajo del agente.',
  'intelligence.tasks.sourceList.empty': 'No hay tareas de fuentes en espera.',
  'intelligence.tasks.sourceList.queued': 'En cola',
  'intelligence.tasks.sourceList.workOnTask': 'Trabajar en la tarea',
  'intelligence.tasks.sourcePlan.title': 'Refinar tarea de fuente',
  'intelligence.tasks.sourcePlan.subtitle':
    'Revisa el borrador de investigación antes de crear una tarea de agente.',
  'intelligence.tasks.sourcePlan.researchAgent': 'Borrador del agente investigador',
  'intelligence.tasks.sourcePlan.approve': 'Aprobar plan',
  'intelligence.tasks.sourcePlan.creating': 'Creando tarea…',
  'intelligence.tasks.sourcePlan.createFailed': 'No se pudo crear la tarea del agente',
  'intelligence.tasks.workTaskFailed': 'No se pudo iniciar el trabajo en la tarea',
  'intelligence.workTask.sourceTaskHeading': 'Tarea de origen:',
  'intelligence.workTask.repositoryLine': '- Repositorio: {repo}',
  'intelligence.workTask.externalIdLine': '- ID externo: {externalId}',
  'intelligence.workTask.urlLine': '- Dirección: {url}',
  'intelligence.workTask.closingInstruction':
    'Empieza reformulando brevemente el plan de implementación concreto y luego ejecútalo. Mantén el progreso visible en este hilo y actualiza el tablero de tareas cuando cambie el estado del trabajo.',
  'intelligence.agentWork.subtitle':
    'Cada ejecución de agente en segundo plano, agrupada por estado del ciclo de vida.',
  'intelligence.agentWork.loading': 'Cargando trabajo del agente…',
  'intelligence.agentWork.failedToLoad': 'No se pudo cargar el trabajo del agente',
  'intelligence.agentWork.empty': 'Aún no hay ejecuciones de agente en segundo plano.',
  'intelligence.agentWork.bucket.needsInput': 'Requiere intervención',
  'intelligence.agentWork.bucket.working': 'En curso',
  'intelligence.agentWork.bucket.completed': 'Completado',
  'intelligence.agentWork.bucket.failed': 'Fallido',
  'intelligence.agentWork.bucket.stopped': 'Detenido',
  'intelligence.agentWork.column.agent': 'Agente',
  'intelligence.agentWork.column.status': 'Estado',
  'intelligence.agentWork.column.elapsed': 'Transcurrido',
  'intelligence.agentWork.column.cost': 'Costo',
  'intelligence.agentWork.column.tokens': 'Fichas',
  'intelligence.agentWork.status.pending': 'Pendiente',
  'intelligence.agentWork.status.running': 'En ejecución',
  'intelligence.agentWork.status.awaitingUser': 'Requiere intervención',
  'intelligence.agentWork.status.paused': 'Pausado',
  'intelligence.agentWork.status.completed': 'Completado',
  'intelligence.agentWork.status.failed': 'Fallido',
  'intelligence.agentWork.status.cancelled': 'Cancelado',
  'intelligence.agentWork.status.interrupted': 'Interrumpido',
  'intelligence.agentWork.kind.subagent': 'Subagente',
  'intelligence.agentWork.kind.workerThread': 'Hilo de worker',
  'intelligence.agentWork.kind.backgroundAgent': 'Agente en segundo plano',
  'intelligence.agentWork.kind.teamMember': 'Miembro del equipo',
  'intelligence.agentWork.kind.workflowChild': 'Hijo de flujo de trabajo',
  'intelligence.agentWork.openThread': 'Abrir hilo',
  'intelligence.agentWork.openWorker': 'Abrir trabajador',
  'worktree.label': 'Worktree',
  'worktree.dirty': 'Cambios sin confirmar',
  'worktree.clean': 'Limpio',
  'worktree.changedFile': 'archivo modificado',
  'worktree.changedFiles': 'archivos modificados',
  'worktree.removing': 'Eliminando…',
  'worktree.removeFailed': 'No se pudo eliminar el worktree',
  'worktree.diffFailed': 'No se pudo cargar el diff',
  'worktree.diffLoading': 'Cargando diff…',
  'worktree.diffEmpty': 'Sin cambios respecto a HEAD.',
  'worktree.dirtyConfirm':
    'Este worktree tiene cambios sin confirmar. Eliminarlo descarta ese trabajo. La rama del worker se conserva.',
  'worktree.action.open': 'Abrir carpeta',
  'worktree.action.diff': 'Diff',
  'worktree.action.hideDiff': 'Ocultar diff',
  'worktree.action.remove': 'Eliminar',
  'worktree.action.removeAnyway': 'Descartar y eliminar',
  'worktree.action.preserve': 'Conservar',
  'worktree.panel.subtitle':
    'Worktrees de git aislados creados por workers de agentes en paralelo.',
  'worktree.panel.loading': 'Cargando worktrees…',
  'worktree.panel.failedToLoad': 'No se pudieron cargar los worktrees',
  'worktree.panel.empty':
    'No hay worktrees aislados. Los workers en paralelo con aislamiento de worktree aparecerán aquí.',
  'worktree.panel.overlapsTitle': 'Cambios superpuestos',
  'worktree.panel.overlapHint':
    'Estos archivos fueron modificados por más de un worktree: concilia antes de fusionar.',
  'intelligence.agentWork.action.stop': 'Detener',
  'intelligence.agentWork.action.retry': 'Reintentar',
  'intelligence.agentWork.action.continue': 'Continuar',
  'intelligence.agentWork.action.followUp': 'Hacer seguimiento',
  'intelligence.agentWork.action.send': 'Enviar',
  'intelligence.agentWork.action.cancel': 'Cancelar',
  'intelligence.agentWork.action.continuePlaceholder': 'Responde para desbloquear este agente…',
  'intelligence.agentWork.action.followUpPlaceholder': 'Envía una instrucción de seguimiento…',
  'intelligence.agentWork.action.failed': 'La acción falló',
  'intelligence.teams.subtitle': 'Equipos de agentes coordinados y las tareas que comparten.',
  'intelligence.teams.loading': 'Cargando equipos…',
  'intelligence.teams.failedToLoad': 'Error al cargar los equipos',
  'intelligence.teams.empty': 'Aún no hay equipos de agentes',
  'intelligence.teams.emptyHint':
    'Los equipos aparecen aquí cuando un agente genera subagentes coordinados para compartir un objetivo.',
  'intelligence.teams.refresh': 'Actualizar',
  'intelligence.teams.backToList': 'Todos los equipos',
  'intelligence.teams.status.active': 'Activo',
  'intelligence.teams.status.closed': 'Cerrado',
  'intelligence.teams.header.lead': 'líder',
  'intelligence.teams.header.taskCount': '{count} tareas',
  'intelligence.teams.header.memberCount': '{count} miembros',
  'intelligence.teams.member.active': 'Activo',
  'intelligence.teams.member.pending': 'Pendiente',
  'intelligence.teams.member.idle': 'Inactivo',
  'intelligence.teams.member.stopped': 'Detenido',
  'intelligence.teams.column.todo': 'Pendiente',
  'intelligence.teams.column.ready': 'Listo',
  'intelligence.teams.column.inProgress': 'En progreso',
  'intelligence.teams.column.blocked': 'Bloqueado',
  'intelligence.teams.column.done': 'Completado',
  'intelligence.teams.emptyColumn': 'Vacío',
  'intelligence.teams.unclaimed': 'Sin asignar',
  'intelligence.teams.pickedUpBy': 'Asumido por {name}',
  'intelligence.teams.depLockTitle': '{count} dependencias sin cumplir',
  'intelligence.teams.gate.pending': 'Control pendiente',
  'intelligence.teams.gate.passed': 'Control superado',
  'intelligence.teams.gate.failed': 'Control fallido',
  'intelligence.teams.gate.label': 'Control: {status}',
  'intelligence.teams.activity.title': 'Actividad del equipo',
  'intelligence.teams.activity.empty': 'Aún no hay mensajes',
  'intelligence.teams.activity.toTeam': 'equipo',
  'intelligence.teams.member.start': 'Iniciar',
  'intelligence.teams.composer.placeholder': 'Mensaje a un compañero…',
  'intelligence.teams.composer.send': 'Enviar',
  'intelligence.teams.composer.recipient': 'Destinatario',
  'intelligence.teams.composer.toTeam': 'Todo el equipo',
  'intelligence.teams.action.blocked': 'Esperando dependencias',
  'intelligence.teams.action.alreadyClaimed': 'Ya reclamada por otro compañero',
  'intelligence.teams.action.alreadyActive': 'El compañero ya está en ejecución',
  'intelligence.teams.action.noClaimableTask': 'No hay tarea lista para este compañero',
  'intelligence.teams.action.unknownTask': 'Tarea no encontrada',
  'intelligence.refine.objectiveDefault':
    'Convierte la tarea de origen en una tarea de agente lista para implementar: {title}',
  'intelligence.refine.sourceLine': 'Origen: {url}',
  'intelligence.refine.sourceIntake': 'Origen: recepción de fuentes de tareas',
  'intelligence.refine.repositoryLine': 'Repositorio: {repo}',
  'intelligence.refine.externalTaskLine': 'Tarea externa: {externalId}',
  'intelligence.refine.planStep1':
    'Lee la tarea de origen vinculada y confirma el comportamiento exacto solicitado.',
  'intelligence.refine.planStep2':
    'Inspecciona las rutas de código relevantes e identifica el límite de implementación más pequeño.',
  'intelligence.refine.planStep3':
    'Implementa el cambio con pruebas centradas en el comportamiento visible para el usuario.',
  'intelligence.refine.planStep4':
    'Ejecuta una validación específica y registra los riesgos residuales o el trabajo de seguimiento.',
  'intelligence.refine.acceptance1':
    'Los requisitos de la tarea de origen están representados en la implementación final.',
  'intelligence.refine.acceptance2':
    'Las pruebas unitarias o de integración relevantes cubren el comportamiento modificado.',
  'intelligence.refine.acceptance3':
    'Los resultados de la validación y cualquier riesgo sin resolver se registran al finalizar.',
  'notifications.card.dismiss': 'Descartar notificación',
  'notifications.card.importanceTitle': 'Importancia: {pct}%',
  'notifications.center.empty': 'Sin notificaciones aún',
  'notifications.center.emptyHint': 'Sugerencia de vacío',
  'notifications.center.filterAll': 'Filtrar todo',
  'notifications.center.markAllRead': 'Marcar todo como leído',
  'notifications.center.title': 'Notificaciones',
  'notifications.meeting.joinListen': 'Unirse (solo escuchar)',
  'notifications.meeting.joinActive': 'Unirse y responder',
  'notifications.meeting.skip': 'Esta no',
  'notifications.meeting.alwaysJoin': 'Unirse siempre',
  'notifications.meeting.actionError': 'No se pudo completar esa acción. Inténtalo de nuevo.',
  'notifications.flow.approveTitle': 'El flujo de trabajo necesita aprobación',
  'notifications.flow.approve': 'Aprobar',
  'notifications.flow.approving': 'Aprobando…',
  'notifications.flow.dismiss': 'Descartar',
  'notifications.flow.error': 'No se pudo reanudar el flujo de trabajo. Inténtalo de nuevo.',
  'notifications.flow.gateCount': 'Esperando {count} puerta(s) de aprobación',
  'notifications.flow.approveHint': 'Reanudar el flujo de trabajo después de este punto de control',
  'notifications.flow.dismissHint': 'Ocultar este aviso sin reanudar el flujo de trabajo',
  'notifications.flow.viewRun': 'Ver ejecución',
  'notifications.flowGate.title': 'El flujo de trabajo necesita aprobación',
  'notifications.flowGate.tool': 'Herramienta:',
  'notifications.flowGate.approve': 'Aprobar una vez',
  'notifications.flowGate.approveAlways': 'Aprobar siempre',
  'notifications.flowGate.approveAlwaysHint':
    'Omitir esta verificación en futuras ejecuciones de este flujo',
  'notifications.flowGate.deny': 'Denegar',
  'notifications.flowGate.deciding': 'Laboral…',
  'notifications.flowGate.error': 'No se pudo registrar su decisión; inténtelo de nuevo.',
  'flowRuns.inspector.title': 'Detalles de la ejecución',
  'flowRuns.inspector.startedAt': 'Iniciado',
  'flowRuns.inspector.finishedAt': 'Finalizado',
  'flowRuns.inspector.running': 'En ejecución…',
  'flowRuns.inspector.error': 'Error',
  'flowRuns.inspector.pendingApprovals': 'Aprobaciones pendientes',
  'flowRuns.inspector.pendingApprovalsCount': '{count} nodo(s) esperando aprobación',
  'flowRuns.inspector.approval.tool': 'Herramienta:',
  'flowRuns.inspector.approval.approve': 'Aprobar una vez',
  'flowRuns.inspector.approval.approveAlways': 'Aprobar siempre',
  'flowRuns.inspector.approval.approveAlwaysHint':
    'Omitir esta verificación en futuras ejecuciones de este flujo',
  'flowRuns.inspector.approval.deny': 'Denegar',
  'flowRuns.inspector.approval.deciding': 'Laboral…',
  'flowRuns.inspector.approval.loadError':
    'No se pudieron cargar las aprobaciones pendientes de esta ejecución.',
  'flowRuns.inspector.steps': 'Pasos',
  'flowRuns.inspector.noSteps': 'Aún no se han registrado pasos.',
  'flowRuns.inspector.output': 'Mostrar salida sin procesar',
  'flowRuns.inspector.summary.failedPrefix': 'No se pudo completar:',
  'flowRuns.inspector.summary.unknownError': 'algo salió mal',
  'flowRuns.inspector.summary.itemsFetched': 'Elementos obtenidos: {count}',
  'flowRuns.inspector.summary.completed': 'Paso completado',
  'flowRuns.inspector.summary.noOutput': 'No se generó ninguna salida',
  'flowRuns.inspector.port': 'Puerto',
  'flowRuns.inspector.loading': 'Cargando ejecución…',
  'flowRuns.inspector.loadError': 'No se pudo cargar esta ejecución',
  'flowRuns.inspector.fixWithAgent': 'Corregir con el agente',
  'flowRuns.inspector.dataTable': 'Tabla',
  'flowRuns.inspector.dataJson': 'JSON',
  'flowRuns.inspector.dataViewLabel': 'Vista de salida',
  'flowRuns.inspector.itemCount': '{count} elemento(s)',
  'flowRuns.inspector.noItems': 'Sin elementos de salida',
  'flowRuns.inspector.emptyValue': '(vacío)',
  'flowRuns.inspector.binaryLabel': 'Binario',
  'flowRuns.inspector.showSource': 'Origen',
  'flowRuns.inspector.hideSource': 'Ocultar origen',
  'flowRuns.inspector.sourceInputTitle': 'Elemento de entrada de origen',
  'flowRuns.status.running': 'En ejecución',
  'flowRuns.status.completed': 'Completado',
  'flowRuns.status.completed_with_warnings': 'Completado con advertencias',
  'flowRuns.status.pending_approval': 'Esperando aprobación',
  'flowRuns.status.failed': 'Fallido',
  'flowRuns.status.cancelled': 'Cancelado',
  'flowRuns.status.interrupted': 'Interrumpido',

  'flows.page.title': 'Flujos de trabajo',
  'flows.page.description':
    'Automatizaciones guardadas que puedes habilitar, ejecutar y supervisar.',
  'flows.page.emptyTitle': 'Aún no hay flujos de trabajo',
  'flows.page.emptyDescription':
    'Los flujos de trabajo guardados aparecerán aquí en cuanto crees uno desde el lienzo.',
  'flows.page.loading': 'Cargando flujos de trabajo…',
  'flows.page.loadError': 'No se pudieron cargar los flujos de trabajo. Inténtalo de nuevo.',
  'flows.page.newWorkflow': 'Nuevo flujo de trabajo',
  'flows.list.lastRun': 'Última ejecución',
  'flows.list.neverRun': 'Nunca ejecutado',
  'flows.list.justNow': 'Justo ahora',
  'flows.discoveries.title': 'Descubrimientos de flujos',
  'flows.discoveries.description': 'Automatizaciones que sugiere Flow Scout, según cómo trabajas.',
  'flows.allRuns.title': 'Ejecuciones de flujos',
  'flows.allRuns.description': 'Cada ejecución de flujo en tu espacio, las más recientes primero.',
  'flows.allRuns.loading': 'Cargando ejecuciones…',
  'flows.allRuns.empty': 'Aún no hay ejecuciones de flujos.',
  'flows.allRuns.unknownWorkflow': 'Flujo desconocido',
  'flows.allRuns.status.running': 'En ejecución',
  'flows.allRuns.status.completed': 'Completado',
  'flows.allRuns.status.completed_with_warnings': 'Completado con advertencias',
  'flows.allRuns.status.pending_approval': 'Pendiente de aprobación',
  'flows.allRuns.status.failed': 'Fallido',
  'flows.allRuns.status.cancelled': 'Cancelado',
  'flows.allRuns.status.interrupted': 'Interrumpido',
  'flows.list.minutesAgo': 'hace {count} min',
  'flows.list.hoursAgo': 'hace {count} h',
  'flows.list.daysAgo': 'hace {count} d',
  'flows.list.runNow': 'Ejecutar',
  'flows.list.running': 'Ejecutando…',
  'flows.list.viewRuns': 'Ver ejecuciones',
  'flows.list.toggleEnabled': 'Habilitar flujo de trabajo',
  'flows.list.enabled': 'Habilitado',
  'flows.list.paused': 'Pausado',
  'flows.list.runStarted': 'Flujo de trabajo iniciado',
  'flows.runs.title': 'Ejecuciones de {name}',
  'flows.runs.titleFallback': 'Ejecuciones del flujo de trabajo',
  'flows.runs.loading': 'Cargando ejecuciones…',
  'flows.runs.loadError': 'No se pudieron cargar las ejecuciones',
  'flows.runs.empty': 'Aún no hay ejecuciones',
  'flows.promptBar.label': 'Describe un flujo de trabajo',
  'flows.promptBar.placeholder': 'Describe tu flujo de trabajo',
  'flows.promptBar.copilotTitle': 'Copiloto',
  'flows.promptBar.submit': 'Crear',
  'flows.promptBar.startBuilding': 'Empezar a crear',
  'flows.promptBar.disclaimer':
    'El Copiloto usa IA y puede cometer errores. Verifica las respuestas.',
  'flows.promptBar.thinking': 'Creando…',
  'flows.promptBar.heroTitle': 'Describe un flujo de trabajo',
  'flows.promptBar.heroSubtitle': 'Indica al generador qué automatizar y revisa su propuesta.',
  'flows.promptBar.error': 'No se pudo contactar con el generador de flujos. Inténtalo de nuevo.',
  'flows.promptBar.offline': 'Estás sin conexión. Reconéctate para crear un flujo.',
  'flows.suggest.title': 'Sugerencias para ti',
  'flows.suggest.subtitle':
    'Automatizaciones que el Flow Scout cree que te ayudarían, según cómo trabajas.',
  'flows.suggest.discover': 'Descubrir',
  'flows.suggest.rediscover': 'Actualizar',
  'flows.suggest.discovering': 'Buscando automatizaciones…',
  'flows.suggest.empty':
    'Aún no hay sugerencias. Ejecuta Descubrir y el Flow Scout revisará tu trabajo en busca de automatizaciones que valga la pena configurar.',
  'flows.suggest.error': 'No se pudo ejecutar el descubrimiento. Inténtalo de nuevo.',
  'flows.suggest.why': 'Por qué',
  'flows.suggest.build': 'Crear esto',
  'flows.suggest.opening': 'Abriendo…',
  'flows.suggest.dismiss': 'Descartar',
  'flows.suggest.uses': 'Usa',
  'flows.suggest.trigger.schedule': 'Programado',
  'flows.suggest.trigger.app_event': 'En evento',
  'flows.suggest.trigger.manual': 'Bajo demanda',
  'flows.copilot.open': 'Copiloto',
  'flows.copilot.title': 'Copiloto de flujos',
  'flows.copilot.subtitle': 'Pide cambios y revisa cada propuesta antes de aplicarla.',
  'flows.copilot.close': 'Cerrar copiloto',
  'flows.copilot.placeholder': 'Pide un cambio…',
  'flows.copilot.send': 'Enviar',
  'flows.copilot.thinking': 'Pensando…',
  'flows.copilot.error': 'No se pudo contactar con el generador de flujos. Inténtalo de nuevo.',
  'flows.copilot.offline': 'Estás sin conexión. Reconéctate para usar el copiloto.',
  'flows.copilot.emptyState':
    'Describe un cambio en este flujo y el generador propondrá una actualización.',
  'flows.copilot.proposalTitle': 'Cambios propuestos',
  'flows.copilot.added': '{count} añadidos',
  'flows.copilot.removed': '{count} eliminados',
  'flows.copilot.noChanges': 'Esta propuesta no cambia ningún nodo.',
  'flows.copilot.accept': 'Aplicar al borrador',
  'flows.copilot.acceptAndSave': 'Aceptar y guardar',
  'flows.copilot.saveAndEnable': 'Guardar y activar',
  'flows.copilot.saving': 'Guardando…',
  'flows.copilot.enabling': 'Activando…',
  'flows.copilot.enableError':
    'Guardado, pero no se pudo activar el flujo de trabajo. Actívalo desde la lista.',
  'flows.copilot.reject': 'Descartar',
  'flows.copilot.previewHint': 'Revisando un borrador propuesto: aún no se ha guardado nada.',
  'flows.copilot.repairDisplay': 'Falló una ejecución; revísala y propón una solución.',
  'flows.copilot.tool.proposing': 'Proponiendo flujo de trabajo…',
  'flows.copilot.tool.dryRunning': 'Ejecutando prueba del flujo de trabajo…',
  'flows.copilot.tool.saving': 'Guardando flujo de trabajo…',
  'flows.copilot.tool.usingTools': 'Usando herramientas…',
  'flows.copilot.cappedNotice':
    'El generador alcanzó su límite de iteraciones antes de terminar este flujo de trabajo. Al continuar, seguirá construyendo a partir del borrador actual.',
  'flows.copilot.continueBuilding': 'Continuar creando',
  'flows.list.view': 'Ver flujo de trabajo',
  'flows.list.export': 'Exportar',
  'flows.list.exported': 'Flujo de trabajo exportado',
  'flows.page.import': 'Importar',
  'flows.import.invalidFile': 'Ese archivo no es un JSON de flujo de trabajo válido.',
  'flows.import.error':
    'No se pudo importar este flujo de trabajo. Comprueba el archivo e inténtalo de nuevo.',
  'flows.import.warningTitle': 'Advertencia de importación',
  'flows.canvas.title': 'Flujo de trabajo',
  'flows.canvas.loading': 'Cargando flujo de trabajo…',
  'flows.canvas.loadError': 'No se pudo cargar este flujo de trabajo. Inténtalo de nuevo.',
  'flows.canvas.notFound': 'No se pudo encontrar este flujo de trabajo.',
  'flows.canvas.draftMissing':
    'No hay ningún borrador de flujo para abrir. Propón uno desde el chat primero.',
  'flows.canvas.backToList': 'Volver a los flujos de trabajo',
  'flows.nodeKind.trigger': 'Disparador',
  'flows.nodeKind.agent': 'Agente',
  'flows.nodeKind.tool_call': 'Llamada a herramienta',
  'flows.nodeKind.http_request': 'Solicitud HTTP',
  'flows.nodeKind.code': 'Código',
  'flows.nodeKind.condition': 'Condición',
  'flows.nodeKind.switch': 'Selector',
  'flows.nodeKind.merge': 'Combinar',
  'flows.nodeKind.split_out': 'Dividir salida',
  'flows.nodeKind.transform': 'Transformar',
  'flows.nodeKind.output_parser': 'Analizador de salida',
  'flows.nodeKind.sub_workflow': 'Subflujo de trabajo',
  'flows.nodeKind.memory': 'Memoria',
  'flows.nodeKind.dedup': 'Deduplicación',
  'flows.nodeKind.loop': 'Bucle',
  'flows.nodeSummary.trigger.manual': 'Se ejecuta a petición',
  'flows.nodeSummary.trigger.webhook': 'Se ejecuta con un webhook entrante',
  'flows.nodeSummary.trigger.appEventOn': 'En {parts}',
  'flows.nodeSummary.trigger.appEvent': 'Se ejecuta con un evento de la app',
  'flows.nodeSummary.trigger.unknownKind': 'Disparador: {kind}',
  'flows.nodeSummary.agent.defaultModel': 'modelo predeterminado',
  'flows.nodeSummary.agent.withPrompt': '“{prompt}” · {model}',
  'flows.nodeSummary.agent.default': 'Pregunta a {model}',
  'flows.nodeSummary.toolCall.runsNative': 'Ejecuta {name}',
  'flows.nodeSummary.toolCall.pickNative': 'Ejecuta una herramienta de OpenHuman (elige una)',
  'flows.nodeSummary.toolCall.runs': 'Ejecuta {slug}',
  'flows.nodeSummary.toolCall.pick': 'Ejecuta una acción de app (elige una)',
  'flows.nodeSummary.http.withUrl': '{method} {url}',
  'flows.nodeSummary.http.noUrl': 'Solicitud {method} (configura una URL)',
  'flows.nodeSummary.code.runs': 'Ejecuta código {lang}',
  'flows.nodeSummary.condition.withField': 'Si {field} → verdadero / falso',
  'flows.nodeSummary.condition.default': 'Bifurca en verdadero / falso',
  'flows.nodeSummary.switch.byExpr': 'Enruta según {expr}',
  'flows.nodeSummary.switch.byExprWithRoutes': 'Enruta según {expr} ({count} rutas)',
  'flows.nodeSummary.switch.byValue': 'Enruta según un valor',
  'flows.nodeSummary.switch.byValueWithRoutes': 'Enruta según un valor ({count} rutas)',
  'flows.nodeSummary.merge': 'Combina ramas paralelas',
  'flows.nodeSummary.splitOut.withPath': 'Divide cada {path}',
  'flows.nodeSummary.splitOut.default': 'Divide una lista en elementos',
  'flows.nodeSummary.transform.default': 'Reestructura cada elemento',
  'flows.nodeSummary.transform.setFieldsSingular': 'Establece {n} campo en cada elemento',
  'flows.nodeSummary.transform.setFieldsPlural': 'Establece {n} campos en cada elemento',
  'flows.nodeSummary.outputParser': 'Analiza la salida anterior',
  'flows.nodeSummary.subWorkflow': 'Ejecuta un flujo de trabajo anidado',
  'flows.nodeSummary.memory.flavourWith': 'Lee el estilo "{flavour}"',
  'flows.nodeSummary.memory.flavour': 'Lee un estilo de memoria',
  'flows.nodeSummary.memory.people': 'Consulta la memoria de personas',
  'flows.nodeSummary.memory.remember': 'Guarda un valor en este flujo de trabajo',
  'flows.nodeSummary.memory.forget': 'Olvida un valor de este flujo de trabajo',
  'flows.nodeSummary.memory.searchScoped': 'Busca en la memoria ({scope})',
  'flows.nodeSummary.memory.search': 'Busca en la memoria',
  'flows.nodeSummary.memory.recallScoped': 'Recupera de la memoria ({scope})',
  'flows.nodeSummary.memory.recall': 'Recupera de la memoria',
  'flows.nodeSummary.dedup.withKey': 'Omite elementos ya vistos por {key}',
  'flows.nodeSummary.dedup.default': 'Omite elementos ya procesados',
  'flows.nodeSummary.loop.upTo': 'Se repite hasta {max} veces',
  'flows.nodeSummary.loop.whileCondition': 'Se repite hasta {max} veces mientras {condition}',
  'flows.palette.title': 'Nodos',
  'flows.palette.addNode': 'Añadir nodo {kind}',
  'flows.editor.save': 'Guardar',
  'flows.editor.deleteSelected': 'Eliminar selección',
  // ── Validation UX + draft/dirty state (issue B5b / Phase 3c–3d)
  'flows.editor.saving': 'Guardando…',
  'flows.editor.run': 'Ejecutar',
  'flows.editor.running': 'Ejecutando…',
  'flows.editor.runFailed': 'No se pudo iniciar la ejecución',
  'flows.editor.validate': 'Validar',
  'flows.editor.validating': 'Validando…',
  'flows.editor.discard': 'Descartar cambios',
  'flows.editor.confirm.runTitle': '¿Ejecutar el flujo de trabajo?',
  'flows.editor.confirm.runBody': 'Esto ejecutará el flujo de trabajo ahora.',
  'flows.editor.confirm.saveTitle': '¿Guardar los cambios?',
  'flows.editor.confirm.saveBody': 'Esto guardará tus cambios en el flujo de trabajo.',
  'flows.editor.confirm.discardTitle': '¿Descartar los cambios?',
  'flows.editor.confirm.discardBody':
    'Esto revierte todas las ediciones sin guardar y no se puede deshacer.',
  'flows.editor.confirm.confirm': 'Confirmar',
  'flows.editor.confirm.cancel': 'Cancelar',
  'flows.editor.unsaved': 'Cambios sin guardar',
  'flows.editor.saveBlocked': 'Corrige los errores de abajo antes de guardar.',
  'flows.editor.errorsTitle': 'Errores',
  'flows.editor.warningsTitle': 'Advertencias',
  'flows.editor.saveFailedTitle': 'No se pudo guardar',
  'flows.editor.leaveTitle': '¿Salir sin guardar?',
  'flows.editor.leaveBody':
    'Tienes cambios sin guardar en este flujo de trabajo. Si sales ahora, se perderán.',
  'flows.editor.leaveStay': 'Quedarme',
  'flows.editor.leaveDiscard': 'Salir',
  // ── Node config drawer (issue B5b / Phase 3b): per-kind config forms
  'flowRuns.inspector.diagnosticsTitle': 'Advertencias de expresión',
  'flowRuns.inspector.diagnosticResolvedNull': 'se resolvió como null',
  'flows.runs.sidebarTitle': 'Ejecuciones',
  'flows.runs.refresh': 'Actualizar ejecuciones',
  'flows.palette.appAction': 'Acción de app',
  'flows.palette.ohTool': 'Herramienta',
  'flows.editor.deleteNode': 'Eliminar',
  'flows.nodeConfig.connections.title': 'Conexiones',
  'flows.nodeConfig.connections.inputs': 'Entradas',
  'flows.nodeConfig.connections.outputs': 'Salidas',
  'flows.nodeConfig.connections.none': 'Aún no está conectado a ningún otro nodo.',
  'flows.nodeConfig.connections.remove': 'Quitar conexión',
  'flows.nodeConfig.trigger.scheduleCronLabel': 'Expresión cron',
  'flows.nodeConfig.trigger.scheduleFreqLabel': 'Frecuencia',
  'flows.nodeConfig.trigger.scheduleFreq_minutes': 'Cada N minutos',
  'flows.nodeConfig.trigger.scheduleFreq_hours': 'Cada N horas',
  'flows.nodeConfig.trigger.scheduleFreq_daily': 'A una hora cada día',
  'flows.nodeConfig.trigger.scheduleEvery': 'cada',
  'flows.nodeConfig.trigger.scheduleInterval': 'Intervalo',
  'flows.nodeConfig.trigger.scheduleUnit_minutes': 'min.',
  'flows.nodeConfig.trigger.scheduleUnit_hours': 'h',
  'flows.nodeConfig.trigger.scheduleAt': 'a las',
  'flows.nodeConfig.trigger.scheduleTime': 'Hora del día',
  'flows.nodeConfig.trigger.scheduleDays': 'En días (opcional: deja vacío para todos los días)',
  'flows.nodeConfig.trigger.scheduleAdvanced': 'Avanzado (editar cron)',
  'flows.nodeConfig.trigger.scheduleSimple': 'Volver al horario simple',
  'flows.cron.customSchedule': 'Horario personalizado ({expr})',
  'flows.cron.noScheduleSet': 'Sin horario configurado',
  'flows.cron.weekdays': 'días laborables',
  'flows.cron.weekends': 'fines de semana',
  'flows.cron.everyMinute': 'Cada minuto',
  'flows.cron.everyMinuteOnDays': 'Cada minuto los {days}',
  'flows.cron.everyNMinutes': 'Cada {n} minutos',
  'flows.cron.everyNMinutesOnDays': 'Cada {n} minutos los {days}',
  'flows.cron.everyHour': 'Cada hora',
  'flows.cron.everyHourOnDays': 'Cada hora los {days}',
  'flows.cron.everyNHours': 'Cada {n} horas',
  'flows.cron.everyNHoursOnDays': 'Cada {n} horas los {days}',
  'flows.cron.everyDayAtTime': 'Todos los días a las {time}',
  'flows.cron.atTimeOnDays': 'A las {time} los {days}',
  'flows.cron.invalidInterval': 'Intervalo no válido',
  'flows.cron.dailyEvery24h': 'Diario (cada 24 h)',
  'flows.cron.everyNDays': 'Cada {n} días',
  'flows.cron.everyNHoursShort': 'Cada {n} h',
  'flows.cron.everyNMinutesShort': 'Cada {n} min',
  'flows.cron.everySecond': 'Cada segundo',
  'flows.cron.everyNSeconds': 'Cada {n} s',
  'flows.cron.onceAtRaw': 'Una vez el {at}',
  'flows.cron.onceAt': 'Una vez el {at}',
  'flows.nodeConfig.trigger.pickApp': 'Primero elige una app conectada.',
  'flows.nodeConfig.tool.pickConnection': 'Primero elige una conexión.',
  'flows.nodeConfig.composio.noConnections':
    'Aún no hay apps conectadas. Conecta una en Ajustes → Apps y luego selecciónala aquí.',
  'flows.nodeConfig.composio.selectApp': 'Selecciona una app…',
  'flows.nodeConfig.composio.select': 'Seleccionar…',
  'flows.nodeConfig.composio.loading': 'Cargando…',
  'flows.nodeConfig.composio.custom': 'Introducir manualmente…',
  'flows.nodeConfig.composio.customPlaceholder': 'SLUG_NAME',
  'flows.nodeConfig.agent.modelHint':
    'Elige un nivel de capacidad; el espacio de trabajo resuelve el modelo.',
  'flows.nodeConfig.agent.modelInherit': 'Predeterminado (heredar)',
  'flows.nodeConfig.agent.agentRefLabel': 'Agente',
  'flows.nodeConfig.agent.agentRefHint':
    'Ejecuta este nodo como un agente registrado: se aplican sus herramientas y salvaguardas.',
  'flows.nodeConfig.agent.agentRefInherit': 'Predeterminado (constructor de flujos)',
  'flows.nodeConfig.agent.modelManagedTiers': 'Niveles gestionados',
  'flows.nodeConfig.agent.modelHints': 'Sugerencias de modelo',
  'flows.nodeConfig.agent.modelCustom': 'Modelo personalizado…',
  'flows.nodeConfig.agent.modelCustomPlaceholder': 'p. ej., gpt-4o-mini',
  'flows.nodeConfig.tool.requiredMark': 'obligatorio',
  'flows.nodeConfig.tool.requiredMissing': 'Obligatorio: no conectado',
  'flows.nodeConfig.tool.argsAdvancedLabel': 'Todos los argumentos (avanzado)',
  'flows.nodeConfig.upstream.insert': 'Insertar…',
  'flows.nodeConfig.upstream.insertLabel': 'Insertar un valor de un paso anterior',
  'flows.nodeConfig.native.toolLabel': 'Herramienta',
  'flows.nodeConfig.native.toolHint':
    'Una de las herramientas integradas del asistente (búsqueda, medios, archivos, …).',
  'flows.nodeConfig.native.select': 'Selecciona una herramienta…',
  'flows.nodeConfig.native.loading': 'Cargando herramientas…',
  'flows.nodeConfig.close': 'Cerrar ajustes',
  'flows.nodeConfig.nameLabel': 'Nombre',
  'flows.nodeConfig.namePlaceholder': 'Nombre del nodo',
  'flows.nodeConfig.editForm': 'Editar como formulario',
  'flows.nodeConfig.editJson': 'Editar como JSON',
  'flows.nodeConfig.rawJsonLabel': 'Configuración (JSON)',
  'flows.nodeConfig.rawJsonHint': 'Configuración libre para este nodo.',
  'flows.nodeConfig.rawJsonInvalid':
    'JSON no válido: los cambios no se aplican hasta que sea válido.',
  'flows.nodeConfig.expressionHint':
    'Empieza con = para calcular el valor a partir de la entrada del nodo, p. ej. =item.url',
  'flows.nodeConfig.expressionBadge': 'Expresión',
  'flows.nodeConfig.keymapKeyPlaceholder': 'Clave',
  'flows.nodeConfig.keymapValuePlaceholder': 'Valor',
  'flows.nodeConfig.keymapRemove': 'Quitar fila',
  'flows.nodeConfig.keymapAdd': 'Añadir fila',
  'flows.nodeConfig.credentialLabel': 'Credencial',
  'flows.nodeConfig.credentialHint': 'Elige una cuenta o credencial conectada para este nodo.',
  'flows.nodeConfig.credentialEmpty': 'No hay credenciales conectadas disponibles.',
  'flows.nodeConfig.credentialNone': 'Ninguna',
  'flows.nodeConfig.trigger.kindLabel': 'Tipo de activador',
  'flows.nodeConfig.trigger.kind_manual': 'Manual',
  'flows.nodeConfig.trigger.kind_schedule': 'Programación',
  'flows.nodeConfig.trigger.kind_webhook': 'Webhook',
  'flows.nodeConfig.trigger.kind_app_event': 'Evento de app',
  'flows.nodeConfig.trigger.scheduleLabel': 'Programación cron',
  'flows.nodeConfig.trigger.scheduleHint': 'Expresión cron: minuto hora día mes día de la semana.',
  'flows.nodeConfig.trigger.toolkitLabel': 'Kit de herramientas',
  'flows.nodeConfig.trigger.triggerSlugLabel': 'Slug del activador',
  'flows.nodeConfig.trigger.webhookHint':
    'Los activadores de webhook se guardan pero todavía no se ejecutan automáticamente.',
  'flows.nodeConfig.http.methodLabel': 'Método',
  'flows.nodeConfig.http.urlLabel': 'URL',
  'flows.nodeConfig.http.headersLabel': 'Encabezados',
  'flows.nodeConfig.http.bodyLabel': 'Cuerpo (JSON)',
  'flows.nodeConfig.agent.promptLabel': 'Instrucción',
  'flows.nodeConfig.agent.promptPlaceholder': 'Instrucciones para el agente…',
  'flows.nodeConfig.agent.modelLabel': 'Modelo',
  'flows.nodeConfig.tool.slugLabel': 'Slug de la herramienta',
  'flows.nodeConfig.tool.argsLabel': 'Argumentos (JSON)',
  'flows.nodeConfig.condition.fieldLabel': 'Campo',
  'flows.nodeConfig.condition.fieldHint':
    'Clave del elemento de entrada cuya veracidad se evalúa. Enruta a verdadero o falso.',
  'flows.nodeConfig.switch.expressionLabel': 'Expresión',
  'flows.nodeConfig.switch.hint':
    'El valor resultante selecciona el puerto de salida correspondiente; null va a default.',
  'flows.nodeConfig.switch.fieldLabel': 'Campo (alternativo)',
  'flows.nodeConfig.transform.setLabel': 'Definir campos',
  'flows.nodeConfig.transform.setHint':
    'Cada valor es una expresión evaluada por elemento, p. ej. =item.name',
  'flows.nodeConfig.code.languageLabel': 'Lenguaje',
  'flows.nodeConfig.code.language_javascript': 'JavaScript',
  'flows.nodeConfig.code.language_python': 'Python',
  'flows.nodeConfig.code.sourceLabel': 'Código fuente',
  'flows.nodeConfig.memory.operationLabel': 'Operación',
  'flows.nodeConfig.memory.operation_recall': 'Recordar',
  'flows.nodeConfig.memory.operation_search': 'Buscar',
  'flows.nodeConfig.memory.operation_flavour': 'Estilo',
  'flows.nodeConfig.memory.operation_people': 'Personas',
  'flows.nodeConfig.memory.operation_remember': 'Guardar',
  'flows.nodeConfig.memory.operation_forget': 'Olvidar',
  'flows.nodeConfig.memory.scopeLabel': 'Alcance',
  'flows.nodeConfig.memory.scopeHint': 'Dónde buscar esta memoria.',
  'flows.nodeConfig.memory.scopeWriteHint':
    'Solo se permite escribir dentro de este flujo de trabajo, nunca en tu memoria personal.',
  'flows.nodeConfig.memory.scope_user': 'Tú (solo lectura)',
  'flows.nodeConfig.memory.scope_flow': 'Este flujo de trabajo',
  'flows.nodeConfig.memory.scope_flows': 'Todos los flujos de trabajo (solo lectura)',
  'flows.nodeConfig.memory.queryLabel': 'Consulta',
  'flows.nodeConfig.memory.queryOptionalHint': 'Opcional: acota la búsqueda de personas.',
  'flows.nodeConfig.memory.flavourLabel': 'Estilo',
  'flows.nodeConfig.memory.flavourHint':
    'Qué faceta de la persona leer, por ejemplo communication.',
  'flows.nodeConfig.memory.flavour_communication': 'Comunicación',
  'flows.nodeConfig.memory.flavour_coding_style': 'Estilo de código',
  'flows.nodeConfig.memory.flavour_stack': 'Stack',
  'flows.nodeConfig.memory.flavour_workflow': 'Flujo de trabajo',
  'flows.nodeConfig.memory.flavour_environment': 'Entorno',
  'flows.nodeConfig.memory.flavour_directives': 'Directivas',
  'flows.nodeConfig.memory.flavour_anti_preferences': 'Preferencias negativas',
  'flows.nodeConfig.memory.keyLabel': 'Clave',
  'flows.nodeConfig.memory.valueLabel': 'Valor',
  'flows.nodeConfig.memory.limitLabel': 'Límite',
  'flows.nodeConfig.memory.limitHint': 'Número máximo de resultados.',
  'flows.nodeConfig.memory.minScoreLabel': 'Puntuación mínima',
  'flows.nodeConfig.memory.minScoreHint': 'Umbral de relevancia de 0 a 1.',
  'flows.nodeConfig.dedup.keyLabel': 'Clave',
  'flows.nodeConfig.dedup.keyHint':
    'Una expresión de id estable por elemento, p. ej. =item.id. Los elementos con una clave ya vista se omiten.',

  // `loop` node: a bounded loop head. Emits on `body` until its cap or
  // condition says stop, then on `done`.
  'flows.nodeConfig.loop.maxIterationsLabel': 'Iteraciones máximas',
  'flows.nodeConfig.loop.maxIterationsHint':
    'Cuántas veces puede ejecutarse el cuerpo antes de que el bucle se detenga. Siempre finito.',
  'flows.nodeConfig.loop.onExceededLabel': 'Al alcanzar el límite',
  'flows.nodeConfig.loop.onExceededHint':
    'Hacer fallar la ejecución, o dejar de iterar y continuar por el puerto done con los elementos de la última pasada.',
  'flows.nodeConfig.loop.onExceeded_error': 'Hacer fallar la ejecución',
  'flows.nodeConfig.loop.onExceeded_continue': 'Continuar con resultados parciales',
  'flows.nodeConfig.loop.conditionLabel': 'Continuar mientras',
  'flows.nodeConfig.loop.conditionHint':
    'Opcional. Mientras esto sea verdadero el bucle continúa; el primer resultado falso sale por el puerto done.',

  'flows.enableApproval.title': '¿Permitir que este flujo de trabajo actúe?',
  'flows.enableApproval.intro':
    'Este flujo de trabajo necesita tu permiso para las acciones siguientes. La aprobación se aplica solo a este flujo de trabajo.',
  'flows.enableApproval.approveAll': 'Aprobar todo',
  'flows.enableApproval.deny': 'Denegar',
  'flows.enableApproval.enableAnyway': 'Activar de todos modos',
  'flows.enableApproval.granting': 'Aprobando…',
  'flows.enableApproval.error': 'No se pudieron guardar las aprobaciones. Inténtalo de nuevo.',
  'flows.enableApproval.blockedHint': 'Bloqueado por tu configuración de acceso del agente.',
  'flows.enableApproval.dynamicHint':
    'Se decide durante la ejecución; te preguntará si es necesario.',
  'flows.enableApproval.agentHint':
    'Este paso de IA puede pedir permiso aparte para sus propias acciones.',
  'flows.enableApproval.deniedDisabled': 'Guardado, pero el flujo de trabajo quedó desactivado.',
  'flows.chooser.title': 'Crear un flujo de trabajo',
  'flows.chooser.subtitle': 'Elige cómo quieres empezar.',
  'flows.chooser.scratchTitle': 'Empezar desde cero',
  'flows.chooser.scratchDescription':
    'Comienza con un lienzo en blanco y un único disparador manual.',
  'flows.chooser.templateTitle': 'Desde una plantilla',
  'flows.chooser.templateDescription': 'Empieza con un ejemplo listo y personalízalo.',
  'flows.chooser.describeTitle': 'Descríbelo',
  'flows.chooser.describeDescription':
    'Dile al asistente lo que quieres y deja que redacte el flujo de trabajo.',
  'flows.chooser.creating': 'Creando el flujo de trabajo…',
  'flows.chooser.createError': 'No se pudo crear el flujo de trabajo. Inténtalo de nuevo.',
  'flows.templates.title': 'Empezar desde una plantilla',
  'flows.templates.subtitle': 'Elige un punto de partida y personalízalo en el editor.',
  'flows.templates.use': 'Usar plantilla',
  'flows.templates.back': 'Atrás',
  'flows.templates.empty': 'No hay plantillas disponibles.',
  'flows.templates.category.scheduled': 'Programado',
  'flows.templates.category.triggered': 'Activado',
  'flows.templates.category.onDemand': 'Bajo demanda',
  'flows.templates.daily-digest.name': 'Resumen diario al canal',
  'flows.templates.daily-digest.description':
    'Según una programación, un agente escribe un breve resumen y lo publica en un canal.',
  'flows.templates.scheduled-scrape.name': 'Extracción programada a la memoria',
  'flows.templates.scheduled-scrape.description':
    'Obtén una fuente según una programación, transforma los resultados y guárdalos en la memoria.',
  'flows.templates.webhook-triage.name': 'Clasificación de webhook y aviso',
  'flows.templates.webhook-triage.description':
    'Un agente clasifica un webhook entrante y luego recibes un aviso.',
  'flows.templates.app-event-route.name': 'Evento de app a acción condicional',
  'flows.templates.app-event-route.description':
    'Un evento de una app conectada ejecuta una comprobación y actúa cuando coincide.',
  'flows.templates.http-fetch-parse.name': 'Obtener y analizar una API',
  'flows.templates.http-fetch-parse.description':
    'Llama a un extremo HTTP bajo demanda y analiza la respuesta a una forma utilizable.',
  'flows.templates.ask-agent.name': 'Preguntar al agente',
  'flows.templates.ask-agent.description':
    'Un disparador manual sencillo que entrega una tarea a un agente.',
  'flows.templates.opus-sonnet-brief.name':
    'Informe de investigación (Opus planifica, Sonnet redacta)',
  'flows.templates.opus-sonnet-brief.description':
    'Un agente de nivel razonamiento planifica el informe, un agente de nivel chat lo redacta y luego se da forma al resultado para ti.',

  'oauth.button.connecting': 'Conectando...',
  'oauth.button.loopbackTimeout':
    'El inicio de sesión expiró: el navegador no completó la redirección OAuth. Por favor, inténtalo de nuevo.',
  'oauth.login.continueWith': 'Continuar con',
  'onboarding.contextGathering.buildingDesc': 'Descripción de construcción',
  'onboarding.contextGathering.buildingProfile': 'Construyendo tu perfil...',
  'onboarding.contextGathering.continueToChat': 'Continuar al chat',
  'onboarding.contextGathering.coreAlive':
    'El núcleo está disponible: el primer arranque puede tardar un minuto.',
  'onboarding.contextGathering.coreAliveProbing': 'Comprobando la conexión con el núcleo…',
  'onboarding.contextGathering.coreUnreachable':
    'El núcleo no responde. Puedes continuar e intentarlo más tarde.',
  'onboarding.contextGathering.errorDesc':
    'No pudimos construir tu perfil completo ahora mismo, pero no pasa nada: puedes continuar y tu perfil se construirá con el tiempo.',
  'onboarding.contextGathering.stillWorkingDesc':
    'El primer arranque puede tardar 30–60 segundos mientras preparamos tu modelo local y tus herramientas. Puedes continuar al chat en cualquier momento: la construcción del perfil sigue en segundo plano.',
  'onboarding.contextGathering.stillWorkingTitle': 'Seguimos trabajando en tu perfil…',
  'onboarding.contextGathering.title': 'Recopilación de contexto',
  'openhuman.team_list_teams': 'Lista de equipos',
  'overlay.ariaAttention': 'Mensaje de atención',
  'overlay.ariaCompanion': 'Acompañante activo',
  'overlay.ariaOrb': 'Overlay de OpenHuman',
  'overlay.ariaVoiceActive': 'Entrada de voz activa',
  'overlay.companion.error': 'error',
  'overlay.companion.listening': 'Escuchando…',
  'overlay.companion.speaking': 'Hablando…',
  'overlay.companion.thinking': 'Pensando…',
  'overlay.orbTitle': 'Arrastra para mover · Doble clic para restablecer posición',
  'pages.settings.account.connections': 'Conexiones',
  'pages.settings.account.connectionsDesc': 'Descripción de conexiones',
  'pages.settings.account.migration': 'Importar desde otro asistente',
  'pages.settings.account.migrationDesc':
    'Migra memoria y notas desde OpenClaw (y pronto Hermes) a este espacio de trabajo.',
  'pages.settings.account.privacy': 'Privacidad',
  'pages.settings.account.privacyDesc': 'Descripción de privacidad',
  'pages.settings.account.recoveryPhrase': 'Frase de recuperación',
  'pages.settings.account.recoveryPhraseDesc': 'Descripción de frase de recuperación',
  'pages.settings.account.team': 'Equipo',
  'pages.settings.account.teamDesc': 'Descripción de equipo',
  'pages.settings.accountSection.description':
    'Frase de recuperación, equipo, conexiones y configuración de privacidad.',
  'pages.settings.accountSection.title': 'Cuenta',
  'pages.settings.ai.llm': 'LLM',
  'pages.settings.ai.llmDesc': 'Descripción de LLM',
  'pages.settings.ai.voice': 'Voz',
  'pages.settings.ai.voiceDesc': 'Descripción de voz',
  'pages.settings.aiSection.description':
    'Proveedores de modelos de lenguaje, Ollama local y voz (STT / TTS).',
  'pages.settings.aiSection.title': 'IA',
  'settings.developerMenu.composio.title': 'Composio',
  'settings.developerMenu.composio.desc':
    'Modo de enrutamiento, activadores de integración y archivo de historial de activadores.',
  'pages.settings.features.messagingChannels': 'Canales de mensajería',
  'pages.settings.features.messagingChannelsDesc': 'Descripción de canales de mensajería',
  'pages.settings.features.notifications': 'Notificaciones',
  'pages.settings.features.notificationsDesc': 'Descripción de notificaciones',
  'pages.settings.features.tools': 'Herramientas',
  'pages.settings.features.toolsDesc': 'Descripción de herramientas',
  'pages.settings.featuresSection.title': 'Funciones',
  'privacy.dataKind.credentials': 'Credenciales',
  'privacy.dataKind.derived': 'Derivado',
  'privacy.dataKind.diagnostics': 'Diagnósticos',
  'privacy.dataKind.metadata': 'Metadatos',
  'privacy.dataKind.raw': 'Sin procesar',
  'privacy.whatLeaves.link.label': '¿Qué sale de mi ordenador?',
  'rewards.community.achievementsUnlocked': '{unlocked} de {total} logros desbloqueados',
  'rewards.community.activityStreakHint':
    'Días consecutivos en los que estuviste activo en OpenHuman.',
  'rewards.community.activityTitle': 'Tu actividad',
  'rewards.community.claimCredited': '{amount} añadidos a tu saldo',
  'rewards.community.claimError': 'No se pudo reclamar. Inténtalo de nuevo.',
  'rewards.community.claimTokens': 'Reclamar {tokens} tokens',
  'rewards.community.claimed': 'Reclamado',
  'rewards.community.claiming': 'Reclamando…',
  'rewards.community.connectDiscord': 'Conectar Discord',
  'rewards.community.connectDiscordError':
    'No se pudo iniciar la conexión con Discord. Inténtalo de nuevo.',
  'rewards.community.connectingDiscord': 'Conectando…',
  'rewards.community.cumulativeTokens': 'Tokens acumulados',
  'rewards.community.currentStreak': 'Racha de actividad',
  'rewards.community.disconnectDiscord': 'Desconectar',
  'rewards.community.disconnectDiscordError': 'No se pudo desconectar Discord. Inténtalo de nuevo.',
  'rewards.community.disconnectingDiscord': 'Desconectando…',
  'rewards.community.discordAccount': 'Cuenta de Discord',
  'rewards.community.discordConnected': 'Discord conectado',
  'rewards.community.discordConnectedAs': 'Conectado como {username}',
  'rewards.community.discordDetails': 'Discord',
  'rewards.community.discordLinkedNotInGuild': 'Discord vinculado pero no en el servidor',
  'rewards.community.discordMember': 'Te uniste al servidor',
  'rewards.community.discordNotLinked': 'Discord no vinculado',
  'rewards.community.discordServer': 'Servidor de Discord',
  'rewards.community.discordStatusUnavailable': 'Estado de Discord no disponible',
  'rewards.community.discordWaiting': 'Esperando en Discord',
  'rewards.community.heroSubtitle': 'Subtítulo hero',
  'rewards.community.heroTitle': 'Título hero',
  'rewards.community.joinDiscord': 'Unirse a Discord',
  'rewards.community.loadingRewards': 'Cargando recompensas…',
  'rewards.community.locked': 'Desbloqueado',
  'rewards.community.longestStreak': 'Racha más larga',
  'rewards.community.retrying': 'Reintentando…',
  'rewards.community.rewardTokens': '+{tokens} tokens',
  'rewards.community.rewardTokensMonthly': '+{tokens} tokens/mes',
  'rewards.community.roleAssigned': 'Rol asignado',
  'rewards.community.roleAssignmentCount': '{assigned} de {unlocked} roles asignados',
  'rewards.community.roleClaimDesc':
    'Has desbloqueado roles de Discord, pero aún no te has unido al servidor de OpenHuman. Únete para que se asignen automáticamente.',
  'rewards.community.roleClaimTitle': 'Reclama tus roles de Discord',
  'rewards.community.roleJoinToClaim': 'Únete al servidor para reclamar',
  'rewards.community.rolePending': 'Sincronizando rol…',
  'rewards.community.rolesAndRewards': 'Roles y recompensas',
  'rewards.community.streakDays': '{n} días',
  'rewards.community.syncPending': 'Sincronización de recompensas pendiente',
  'rewards.community.syncPendingDesc': 'Descripción de sincronización pendiente',
  'rewards.community.syncUnavailable': 'Sincronización no disponible',
  'rewards.community.tryAgain': 'Reintentando…',
  'rewards.community.unknown': 'Desconocido',
  'rewards.community.unlocked': 'Desbloqueado',
  'rewards.community.yourProgress': 'Tu progreso',
  'rewards.coupon.colCode': 'Código',
  'rewards.coupon.colRedeemed': 'Canjeado',
  'rewards.coupon.colReward': 'Recompensa',
  'rewards.coupon.colStatus': 'Estado',
  'rewards.coupon.loadingHistory': 'Cargando historial de recompensas…',
  'rewards.coupon.noCodes': 'Aún no se han canjeado códigos de recompensa.',
  'rewards.coupon.pending': 'Pendiente',
  'rewards.coupon.placeholder': 'Código de cupón',
  'rewards.coupon.promoCredits': 'Créditos promocionales',
  'rewards.coupon.recentRedemptions': 'Canjes recientes',
  'rewards.coupon.redeemAccepted':
    '{code} aceptado. {amount} se desbloqueará cuando se complete la acción requerida.',
  'rewards.coupon.redeemButton': 'Canjear código',
  'rewards.coupon.redeemSuccess': '{code} canjeado. Se añadieron {amount} a tus créditos.',
  'rewards.coupon.redeemedCodes': 'Códigos canjeados',
  'rewards.coupon.redeeming': 'Canjeando...',
  'rewards.coupon.statusApplied': 'Aplicado',
  'rewards.coupon.statusPendingAction': 'Acción pendiente',
  'rewards.coupon.statusRedeemed': 'Canjeado',
  'rewards.coupon.subtitle': 'Subtítulo',
  'rewards.coupon.title': 'Canjear un código de cupón',
  'rewards.referralSection.activity': 'Actividad de referidos',
  'rewards.referralSection.apply': 'Aplicando…',
  'rewards.referralSection.applying': 'Aplicando…',
  'rewards.referralSection.colReferredUser': 'Usuario referido',
  'rewards.referralSection.colReward': 'Recompensa',
  'rewards.referralSection.colStatus': 'Estado',
  'rewards.referralSection.colUpdated': 'Actualizado',
  'rewards.referralSection.completed': 'Completado',
  'rewards.referralSection.copyCode': 'Copiar código',
  'rewards.referralSection.copyFailed': 'Error al copiar',
  'rewards.referralSection.haveCode': '¿Tienes un código de referido?',
  'rewards.referralSection.haveCodeDesc': 'Descripción de código disponible',
  'rewards.referralSection.linked': 'Vinculado',
  'rewards.referralSection.linkedCode': '(código {code})',
  'rewards.referralSection.loading': 'Cargando programa de referidos…',
  'rewards.referralSection.retry': 'Reintentar',
  'rewards.referralSection.noReferrals': 'Sin referidos',
  'rewards.referralSection.pendingReferrals': 'Referidos pendientes',
  'rewards.referralSection.placeholder': 'Código de referido',
  'rewards.referralSection.share': 'Compartir',
  'rewards.referralSection.statusCompleted': 'Estado: completado',
  'rewards.referralSection.statusExpired': 'Estado: expirado',
  'rewards.referralSection.statusJoined': 'Estado: unido',
  'rewards.referralSection.subtitle': 'Subtítulo',
  'rewards.referralSection.title': 'Invita amigos, gana créditos',
  'rewards.referralSection.totalEarned': 'Total ganado',
  'rewards.referralSection.yourCode': 'Tu código',
  'settings.ai.addCloudProvider': 'Añadir proveedor en la nube',
  'settings.ai.addProvider': 'Guardando…',
  'settings.ai.apiKeyFieldLabel': 'Etiqueta de campo de clave API',
  'settings.ai.apiKeyRequired': 'Pega tu clave API para continuar.',
  'settings.ai.apiKeyStoredEncrypted': 'Clave API almacenada cifrada',
  'settings.ai.apiKeysEncrypted': 'perfiles-de-autenticación.json',
  'settings.ai.clearStoredKey': 'Borrar clave almacenada',
  'settings.ai.connectProvider': 'Conectar proveedor',
  'settings.ai.customRouting': 'Enrutamiento personalizado',
  'settings.ai.defaultResolvesTo': 'El valor predeterminado se resuelve a',
  'settings.ai.discard': 'Descartar',
  'settings.ai.editProvider': 'Editar proveedor',
  'settings.ai.llmProviders': 'Proveedores LLM',
  'settings.ai.llmProvidersDesc': 'Descripción de proveedores LLM',
  'settings.ai.localOllama': 'Local (Ollama)',
  'settings.ai.modelLabel': 'Modelo',
  'settings.ai.noCustomProviders': 'Sin proveedores personalizados',
  'settings.ai.openAiCompat.authHeaderExample': 'Autorización: Portador <su clave>',
  'settings.ai.openAiCompat.authHeaderLabel': 'encabezado de autenticación',
  'settings.ai.openAiCompat.baseUrlLabel': 'URL base',
  'settings.ai.openAiCompat.baseUrlUnavailable': 'No disponible',
  'settings.ai.openAiCompat.clearKey': 'Borrar clave',
  'settings.ai.openAiCompat.description':
    'Señale los arneses locales en este servidor /v1 para enrutar a través de los proveedores configurados a continuación. La autenticación utiliza una clave estable que usted establece aquí, no el portador interno del núcleo de la aplicación.',
  'settings.ai.openAiCompat.keyConfigured': 'Clave configurada',
  'settings.ai.openAiCompat.keyRequired': 'Se requiere clave',
  'settings.ai.openAiCompat.rotateKey': 'Girar clave',
  'settings.ai.openAiCompat.setKey': 'Establecer clave',
  'settings.ai.openAiCompat.title': 'Punto final compatible con OpenAI',
  'settings.ai.providerLabel': 'Proveedor',
  'skills.mcpComingSoon.title': 'MCP Servidores',
  'skills.mcpComingSoon.description':
    'La gestión de servidores MCP llegará pronto. Esta pestaña será el lugar para descubrir, conectar y monitorear tus integraciones de servidor MCP.',
  'settings.ai.routing': 'Enrutamiento',
  'settings.ai.claudeCode.button': 'Claude Code',
  'settings.ai.claudeCode.inlineNotConnected':
    'Sin conexión: enruta el chat a través de tu Claude Code CLI local.',
  'settings.ai.claudeCode.checkingSignIn': 'Comprobando inicio de sesión…',
  'settings.ai.claudeCode.inlineConnected': 'Conectado.',
  'settings.ai.claudeCode.signedInAs': 'Sesión iniciada como',
  'settings.ai.claudeCode.subscriptionFallback': 'Suscripción de Claude',
  'settings.ai.claudeCode.usingApiKeyEnv': 'Usando ANTHROPIC_API_KEY',
  'settings.ai.claudeCode.cliNotInstalled': 'CLI no instalado',
  'settings.ai.claudeCode.signInUnknown': 'Estado de inicio de sesión desconocido',
  'settings.ai.claudeCode.connectedNotSignedIn': 'Conectado · sin iniciar sesión',
  'settings.ai.claudeCode.modalTitle': 'Claude Code CLI',
  'settings.ai.claudeCode.modelHelp':
    'Un ID de modelo que acepta la CLI de claude: un alias (sonnet, opus) o un nombre completo (claude-sonnet-4-5). Se pasa tal cual a claude --model, así que los nombres comerciales como sonnet-4-5 se rechazan.',
  'settings.ai.claudeCode.modalDescription':
    'Enruta las cargas de chat, agénticas y de razonamiento a través de tu Claude Code CLI instalado localmente. Sin clave de API: usa el propio inicio de sesión del CLI.',
  'settings.ai.claudeCode.close': 'Cerrar',
  'settings.ai.claudeCode.connection': 'Conexión',
  'settings.ai.claudeCode.enabled': 'Activado',
  'settings.ai.claudeCode.notEnabled': 'No activado',
  'settings.ai.claudeCode.disconnect': 'Desconectar',
  'settings.ai.claudeCode.disconnecting': 'Desconectando…',
  'settings.ai.claudeCode.enable': 'Activar Claude Code',
  'settings.ai.claudeCode.enabling': 'Activando…',
  'settings.ai.claudeCode.authentication': 'Autenticación',
  'settings.ai.claudeCode.recheck': 'Volver a comprobar',
  'settings.ai.claudeCode.checking': 'Comprobando…',
  'settings.ai.claudeCode.openingTerminal': 'Abriendo terminal…',
  'settings.ai.claudeCode.signIn': 'Iniciar sesión con Claude',
  'settings.ai.claudeCode.reconnect': 'Reconectar',
  'settings.ai.claudeCode.loginHint':
    'Abre un terminal que ejecuta claude login. Cuando termine, haz clic en Volver a comprobar.',
  'settings.ai.claudeCode.loginError':
    'No se pudo abrir el terminal de inicio de sesión. Inténtalo de nuevo.',
  'settings.ai.claudeCode.fullAccess': 'Acceso completo',
  'settings.ai.claudeCode.fullAccessOn':
    'Claude Code puede ejecutar comandos, usar la red y generar subagentes.',
  'settings.ai.claudeCode.fullAccessOff':
    'Aceptar solo ediciones: aplica los cambios de archivos automáticamente y restringe comandos y red.',
  'settings.ai.claudeCode.sandboxNoteMac':
    'En macOS, ~/.openhuman permanece protegido por el sandbox en ambos modos.',
  'settings.ai.claudeCode.sandboxNoteOther':
    'El acceso completo no tiene restricciones en esta plataforma: actívalo solo si confías en el espacio de trabajo.',
  'settings.ai.claudeCode.enableToCheck': 'Activa Claude Code para comprobar el inicio de sesión.',
  'settings.ai.claudeCode.usingApiKeyEnvDetail': 'Usando ANTHROPIC_API_KEY del entorno.',
  'settings.ai.claudeCode.notFoundInstall':
    'Claude Code CLI no encontrado: instálalo con: npm install -g @anthropic-ai/claude-code',
  'settings.ai.claudeCode.unknownDetail':
    'No se pudo determinar el estado de inicio de sesión. Tu claude CLI puede ser anterior al estado de autenticación: prueba Reconectar y luego Volver a comprobar.',
  'settings.ai.claudeCode.notSignedIn': 'Sesión no iniciada.',
  'settings.ai.routingCustom': 'Enrutamiento personalizado',
  'settings.ai.routingDefault': 'Predeterminado',
  'settings.ai.routingDesc': 'Descripción de enrutamiento',
  'settings.ai.saveChanges': 'Guardando…',
  'settings.ai.saving': 'Guardando…',
  'settings.ai.unsavedChange': 'cambio sin guardar',
  'settings.ai.unsavedChanges': 'cambios sin guardar',
  'settings.ai.workloadGroupBackground': 'Grupo de carga de trabajo en segundo plano',
  'settings.ai.workloadGroupChat': 'Grupo de carga de trabajo de chat',
  'settings.ai.disconnectProvider': 'Desconectar {label}',
  'settings.ai.connectProviderLabel': 'Conectar {label}',
  'settings.ai.editProviderEndpoint': 'Editar punto de conexión de {label}',
  'settings.ai.defaultLocalEndpoint': 'http://localhost:11434/v1',
  'settings.ai.editEndpoint': 'Editar punto de conexión',
  'settings.ai.endpointUrlLabel': 'Punto final URL',
  'settings.ai.localRuntimeHelper':
    'Donde {label} es accesible. Por defecto es localhost; apunte esto a un host remoto (por ejemplo, http://10.0.0.4:11434/v1) para usar una instancia compartida.',
  'settings.ai.endpointUrlRequired': 'Se requiere el punto final URL.',
  'settings.ai.endpointProtocolRequired': 'El punto final debe comenzar con http:// o https://.',
  'settings.ai.connectProviderDialog': 'Conectar {label}',
  'settings.ai.getProviderApiKey': 'Obtener API Key',
  'settings.ai.or': 'O',
  'settings.ai.codexOauthMissingAuthUrl':
    'Codex OAuth no devolvió una URL de autorización. Intenta iniciar sesión de nuevo.',
  'settings.ai.codexOauthMissingCallbackUrl':
    'Pega la URL de redirección de tu navegador después de iniciar sesión.',
  'settings.ai.openRouterOauthDescription':
    'Inicia sesión con OpenRouter e importa una clave API controlada por el usuario usando PKCE.',
  'settings.ai.connecting': 'Conectando...',
  'settings.ai.codexAuthButton': 'Conectar Codex',
  'settings.ai.codexAuthHelper':
    'Usa el inicio de sesión existente de Codex CLI desde ~/.codex/auth.json.',
  'settings.ai.backgroundLoops': 'Bucles de fondo',
  'settings.ai.backgroundLoopsDesc':
    'Vea qué se ejecuta sin un mensaje de chat, pause el trabajo de latido y examine las filas recientes del libro mayor de créditos.',
  'settings.ai.heartbeatControls': 'Controles de latidos del corazón',
  'settings.ai.heartbeatControlsDesc':
    'Predeterminado apagado. Activar inicia el bucle; desactivar aborta la tarea en ejecución.',
  'settings.ai.heartbeatLoop': 'Bucle de latidos del corazón',
  'settings.ai.heartbeatLoopDesc':
    'Programador maestro para planificador + inferencia subconsciente opcional.',
  'settings.ai.subconsciousInference': 'inferencia subconsciente',
  'settings.ai.subconsciousInferenceDesc':
    'Ejecuta la evaluación task/reflection respaldada por modelo en los latidos del corazón.',
  'settings.ai.calendarMeetingChecks': 'Verificaciones de reuniones del calendario',
  'settings.ai.calendarMeetingChecksDesc':
    'Llama a la lista de eventos del calendario para conexiones de calendario Google activas.',
  'settings.ai.calendarCap': 'tapa del calendario',
  'settings.ai.connectionsPerTick': '{count} conexión/tick',
  'settings.ai.meetingLookahead': 'Reunión anticipada',
  'settings.ai.minutesShort': '{count} min',
  'settings.ai.reminderLookahead': 'Recordatorio anticipado',
  'settings.ai.cronReminderChecks': 'Comprobaciones de recordatorio cron',
  'settings.ai.cronReminderChecksDesc':
    'Analiza los trabajos cron habilitados para elementos próximos similares a recordatorios.',
  'settings.ai.relevantNotificationChecks': 'Comprobaciones de notificaciones relevantes',
  'settings.ai.relevantNotificationChecksDesc':
    'Promueve las notificaciones locales urgentes en alertas proactivas.',
  'settings.ai.externalDelivery': 'Entrega externa',
  'settings.ai.externalDeliveryDesc':
    'Permite que las alertas de latido envíen mensajes proactivos a canales externos.',
  'settings.ai.interval': 'Intervalo',
  'settings.ai.running': 'Corriendo...',
  'settings.ai.plannerTickNow': 'Planificador marca ahora',
  'settings.ai.loadingHeartbeatControls': 'Cargando controles de latidos...',
  'settings.ai.heartbeatControlsUnavailable': 'Los controles de latidos no están disponibles.',
  'settings.ai.loopMap': 'Mapa de bucle',
  'settings.ai.plannerSummary':
    'Planificador: {sourceEvents} eventos de origen, {sent} enviados, {deduped} deduplicados.',
  'settings.ai.routeLabel': 'ruta: {route}',
  'settings.ai.on': 'en',
  'settings.ai.off': 'apagado',
  'settings.ai.recentUsageLedger': 'Libro mayor de uso reciente',
  'settings.ai.recentUsageLedgerDesc':
    'Las filas del backend exponen action/time hoy; las etiquetas de origen necesitan soporte del backend.',
  'settings.ai.latestSpend': 'Último gasto: {amount} en {time} ({action})',
  'settings.ai.topActions': 'Acciones principales',
  'settings.ai.noSpendRows': 'No se han cargado filas de gastos.',
  'settings.ai.topHours': 'Horas principales',
  'settings.ai.noHourlySpend': 'Aún no hay gasto por horas.',
  'settings.ai.openhumanDefault': 'OpenHuman (predeterminado)',
  'settings.ai.localModelResolved': 'Ollama · {model}',
  'settings.ai.customRoutingForWorkload': 'Ruta personalizada para {label}',
  'settings.ai.loadingModels': 'Cargando modelos...',
  'settings.ai.enterModelIdManually': 'o ingrese la identificación del modelo manualmente:',
  'settings.ai.modelIdPlaceholderForProvider': '{slug} identificación del modelo',
  'settings.ai.modelIdPlaceholder': 'model-id',
  'settings.ai.selectModel': 'Seleccione un modelo...',
  'settings.ai.deploymentNameLabel': 'Nombre de la implementación',
  'settings.ai.deploymentNamePlaceholder': 'my-gpt-deployment',
  'settings.ai.deploymentNameHelp':
    'Introduzca el nombre de la implementación que definió en Azure AI Foundry. No es el ID del modelo.',
  'settings.ai.deploymentNameLegacyHint':
    'Este valor coincide con un ID de modelo base del catálogo del proveedor. Azure enruta las solicitudes por nombre de implementación, así que confirme que este es el nombre que dio a su implementación.',
  'settings.ai.deploymentNameProviderHint':
    'Punto de conexión de Azure detectado. Defina el nombre de su implementación en el campo de modelo tras elegir este proveedor.',
  'settings.ai.chooseModelFromList': 'Elegir de la lista',
  'settings.ai.enterModelIdManuallyAction': 'Introducir el ID del modelo manualmente',
  'settings.ai.enterDeploymentNameManuallyAction':
    'Introducir el nombre de implementación manualmente',
  'settings.ai.probeFailedHint':
    'No hemos podido leer la lista de modelos de este proveedor. Esa lista solo rellena el desplegable, así que puedes añadir el proveedor igualmente y escribir tú mismo el nombre del modelo o de la implementación.',
  'settings.ai.probeFailedAddAnyway': 'Añadir sin verificar',
  'settings.ai.azureV1EndpointHint':
    'Para Azure, usa la URL base v1: https://YOUR-RESOURCE.openai.azure.com/openai/v1. La URL de recurso antigua no ofrece una lista de modelos y espera otra cabecera de autenticación.',
  'settings.ai.temperatureOverride': 'Anulación de temperatura',
  'settings.ai.temperatureOverrideSlider': 'Anulación de temperatura (control deslizante)',
  'settings.ai.temperatureOverrideValue': 'Anulación de temperatura (valor)',
  'settings.ai.temperatureOverrideDesc':
    'Más bajo = más determinista. Déjelo sin marcar para usar el valor predeterminado del proveedor.',
  'settings.ai.modelVision': 'Admite visión (entrada de imágenes)',
  'settings.ai.modelVisionDesc':
    'Actívalo si este modelo acepta imágenes. Permite adjuntar imágenes en el chat cuando este modelo está seleccionado.',
  'settings.ai.testFailed': 'Prueba fallida',
  'settings.ai.providerTest.authRejected':
    "La clave se guardó, pero '{slug}' la rechazó. Comprueba que pegaste la clave completa y que sigue activa en el panel del proveedor.",
  'settings.ai.providerTest.modelNotRecognized':
    "La clave se guardó y se aceptó, pero '{slug}' no reconoce el modelo seleccionado. Elige un identificador de modelo que este proveedor sirva realmente (su modelo predeterminado se define en la entrada del proveedor).",
  'settings.ai.providerTest.quotaOrBilling':
    "La clave se guardó y se aceptó, pero '{slug}' rechazó la solicitud por motivos de cuota o facturación. Revisa el saldo de tu cuenta y los límites de uso con el proveedor.",
  'settings.ai.providerTest.endpointNotFound':
    "La clave se guardó, pero el endpoint configurado para '{slug}' devolvió 404. Revisa la URL base: un proveedor compatible con OpenAI suele necesitar el sufijo '/v1' (por ejemplo, https://api.openai.com/v1).",
  'settings.ai.providerTest.timeout':
    "La clave se guardó, pero '{slug}' no respondió a tiempo. Revisa la URL del endpoint y tu red, y vuelve a probar.",
  'settings.ai.providerTest.emptyReply':
    "La clave se guardó, pero '{slug}' devolvió una respuesta vacía a un mensaje de prueba. Revisa el identificador de modelo configurado para este proveedor.",
  'settings.ai.providerTest.unknown':
    "La clave se guardó, pero una llamada de prueba a '{slug}' falló. Revisa la página de estado del proveedor y la URL del endpoint, y vuelve a probar.",
  'settings.ai.testingModel': 'Modelo de prueba...',
  'settings.ai.modelResponse': 'Respuesta modelo',
  'settings.ai.providerWithValue': 'Proveedor: {value}',
  'settings.ai.noneDash': 'Ninguno',
  'settings.ai.promptHelloWorld': 'Mensaje: Hola mundo',
  'settings.ai.startedAt': 'Iniciado: {value}',
  'settings.ai.waitingForModelResponse': 'Esperando respuesta del modelo seleccionado...',
  'settings.ai.response': 'Respuesta',
  'settings.ai.testing': 'Probando...',
  'settings.ai.test': 'prueba',
  'settings.ai.slugMissingError': 'Ingrese el nombre de un proveedor para generar un slug.',
  'settings.ai.slugInUseError': 'Ese nombre de proveedor ya está en uso.',
  'settings.ai.slugReservedError': 'Elija un nombre de proveedor diferente.',
  'settings.ai.providerNamePlaceholder': 'Mi proveedor',
  'settings.ai.slugLabel': 'Babosa:',
  'settings.ai.openAiUrlLabel': 'URL de OpenAI',
  'settings.ai.openAiUrlPlaceholder': 'https://api.openai.com/v1',
  'settings.ai.keepExistingKeyPlaceholder': 'Déjelo en blanco para conservar la clave existente',
  'settings.ai.reindexingMemory': 'Memoria de reindexación',
  'settings.ai.reindexingMemoryMessage':
    'Los embeddings están siendo reprocesados. El(los) elemento(s) de memoria {pending} están siendo re-embebidos bajo el modelo actual; la recuperación semántica se reduce hasta que esto termine. La búsqueda por palabras clave sigue funcionando, y el re-embedding continúa en segundo plano si cierras esto.',
  'settings.ai.signInWithOpenRouter': 'Iniciar sesión con OpenRouter',
  'settings.ai.weekBudget': 'Presupuesto semanal',
  'settings.ai.cycleRemaining': 'Ciclo restante',
  'settings.ai.cycleTotalSpend': 'Gasto total del ciclo',
  'settings.ai.avgSpendRow': 'Fila de gasto medio',
  'settings.ai.backgroundApiReads': 'Bg API lee',
  'settings.ai.backgroundWakeups': 'Bg despertares',
  'settings.ai.budgetMath': 'Matemáticas presupuestarias',
  'settings.ai.rowsLeft': 'Filas restantes',
  'settings.ai.rowsPerFullWeekBudget': 'Presupuesto de filas por semana completa',
  'settings.ai.sampleBurnRate': 'Tasa de grabación de muestras',
  'settings.ai.projectedEmpty': 'vacío proyectado',
  'settings.ai.apiReadsPerDollarRemaining': 'API lecturas por $ restantes',
  'settings.ai.loopCallBudget': 'Presupuesto de llamadas en bucle',
  'settings.ai.heartbeatTicks': 'Latidos del corazón',
  'settings.ai.calendarPlannerCalls': 'Llamadas del planificador de calendario',
  'settings.ai.calendarFanoutCap': 'Tapa de distribución del calendario',
  'settings.ai.subconsciousModelCalls': 'Llamadas del modelo subconsciente',
  'settings.ai.composioSyncScans': 'Composio escaneos de sincronización',
  'settings.ai.totalBackgroundApiReadBudget': 'Total bg API leer presupuesto',
  'settings.ai.memoryWorkerPolls': 'Encuestas de trabajadores de la memoria',
  'settings.ai.defaultProviderName': 'OpenHuman',
  'settings.ai.routing.managed': 'Gestionado',
  'settings.ai.routing.managedAlwaysOn': 'Siempre encendido',
  'settings.ai.routing.managedHint':
    'Gestionado siempre está disponible como alternativa. Para utilizar su propio modelo, elija un modo de enrutamiento a continuación.',
  'settings.ai.routing.managedDesc':
    'OpenHuman ejecutará toda la inferencia en la nube, elegirá el mejor modelo para la tarea, optimizará para el costo y mantendrá los valores predeterminados de enrutamiento más seguros.',
  'settings.ai.routing.managedMsg':
    'OpenHuman manejará toda la inferencia para cada carga de trabajo y elegirá automáticamente la mejor ruta para costo, calidad y seguridad.',
  'settings.ai.routing.useYourOwn': 'Utilice sus propios modelos',
  'settings.ai.routing.useYourOwnDesc':
    'Elige un proveedor + modelo y dirige todas las cargas de trabajo a través de él. Esto es simple, pero puede ser ineficiente porque la inferencia ligera y la pesada comparten la misma ruta.',
  'settings.ai.routing.advanced': 'Avanzado',
  'settings.ai.routing.advancedDesc':
    'Elige diferentes modelos para diferentes tareas. Esta es la mejor opción para una optimización estricta de costos y el mayor control.',
  'settings.ai.routing.customDesc':
    'El enrutamiento detallado te ofrece la mejor optimización de costos y el mayor control. Usa las filas a continuación para decidir qué cargas de trabajo permanecen gestionadas, cuáles usan tu valor predeterminado compartido y cuáles se asignan a un modelo específico.',
  'settings.ai.routing.chatAndConversations': 'Chat y conversaciones',
  'settings.ai.routing.chatDesc':
    'Modelos utilizados durante la interacción directa con el usuario, respuestas, razonamiento, bucles de agentes y ayuda en programación.',
  'settings.ai.routing.backgroundTasks': 'Tareas en segundo plano',
  'settings.ai.routing.bgTasksDesc':
    'Modelos utilizados fuera del flujo principal de la conversación para resumen, latido, aprendizaje y evaluación subconsciente.',
  'settings.ai.routing.workload.chat.label': 'Chat',
  'settings.ai.routing.workload.chat.description':
    'Intercambio conversacional directo: modo “Rápido” en Conversaciones',
  'settings.ai.routing.workload.chat.hint':
    'Recomendado: un modelo de chat rápido económico o de costo medio con tokens altos por segundo y baja latencia. Los modelos locales de código abierto pueden funcionar bien aquí si se sienten receptivos.',
  'settings.ai.routing.workload.reasoning.label': 'Reasoning',
  'settings.ai.routing.workload.reasoning.description':
    'Agente de chat principal, resumidor de reuniones: modo “Razonamiento” en Conversaciones',
  'settings.ai.routing.workload.reasoning.hint':
    'Recomendado: una frontera más cara o un modelo de razonamiento sólido para el pensamiento profundo. Esto se utiliza para el agente de chat principal, resúmenes de reuniones y síntesis de respuestas más completas.',
  'settings.ai.routing.workload.agentic.label': 'Agentic',
  'settings.ai.routing.workload.agentic.description':
    'Corredores de subagentes, bucles de herramientas, decisiones de GIF',
  'settings.ai.routing.workload.agentic.hint':
    'Recomendado: un modelo confiable que sigue instrucciones con un fuerte uso de herramientas. Los modelos de frontera de costo medio suelen ser los más seguros; Los modelos de código abierto capaces pueden funcionar si la llamada a herramientas es estable.',
  'settings.ai.routing.workload.coding.label': 'Coding',
  'settings.ai.routing.workload.coding.description':
    'Pases de generación y refactorización de código.',
  'settings.ai.routing.workload.coding.hint':
    'Recomendado: un modelo ajustado a la codificación con un sólido seguimiento de instrucciones, calidad de edición y rendimiento en contextos prolongados. Por lo general, vale la pena gastar más en esto.',
  'settings.ai.routing.workload.vision.label': 'Vision',
  'settings.ai.routing.workload.vision.description':
    'Comprensión de imágenes para el subagente de visión: siempre multimodal',
  'settings.ai.routing.workload.vision.hint':
    'Recomendado: un modelo multimodal que acepta entrada de imágenes. El valor predeterminado administrado (vision-v1) es compatible con imágenes; cualquier proveedor que envíe aquí siempre será tratado como habilitado para la visión.',
  'settings.ai.routing.workload.memory.label': 'Resumen de memoria',
  'settings.ai.routing.workload.memory.description': 'Extractos de árboles y consolidaciones.',
  'settings.ai.routing.workload.memory.hint':
    'Recomendado: un modelo de resumen más económico. Debe ser coherente y compacto, pero no necesita un razonamiento de primer nivel.',
  'settings.ai.routing.workload.heartbeat.label': 'Heartbeat',
  'settings.ai.routing.workload.heartbeat.description':
    'Razonamiento en segundo plano entre turnos de usuario.',
  'settings.ai.routing.workload.heartbeat.hint':
    'Recomendado: un modelo en segundo plano económico y eficiente. Esto ocurre a menudo entre turnos, por lo que el bajo costo importa más que la máxima inteligencia.',
  'settings.ai.routing.workload.learning.label': 'Aprendizaje · Reflexiones',
  'settings.ai.routing.workload.learning.description':
    'Reflexión periódica sobre la historia reciente',
  'settings.ai.routing.workload.learning.hint':
    'Recomendado: un modelo reflectante más fuerte. Esto puede ser de costo medio o premium porque se beneficia de una mejor síntesis a lo largo de la historia reciente.',
  'settings.ai.routing.workload.subconscious.label': 'Subconscious',
  'settings.ai.routing.workload.subconscious.description':
    'Puntuación de acontecimientos + comprobaciones de deriva',
  'settings.ai.routing.workload.subconscious.hint':
    'Recomendado: un modelo de seguimiento muy económico, idealmente uno que sea ligero y predecible. Esto es para puntuación de acontecimientos, verificaciones de deriva y evaluación de antecedentes silenciosa.',
  'settings.ai.routing.addCustomProvider': 'Agregar proveedor personalizado',
  'settings.ai.globalModel.title': 'Elige un modelo para todo',
  'settings.ai.globalModel.desc':
    'Esto dirige toda la inferencia a través de un modelo. Es más sencillo, pero puede ser ineficiente en cuanto a costo y calidad porque las tareas ligeras y pesadas usarán la misma ruta.',
  'settings.ai.globalModel.noProviders':
    'Agrega o conecta un proveedor primero. Luego puedes enrutar cada carga de trabajo a través de un modelo aquí.',
  'settings.ai.globalModel.provider': 'Proveedor',
  'settings.ai.globalModel.model': 'modelo',
  'settings.ai.globalModel.loadingModels': 'Cargando modelos…',
  'settings.ai.globalModel.enterModelId': 'Ingrese la identificación del modelo',
  'settings.ai.globalModel.appliesToAll':
    'Aplica el mismo proveedor + modelo a chat, razonamiento, codificación, memoria, latido, aprendizaje y subconsciente. Los embeddings se configuran por separado. Los cambios se guardan cuando haces clic en guardar.',
  'settings.ai.globalModel.saving': 'Guardando…',
  'settings.ai.globalModel.saved': 'Guardado',
  'settings.ai.workload.noModel': 'Ningún modelo seleccionado',
  'settings.ai.workload.changeModel': 'Cambiar modelo',
  'settings.ai.workload.chooseModel': 'Elige modelo',
  'settings.ai.provider.ollama': 'Ollama',
  'settings.billing.autoRecharge.addAmount': 'Agregar esta cantidad',
  'settings.billing.autoRecharge.addCard': 'Agregar tarjeta',
  'settings.billing.autoRecharge.amountHint': 'Sugerencia de cantidad',
  'settings.billing.autoRecharge.defaultCard': 'Tarjeta predeterminada',
  'settings.billing.autoRecharge.lastRechargeFailed': 'Última recarga fallida',
  'settings.billing.autoRecharge.lastRecharged': 'Última recarga',
  'settings.billing.autoRecharge.expires': 'Vence {date}',
  'settings.billing.autoRecharge.noCards': 'Sin tarjetas',
  'settings.billing.autoRecharge.paymentMethods': 'Métodos de pago',
  'settings.billing.autoRecharge.rechargeInProgress': 'Recarga en progreso',
  'settings.billing.autoRecharge.spentThisWeek': '${spent} de ${limit} usados esta semana',
  'settings.billing.autoRecharge.rechargeWhen': 'Recargar cuando el saldo caiga por debajo de',
  'settings.billing.autoRecharge.saveSettings': 'Guardando…',
  'settings.billing.autoRecharge.saving': 'Guardando…',
  'settings.billing.autoRecharge.setDefault': ':',
  'settings.billing.autoRecharge.subtitle': 'Subtítulo',
  'settings.billing.autoRecharge.title': 'Activar recarga automática',
  'settings.billing.autoRecharge.toggleAriaLabel': 'Activar/desactivar recarga automática',
  'settings.billing.autoRecharge.weeklyLimit': 'Límite de gasto semanal',
  'settings.billing.history.desc': 'Descripción',
  'settings.billing.history.empty': 'Vacío',
  'settings.billing.history.openPortal': 'Abrir portal',
  'settings.billing.history.posted': 'Publicado',
  'settings.billing.history.title': 'Título',
  'settings.billing.inferenceBudget.cycleEnds': 'El ciclo termina',
  'settings.billing.inferenceBudget.exhausted': 'Agotado',
  'settings.billing.inferenceBudget.loadError': 'Error de carga',
  'settings.billing.inferenceBudget.noBudgetDesc': 'Sin descripción de presupuesto',
  'settings.billing.inferenceBudget.noRecurringBudget': 'Sin presupuesto recurrente',
  'settings.billing.inferenceBudget.noRecurringPlanBudget': 'Sin presupuesto de plan recurrente',
  'settings.billing.inferenceBudget.noRecurringWeeklyDesc':
    'Su plan actual no incluye un presupuesto semanal recurrente para inferencias. En su lugar, el uso se paga con los créditos disponibles.',
  'settings.billing.inferenceBudget.remaining': 'Restante',
  'settings.billing.inferenceBudget.remainingSummary': '{remaining} / {budget} restante',
  'settings.billing.inferenceBudget.spentThisCycle': 'Pasé {amount} este ciclo',
  'settings.billing.inferenceBudget.cycleEndsOn': 'El ciclo termina {date}',
  'settings.billing.inferenceBudget.exhaustedDesc':
    'El uso de la suscripción incluida se ha agotado. Recarga créditos para seguir usando AI sin esperar al próximo ciclo.',
  'settings.billing.inferenceBudget.discountVsPayg':
    '{pct}% más barato por llamada que pagar por uso.',
  'settings.billing.inferenceBudget.cycleSpend': 'Gasto en ciclo',
  'settings.billing.inferenceBudget.totalAmount': '{amount} en total',
  'settings.billing.inferenceBudget.inference': 'Inferencia',
  'settings.billing.inferenceBudget.integrations': 'Integraciones',
  'settings.billing.inferenceBudget.calls': '{count} llamadas',
  'settings.billing.inferenceBudget.dailySpend': 'Gasto diario',
  'settings.billing.inferenceBudget.dailySpendPoint': '{date}: {amount}',
  'settings.billing.inferenceBudget.topModels': 'Mejores modelos',
  'settings.billing.inferenceBudget.noInferenceUsage': 'No se utilizan inferencias en este ciclo.',
  'settings.billing.inferenceBudget.topIntegrations': 'Principales integraciones',
  'settings.billing.inferenceBudget.noIntegrationUsage': 'No hay uso de integración en este ciclo.',
  'settings.billing.inferenceBudget.tenHourCap': 'Límite de diez horas',
  'settings.billing.inferenceBudget.title': 'Título',
  'settings.billing.inferenceBudget.unableToLoad': 'No se pueden cargar datos de uso',
  'settings.billing.inferenceBudget.notAvailable': 'n/a',
  'settings.billing.payAsYouGo.available': 'Disponible',
  'settings.billing.payAsYouGo.chargeCustomAmount': 'Abriendo…',
  'settings.billing.payAsYouGo.chooseTopUpDesc': 'Descripción de recarga',
  'settings.billing.payAsYouGo.chooseTopUpTitle': 'Título de recarga',
  'settings.billing.payAsYouGo.creditBalanceDesc': 'Descripción de saldo de crédito',
  'settings.billing.payAsYouGo.creditBalanceTitle': 'Título de saldo de crédito',
  'settings.billing.payAsYouGo.customAmount': 'Cantidad personalizada',
  'settings.billing.payAsYouGo.enterAmount': 'Ingresar cantidad',
  'settings.billing.payAsYouGo.opening': 'Abriendo',
  'settings.billing.payAsYouGo.promotionalCredits': 'Créditos promocionales',
  'settings.billing.payAsYouGo.topUpBalance': 'Recargar saldo',
  'settings.billing.payAsYouGo.topUpCredits': 'Recargar créditos',
  'settings.billing.payAsYouGo.unableToLoad': 'No se pudo cargar el saldo.',
  'settings.billing.subscription.annual': 'Anual',
  'settings.billing.subscription.billedAnnually': 'Facturado anualmente',
  'settings.billing.subscription.chooseSubtitle': 'Elegir subtítulo',
  'settings.billing.subscription.chooseTitle': 'Elegir título',
  'settings.billing.subscription.cryptoDesc': 'Descripción de cripto',
  'settings.billing.subscription.cryptoQuestion': 'Pregunta de cripto',
  'settings.billing.subscription.current': 'Actual',
  'settings.billing.subscription.currentPlan': 'Plan actual',
  'settings.billing.subscription.monthly': 'Mensual',
  'settings.billing.subscription.paymentConfirmed': 'Pago confirmado',
  'settings.billing.subscription.perMonth': 'Por mes',
  'settings.billing.subscription.popular': 'populares',
  'settings.billing.subscription.save': '{pct}',
  'settings.billing.subscription.upgrade': 'Mejorar plan',
  'settings.billing.subscription.waiting': 'Esperando',
  'settings.billing.subscription.waitingPayment': 'Esperando pago',
  'settings.composio.apiKeyDesc':
    'Actualmente hay una clave API de Composio almacenada en este dispositivo.',
  'settings.composio.apiKeyExamplePlaceholder': 'ck_live_xxxxxxxxxxxxxxxx',
  'settings.composio.apiKeyLabel': 'Clave API de Composio',
  'settings.composio.apiKeyStored': 'Clave API almacenada',
  'settings.composio.apiKeyStoredPlaceholder': '••••••••••••••••',
  'settings.composio.clearedToBackend': 'Cambiado al modo Backend',
  'settings.composio.confirmItem1': 'Una cuenta en app.composio.dev con una clave API',
  'settings.composio.confirmItem2':
    'Vuelve a vincular cada integración a través de tu cuenta personal de Composio',
  'settings.composio.confirmItem3':
    'Nota: los triggers de Composio (webhooks en tiempo real) aún no funcionan en modo Directo: solo las llamadas de herramientas síncronas',
  'settings.composio.confirmNeedItems': 'Necesitarás:',
  'settings.composio.confirmSwitch': 'Entiendo, cambiar a Directo',
  'settings.composio.confirmTitle': '⚠️ Cambiando a modo Directo',
  'settings.composio.confirmWarning':
    'Tus integraciones existentes (Gmail, Slack, GitHub, etc. vinculadas a través de OpenHuman) no serán visibles: viven en el inquilino de Composio gestionado por OpenHuman.',
  'settings.composio.intro':
    'Composio integra más de 250 aplicaciones externas como herramientas que tu agente puede invocar. Elige cómo se enrutan esas llamadas.',
  'settings.composio.title': 'Composio',
  'settings.composio.modeDirect': 'Directo (usa tu propia clave API)',
  'settings.composio.modeDirectDesc':
    'Las llamadas van directamente a backend.composio.dev. Soberano / amigable con uso sin conexión. La ejecución de herramientas funciona de forma síncrona; los webhooks de triggers en tiempo real aún no están enrutados en modo directo (incidencia pendiente).',
  'settings.composio.modeManaged': 'Gestionado (OpenHuman lo maneja por ti)',
  'settings.composio.modeManagedDesc':
    'OpenHuman canaliza las llamadas de herramientas a través de nuestro backend (recomendado). La autenticación se intermedia; nunca pegas una clave API de Composio. Los webhooks están totalmente enrutados.',
  'settings.composio.routingMode': 'Modo de enrutamiento',
  'settings.composio.saveErrorNoKey':
    'Error al guardar. El modo Directo requiere una clave API no vacía.',
  'settings.composio.saving': 'Guardando…',
  'settings.composio.switching': 'Cambiando…',
  'settings.cron.jobs.commandRequired': 'El comando es obligatorio para los trabajos de shell',
  'settings.cron.jobs.createJob': 'Nuevo trabajo programado',
  'settings.cron.jobs.created': 'Trabajo creado',
  'settings.cron.jobs.custom': 'Personalizado',
  'settings.cron.jobs.desc': 'Descripción',
  'settings.cron.jobs.edit': 'Editar',
  'settings.cron.jobs.editJob': 'Editar trabajo programado',
  'settings.cron.jobs.empty': 'No se encontraron tareas cron del core.',
  'settings.cron.jobs.errorCreate': 'No se pudo crear el trabajo cron: {message}',
  'settings.cron.jobs.errorLoadList':
    'No se pudieron cargar los trabajos cron del núcleo: {message}',
  'settings.cron.jobs.errorLoadRuns': 'No se pudo cargar el historial de ejecuciones: {message}',
  'settings.cron.jobs.errorRemove': 'No se pudo eliminar el trabajo cron del núcleo: {message}',
  'settings.cron.jobs.errorRun': 'No se pudo ejecutar el trabajo cron del núcleo: {message}',
  'settings.cron.jobs.errorToggle': 'No se pudo actualizar el trabajo cron del núcleo: {message}',
  'settings.cron.jobs.errorUpdate': 'No se pudo actualizar el trabajo cron: {message}',
  'settings.cron.jobs.formAtLabel': 'Ejecutar a las',
  'settings.cron.jobs.formCancel': 'Cancelar',
  'settings.cron.jobs.formCommand': 'Comando de shell',
  'settings.cron.jobs.formCommandPlaceholder': 'p. ej. curl https://example.com/health',
  'settings.cron.jobs.formCreate': 'Crear',
  'settings.cron.jobs.formCronCustom': 'Expresión personalizada',
  'settings.cron.jobs.formCronCustomPlaceholder': 'p. ej. */30 * * * *',
  'settings.cron.jobs.formCronPreset': 'Predefinido',
  'settings.cron.jobs.formCronPreview': 'Ejecuciones: {preview}',
  'settings.cron.jobs.formDeleteAfterRun': 'Eliminar tras la primera ejecución',
  'settings.cron.jobs.formDelivery': 'Modo de entrega',
  'settings.cron.jobs.formDeliveryNone': 'Ninguno (solo salida)',
  'settings.cron.jobs.formDeliveryProactive': 'Proactivo (notificación push)',
  'settings.cron.jobs.formError': 'No se pudo guardar el trabajo',
  'settings.cron.jobs.formEveryLabel': 'Intervalo (milisegundos)',
  'settings.cron.jobs.formEveryPlaceholder': 'p. ej. 3600000',
  'settings.cron.jobs.formJobType': 'Tipo de trabajo',
  'settings.cron.jobs.formJobTypeAgent': 'Agent (instrucción de IA)',
  'settings.cron.jobs.formJobTypeShell': 'Comando de shell',
  'settings.cron.jobs.formName': 'Nombre del trabajo',
  'settings.cron.jobs.formNamePlaceholder': 'p. ej. daily-report, cleanup-task',
  'settings.cron.jobs.formPrompt': 'Instrucción del agente',
  'settings.cron.jobs.formPromptPlaceholder': '¿Qué debe hacer el agente en cada ejecución?',
  'settings.cron.jobs.formPromptRequired':
    'La instrucción es obligatoria para los trabajos de agente',
  'settings.cron.jobs.formSave': 'Guardar',
  'settings.cron.jobs.formSaving': 'Guardando…',
  'settings.cron.jobs.formScheduleAt': 'Una sola vez (ejecutar a las)',
  'settings.cron.jobs.formScheduleCron': 'Recurrente (cron)',
  'settings.cron.jobs.formScheduleEvery': 'Intervalo (cada N ms)',
  'settings.cron.jobs.formScheduleRequired': 'La programación es obligatoria',
  'settings.cron.jobs.formScheduleType': 'Tipo de programación',
  'settings.cron.jobs.formSessionIsolated': 'Aislada (recomendado)',
  'settings.cron.jobs.formSessionMain': 'Sesión principal',
  'settings.cron.jobs.formSessionTarget': 'Sesión de destino',
  'settings.cron.jobs.formProfile': 'Perfil del agente',
  'settings.cron.jobs.formProfileNone': 'Sin perfil',
  'settings.cron.jobs.formProfileHint':
    'Ejecuta esta tarea como el perfil seleccionado, usando su alma, memoria y espacio de trabajo.',
  'settings.cron.jobs.profile': 'Perfil',
  'settings.cron.jobs.lastStatus': 'Último estado',
  'settings.cron.jobs.loading': 'Cargando tareas cron...',
  'settings.cron.jobs.loadingRuns': 'Cargando ejecuciones',
  'settings.cron.jobs.nextRun': 'Próxima ejecución',
  'settings.cron.jobs.pause': 'Pausar',
  'settings.cron.jobs.paused': 'Pausado',
  'settings.cron.jobs.recentRuns': 'Ejecuciones recientes',
  'settings.cron.jobs.removing': 'Eliminando',
  'settings.cron.jobs.resume': 'Reanudar',
  'settings.cron.jobs.runningNow': 'Ejecutando ahora',
  'settings.cron.jobs.saving': 'Guardando…',
  'settings.cron.jobs.schedule': 'Programación',
  'settings.cron.jobs.title': 'Tareas cron del core',
  'settings.cron.jobs.updated': 'Trabajo actualizado',
  'settings.cron.jobs.viewRuns': 'Ver ejecuciones',
  'settings.cron.schedule.every2hours': 'Cada 2 horas',
  'settings.cron.schedule.every30min': 'Cada 30 minutos',
  'settings.cron.schedule.every6hours': 'Cada 6 horas',
  'settings.cron.schedule.everyHour': 'Cada hora',
  'settings.cron.schedule.onceDaily': 'Una vez al día (9 a. m.)',
  'settings.localModel.deviceCapability.active': 'Activo',
  'settings.localModel.deviceCapability.appliedTier': 'Nivel aplicado',
  'settings.localModel.deviceCapability.applying': 'Aplicando',
  'settings.localModel.deviceCapability.cores': '{count}',
  'settings.localModel.deviceCapability.couldNotLoadPresets': 'No se pudieron cargar los presets',
  'settings.localModel.deviceCapability.cpu': 'CPU',
  'settings.localModel.deviceCapability.customModelIds': 'IDs de modelos personalizados',
  'settings.localModel.deviceCapability.detected': 'Detectado',
  'settings.localModel.deviceCapability.disabled': 'Desactivado',
  'settings.localModel.deviceCapability.disabledDesc': 'Descripción de desactivado',
  'settings.localModel.deviceCapability.downloadingModels': '(descargando modelos)',
  'settings.localModel.deviceCapability.downloadingSetupDesc':
    'Descargando el instalador de OllamaSetup (~2 GB) y descomprimiéndolo. Esto puede tardar un minuto en la primera instalación.',
  'settings.localModel.deviceCapability.failedToApplyPreset': 'No se pudo aplicar el preset',
  'settings.localModel.deviceCapability.gpu': 'GPU',
  'settings.localModel.deviceCapability.installFailed': 'Instalación de Ollama fallida',
  'settings.localModel.deviceCapability.installFailedDesc':
    'El instalador terminó antes de que Ollama estuviera disponible. Haz clic en reintentar o instálalo manualmente desde ollama.com.',
  'settings.localModel.deviceCapability.installFirst': 'Ejecuta Ollama primero.',
  'settings.localModel.deviceCapability.installFirstDesc':
    'Los niveles locales dependen de un endpoint de Ollama gestionado externamente. Inícialo tú mismo, descarga los modelos que quieras y sigue usando "Desactivado (respaldo en la nube)" hasta que el runtime sea accesible.',
  'settings.localModel.deviceCapability.installOllamaFirst':
    'Ejecuta Ollama primero para usar este nivel',
  'settings.localModel.deviceCapability.installingOllama': 'Instalando Ollama',
  'settings.localModel.deviceCapability.loadingDeviceInfo': 'Cargando info del dispositivo',
  'settings.localModel.deviceCapability.localAiDisabled':
    'IA local desactivada: usando respaldo en la nube.',
  'settings.localModel.deviceCapability.modelTier': 'Nivel de modelo',
  'settings.localModel.deviceCapability.needsOllama': 'Necesita Ollama',
  'settings.localModel.deviceCapability.notDetected': 'No detectado',
  'settings.localModel.deviceCapability.disabledLowercase': 'discapacitado',
  'settings.localModel.deviceCapability.presetDetails':
    'Chat: {chatModel} · Visión: {visionModel} · RAM objetivo: {targetRamGb} GB',
  'settings.localModel.deviceCapability.ram': 'RAM',
  'settings.localModel.deviceCapability.recommended': 'Recomendado',
  'settings.localModel.deviceCapability.retryInstall': 'Reintentando…',
  'settings.localModel.deviceCapability.retrying': 'Reintentando…',
  'settings.localModel.deviceCapability.starting': 'Iniciando…',
  'settings.localModel.download.audioPathPlaceholder': 'Ruta absoluta al archivo de audio',
  'settings.localModel.download.capabilityChat': 'Charla',
  'settings.localModel.download.capabilityEmbedding': 'Incrustar',
  'settings.localModel.download.capabilityAssets': 'Activos de capacidad',
  'settings.localModel.download.capabilityStt': 'STT',
  'settings.localModel.download.capabilityTts': 'TTS',
  'settings.localModel.download.capabilityVision': 'Visión',
  'settings.localModel.download.downloading': 'Descargando...',
  'settings.localModel.download.embeddingDimensions': 'Dimensiones: {dimensions}',
  'settings.localModel.download.embeddingModel': 'Modelo: {modelId}',
  'settings.localModel.download.embeddingPlaceholder': 'Una cadena de entrada por línea...',
  'settings.localModel.download.embeddingVectors': 'Vectores: {count}',
  'settings.localModel.download.noThinkMode': 'Sin modo de pensamiento',
  'settings.localModel.download.notAvailable': 'n/a',
  'settings.localModel.download.promptPlaceholder':
    'Escribe cualquier prompt y ejecútalo en el modelo local...',
  'settings.localModel.download.quantizationPref': 'Preferencia de cuantización',
  'settings.localModel.download.runEmbeddingTest': 'Ejecutando...',
  'settings.localModel.download.runPromptTest': 'Ejecutar prueba de prompt',
  'settings.localModel.download.runSummaryTest': 'Ejecutar prueba de resumen',
  'settings.localModel.download.runTranscriptionTest': 'Ejecutando...',
  'settings.localModel.download.runTtsTest': 'Ejecutando...',
  'settings.localModel.download.runVisionTest': 'Ejecutando...',
  'settings.localModel.download.running': 'Ejecutando...',
  'settings.localModel.download.runningPrompt': 'Ejecutando prompt',
  'settings.localModel.download.summaryHelper':
    'Llama a `openhuman.inference_summarize` a través del núcleo de Rust',
  'settings.localModel.download.summarizePlaceholder':
    'Pega texto para resumir con el modelo local...',
  'settings.localModel.download.testCustomPrompt': 'Probar prompt personalizado',
  'settings.localModel.download.testEmbeddings': 'Probar embeddings',
  'settings.localModel.download.testSummarization': 'Probar resumen',
  'settings.localModel.download.testVisionPrompt': 'Probar prompt de visión',
  'settings.localModel.download.testVoiceInput': 'Probar entrada de voz (STT)',
  'settings.localModel.download.testVoiceOutput': 'Probar salida de voz (TTS)',
  'settings.localModel.download.transcript': 'Transcripción:',
  'settings.localModel.download.ttsOutput': 'Salida: {outputPath}',
  'settings.localModel.download.ttsOutputPlaceholder': 'Ruta WAV de salida opcional',
  'settings.localModel.download.ttsPlaceholder': 'Ingresa texto para sintetizar...',
  'settings.localModel.download.ttsVoice': 'Voz: {voiceId}',
  'settings.localModel.download.visionImagePlaceholder':
    'Una referencia de imagen por línea (data URI, URL o marcador de ruta local)',
  'settings.localModel.download.visionPromptPlaceholder':
    'Ingresa un prompt para el modelo de visión...',
  'settings.localModel.status.allChecksPassed': 'Todas las verificaciones pasaron',
  'settings.localModel.status.artifact': 'Artefacto',
  'settings.localModel.status.backend': 'backend',
  'settings.localModel.status.binary': 'Binario',
  'settings.localModel.status.bootstrapResume': 'Bootstrap / Reanudar',
  'settings.localModel.status.checking': 'Verificando...',
  'settings.localModel.status.checkingOllama': 'Verificando Ollama',
  'settings.localModel.status.contextBelowMinimumBadge':
    '{contextLength} ctx - debajo de {required} min',
  'settings.localModel.status.contextBelowMinimumTitle':
    'Rechazado: los tokens {contextLength} de la ventana de contexto están por debajo del mínimo de tokens {required} que requiere la capa de memoria. El truncamiento silencioso corrompería la recuperación.',
  'settings.localModel.status.contextOkBadge': '{contextLength}ctx ✓',
  'settings.localModel.status.contextOkTitle':
    'Los tokens {contextLength} de la ventana de contexto cumplen con el mínimo de la capa de memoria de tokens {required}.',
  'settings.localModel.status.contextUnknownBadge': 'ctx desconocido',
  'settings.localModel.status.contextUnknownTitle':
    'Ventana de contexto desconocida; No se pudo confirmar que cumpla con el mínimo de capa de memoria del token {required}.',
  'settings.localModel.status.customLocation': 'Ubicación personalizada',
  'settings.localModel.status.customLocationDesc': 'Descripción de ubicación personalizada',
  'settings.localModel.status.diagnosticsHint':
    'Haz clic en "Ejecutar diagnósticos" para verificar que Ollama está en ejecución y los modelos están instalados.',
  'settings.localModel.status.downloadingUnknown': 'Descargando (tamaño desconocido)',
  'settings.localModel.status.eta': 'ETA',
  'settings.localModel.status.expectedModels': 'Modelos esperados',
  'settings.localModel.status.expectedChat': 'Charla: {model}',
  'settings.localModel.status.expectedEmbedding': 'Incrustación: {model}',
  'settings.localModel.status.expectedVision': 'Visión: {model}',
  'settings.localModel.status.externalProcess': 'Proceso externo',
  'settings.localModel.status.forceRebootstrap': 'Forzar re-bootstrap',
  'settings.localModel.status.generationTps': 'TPS de generación',
  'settings.localModel.status.hideErrorDetails': 'Ocultar detalles del error',
  'settings.localModel.status.installManually': 'Instalar manualmente',
  'settings.localModel.status.installManuallyFrom': 'Instalar manualmente desde',
  'settings.localModel.status.installOllama': 'Iniciando…',
  'settings.localModel.status.installedModels': 'Modelos instalados',
  'settings.localModel.status.installing': 'Instalando...',
  'settings.localModel.status.installingOllama': 'Instalando runtime de Ollama...',
  'settings.localModel.status.issues': 'Problemas',
  'settings.localModel.status.issuesFound': 'Se encontraron {count} problema(s)',
  'settings.localModel.status.lastLatency': 'Última latencia',
  'settings.localModel.status.model': 'Modelo',
  'settings.localModel.status.notAvailable': 'n/a',
  'settings.localModel.status.notFound': 'No encontrado',
  'settings.localModel.status.notRunning': 'No en ejecución',
  'settings.localModel.status.ollamaBinaryPath': 'Ruta del binario de Ollama',
  'localModel.ollamaServer.helperText': 'Ejemplo: http://192.168.1.5:11434',
  'localModel.ollamaServer.label': 'URL del servidor Ollama',
  'localModel.ollamaServer.modelCount': 'modelos',
  'localModel.ollamaServer.placeholder': 'http://localhost:11434',
  'localModel.ollamaServer.reachable': 'Accesible',
  'localModel.ollamaServer.resetButton': 'Restablecer al valor predeterminado',
  'localModel.ollamaServer.saveButton': 'Guardar',
  'localModel.ollamaServer.testButton': 'Probar conexión',
  'localModel.ollamaServer.unreachable': 'No accesible',
  'localModel.ollamaServer.validationError': 'Debe ser una URL http:// o https:// válida',
  'settings.localModel.status.ollamaDiagnostics': 'Diagnósticos de Ollama',
  'settings.localModel.status.ollamaNotInstalled': 'Runtime de Ollama no disponible',
  'settings.localModel.status.ollamaNotInstalledDesc':
    'OpenHuman ahora trata Ollama como un runtime de inferencia externo. Inicia tu propio servidor Ollama, descarga los modelos que quieras y apunta el enrutado de cargas hacia él.',
  'settings.localModel.status.progress': 'Progreso',
  'settings.localModel.status.provider': 'Proveedor',
  'settings.localModel.status.retryBootstrap': 'Reintentar bootstrap',
  'settings.localModel.status.runDiagnostics': 'Verificando...',
  'settings.localModel.status.running': 'Ejecutándose',
  'settings.localModel.status.runningExternalProcess': 'Ejecutándose como proceso externo',
  'settings.localModel.status.runtimeStatus': 'Estado del runtime',
  'settings.localModel.status.server': 'Servidor',
  'settings.localModel.status.setPath': 'Configurando...',
  'settings.localModel.status.setting': 'Configurando...',
  'settings.localModel.status.showErrorDetails': 'Ocultar detalles del error',
  'settings.localModel.status.showInstallErrorDetails': 'Ocultar detalles del error',
  'settings.localModel.status.suggestedFixes': 'Correcciones sugeridas',
  'settings.localModel.status.thenSetPath': 'Luego configura la ruta',
  'settings.localModel.status.triggering': 'Activando...',
  'settings.localModel.status.unavailable': 'No disponible',
  'settings.localModel.status.working': 'Trabajando...',
  'settings.developerMenu.ai.title': 'Configuración de IA',
  'settings.developerMenu.ai.desc':
    'Proveedores en la nube, modelos locales de Ollama y enrutamiento por carga de trabajo',
  'settings.developerMenu.messagingChannels.title': 'Canales de mensajería',
  'settings.developerMenu.messagingChannels.desc':
    'Configura los modos de autenticación de Telegram/Discord y el enrutamiento de canal predeterminado',
  'settings.developerMenu.tools.title': 'Herramientas',
  'settings.developerMenu.tools.desc':
    'Activa o desactiva las capacidades que OpenHuman puede usar en tu nombre',
  'settings.developerMenu.agentChat.title': 'Chat del agente',
  'settings.developerMenu.agentChat.desc':
    'Prueba conversaciones del agente con ajustes de modelo y temperatura',
  'settings.developerMenu.devWorkflow.title': 'Flujo de trabajo de desarrollo',
  'settings.developerMenu.devWorkflow.desc':
    'Agente autónomo que selecciona tus problemas GitHub y genera PRs según un horario',
  'settings.developerMenu.devWorkflow.panelDesc':
    'Configura un agente desarrollador autónomo que seleccione los problemas GitHub asignados a ti y genere solicitudes de extracción automáticamente según un horario.',
  'settings.developerMenu.skillsRunner.title': 'Corredor de habilidades',
  'settings.developerMenu.skillsRunner.desc':
    'Ejecute cualquier habilidad incluida de manera ad hoc: complete sus entradas y active una ejecución autónoma en segundo plano',
  'settings.developerMenu.skillsRunner.panelDesc':
    'Elige una habilidad agrupada, completa sus entradas declaradas y ejecuta una ejecución en segundo plano de tipo fire-and-forget. Usa Dev Workflow en su lugar si quieres un trabajo recurrente programado con cron.',
  'settings.skillsRunner.skill': 'Habilidad',
  'settings.skillsRunner.selectSkill': 'Selecciona una habilidad…',
  'settings.skillsRunner.loadingSkills': 'Cargando habilidades…',
  'settings.skillsRunner.loadingDescription': 'Cargando entradas de habilidades…',
  'settings.skillsRunner.noInputs': 'Esta habilidad no declara entradas.',
  'settings.skillsRunner.placeholder.required': 'requerido',
  'settings.skillsRunner.runNow': 'Corre ahora',
  'settings.skillsRunner.starting': 'Comenzando…',
  'settings.skillsRunner.started': 'Iniciado: id de ejecución:',
  'settings.skillsRunner.logPath': 'Registro:',
  'settings.skillsRunner.error.listSkills': 'Error al cargar habilidades:',
  'settings.skillsRunner.error.describe': 'Error al cargar las entradas:',
  'settings.skillsRunner.error.missingRequired': 'Faltan datos de entrada requeridos:',
  'settings.skillsRunner.error.run': 'Error al iniciar la ejecución:',
  'settings.skillsRunner.error.preflightGate': 'La puerta de preembarque falló',
  'settings.skillsRunner.error.runtimeUnavailable': 'Runtime no disponible',
  'settings.skillsRunner.error.runtimeUnavailableDefault': 'no disponible',
  'settings.skillsRunner.schedule.heading': 'Horario (recurrente)',
  'settings.skillsRunner.schedule.help':
    'Guarda esta habilidad + entradas como un trabajo cron recurrente. El agente llamará a run_workflow en cada tick.',
  'settings.skillsRunner.schedule.frequency': 'Frecuencia',
  'settings.skillsRunner.schedule.every30min': 'Cada 30 minutos',
  'settings.skillsRunner.schedule.everyHour': 'Cada hora',
  'settings.skillsRunner.schedule.every2hours': 'Cada 2 horas',
  'settings.skillsRunner.schedule.every6hours': 'Cada 6 horas',
  'settings.skillsRunner.schedule.onceDaily': 'Una vez al día (9:00)',
  'settings.skillsRunner.schedule.save': 'Guardar horario',
  'settings.skillsRunner.schedule.saving': 'Guardando…',
  'settings.skillsRunner.schedule.saved': 'Horario guardado.',
  'settings.skillsRunner.schedule.error': 'Error al guardar el horario:',
  'settings.skillsRunner.schedule.loadingJobs': 'Cargando horarios existentes…',
  'settings.skillsRunner.schedule.noJobs': 'Aún no hay horarios guardados para esta habilidad.',
  'settings.skillsRunner.schedule.existing': 'Trabajos programados para esta habilidad:',
  'settings.skillsRunner.schedule.inputsLabel': 'Entradas',
  'settings.skillsRunner.schedule.inputsNone': 'Sin entradas',
  'settings.skillsRunner.schedule.runNow': 'Correr',
  'settings.skillsRunner.schedule.remove': 'Eliminar',
  'settings.skillsRunner.scheduleEnabled': 'Habilitado',
  'settings.skillsRunner.scheduleDisabled': 'Pausado',
  'settings.skillsRunner.scheduleToggleAria': 'Alternar programación habilitada',
  'settings.skillsRunner.schedule.history': 'Historia',
  'settings.skillsRunner.schedule.historyLoading': 'Cargando historial…',
  'settings.skillsRunner.schedule.historyEmpty': 'Aún no hay ejecuciones para este horario.',
  'settings.skillsRunner.schedule.historyNoOutput': 'No se capturó salida.',
  'settings.skillsRunner.schedule.active': 'activo',
  'settings.skillsRunner.schedule.lastRunLabel': 'último:',
  'settings.skillsRunner.recentRuns.headingForSkill': 'Ejecuciones recientes para esta habilidad',
  'settings.skillsRunner.recentRuns.headingAll': 'Carreras de habilidades recientes (todas)',
  'settings.skillsRunner.recentRuns.refresh': 'Refrescar',
  'settings.skillsRunner.recentRuns.loading': 'Cargando carreras recientes…',
  'settings.skillsRunner.recentRuns.empty': 'No hay carreras recientes.',
  'settings.skillsRunner.viewer.loading': 'Cargando registro…',
  'settings.skillsRunner.viewer.tailing': 'Seguimiento en vivo',
  'settings.skillsRunner.viewer.fetching': 'obteniendo',
  'settings.skillsRunner.viewer.error': 'Error al leer el registro:',
  'settings.skillsRunner.repoPicker.loading': 'Cargando repositorios…',
  'settings.skillsRunner.repoPicker.select': 'Selecciona un repositorio…',
  'settings.skillsRunner.repoPicker.empty':
    'No se devolvieron repositorios. Conecta GitHub a través de Composio para llenar esta lista.',
  'settings.skillsRunner.repoPicker.notConnected':
    'GitHub no está conectado a través de Composio. Conéctalo primero en Habilidades → Composio.',
  'settings.skillsRunner.repoPicker.privateTag': '(privado)',
  'settings.skillsRunner.branchPicker.needRepo': 'Primero elige un repositorio…',
  'settings.skillsRunner.branchPicker.loading': 'Cargando ramas…',
  'settings.skillsRunner.branchPicker.select': 'Seleccione una sucursal…',
  'settings.devWorkflow.githubRepository': 'Repositorio GitHub',
  'settings.devWorkflow.loadingRepositories': 'Cargando repositorios...',
  'settings.devWorkflow.selectRepository': 'Selecciona un repositorio',
  'settings.devWorkflow.privateTag': '(privado)',
  'settings.devWorkflow.detectingForkInfo': 'Detectando información del fork...',
  'settings.devWorkflow.forkDetected': 'Bifurcación detectada',
  'settings.devWorkflow.upstream': 'Corriente arriba:',
  'settings.devWorkflow.forkPrNote': 'Se abrirán PRs contra el repositorio principal.',
  'settings.devWorkflow.notForkNote':
    'No es un fork. Los PR se harán directamente contra este repositorio.',
  'settings.devWorkflow.targetBranch': 'Rama de destino',
  'settings.devWorkflow.targetBranchNote': 'Se crearán PRs contra esta rama',
  'settings.devWorkflow.loadingBranches': 'Cargando ramas...',
  'settings.devWorkflow.runFrequency': 'Frecuencia de ejecución',
  'settings.devWorkflow.runFrequencyNote':
    'Con qué frecuencia el agente debe comprobar si hay problemas y levantar PRs.',
  'settings.devWorkflow.updateConfiguration': 'Actualizar configuración',
  'settings.devWorkflow.saveConfiguration': 'Guardar configuración',
  'settings.devWorkflow.remove': 'Eliminar',
  'settings.devWorkflow.saved': 'guardado',
  'settings.devWorkflow.activeConfiguration': 'Configuración activa',
  'settings.devWorkflow.activeConfigRepository': 'Repositorio:',
  'settings.devWorkflow.activeConfigUpstream': 'Corriente arriba:',
  'settings.devWorkflow.activeConfigTargetBranch': 'Rama destino:',
  'settings.devWorkflow.activeConfigSchedule': 'Horario:',
  'settings.devWorkflow.enabled': 'Habilitado',
  'settings.devWorkflow.paused': 'Pausado',
  'settings.devWorkflow.nextRun': 'Próxima carrera',
  'settings.devWorkflow.lastRun': 'Última ejecución',
  'settings.devWorkflow.runNow': 'Corre ahora',
  'settings.devWorkflow.running': 'Corriendo…',
  'settings.devWorkflow.recentRuns': 'Ejecuciones recientes',
  'settings.devWorkflow.cronSaveError': 'Error al guardar la configuración',
  'settings.devWorkflow.lastOutput': 'Última salida',
  'settings.devWorkflow.noOutput': 'No se capturó salida',
  'settings.devWorkflow.runningStatus':
    'El agente está en funcionamiento: seleccionando un problema y trabajando en una solución...',
  'settings.devWorkflow.errorNotConnected':
    'GitHub no está conectado. Por favor, conecte GitHub a través de Configuración > Avanzado > Composio primero.',
  'settings.devWorkflow.errorToolNotEnabled':
    'La herramienta GITHUB_LIST_REPOSITORIES_FOR_THE_AUTHENTICATED_USER no está habilitada en este backend. Por favor, pide a tu administrador que la habilite en la integración de Composio (backend#842).',
  'settings.devWorkflow.errorNotAuthenticated': 'No autenticado. Por favor, inicie sesión primero.',
  'settings.devWorkflow.errorNoRepositories':
    'No se encontraron repositorios para esta cuenta GitHub.',
  'settings.devWorkflow.schedule.every30min': 'Cada 30 minutos',
  'settings.devWorkflow.schedule.everyHour': 'Cada hora',
  'settings.devWorkflow.schedule.every2hours': 'Cada 2 horas',
  'settings.devWorkflow.schedule.every6hours': 'Cada 6 horas',
  'settings.devWorkflow.schedule.onceDaily': 'Una vez al día (9 AM)',
  'settings.developerMenu.tasks.title': 'Tareas',
  'settings.developerMenu.tasks.desc':
    'Explora y gestiona los tableros de tareas: tus pendientes y los tableros que los agentes crean en las conversaciones.',
  'settings.developerMenu.cronJobs.title': 'Tareas cron',
  'settings.developerMenu.cronJobs.desc':
    'Ver y configurar tareas programadas para habilidades en tiempo de ejecución',
  'settings.developerMenu.localModelDebug.title': 'Depuración del modelo local',
  'settings.developerMenu.localModelDebug.desc':
    'Configuración de Ollama, descargas de recursos, pruebas de modelo y diagnósticos',
  'settings.developerMenu.webhooks.title': 'Ganchos web',
  'settings.developerMenu.webhooks.desc':
    'Inspecciona registros de webhooks en tiempo de ejecución y solicitudes capturadas',
  'settings.developerMenu.eventLog.title': 'Registro de eventos',
  'settings.developerMenu.eventLog.desc':
    'Transmisión en vivo codificada por colores de todos los eventos de agentes, herramientas y sistemas',
  'settings.developerMenu.eventLog.allTypes': 'Todos los tipos',
  'settings.developerMenu.eventLog.filterAgent': 'Filtrar...',
  'settings.developerMenu.eventLog.download': 'Descargar',
  'settings.developerMenu.eventLog.events': 'eventos',
  'settings.developerMenu.eventLog.live': 'Vivir',
  'settings.developerMenu.eventLog.disconnected': 'desconectado',
  'settings.developerMenu.eventLog.waiting': 'Esperando eventos...',
  'settings.developerMenu.eventLog.notConnected': 'No conectado al núcleo',
  'settings.developerMenu.eventLog.jumpToLatest': 'Saltar a lo más reciente',
  'settings.developerMenu.eventLog.badge.tool': 'TOOL',
  'settings.developerMenu.eventLog.badge.agent': 'AGENT',
  'settings.developerMenu.eventLog.badge.info': 'INFO',
  'settings.developerMenu.eventLog.badge.mem': 'MEM',
  'settings.developerMenu.eventLog.badge.chan': 'CHAN',
  'settings.developerMenu.eventLog.badge.cron': 'CRON',
  'settings.developerMenu.eventLog.badge.hook': 'HOOK',
  'settings.developerMenu.eventLog.badge.warn': 'WARN',
  'settings.developerMenu.eventLog.badge.skill': 'SKILL',
  'settings.developerMenu.eventLog.badge.comp': 'COMP',
  'settings.developerMenu.eventLog.badge.mcp': 'MCP',
  'settings.developerMenu.intelligence.title': 'Inteligencia',
  'settings.developerMenu.intelligence.desc':
    'Espacio de trabajo de memoria, motor subconsciente, sueños y ajustes',
  'settings.developerMenu.notificationRouting.title': 'Enrutamiento de notificaciones',
  'settings.developerMenu.notificationRouting.desc':
    'Puntuación de importancia con IA y escalado al orquestador para alertas de integración',
  'settings.developerMenu.composeioTriggers.title': 'Disparadores de ComposeIO',
  'settings.developerMenu.composeioTriggers.desc':
    'Ver historial y archivo de disparadores de ComposeIO',
  'settings.developerMenu.composioRouting.title': 'Enrutamiento de Composio (modo directo)',
  'settings.developerMenu.composioRouting.desc':
    'Usa tu propia clave API de Composio y enruta llamadas directamente a backend.composio.dev',
  'settings.developerMenu.integrationTriggers.title': 'Disparadores de integración',
  'settings.developerMenu.integrationTriggers.desc':
    'Configura los ajustes de triaje de IA para disparadores de integración de Composio',
  'settings.developerMenu.mcpServer.title': 'MCP Servidor',
  'settings.developerMenu.mcpServer.desc':
    'Configure clientes MCP externos para conectarse a OpenHuman',
  'settings.developerMenu.autonomy.title': 'Autonomía del agente',
  'settings.developerMenu.autonomy.desc':
    'Límites de frecuencia de acciones de herramientas y umbrales de seguridad',
  'settings.developerMenu.voiceDebug.title': 'Voz (depuración)',
  'settings.developerMenu.voiceDebug.desc':
    'Estado del tiempo de ejecución del dictado de voz y configuración de depuración',
  'settings.mcpServer.title': 'MCP Servidor',
  'settings.mcpServer.toolsSectionTitle': 'Herramientas disponibles',
  'settings.mcpServer.toolsSectionDesc':
    'Herramientas expuestas a través del servidor stdio MCP cuando se ejecuta openhuman-core mcp',
  'settings.mcpServer.configSectionTitle': 'Configuración del cliente',
  'settings.mcpServer.configSectionDesc':
    'Seleccione su cliente MCP para generar el fragmento de configuración correcto',
  'settings.mcpServer.copySnippet': 'Copiar al portapapeles',
  'settings.mcpServer.copied': '¡Copiado!',
  'settings.mcpServer.openConfigFile': 'Abrir archivo de configuración',
  'settings.mcpServer.binaryPathNotFound':
    'OpenHuman binario no encontrado. Si se ejecuta desde el código fuente, compila con: cargo build --bin openhuman-core',
  'settings.mcpServer.openConfigError': 'No se pudo abrir el archivo de configuración',
  'settings.mcpServer.clientClaudeDesktop': 'Escritorio Claude',
  'settings.mcpServer.clientCursor': 'Cursor',
  'settings.mcpServer.clientCodex': 'Códice',
  'settings.mcpServer.clientZed': 'Zed',
  'settings.mcpServer.configFilePath': 'Archivo de configuración',
  'settings.mcpServer.clientSelectorAriaLabel': 'MCP selector de cliente',
  'settings.appearance.menuDesc': 'Elige claro, oscuro o igualar el tema del sistema',
  'settings.agentAccess.title': 'Acceso del agente al sistema operativo',
  'settings.agentAccess.menuDesc':
    'Controla dónde el agente puede read/write y si puede usar la consola.',
  'settings.agentAccess.loadError': 'Error al cargar la configuración de acceso',
  'settings.agentAccess.saveError': 'Error al guardar la configuración de acceso',
  'settings.agentAccess.saved': 'Guardado: se aplica en tu próximo mensaje.',
  'settings.agentAccess.desktopOnly':
    'La configuración de acceso solo está disponible en la aplicación de escritorio.',
  'settings.agentAccess.loading': 'Cargando…',
  'settings.agentAccess.accessMode': 'Modo de acceso',
  'settings.agentAccess.tier.readonly.title': 'Solo lectura',
  'settings.agentAccess.tier.readonly.desc':
    'Lee archivos y ejecuta comandos de solo lectura para explorar, pero nunca escribe, edita ni ejecuta nada que cambie el estado.',
  'settings.agentAccess.tier.supervised.title': 'Pregunta antes de editar',
  'settings.agentAccess.tier.supervised.desc':
    'Crea nuevos archivos libremente, pero solicita su aprobación antes de editar un archivo existente, ejecutar un comando, acceder a la red o instalar algo.',
  'settings.agentAccess.tier.full.title': 'Acceso completo',
  'settings.agentAccess.tier.full.desc':
    'Ejecuta comandos con acceso completo de tu cuenta de usuario: puede read/write en cualquier lugar permitido, excepto en los almacenes de credenciales y del sistema. Los comandos destructivos, el acceso a la red y las instalaciones aún requieren aprobación.',
  'settings.agentAccess.defaultTag': '(predeterminado)',
  'settings.agentAccess.fullWarning':
    '⚠ El acceso completo ejecuta comandos con el acceso total de tu cuenta y no está en un entorno aislado. Solo actívalo cuando confíes en el agente con esta máquina. Los directorios de credenciales y del sistema siguen bloqueados, y las acciones destructivas, de red e instalación aún requieren aprobación.',
  'settings.agentAccess.confine.label': 'Restringir al espacio de trabajo',
  'settings.agentAccess.confine.desc':
    'Restringe al agente al directorio de trabajo (más cualquier carpeta concedida), sea cual sea el modo de acceso seleccionado. Cuando está desactivado, puede acceder a cualquier lugar al que pueda acceder tu usuario, excepto a los directorios de credenciales y del sistema que siempre están bloqueados.',
  'settings.agentAccess.requireTaskPlanApproval.label': 'Requerir la aprobación del plan de tareas',
  'settings.agentAccess.requireTaskPlanApproval.desc':
    'Pausa antes de que un agente asignado ejecute un breve tarea elaborada por el agente.',
  'settings.agentAccess.autoApproveAll.label': 'Aprobar automáticamente todas las acciones',
  'settings.agentAccess.autoApproveAll.desc':
    'Cuando está activado, el agente ejecutará todas las acciones elegibles sin pedir tu aprobación primero. Esto incluye escritura de archivos, comandos de shell, solicitudes de red y cualquier otro efecto secundario. Los bloqueos de seguridad estrictos, incluidos los directorios de credenciales y del sistema, siguen aplicándose, y las acciones con un origen no confiable o desconocido nunca se aprueban automáticamente.',
  'settings.agentAccess.tinyplaceAutopilot.title': 'Agente autónomo de tiny.place',
  'settings.agentAccess.tinyplaceAutopilot.desc':
    'Deja que OpenHuman actúe en tiny.place por su cuenta. De forma programada, busca trabajo que valga la pena (primero las recompensas abiertas), hace lo que encaja con sus habilidades y actúa desde tu identidad. Funciona sin supervisión y puede gastar, así que mantenlo en devnet mientras pruebas. Desactivado por defecto.',
  'settings.agentAccess.tinyplaceAutopilot.label': 'Ejecutar automáticamente',
  'settings.agentAccess.timeout.label': 'Tiempo de espera de la acción',
  'settings.agentAccess.timeout.desc':
    'Cuánto tiempo puede ejecutarse una sola herramienta o acción antes de cancelarse. Aumenta este valor si un modelo local grande se interrumpe antes de terminar su respuesta.',
  'settings.agentAccess.timeout.unit': 'segundos',
  'settings.agentAccess.timeout.invalid':
    'Introduce un número entero de segundos dentro del rango permitido',
  'settings.agentAccess.timeout.envOverride':
    'La variable de entorno OPENHUMAN_TOOL_TIMEOUT_SECS está anulando este ajuste, por lo que los cambios aquí no tendrán efecto hasta que se elimine.',
  'settings.agentAccess.grantedFolders': 'Carpetas concedidas',
  'settings.agentAccess.alwaysAllow': 'Herramientas siempre permitidas',
  'settings.agentAccess.alwaysAllowDesc':
    'Las herramientas que marcaste como "Permitir siempre" en el chat se ejecutan sin pedir permiso. Elimina una para que se te pregunte nuevamente.',
  'settings.agentAccess.alwaysAllowNone': 'Aún no hay herramientas siempre permitidas.',
  'settings.agentAccess.grantedDesc':
    'Carpetas que el agente puede leer y escribir, además del espacio de trabajo. Los almacenes de credenciales (~/.ssh, ~/.gnupg, ~/.aws, llaveros) y los directorios del sistema (/etc, /System, C:\\Windows,…) siempre están bloqueados, incluso dentro de una carpeta concedida.',
  'settings.agentAccess.noneGranted': 'No se otorgaron carpetas.',
  'settings.agentAccess.readWrite': 'leer + escribir',
  'settings.agentAccess.readOnly': 'solo lectura',
  'settings.agentAccess.remove': 'Eliminar',
  'settings.agentAccess.pathPlaceholder': 'Ruta absoluta de la carpeta',
  'settings.agentAccess.accessLevelLabel': 'Nivel de acceso',
  'settings.agentAccess.add': 'Añadir',
  'settings.agentAccess.saving': 'Guardando…',
  'settings.agentAccess.changesApply': 'Los cambios se aplican en tu próximo mensaje.',
  'settings.agentAccess.directories': 'Directorios',
  'settings.agentAccess.actionSandbox': 'Sandbox de acciones',
  'settings.agentAccess.readWriteAccess': 'lectura + escritura',
  'settings.agentAccess.actionSandboxDesc':
    'Directorio de trabajo predeterminado para herramientas de shell, archivos y git.',
  'settings.agentAccess.actionDir.edit': 'Editar',
  'settings.agentAccess.actionDir.save': 'Guardar',
  'settings.agentAccess.actionDir.cancel': 'Cancelar',
  'settings.agentAccess.actionDir.placeholder': 'Ruta absoluta, p. ej. /Users/you/Projects',
  'settings.agentAccess.actionDir.envLocked':
    'Definido por OPENHUMAN_ACTION_DIR. Cambia la variable de entorno para anularlo.',
  'settings.agentAccess.actionDir.saved': 'Directorio de acciones actualizado.',
  'settings.agentAccess.internalState': 'Estado interno',
  'settings.agentAccess.agentBlocked': 'bloqueado para el agente',
  'settings.agentAccess.internalStateDesc':
    'Bases de datos de memoria, sesiones, tokens y otros datos esenciales. No accesible para herramientas del agente.',
  'settings.agentAccess.actionDirInputLabel': 'Ruta del sandbox de acciones',
  'settings.agentAccess.actionDirSave': 'Guardar',
  'settings.agentAccess.actionDirSaving': 'Guardando…',
  'settings.agentAccess.actionDirSaved': 'Sandbox de acciones actualizado.',
  'settings.agentAccess.actionDirEmptyError': 'La ruta no puede estar vacía.',
  'settings.agentAccess.actionDirSaveError': 'No se pudo actualizar el sandbox de acciones.',
  'settings.agentAccess.actionDirEnvOverrideError':
    'OPENHUMAN_ACTION_DIR está definido: elimina la variable de entorno para editar esto desde Ajustes.',
  'settings.agentAccess.actionDirEnvOverrideNote':
    'Anulado por OPENHUMAN_ACTION_DIR: elimina la variable de entorno para gestionarlo desde Ajustes.',
  'settings.agentAccess.approvalHistory': 'Historial de aprobaciones',
  'settings.agentAccess.approvalHistoryDesc':
    'Revisa las decisiones anteriores de Aprobar / Denegar solicitadas por el agente.',
  'settings.agentAccess.viewApprovalHistory': 'Ver historial de aprobaciones',

  // ── Panel de Permisos ─────────────────────────────────────────────
  'settings.permissions.title': 'Permisos',
  'settings.permissions.menuDesc': 'Elige qué puede hacer tu asistente y dónde puede trabajar.',
  'settings.permissions.accessMode': '¿Qué puede hacer el asistente?',
  'settings.permissions.accessModeDesc':
    'Elige cuánta libertad tiene el asistente al realizar acciones en tu ordenador.',
  'settings.permissions.preset.readonly.title': 'Solo mirar',
  'settings.permissions.preset.readonly.desc':
    'El asistente puede leer archivos y explorar, pero nunca escribir, editar ni ejecutar nada que cambie el estado.',
  'settings.permissions.preset.supervised.title': 'Preguntar primero',
  'settings.permissions.preset.supervised.desc':
    'Puede crear archivos nuevos libremente, pero siempre pedirá tu aprobación antes de editar, ejecutar comandos o acceder a la red.',
  'settings.permissions.preset.full.title': 'Control total',
  'settings.permissions.preset.full.desc':
    'Opera con tu acceso de cuenta completo. Los comandos destructivos, el acceso a la red y las instalaciones siguen pidiendo aprobación.',
  'settings.permissions.folders': '¿Dónde puede trabajar?',
  'settings.permissions.foldersDesc':
    'La carpeta predeterminada que el asistente lee y escribe. Puedes añadir más carpetas en los ajustes avanzados.',

  'settings.meetings.title': 'Reuniones',
  'settings.meetings.menuDesc':
    'Auto-unión, resúmenes y transcripciones del Asistente de reuniones',
  'settings.meetings.desktopOnly':
    'Los ajustes de reuniones solo están disponibles en el escritorio.',
  'settings.meetings.loading': 'Cargando…',
  'settings.meetings.loadError': 'No se pudieron cargar los ajustes de reuniones.',
  'settings.meetings.saveError': 'No se pudieron guardar los ajustes de reuniones.',
  'settings.meetings.saved': 'Guardado',
  'settings.meetings.saving': 'Guardando…',
  'settings.meetings.autoJoin.title': 'Política de auto-unión',
  'settings.meetings.autoJoin.desc':
    'Cuando un evento del calendario tiene un enlace de Google Meet',
  'settings.meetings.autoJoin.askEachTime': 'Preguntar cada vez',
  'settings.meetings.autoJoin.always': 'Unirse siempre',
  'settings.meetings.autoJoin.never': 'No unirse nunca',
  'settings.meetings.autoSummarize.title': 'Resumen tras la llamada',
  'settings.meetings.autoSummarize.desc': 'Generar un resumen al terminar la llamada',
  'settings.meetings.autoSummarize.ask': 'Preguntar tras la llamada',
  'settings.meetings.autoSummarize.always': 'Resumir siempre',
  'settings.meetings.autoSummarize.never': 'No resumir nunca',
  'settings.meetings.listenOnly': 'Modo solo escucha',
  'settings.meetings.listenOnlyDesc': 'Unirse con el micrófono silenciado',
  'settings.meetings.ingestTranscripts': 'Ingerir transcripciones del backend',
  'settings.meetings.ingestTranscriptsDesc':
    'Guardar las transcripciones de reuniones en la memoria',
  'settings.sandbox.title': 'Ejecución en sandbox',
  'settings.sandbox.menuDesc':
    'Configurar backends de sandbox para el aislamiento de herramientas del agente.',
  'settings.sandbox.loading': 'Cargando…',
  'settings.sandbox.desktopOnly':
    'La configuración de sandbox solo está disponible en la aplicación de escritorio.',
  'settings.sandbox.loadError': 'Error al cargar la configuración de sandbox.',
  'settings.sandbox.saveError': 'Error al guardar la configuración de sandbox.',
  'settings.sandbox.saved': 'Guardado: se aplica a las nuevas sesiones del agente.',
  'settings.sandbox.saving': 'Guardando…',
  'settings.sandbox.status': 'Estado',
  'settings.sandbox.dockerStatus': 'Docker',
  'settings.sandbox.available': 'Disponible',
  'settings.sandbox.unavailable': 'No disponible',
  'settings.sandbox.detectedBackend': 'Backend del SO',
  'settings.sandbox.enableLabel': 'Habilitar ejecución en sandbox',
  'settings.sandbox.enableDesc':
    'Ejecutar las herramientas del agente dentro de un entorno sandbox aislado.',
  'settings.sandbox.backendLabel': 'Backend',
  'settings.sandbox.backendDesc':
    'Elige qué backend de aislamiento usar para la ejecución en sandbox.',
  'settings.sandbox.backend.auto': 'Automático (detectar el mejor disponible)',
  'settings.sandbox.backend.docker': 'Docker',
  'settings.sandbox.backend.landlock': 'Landlock (Linux)',
  'settings.sandbox.backend.firejail': 'Firejail (Linux)',
  'settings.sandbox.backend.bubblewrap': 'Bubblewrap (Linux)',
  'settings.sandbox.backend.none': 'Ninguno (sin sandbox)',
  'settings.sandbox.dockerSettings': 'Configuración de Docker',
  'settings.sandbox.dockerImage': 'Imagen',
  'settings.sandbox.dockerImagePlaceholder': 'alpine:3.20',
  'settings.sandbox.memoryLimit': 'Límite de memoria',
  'settings.sandbox.memoryUnit': 'MB',
  'settings.sandbox.cpuLimit': 'Límite de CPU',
  'settings.sandbox.cpuUnit': 'núcleos',
  'settings.sandbox.envPassthrough': 'Reenvío de variables de entorno',
  'settings.sandbox.envPassthroughDesc': 'Variables de entorno reenviadas al sandbox.',
  'settings.sandbox.noEnvVars': 'No hay variables de entorno configuradas.',
  'settings.approvalHistory.title': 'Historial de aprobaciones',
  'settings.approvalHistory.subtitle':
    'Decisiones recientes de aprobación de herramientas, las más nuevas primero.',
  'settings.approvalHistory.refresh': 'Actualizar',
  'settings.approvalHistory.loading': 'Cargando historial de aprobaciones…',
  'settings.approvalHistory.retry': 'Reintentar',
  'settings.approvalHistory.emptyState': 'Aún no hay decisiones de aprobación registradas.',
  'settings.approvalHistory.errorGeneric':
    'No se pudo cargar el historial de aprobaciones. Inténtalo de nuevo.',
  'settings.approvalHistory.decidedAt': 'Decidido el {date}',
  'settings.approvalHistory.decision.approveOnce': 'Aprobado una vez',
  'settings.approvalHistory.decision.approveAlways': 'Siempre permitido',
  'settings.approvalHistory.decision.approveAlwaysFlow': 'Siempre permitido (flujo)',
  'settings.approvalHistory.decision.deny': 'Denegado',
  'settings.theme.variantLight': 'Claro',
  'settings.theme.variantDark': 'Oscuro',
  'settings.theme.variantAuto': 'Automático',
  'settings.theme.variantAria': 'Variante del tema',
  'settings.theme.backdropHeading': 'Fondo',
  'settings.theme.backdrop.mesh': 'Malla',
  'settings.theme.backdrop.solid': 'Sólido',
  'settings.theme.backdrop.image': 'Imagen',
  'settings.theme.backdropImageUrl': 'URL de la imagen de fondo',
  'settings.theme.backdropDots': 'Mostrar puntos de fondo',
  'settings.theme.backdropHint':
    'La malla muestra el degradado animado; Sólido usa un fondo plano; Imagen pinta el tuyo propio.',
  'settings.theme.autoForkHint':
    'Editar un preajuste guarda automáticamente tus cambios como un nuevo tema personalizado.',
  'settings.theme.title': 'Estudio de temas',
  'settings.theme.menuDesc':
    'Personaliza por completo los colores y las fuentes, o elige un tema predefinido.',
  'settings.theme.presetsHeading': 'Temas',
  'settings.theme.builtInBadge': 'Predefinido',
  'settings.theme.customBadge': 'Personalizado',
  'settings.theme.customizeHint':
    'Los temas predefinidos son de solo lectura. Duplica este tema para editar sus colores y fuentes.',
  'settings.theme.duplicate': 'Duplicar y personalizar',
  'settings.theme.copyName': '{name} (personalizado)',
  'settings.theme.importedName': 'Tema importado',
  'settings.theme.contrastWarn':
    'Bajo contraste entre el texto y el fondo: este tema puede resultar difícil de leer.',
  'settings.theme.group.surfaces': 'Superficies',
  'settings.theme.group.text': 'Texto',
  'settings.theme.group.borders': 'Bordes',
  'settings.theme.group.accents': 'Colores de acento',
  'settings.theme.showShades': 'Mostrar todos los tonos de acento',
  'settings.theme.hideShades': 'Ocultar todos los tonos de acento',
  'settings.theme.fontsHeading': 'Fuentes',
  'settings.theme.fontRole.title': 'Título',
  'settings.theme.fontRole.heading': 'Encabezado',
  'settings.theme.fontRole.body': 'Cuerpo',
  'settings.theme.fontRole.mono': 'Monoespaciada',
  'settings.theme.fontRole.serif': 'Con serifa',
  'settings.theme.fontCurrent': 'Actual',
  'settings.theme.actions': 'Gestionar tema',
  'settings.theme.reset': 'Restablecer ajustes',
  'settings.theme.delete': 'Eliminar tema',
  'settings.theme.export': 'Copiar JSON',
  'settings.theme.copied': '¡Copiado!',
  'settings.theme.import': 'Importar tema',
  'settings.theme.importHint':
    'Pega el JSON de un tema exportado para añadirlo como tema personalizado.',
  'settings.theme.importApply': 'Importar',
  'settings.theme.importError': 'No se pudo analizar ese JSON de tema.',
  'settings.appearance.title': 'Apariencia',
  'settings.appearance.themeHeading': 'Tema',
  'settings.appearance.themeAria': 'Tema',
  'settings.appearance.modeLight': 'Luz',
  'settings.appearance.modeLightDesc': 'Superficies brillantes, texto oscuro.',
  'settings.appearance.modeDark': 'oscuro',
  'settings.appearance.modeDarkDesc':
    'Las superficies oscuras son más agradables a la vista después del anochecer.',
  'settings.appearance.modeSystem': 'Sistema de partidos',
  'settings.appearance.modeSystemDesc':
    'Siga la configuración de apariencia de su sistema operativo.',
  'settings.appearance.helperText':
    'El modo oscuro cambia toda la aplicación (chat, configuración, paneles) a una paleta tenue. El "sistema de coincidencias" sigue la apariencia de su sistema operativo y se actualiza en vivo.',
  'settings.appearance.fontSizeHeading': 'Tamaño de fuente',
  'settings.appearance.fontSizeAria': 'Tamaño de fuente',
  'settings.appearance.fontSizeSmall': 'Pequeño',
  'settings.appearance.fontSizeSmallDesc': 'Texto compacto: más contenido en pantalla.',
  'settings.appearance.fontSizeMedium': 'Mediano',
  'settings.appearance.fontSizeMediumDesc': 'El tamaño predeterminado y equilibrado.',
  'settings.appearance.fontSizeLarge': 'Grande',
  'settings.appearance.fontSizeLargeDesc': 'Texto más grande para leer con más facilidad.',
  'settings.appearance.fontSizeXLarge': 'Extra grande',
  'settings.appearance.fontSizeXLargeDesc': 'El texto más grande, para la máxima legibilidad.',
  'settings.appearance.fontSizeHelperText':
    'Escala el texto en toda la app (chat, ajustes y paneles) independientemente de la configuración de fuente de tu sistema.',
  'settings.appearance.fontSizeCustomLabel': 'Tamaño personalizado',
  'settings.appearance.fontSizeCustomAria': 'Tamaño de fuente personalizado en píxeles',
  'settings.appearance.fontSizeCustomSliderAria':
    'Control deslizante de tamaño de fuente personalizado, en píxeles',
  'settings.appearance.fontSizeUnit': 'px',
  'settings.appearance.tabBarHeading': 'Barra de pestañas inferior',
  'settings.appearance.tabBarAlwaysShowLabels': 'Mostrar siempre etiquetas',
  'settings.appearance.tabBarAlwaysShowLabelsDesc':
    'Cuando está desactivado, las etiquetas solo aparecen al pasar el mouse o para la pestaña activa.',
  'settings.appearance.chatHeading': 'Chat',
  'settings.appearance.assistantTextMode': 'Respuestas del asistente en texto',
  'settings.appearance.hideAgentInsights': 'Ocultar el razonamiento del agente',
  'settings.appearance.hideAgentInsightsDesc':
    'Contrae la cronología paso a paso del agente en el chat. Un enlace «Procesando» parpadeante te permite abrir el proceso completo.',
  'settings.appearance.showChatMascot': 'Mostrar a Tiny en el cuadro de mensaje',
  'settings.appearance.showChatMascotDesc':
    'La mascota se queda de pie sobre el campo de escritura. Si la ocultas, el chat será solo texto hasta que vuelvas a activarlo.',
  'settings.appearance.assistantTextModeDesc':
    'Muestra las respuestas del asistente como texto sin marco y mantiene tus mensajes en burbujas.',
  'settings.mascot.active': 'Activo',
  'settings.mascot.characterDesc': 'Descripción del personaje',
  'settings.mascot.characterDraft': 'Borrador',
  'settings.mascot.characterHeading': 'Encabezado del personaje',
  'settings.mascot.customGifError':
    'Introduce una URL de imagen HTTPS, file:// o local (PNG, GIF, JPEG, WebP o BMP), o sube un archivo.',
  'settings.mascot.customGifHeading': 'Avatar de imagen personalizado',
  'settings.mascot.customGifLabel': 'URL del avatar de imagen personalizado',
  'settings.mascot.customGifPlaceholder': 'https://example.com/avatar.png',
  'settings.mascot.customGifUpload': 'Subir imagen',
  'settings.mascot.customGifInvalidType':
    'Tipo de archivo no compatible. Sube una imagen PNG, GIF, JPEG, WebP o BMP.',
  'settings.mascot.customGifTooLarge':
    'La imagen es demasiado grande. Sube un archivo de hasta 1,5 MB.',
  'settings.mascot.customGifReadError': 'No se pudo leer la imagen. Prueba con otro archivo.',
  'settings.mascot.characterPreview': 'Vista previa',
  'settings.mascot.characterStates': 'estados',
  'settings.mascot.characterVisemes': 'visemas',
  'settings.mascot.colorAria': 'color OpenHuman',
  'settings.mascot.colorDesc': 'Descripción del color',
  'settings.mascot.colorHeading': 'Encabezado del color',
  'settings.mascot.colorBlack': 'negro',
  'settings.mascot.colorBurgundy': 'Borgoña',
  'settings.mascot.colorCustom': 'Personalizado',
  'settings.mascot.colorNavy': 'Marina',
  'settings.mascot.primaryColor': 'Color primario',
  'settings.mascot.secondaryColor': 'Color secundario',
  'settings.mascot.colorYellow': 'amarillo',
  'settings.mascot.libraryUnavailable': 'Biblioteca OpenHuman no disponible',
  'settings.mascot.title': 'OpenHuman',
  'settings.mascot.loadingLibrary': 'Cargando biblioteca de OpenHuman…',
  'settings.mascot.loadDetailError': 'No se pudo cargar la mascota.',
  'settings.mascot.loadLibraryError': 'No se pudo cargar la biblioteca de mascotas.',
  'settings.mascot.localDefault': 'OpenHuman local (predeterminado)',
  'settings.mascot.menuTitle': 'Mascota',
  'settings.mascot.menuDesc': 'Elige el color de la mascota usado en toda la app',
  'settings.mascot.noCharacters': 'Aún no hay personajes de OpenHuman disponibles',
  'settings.mascot.noColorVariants': 'Sin variantes de color',
  'settings.mascot.secondaryHeading': 'Dúo de reunión (segunda mascota)',
  'settings.mascot.secondaryDesc':
    'Añade una segunda mascota para las reuniones. Al fijar dos, aparecen juntas y hablan por turnos. Déjalo en Ninguna para una sola mascota.',
  'settings.mascot.secondaryNone': 'Ninguna (una sola mascota)',
  'settings.mascot.perMascotVoiceHeading': 'Voces por mascota',
  'settings.mascot.primaryVoiceLabel': 'Voz de la primera mascota',
  'settings.mascot.secondaryVoiceLabel': 'Voz de la segunda mascota',
  'settings.mascot.voice.current': 'actual',
  'settings.mascot.voice.customDesc':
    'Encuentra los ID de voz en api.elevenlabs.io/v1/voices o en tu panel de ElevenLabs. Solo se almacena el ID: tu clave de API permanece en el backend.',
  'settings.mascot.voice.customHeading': 'ID de voz personalizado',
  'settings.mascot.voice.customOption': 'Otro (pegar ID de voz)…',
  'settings.mascot.voice.customPlaceholder': 'por ej. 21m00Tcm4TlvDq8ikWAM',
  'settings.mascot.voice.desc':
    'Elige la voz de ElevenLabs que la mascota usa para las respuestas habladas. Filtra por género, elige de la lista curada, pega un ID personalizado, o deja que la app elija una voz que coincida con el idioma de la interfaz.',
  'settings.mascot.voice.genderFemale': 'Femenino',
  'settings.mascot.voice.genderHeading': 'Género de la voz',
  'settings.mascot.voice.genderMale': 'Masculino',
  'settings.mascot.voice.heading': 'Voz',
  'settings.mascot.voice.preset': 'Preajuste de voz',
  'settings.mascot.voice.presetHeading': 'Preajuste de voz',
  'settings.mascot.voice.preview': 'Vista previa de voz',
  'settings.mascot.voice.previewError': 'Falló la vista previa de voz',
  'settings.mascot.voice.previewText': 'Hola, soy tu asistente. Esta es una vista previa de voz.',
  'settings.mascot.voice.previewing': 'Reproduciendo vista previa…',
  'settings.mascot.voice.reset': 'Restablecer al predeterminado',
  'settings.mascot.voice.useLocaleDefault': 'Coincidir con el idioma de la app',
  'settings.mascot.voice.useLocaleDefaultDesc':
    'Elegir automáticamente una voz para el idioma de la interfaz actual.',
  'settings.persona.title': 'Persona',
  'settings.persona.menuTitle': 'Persona',
  'settings.persona.menuDesc':
    'Nombre, personalidad, avatar y voz: tu asistente como una sola identidad',
  'settings.persona.identityHeading': 'Identidad',
  'settings.persona.identityDesc':
    'Un nombre para mostrar y una breve descripción de tu asistente. Se muestra en la aplicación; no cambia la forma en que el asistente razona.',
  'settings.persona.displayNameLabel': 'Nombre para mostrar',
  'settings.persona.displayNamePlaceholder': 'p. ej. Nova',
  'settings.persona.descriptionLabel': 'Descripción',
  'settings.persona.descriptionPlaceholder':
    'por ejemplo, un asistente tranquilo y conciso para mi equipo.',
  'settings.persona.soul.heading': 'Personalidad (SOUL.md)',
  'settings.persona.soul.desc':
    'La personalidad que el asistente sigue en cada conversación. Las ediciones se guardan en tu espacio de trabajo y se aplican en la próxima respuesta.',
  'settings.persona.soul.editorLabel': 'contenido de SOUL.md',
  'settings.persona.soul.reset': 'Restablecer a predeterminado',
  'settings.persona.soul.usingDefault': 'Usando el predeterminado incluido',
  'settings.persona.soul.loadError': 'No se pudo cargar SOUL.md',
  'settings.persona.soul.saveError': 'No se pudo guardar SOUL.md',
  'settings.persona.soul.resetError': 'No se pudo restablecer SOUL.md',
  'settings.persona.builder.modeLabel': 'Modo del editor de persona',
  'settings.persona.builder.modeGuided': 'Guiado',
  'settings.persona.builder.modeAdvanced': 'Avanzado',
  'settings.persona.builder.intro':
    'Rellena unos campos y los escribimos en tu persona por ti. No hace falta markdown.',
  'settings.persona.builder.personalityLabel': 'Personalidad',
  'settings.persona.builder.personalityPlaceholder':
    'p. ej. Cercano, curioso y directo. Honesto ante la incertidumbre.',
  'settings.persona.builder.voiceLabel': 'Estilo de comunicación',
  'settings.persona.builder.voicePlaceholder':
    'p. ej. Empieza por la respuesta, sé breve y adapta mi tono.',
  'settings.persona.builder.aboutLabel': 'Sobre ti',
  'settings.persona.builder.aboutPlaceholder':
    'p. ej. Dirijo un pequeño estudio de diseño y prefiero un lenguaje sencillo.',
  'settings.persona.builder.preservedNote':
    'Cualquier otra sección que hayas escrito a mano se conserva: cambia a Avanzado para ver la persona completa.',
  'settings.persona.builder.securityNote': '¿Quieres elegir lo que el asistente puede hacer?',
  'settings.persona.builder.securityLink': 'Abrir Acceso del agente',
  'settings.persona.templates.heading': 'Empezar con una plantilla',
  'settings.persona.templates.desc':
    'Elige un punto de partida: rellena Personalidad y Estilo de comunicación. Después puedes editarlo todo.',
  'settings.persona.templates.doctor.label': 'Asistente clínico',
  'settings.persona.templates.doctor.desc': 'Cuidadoso, cita fuentes, señala la incertidumbre',
  'settings.persona.templates.researcher.label': 'Asistente de investigación',
  'settings.persona.templates.researcher.desc': 'Riguroso, estructurado, basado en evidencia',
  'settings.persona.templates.executive.label': 'Asistente ejecutivo',
  'settings.persona.templates.executive.desc': 'Conciso, decidido, orientado a la acción',
  'settings.persona.templates.teacher.label': 'Docente',
  'settings.persona.templates.teacher.desc': 'Paciente, explica paso a paso',
  'settings.persona.templates.student.label': 'Compañero de estudio',
  'settings.persona.templates.student.desc': 'Alentador, hace preguntas, lenguaje sencillo',
  'settings.persona.templates.family.label': 'Asistente familiar',
  'settings.persona.templates.family.desc': 'Cálido, amable, seguro para todas las edades',
  'settings.persona.appearanceHeading': 'Avatar y Voz',
  'settings.persona.appearanceDesc':
    'El color de la mascota, el avatar de imagen personalizado y la voz de respuesta se configuran en los ajustes de la mascota.',
  'settings.persona.openMascotSettings': 'Abrir la configuración de Mascota',
  'settings.memoryWindow.balanced.badge': 'Recomendado',
  'settings.memoryWindow.balanced.hint':
    'Predeterminado sensato: buena continuidad sin quemar tokens extra en cada ejecución.',
  'settings.memoryWindow.balanced.label': 'Equilibrado',
  'settings.memoryWindow.description':
    'Cuánto contexto recordado inyecta OpenHuman en cada nueva ejecución del agente. Ventanas más grandes parecen más conscientes de conversaciones pasadas, pero usan más tokens (y cuestan más) en cada ejecución.',
  'settings.memoryWindow.extended.badge': 'Más contexto',
  'settings.memoryWindow.extended.hint':
    'Más memoria a largo plazo inyectada en cada ejecución. Mayor coste de tokens por turno.',
  'settings.memoryWindow.extended.label': 'Extendido',
  'settings.memoryWindow.maximum.badge': 'Mayor coste',
  'settings.memoryWindow.maximum.hint':
    'La ventana segura más grande. Mejor continuidad, factura de tokens significativamente mayor en cada ejecución.',
  'settings.memoryWindow.maximum.label': 'Máximo',
  'settings.memoryWindow.minimal.badge': 'Más barato',
  'settings.memoryWindow.minimal.hint':
    'Ventana de memoria más pequeña. La más barata, rápida y con menor continuidad entre ejecuciones.',
  'settings.memoryWindow.minimal.label': 'Mínimo',
  'settings.memoryWindow.title': 'Ventana de memoria a largo plazo',
  'settings.agentbox.title': 'AgentBox',
  'settings.agentbox.desc':
    'Estado del adaptador del mercado de GMI Cloud y configuración del proveedor',
  'settings.agentbox.intro':
    'Estado de solo lectura del adaptador del mercado AgentBox. El modo y el proveedor GMI MaaS se establecen mediante variables de entorno al iniciar el núcleo.',
  'settings.agentbox.modeLabel': 'Modo del mercado',
  'settings.agentbox.providerHeading': 'Proveedor GMI MaaS',
  'settings.agentbox.slug': 'Identificador del proveedor',
  'settings.agentbox.baseUrl': 'URL base',
  'settings.agentbox.model': 'Modelo',
  'settings.agentbox.notConfigured':
    'Sin configurar. Establece las variables de entorno GMI_MAAS_BASE_URL, GMI_MAAS_API_KEY y GMI_MODELS.',
  'settings.agentbox.unavailable': 'Estado de AgentBox no disponible',
  'settings.modelHealth.title': 'Salud del modelo',
  'settings.modelHealth.desc':
    'Comparación por modelo de calidad, tasa de alucinaciones y costo entre los modelos activos',
  'settings.modelHealth.allStatuses': 'Todos los estados',
  'settings.modelHealth.models': 'modelos',
  'settings.modelHealth.loading': 'Cargando datos del modelo...',
  'settings.modelHealth.empty': 'No hay modelos registrados',
  'settings.modelHealth.col.model': 'Modelo',
  'settings.modelHealth.col.quality': 'Calidad',
  'settings.modelHealth.col.halluc': 'Tasa de alucinación',
  'settings.modelHealth.col.cost': 'Costo / 1M salido',
  'settings.modelHealth.col.agents': 'Agentes',
  'settings.modelHealth.col.status': 'Estado',
  'settings.modelHealth.badge.keep': 'Mantener',
  'settings.modelHealth.badge.replace': 'Reemplazar',
  'settings.modelHealth.badge.staging': 'Prueba de preparación',
  'settings.modelHealth.badge.vision': 'Solo visión',
  'settings.modelHealth.swap': '¿Intercambiar?',
  'settings.modelHealth.modal.title': '¿Reemplazar modelo?',
  'settings.modelHealth.modal.hallucRate': 'Tasa de alucinación',
  'settings.modelHealth.modal.cancel': 'Cancelar',
  'settings.modelHealth.modal.apply': 'Aplicar reemplazo',
  'settings.modelHealth.tag.cheaper': 'CHEAPER',
  'settings.modelHealth.tag.better': 'BETTER',
  'skills.card.moreActions': 'Más acciones',
  'skills.channelIcon.discord': 'Discord',
  'skills.channelIcon.imessage': 'iMessage',
  'skills.channelIcon.telegram': 'Telegram',
  'skills.channelIcon.web': 'Web',
  'skills.channelIcon.yuanbao': 'Yuanbao',
  'skills.composio.poweredBy': 'Desarrollado por Composio',
  'skills.composio.staleStatusTitle': 'Las conexiones muestran un estado obsoleto',
  'skills.create.allowedTools': 'Herramientas permitidas',
  'skills.create.allowedToolsHelp': 'Representado en el frontmatter de SKILL.md como',
  'skills.create.allowedToolsPlaceholder': 'node_exec, buscar',
  'skills.create.author': 'Autor',
  'skills.create.authorPlaceholder': 'Tu nombre',
  'skills.create.commaSeparated': '(separado por comas)',
  'skills.create.createBtn': 'Crear habilidad',
  'skills.create.createError': 'No se pudo crear el skill',
  'skills.create.creating': 'Creando…',
  'skills.create.description': 'Descripción',
  'skills.create.descriptionPlaceholder': '¿Qué hace este skill?',
  'skills.create.optional': '(opcional)',
  'skills.create.inputs.heading': 'Inputs',
  'skills.create.inputs.help':
    'Declara los parámetros que necesita la habilidad. El ejecutor de habilidades mostrará un formulario para estos en tiempo de ejecución.',
  'skills.create.inputs.add': 'Agregar entrada',
  'skills.create.inputs.row.name': 'Nombre de la entrada',
  'skills.create.inputs.row.namePlaceholder': 'p. ej., repo',
  'skills.create.inputs.row.nameError':
    'Solo letras, dígitos, guiones bajos y guiones; debe comenzar con una letra.',
  'skills.create.inputs.row.description': 'Descripción de la entrada',
  'skills.create.inputs.row.descriptionPlaceholder': '¿Qué va en este campo?',
  'skills.create.inputs.row.type': 'Type',
  'skills.create.inputs.row.required': 'Required',
  'skills.create.inputs.row.remove': 'Eliminar entrada',
  'skills.create.inputs.type.string': 'Text',
  'skills.create.inputs.type.integer': 'Number',
  'skills.create.inputs.type.boolean': 'Sí / No',
  'skills.create.license': 'Licencia',
  'skills.create.licensePlaceholder': 'MIT',
  'skills.create.name': 'Nombre',
  'skills.create.namePlaceholder': 'p. ej. Trade Journal',
  'skills.create.scope': 'Alcance',
  'skills.create.scopeProjectHint': '/.openhuman/habilidades/',
  'skills.create.scopeUserHint':
    'Se escribe en ~/.openhuman/skills/<slug>/SKILL.md: disponible en todos los espacios de trabajo.',
  'skills.create.slugLabel': 'Etiqueta de slug',
  'skills.create.subtitle': 'HABILIDAD.md',
  'skills.create.tags': 'Etiquetas',
  'skills.create.tagsPlaceholder': 'comercio, investigación',
  'skills.create.title': 'Nueva habilidad',
  'skills.detail.allowedTools': 'Herramientas permitidas',
  'skills.detail.author': 'Autor',
  'skills.detail.license': 'Licencia',
  'skills.detail.bundledResources': 'Recursos incluidos',
  'skills.detail.description': 'Descripción',
  'skills.detail.closeAriaLabel': 'Cerrar detalles del skill',
  'skills.detail.location': 'Ubicación',
  'skills.detail.noBundledResources': 'Sin recursos incluidos.',
  'skills.detail.platforms': 'Plataformas',
  'skills.detail.relatedSkills': 'Skills relacionadas',
  'skills.detail.source': 'URL de origen',
  'skills.detail.sourceFormat': 'Formato',
  'skills.detail.stars': 'Estrellas',
  'skills.detail.tags': 'Etiquetas',
  'skills.detail.warnings': 'Advertencias',
  'skills.detail.version': 'Versión',
  'skills.install.errors.alreadyInstalledHint':
    'Ya existe una habilidad con esta babosa en el espacio de trabajo. Elimínelo primero o cambie el frontmatter `metadata.id`/`name`.',
  'skills.install.errors.alreadyInstalledTitle': 'Habilidad ya instalada',
  'skills.install.errors.fetchFailedHint':
    'La solicitud no se completó correctamente. Verifique que URL apunte a un archivo público accesible y que el host haya devuelto una respuesta 2xx.',
  'skills.install.errors.fetchFailedTitle': 'Error de recuperación',
  'skills.install.errors.fetchTimedOutHint':
    'El host remoto no respondió a tiempo. Inténtelo de nuevo o aumente el tiempo de espera (1-600 s).',
  'skills.install.errors.fetchTimedOutTitle': 'Se agotó el tiempo de recuperación',
  'skills.install.errors.fetchTooLargeHint':
    'SKILL.md debe tener menos de 1 MiB. Divida los recursos empaquetados en archivos `references/` o `scripts/` en lugar de insertarlos.',
  'skills.install.errors.fetchTooLargeTitle': 'SKILL.md demasiado grande',
  'skills.install.errors.genericHint':
    'El servidor devolvió un error. El mensaje sin formato se muestra a continuación.',
  'skills.install.errors.genericTitle': 'No se pudo instalar la habilidad',
  'skills.install.errors.invalidSkillHint':
    'El frontmatter debe ser YAML válido con campos `nombre` y `descripción` no vacíos, terminados en `---`.',
  'skills.install.errors.invalidSkillTitle': 'SKILL.md no analizó',
  'skills.install.errors.invalidUrlHint':
    'Solo se permiten HTTPS URLs públicos. Los hosts privados, de bucle invertido y de metadatos están bloqueados.',
  'skills.install.errors.invalidUrlTitle': 'URL rechazado',
  'skills.install.errors.unsupportedUrlHint':
    'Sólo funcionan los enlaces directos `.md`. Para GitHub, enlace a un archivo (github.com/owner/repo/blob/.../SKILL.md): las raíces del árbol y del repositorio no están instaladas.',
  'skills.install.errors.unsupportedUrlTitle': 'Formulario URL no compatible',
  'skills.install.errors.writeFailedHint':
    'No se podía escribir en el directorio de habilidades del espacio de trabajo. Verifique los permisos del sistema de archivos para `<workspace>/.openhuman/skills/`.',
  'skills.install.errors.writeFailedTitle': 'No se pudo escribir SKILL.md',
  'skills.install.fetchLog': 'Obtener registro',
  'skills.install.fetchingPrefix': 'buscando',
  'skills.install.fetchingSuffix':
    'esto puede tardar hasta el tiempo de espera que haya configurado.',
  'skills.install.installBtn': 'Instalando…',
  'skills.install.installComplete': 'Instalación completa',
  'skills.install.installing': 'Instalando…',
  'skills.install.parseWarnings': 'Advertencias de análisis',
  'skills.install.rawError': 'Error sin procesar',
  'skills.install.subtitleMiddle': 'sobre HTTPS y lo instala bajo',
  'skills.install.subtitlePrefix': 'Obtiene un solo',
  'skills.install.subtitleSuffix':
    'HTTPS solamente; Los hosts privados y de loopback están bloqueados.',
  'skills.install.successDiscovered': 'Descubrí {count} nuevas habilidades.',
  'skills.install.successNoNewIds':
    'Habilidad instalada, pero no aparecieron nuevos identificadores de habilidad; es posible que el catálogo ya contenga una habilidad con el mismo slug.',
  'skills.install.timeoutHint': '(segundos, opcional)',
  'skills.install.timeoutHelp':
    'El valor predeterminado es 60 segundos. Los valores fuera de 1-600 se bloquean en el lado del servidor.',
  'skills.install.timeoutInvalid': 'Debe ser un número entero entre 1 y 600.',
  'skills.install.timeoutLabel': 'Etiqueta de tiempo límite',
  'skills.install.timeoutPlaceholder': '60',
  'skills.install.title': 'Instalar habilidad desde URL',
  'skills.install.urlHelpMiddle': 'archivo.',
  'skills.install.urlHelpPrefix': 'Enlace directo a un',
  'skills.install.urlHelpSuffix': 'URLs reescritura automática a',
  'skills.install.urlInvalidPrefix': 'URL debe ser un bien formado',
  'skills.install.urlInvalidSuffix': 'enlace.',
  'skills.install.urlLabel': 'URL de la habilidad',
  'skills.install.urlPlaceholder': 'https://raw.githubusercontent.com/owner/repo/main/SKILL.md',
  'skills.meetingBots.bannerDesc': 'Descripción del banner',
  'skills.meetingBots.bannerTitle': 'Título del banner',
  'skills.meetingBots.busyTitle': 'OpenHuman está ocupado',
  'skills.meetingBots.comingSoon': 'Próximamente',
  'skills.meetingBots.couldNotLeaveTitle': 'No se pudo salir de la reunión',
  'skills.meetingBots.couldNotStartTitle': 'No se pudo iniciar OpenHuman',
  'skills.meetingBots.displayName': 'Nombre de visualización',
  'skills.meetingBots.failedToStart': 'No se pudo iniciar OpenHuman.',
  'skills.meetingBots.joiningMessage': 'Debería aparecer como participante en unos segundos.',
  'skills.meetingBots.joiningTitle': 'OpenHuman se está uniendo a la reunión',
  'skills.meetingBots.meetingLink': 'Enlace de la reunión',
  'skills.meetingBots.modalAriaLabel': 'Enviar OpenHuman a una reunión',
  'skills.meetingBots.modalDesc': 'Descripción del modal',
  'skills.meetingBots.modalTitle': 'Enviar OpenHuman a una reunión',
  'skills.meetingBots.newBadge': 'Nuevo',
  'skills.meetingBots.platformComingSoon': 'El soporte de {label} llegará pronto.',
  'skills.meetingBots.platformHints.gmeet': 'meet.google.com/abc-defg-hij',
  'skills.meetingBots.platformHints.teams': 'equipos.microsoft.com/...',
  'skills.meetingBots.platformHints.webex': 'webex.com/meet/...',
  'skills.meetingBots.platformHints.zoom': 'zoom.us/j/...',
  'skills.meetingBots.platforms.gmeet': 'Google Conocer',
  'skills.meetingBots.platforms.teams': 'Equipos de Microsoft',
  'skills.meetingBots.platforms.webex': 'Webex',
  'skills.meetingBots.platforms.zoom': 'Ampliar',
  'skills.meetingBots.sendTo': 'Enviar a',
  'skills.meetingBots.serverOverloaded':
    'OpenHuman tiene una carga muy alta en este momento. Inténtalo de nuevo en unos minutos.',
  'skills.meetingBots.soonSuffix': 'pronto',
  'skills.meetingBots.starting': 'Iniciando…',
  'skills.meetingBots.recentCallsAriaLabel': 'Llamadas de reunión recientes',
  'skills.meetingBots.recentCallsHeading': 'Llamadas recientes',
  'skills.meetingBots.recentCallsEmpty':
    'Aún no hay llamadas anteriores: tu historial de reuniones aparecerá aquí.',
  'skills.meetingBots.recentCallsLoading': 'Cargando\u2026',
  'skills.meetingBots.recentCallAddedBy': 'Añadido por {name}',
  'skills.meetingBots.recentCallParticipants': 'Con {names}',
  'skills.meetingBots.recentCallTurnSingular': '{count} turno',
  'skills.meetingBots.recentCallTurnPlural': '{count} turnos',
  'skills.meetingBots.recentCallDuration': '{seconds}s en llamada',
  'skills.meetingBots.callDetailLoading': 'Cargando transcripción…',
  'skills.meetingBots.callDetailError': 'No se pudo cargar la transcripción.',
  'skills.meetingBots.callDetailRetry': 'Reintentar',
  'skills.meetingBots.callDetailEmpty':
    'No se registró ninguna transcripción ni resumen de esta llamada.',
  'skills.meetingBots.callSummaryHeading': 'Resumen',
  'skills.meetingBots.callKeyPointsHeading': 'Puntos clave',
  'skills.meetingBots.callActionItemsHeading': 'Tareas pendientes',
  'skills.meetingBots.callTranscriptHeading': 'Transcripción',
  'skills.meetingBots.liveBadge': 'En vivo',
  'skills.meetingBots.liveTitle': 'En reunión',
  'skills.meetingBots.liveStatusJoining': 'Uniéndose\u2026',
  'skills.meetingBots.liveStatusActive': 'En vivo en la reunión',
  'skills.meetingBots.liveStatusListening': 'Escuchando (silenciado)',
  'skills.meetingBots.liveStatusEnded': 'Reunión finalizada',
  'skills.meetingBots.liveStatusError': 'Error al unirse',
  'skills.meetingBots.liveTranscriptHeading': 'Transcripción en vivo',
  'skills.meetingBots.liveTranscriptEmpty': 'Esperando voz…',
  'skills.meetingBots.leaveButton': 'Salir',
  'skills.meetingBots.leavingButton': 'Saliendo…',
  'skills.meetingBots.respondToParticipant': 'Tu nombre en esta reunión',
  'skills.meetingBots.respondToParticipantHint': 'p. ej. Ana (tu nombre visible en la llamada)',
  'skills.meetingBots.replyName.label': 'Tu nombre en las reuniones',
  'skills.meetingBots.replyName.description':
    'El nombre que el bot escucha y al que responde. Escribe tu nombre tal como aparece en la llamada: se aplica a cada reunión a la que se une.',
  'skills.meetingBots.replyName.placeholder': 'p. ej., Alex Kim',
  'skills.meetingBots.respondToParticipantDesc':
    'Introduce tu nombre de visualización exacto de la reunión. El bot solo responde cuando dices su nombre (frase de activación).',
  'skills.meetingBots.wakePhrase': 'Frase de activación',
  'skills.meetingBots.wakePhraseHint': 'Hey OpenHuman',
  'skills.meetingBots.wakePhraseDesc':
    'El participante debe decir esto antes de que el bot responda.',
  'skills.meetingBots.activeMode': 'Responder cuando me dirija a él',
  'skills.meetingBots.activeModeDesc':
    'Si está activado, el bot responde en voz alta después de que digas su frase de activación. Si está desactivado, solo escucha y transcribe.',
  'skills.meetingBots.history.allPlatforms': 'Todas las plataformas',
  'skills.meetingBots.history.copyTranscript': 'Copiar',
  'skills.meetingBots.history.downloadTranscript': 'Descargar',
  'skills.meetingBots.history.earlier': 'Antes',
  'skills.meetingBots.history.participantCount': '{count} participante',
  'skills.meetingBots.history.participantCountPlural': '{count} participantes',
  'skills.meetingBots.history.runWithOpenHuman': 'Ejecutar con OpenHuman',
  'skills.meetingBots.history.searchPlaceholder': 'Buscar llamadas…',
  'skills.meetingBots.history.selectPrompt':
    'Selecciona una llamada para ver su resumen y transcripción.',
  'skills.meetingBots.history.today': 'Hoy',
  'skills.meetingBots.history.yesterday': 'Ayer',
  'skills.meetingBots.upcoming.heading': 'Próximas',
  'skills.meetingBots.upcoming.when': 'Cuándo',
  'skills.meetingBots.upcoming.meeting': 'Reunión',
  'skills.meetingBots.upcoming.platform': 'Plataforma',
  'skills.meetingBots.upcoming.people': 'Personas',
  'skills.meetingBots.upcoming.joinPolicy': 'Política de unión',
  'skills.meetingBots.upcoming.joinNow': 'Unirse ahora',
  'skills.meetingBots.upcoming.joinNowAriaLabel': 'Unirse a {title}',
  'skills.meetingBots.upcoming.join': 'Unirse',
  'skills.meetingBots.upcoming.auto': 'Auto',
  'skills.meetingBots.upcoming.ask': 'Preguntar',
  'skills.meetingBots.upcoming.skip': 'Omitir',
  'skills.meetingBots.upcoming.today': 'Hoy',
  'skills.meetingBots.upcoming.tomorrow': 'Mañana',
  'skills.meetingBots.upcoming.empty':
    'No hay reuniones próximas: conecta Google Calendar para verlas aquí.',
  'skills.meetingBots.upcoming.error': 'No se pudieron cargar las reuniones próximas.',
  'skills.meetingBots.upcoming.retry': 'Reintentar',
  'skills.meetingBots.upcoming.refresh': 'Actualizar',
  'skills.meetingBots.upcoming.filterAll': 'Todas las plataformas',
  'skills.meetingBots.upcoming.participants': '{count} participantes',
  'skills.meetingBots.upcoming.imminent': 'Comienza pronto',
  'skills.meetingBots.upcoming.autoJoinsAt': 'Se une automáticamente ~a las {time}',
  'skills.meetingBots.upcoming.asksAtStart': 'Pregunta al inicio',
  'skills.meetingBots.upcoming.watchCalendarHint':
    "Activa 'Vigilar mi calendario' en Predeterminados (icono de engranaje) para que Auto/Preguntar surta efecto: de lo contrario, estas políticas se guardan pero no se activarán.",
  'skills.meetingBots.relative.now': 'ahora',
  'skills.meetingBots.relative.inMinutes': 'en {count}m',
  'skills.meetingBots.relative.inHours': 'en {count}h',
  'skills.meetingBots.relative.minutesAgo': 'hace {count}m',
  'skills.meetingBots.relative.hoursAgo': 'hace {count}h',
  'skills.meetingBots.relative.daysAgo': 'hace {count}d',
  'skills.meetingBots.relative.yesterday': 'ayer',
  'skills.meetingBots.defaults.drawerTitle': 'Valores predeterminados de reuniones',
  'skills.meetingBots.defaults.closeDrawer': 'Cerrar',
  'skills.meetingBots.defaults.openDefaults': 'Valores predeterminados',
  'skills.meetingBots.defaults.watchCalendar': 'Vigilar mi calendario',
  'skills.meetingBots.defaults.watchCalendarDesc':
    'Permite que OpenHuman observe tu calendario conectado para que pueda unirse automáticamente o solicitar reuniones según las políticas a continuación. Esto es independiente de las notificaciones de recordatorio de reuniones.',
  'skills.meetingBots.defaults.globalPolicy': 'Política global de unión automática',
  'skills.meetingBots.defaults.perPlatformTitle': 'Configuración por plataforma',
  'skills.meetingBots.defaults.perPlatformDesc':
    'Anular la política global para plataformas específicas.',
  'skills.meetingBots.defaults.useDefault': 'Usar predeterminado',
  'skills.resource.preview.closeAriaLabel': 'Cerrar vista previa',
  'skills.resource.preview.failed': 'Vista previa fallida',
  'skills.resource.preview.loading': 'Cargando vista previa…',
  'skills.resource.tree.assets': 'Recursos',
  'skills.resource.tree.examples': 'Ejemplos',
  'skills.resource.tree.other': 'Otros',
  'skills.resource.tree.prompts': 'Prompts',
  'skills.resource.tree.references': 'Referencias',
  'skills.resource.tree.scripts': 'Scripts',
  'skills.resource.tree.templates': 'Plantillas',
  'skills.resource.tree.empty': 'Sin recursos incluidos.',
  'skills.search.placeholder': 'Marcador de posición',
  'skills.setup.voice.activation': 'Activación',
  'skills.setup.voice.activeDescPrefix': 'fn',
  'skills.setup.voice.activeDescSuffix': 'fn',
  'skills.setup.voice.activeTitle': 'Inteligencia de voz está activa',
  'skills.setup.voice.customizeSettings': 'Personalizar configuración',
  'skills.setup.voice.downloadSttBtn': 'Descargar modelo STT',
  'skills.setup.voice.enableDesc': 'Descripción de activación',
  'skills.setup.voice.hotkey': 'Tecla de acceso rápido',
  'skills.setup.voice.startBtn': 'Iniciando...',
  'skills.setup.voice.startError': 'No se pudo iniciar el servidor de voz',
  'skills.setup.voice.starting': 'Iniciando...',
  'skills.setup.voice.stepEnable': 'Iniciar servidor de voz',
  'skills.setup.voice.stepSetup': 'Se requiere descarga del modelo',
  'skills.setup.voice.stepSuccess': 'Listo para usar',
  'skills.setup.voice.sttNotReady': 'Modelo de voz a texto no listo',
  'skills.setup.voice.sttNotReadyDesc':
    'La Inteligencia de voz requiere un modelo local de Whisper para transcripción. Descárgalo desde la configuración de Modelo local.',
  'skills.setup.voice.sttReady': 'Modelo de voz a texto listo',
  'skills.setup.voice.sttReturnHint': 'Sugerencia de retorno STT',
  'skills.setup.voice.title': 'Inteligencia de voz',
  'skills.uninstall.couldNotUninstall': 'No se pudo desinstalar',
  'skills.uninstall.description':
    'Esto elimina permanentemente el directorio de la habilidad y todos sus recursos incluidos. El agente dejará de verlo en el próximo turno.',
  'skills.uninstall.title': 'Desinstalar',
  'skills.uninstall.uninstallBtn': 'Desinstalar',
  'skills.uninstall.uninstalling': 'Desinstalando…',
  'upsell.global.limitMessage': 'Mejora tu plan o recarga créditos para continuar',
  'upsell.global.limitTitle': 'Tú',
  'upsell.global.nearLimitMessage':
    'Has usado el {pct}% de tu límite de uso. Mejora el plan para límites más altos.',
  'upsell.global.nearLimitTitle': 'Acercándote al límite de uso',
  'upsell.usageLimit.bodyBudget':
    'Has alcanzado tu límite semanal.{reset} Mejora tu plan o recarga créditos para evitar límites.',
  'upsell.usageLimit.bodyRate':
    'Has alcanzado tu límite de inferencia de 10 horas.{reset} Mejora para obtener límites más altos.',
  'upsell.usageLimit.heading': 'Límite de uso alcanzado',
  'upsell.usageLimit.notNow': 'Ahora no',
  'upsell.usageLimit.perWindow': '{amount}',
  'upsell.usageLimit.planIncludes': '{plan}',
  'upsell.usageLimit.resetsIn': 'Se restablece {time}.',
  'upsell.usageLimit.upgradePlan': 'Mejorar plan',
  'upsell.usageLimit.weeklyInference': '{amount}',
  'walkthrough.steps.startChat.title': 'Empieza en el chat',
  'walkthrough.steps.startChat.content':
    'El chat es tu punto de partida. Las ventanas nuevas se abren con el mismo saludo y las acciones rápidas que viste después de la configuración.',
  'walkthrough.steps.sayHello.title': 'Saluda',
  'walkthrough.steps.sayHello.content':
    'Toca aquí para iniciar una conversación con tu asistente de IA cuando quieras.',
  'walkthrough.steps.meetAi.title': 'Conoce tu IA',
  'walkthrough.steps.meetAi.content':
    'Aquí ocurren las conversaciones. Haz preguntas, pide resúmenes o explora ideas. Todo queda disponible para buscar.',
  'walkthrough.steps.connectWorld.title': 'Conecta tu mundo',
  'walkthrough.steps.connectWorld.content':
    'Gmail, Slack, WhatsApp y más: cada conexión le da más capacidades a tu asistente.',
  'walkthrough.steps.messagingApps.title': 'Chatea donde ya estás',
  'walkthrough.steps.messagingApps.content':
    'WhatsApp, Telegram, Slack, Discord: conecta tus apps de mensajes para que tu asistente pueda encontrarte en cualquier lugar.',
  'walkthrough.steps.settings.title': 'Hazlo tuyo',
  'walkthrough.steps.settings.content':
    'Preferencias, privacidad y notificaciones están aquí. Puedes reiniciar este recorrido desde esta página cuando quieras.',
  'walkthrough.steps.chatTab.title': 'Vuelve al chat',
  'walkthrough.steps.chatTab.content':
    'Usa la pestaña Chat cuando quieras volver a tus conversaciones.',
  'walkthrough.steps.humanTab.title': 'Conoce tu perfil humano',
  'walkthrough.steps.humanTab.content':
    'Human reúne tu contexto personal, identidad y perfil visible para el asistente.',
  'walkthrough.steps.brainTab.title': 'Abre tu Brain',
  'walkthrough.steps.brainTab.content':
    'Brain es el grafo de memoria: el lugar para revisar qué sabe OpenHuman y cómo se conectan las ideas.',
  'walkthrough.steps.agentWorldTab.title': 'Explora Agent World',
  'walkthrough.steps.agentWorldTab.content':
    'Agent World es donde viven agentes reutilizables y automatizaciones compartidas.',
  'walkthrough.steps.connectionsTab.title': 'Gestiona conexiones',
  'walkthrough.steps.connectionsTab.content':
    'Connections siempre está disponible en la navegación principal para agregar o ajustar servicios.',
  'walkthrough.steps.feedbackTab.title': 'Enviar comentarios',
  'walkthrough.steps.feedbackTab.content':
    'Feedback te da un lugar directo para reportar problemas o pedir mejoras.',
  'walkthrough.steps.allSet.title': '¡Todo listo!',
  'walkthrough.steps.allSet.content':
    'Tu asistente te dejó una nota de bienvenida: este es tu espacio para chatear, preguntar o explorar ideas. ¡Diviértete!',
  'walkthrough.tooltip.letsGo': '¡Vamos!',
  'walkthrough.tooltip.next': 'Siguiente →',
  'walkthrough.tooltip.skip': 'Omitir tour',
  'walkthrough.tooltip.stepCounter': '{n} de {total}',
  'webhooks.activity.empty': 'Vacío',
  'webhooks.activity.title': 'Actividad reciente',
  'webhooks.composioHistory.empty': 'Vacío',
  'webhooks.composioHistory.metadataId': 'ID de metadatos',
  'webhooks.composioHistory.metadataUuid': 'UUID de metadatos',
  'webhooks.composioHistory.payload': 'Carga útil',
  'webhooks.composioHistory.title': 'Historial de disparadores de Composio',
  'webhooks.tunnels.active': 'Activo',
  'webhooks.tunnels.createFailed': 'No se pudo crear el túnel',
  'webhooks.tunnels.creating': 'Creando...',
  'webhooks.tunnels.deleteFailed': 'No se pudo eliminar el túnel',
  'webhooks.tunnels.descriptionPlaceholder': 'Descripción (opcional)',
  'webhooks.tunnels.echo': 'eco',
  'webhooks.tunnels.empty': 'Vacío',
  'webhooks.tunnels.enableEcho': 'Activar echo',
  'webhooks.tunnels.inactive': 'Inactivo',
  'webhooks.tunnels.namePlaceholder': 'Nombre del túnel (p. ej. telegram-bot)',
  'webhooks.tunnels.newTunnel': 'Nuevo túnel',
  'webhooks.tunnels.removeEcho': 'Eliminar echo',
  'webhooks.tunnels.title': 'Túneles de webhook',
  'webhooks.tunnels.toggleFailed': 'No se pudo alternar el echo',
  'composio.directModeRequiresKey':
    'Error al guardar. El modo Directo requiere una clave API no vacía.',
  'composio.integrationSlugsHelp': 'Slugs de integración separados por comas, p.',
  'composio.integrationSlugsExample': 'gmail, flojo',
  'composio.integrationSlugsCaseInsensitive': 'No distingue entre mayúsculas y minúsculas.',
  'composio.integrationSlugsPlaceholder': 'gmail, holgura, ...',
  'composio.notYetRouted': 'aún sin enrutar',
  'composio.triggers.loading': 'Cargando…',
  'conversations.taskKanban.todo': 'Pendiente',
  'chat.addReaction': 'Añadir reacción',
  'chat.agentProfile.create': 'Crear perfil de agente',
  'chat.agentProfile.createFailed': 'No se pudo crear el perfil del agente.',
  'chat.agentProfile.customDescription': 'Perfil de agente personalizado',
  'chat.agentProfile.defaultAgentLabel': 'orquestador',
  'chat.agentProfile.exists': 'El perfil del agente "{name}" ya existe.',
  'chat.agentProfile.label': 'Perfil del agente',
  'chat.agentProfile.quick': 'Rápido',
  'chat.agentProfile.reasoning': 'Razonamiento',
  'chat.agentProfile.namePlaceholder': 'Nombre del perfil',
  'chat.agentProfile.promptStylePlaceholder': 'estilo rápido',
  'chat.agentProfile.allowedToolsPlaceholder': 'Herramientas permitidas',
  'chat.backToThread': 'volver a {title}',
  'chat.parentThread': 'hilo principal',
  'chat.removeReaction': 'Quitar {emoji}',
  'settings.composio.loading': 'Cargando…',
  'settings.mascot.noCharactersAvailable': 'Aún no hay personajes de OpenHuman disponibles',
  'skills.uninstall.confirmTitle': '¿Desinstalar {name}?',
  'conversations.taskKanban.blocked': 'Bloqueado',
  'conversations.taskKanban.done': 'Completado',
  'conversations.taskKanban.pending': 'Pendiente',
  'conversations.taskKanban.working': 'Laboral',
  'conversations.taskKanban.awaitingApproval': 'En espera de aprobación',
  'conversations.taskKanban.ready': 'Listo',
  'conversations.taskKanban.rejected': 'Rechazado',
  'conversations.taskKanban.inProgress': 'En progreso',
  'conversations.taskKanban.awaitingApprovalColumn': 'En espera de aprobación',
  'conversations.taskKanban.blockedColumn': 'Bloqueado',
  'conversations.taskKanban.evidenceBadge': 'Evidencia ({count})',
  'conversations.taskKanban.needsInput': 'Estas tareas necesitan tu participación',
  'conversations.taskKanban.emptyColumn': 'Sin tareas',
  'conversations.taskKanban.dragHint': 'Arrastra para mover entre columnas',
  'conversations.taskKanban.movingCard': 'Moviendo…',
  'conversations.taskKanban.statusBadge.ready': 'Listo para empezar',
  'conversations.taskKanban.statusBadge.rejected': 'Rechazado',
  'intelligence.memoryChunk.detail.copiedHint': 'copiado',
  'settings.composio.notYetRouted': 'aún sin enrutar',
  'settings.localModel.download.manageExternal': 'Gestiona este modelo en tu runtime externo.',
  'settings.localModel.status.manageOllamaExternal':
    'Gestiona el proceso de Ollama y las descargas de modelos fuera de OpenHuman, luego vuelve a ejecutar los diagnósticos.',
  'settings.localModel.status.ollamaDocs': 'Documentación de Ollama',
  'settings.localModel.status.thenRetry':
    'para instrucciones de configuración, luego reintenta cuando tu runtime sea accesible.',
  'devOptions.menuAi': 'Configuración de IA',
  'devOptions.menuAiDesc':
    'Proveedores de nube, modelos Ollama locales y enrutamiento por carga de trabajo',
  'devOptions.menuMessaging': 'Canales de mensajería',
  'devOptions.menuMessagingDesc':
    'Configurar los modos de autenticación Telegram/Discord y el enrutamiento de canales predeterminado',
  'devOptions.menuTools': 'Herramientas',
  'devOptions.menuToolsDesc':
    'Habilitar o deshabilitar capacidades que OpenHuman puede usar en su nombre',
  'devOptions.menuAgentChat': 'Chat de agente',
  'devOptions.menuAgentChatDesc':
    'Conversación del agente de prueba con anulaciones de modelo y temperatura',
  'devOptions.menuCronJobs': 'Trabajos cronificados',
  'devOptions.menuCronJobsDesc':
    'Ver y configurar trabajos programados para habilidades en tiempo de ejecución',
  'devOptions.menuLocalModelDebug': 'Depuración del modelo local',
  'devOptions.menuLocalModelDebugDesc':
    'Ollama configuración, descargas de activos, pruebas de modelos y diagnósticos',
  'devOptions.menuWebhooksDebug': 'Ganchos web',
  'devOptions.menuWebhooksDebugDesc':
    'Inspeccionar los registros de webhooks en tiempo de ejecución y los registros de solicitudes capturados',
  'devOptions.menuIntelligence': 'Inteligencia',
  'devOptions.menuIntelligenceDesc':
    'Espacio de trabajo de la memoria, motor subconsciente, sueños y escenarios.',
  'devOptions.menuNotificationRouting': 'Enrutamiento de notificaciones',
  'devOptions.menuNotificationRoutingDesc':
    'Puntuación de importancia de la IA y escalamiento del orquestador para alertas de integración',
  'devOptions.menuComposeIOTriggers': 'Activadores de ComposeIO',
  'devOptions.menuComposeIOTriggersDesc':
    'Ver el historial y el archivo de activadores de ComposeIO',
  'devOptions.menuComposioRouting': 'Composio Enrutamiento (modo directo)',
  'devOptions.menuComposioRoutingDesc':
    'Traiga su propia clave Composio API y enrute las llamadas directamente a backend.composio.dev',
  'devOptions.menuComposioTriggers': 'Desencadenantes de integración',
  'devOptions.menuComposioTriggersDesc':
    'Configurar los ajustes de clasificación de IA para los activadores de integración Composio',
  'memory.sourceFilterAria': 'Filtrar por fuente',
  'calls.comingSoonDescription': 'Las llamadas asistidas por IA llegarán pronto. Mantente atento.',
  'whatsapp.title': 'WhatsApp',
  'subconscious.priority.critical': 'crítico',
  'subconscious.priority.important': 'importante',
  'subconscious.priority.normal': 'normales',
  'subconscious.durationSeconds': '{seconds}s',
  'subconscious.durationMilliseconds': '{milliseconds}ms',
  'settings.appearance': 'Apariencia',
  'settings.appearanceDesc': 'Elija claro, oscuro o combine el tema de su sistema',
  'settings.mascot': 'mascota',
  'settings.mascotDesc': 'Elija el color de mascota utilizado en la aplicación',
  'pages.settings.account.walletBalances': 'Saldos de billetera',
  'pages.settings.account.walletBalancesDesc':
    'Ver saldos en múltiples cadenas de tu billetera local',
  'walletBalances.title': 'Saldos de billetera',
  'walletBalances.refresh': 'Refresh',
  'walletBalances.loading': 'Cargando saldos…',
  'walletBalances.retry': 'Retry',
  'walletBalances.emptyState':
    'Aún no hay cuentas de billetera: configura una billetera en Frase de recuperación.',
  'walletBalances.copyAddress': 'Copiar dirección',
  'walletBalances.providerMissing': 'proveedor no disponible',
  'walletBalances.rawBalance': 'Bruto: {raw}',
  'walletBalances.errorGeneric':
    'No se pueden cargar los saldos de la billetera. Configura tu billetera en Frase de recuperación e inténtalo de nuevo.',
  'walletBalances.setupHint':
    'Tu frase de recuperación aún no está configurada. Configúrala para activar tu monedero y ver los saldos en vivo.',
  'walletBalances.setupCta': 'Configurar frase de recuperación',
  'walletBalances.notSetUp': 'Sin configurar',
  'walletBalances.send': 'Enviar',
  'walletBalances.receive': 'Recibir',
  'walletReceive.scanHint':
    'Escanea este código o copia la dirección de abajo para recibir fondos.',
  'walletReceive.addressLabel': 'Dirección de {network}',
  'walletReceive.onlyChainWarning':
    'Envía solo activos de {network} a esta dirección. Enviar activos de otra red puede provocar una pérdida permanente.',
  'walletSend.available': 'Disponible',
  'walletSend.recipient': 'Dirección del destinatario',
  'walletSend.recipientPlaceholder': 'Pega la dirección de destino',
  'walletSend.recipientRequired': 'Introduce una dirección de destinatario',
  'walletSend.amount': 'Importe',
  'walletSend.invalidAmount': 'Introduce un importe válido',
  'walletSend.review': 'Revisar',
  'walletSend.preparing': 'Preparando…',
  'walletSend.confirmHint':
    'Revisa los detalles a continuación. La firma se realiza localmente; no se transmite nada hasta que confirmes.',
  'walletSend.estimatedFee': 'Comisión de red estimada',
  'walletSend.confirmSend': 'Confirmar y enviar',
  'walletSend.sending': 'Enviando…',
  'walletSend.sent': 'Transacción enviada',
  'walletSend.txHash': 'Hash de la transacción',
  'walletSend.viewExplorer': 'Ver en el explorador',
  'walletSend.done': 'Hecho',
  'walletSend.genericError': 'No se pudo completar la transferencia. Inténtalo de nuevo.',
  'settings.taskSources.title': 'Fuentes de tareas',
  'settings.integrations.title': 'Integraciones',
  'settings.integrations.menuDesc':
    'Fuentes de tareas, enrutamiento de Composio y disparadores de webhooks',
  'settings.taskSources.subtitle':
    'Extrae tareas de tus herramientas al tablero de tareas del agente',
  'settings.taskSources.description':
    'Recopila elementos de trabajo de GitHub, Notion, Linear y ClickUp, enriquétalos y dirígelos al tablero de tareas del agente.',
  'settings.taskSources.connectHint':
    'Las fuentes de tareas utilizan tus cuentas conectadas. Conéctalas primero en Integraciones.',
  'settings.taskSources.disabledBanner':
    'Las fuentes de tareas están deshabilitadas en la configuración. Actívalas para que se actualicen automáticamente.',
  'settings.taskSources.loadError': 'Error al cargar las fuentes de la tarea',
  'settings.taskSources.addTitle': 'Agregar una fuente de tarea',
  'settings.taskSources.provider': 'proveedor',
  'settings.taskSources.name': 'Nombre (opcional)',
  'settings.taskSources.namePlaceholder': 'p. ej. Mis asuntos abiertos',
  'settings.taskSources.github.repo': 'Repositorio (propietario/nombre, opcional)',
  'settings.taskSources.github.labels': 'Etiquetas (separadas por comas)',
  'settings.taskSources.notion.database': 'ID de la base de datos (tablero)',
  'settings.taskSources.notion.browseDatabases': 'Explorar bases de datos',
  'settings.taskSources.notion.loadingDatabases': 'Cargando bases de datos…',
  'settings.taskSources.notion.selectDatabase': 'Selecciona una base de datos…',
  'settings.taskSources.notion.noDatabases': 'No se encontraron bases de datos para esta conexión.',
  'settings.taskSources.linear.team': 'ID del equipo (opcional)',
  'settings.taskSources.clickup.team': 'ID del espacio de trabajo (equipo) (opcional)',
  'settings.taskSources.assignedToMe': 'Solo los elementos asignados a mí',
  'settings.taskSources.add': 'Agregar fuente',
  'settings.taskSources.adding': 'Agregando…',
  'settings.taskSources.preview': 'Avance',
  'settings.taskSources.previewResult': 'La(s) tarea(s) {count} coinciden con este filtro',
  'settings.taskSources.fetchNow': 'Trae ahora',
  'settings.taskSources.fetching': 'Obteniendo…',
  'settings.taskSources.fetchResult':
    'Se enrutaron {routed} de {fetched} tarea(s); se eliminaron {pruned} tarea(s) obsoletas',
  'settings.taskSources.syncAll': 'Sincronizar todo',
  'settings.taskSources.syncing': 'Sincronizando…',
  'settings.taskSources.configured': 'Fuentes configuradas',
  'settings.taskSources.empty': 'Aún no se han configurado fuentes de tareas.',
  'settings.taskSources.proactive': 'proactivo',
  'settings.taskSources.lastFetch': 'Última búsqueda',
  'settings.taskSources.never': 'Nunca',
  'settings.taskSources.statusEnabled': 'Habilitado',
  'settings.taskSources.statusDisabled': 'Deshabilitado',
  'settings.taskSources.enable': 'Habilitar',
  'settings.taskSources.disable': 'Desactivar',
  'settings.taskSources.remove': 'Eliminar',
  'settings.taskSources.removeConfirm':
    '¿Eliminar esta fuente de tarea? Todo el historial de tareas ingeridas se eliminará y no se puede deshacer.',
  'settings.taskSources.refresh': 'Refrescar',
  'settings.taskSources.providers.github': 'GitHub',
  'settings.taskSources.providers.notion': 'Noción',
  'settings.taskSources.providers.linear': 'Lineal',
  'settings.taskSources.providers.clickup': 'ClickUp',
  'skills.dashboard.enable': 'Activar flujo de trabajo programado',
  'skills.dashboard.disable': 'Desactivar flujo de trabajo programado',
  'skills.dashboard.lastRun': 'Última ejecución',
  'skills.dashboard.nextRun': 'Próxima ejecución',
  'skills.dashboard.cardOpenRunner': 'Abrir en el ejecutor',
  'skills.new.title': 'Crear un flujo de trabajo',
  'settings.agents.title': 'Agentes',
  'settings.agents.subtitle':
    'Administra los agentes disponibles para la delegación: los predeterminados integrados y tus propios agentes personalizados.',
  'settings.agents.menuDesc': 'Administrar agentes integrados y personalizados',
  'settings.agents.newAgent': 'Nuevo agente',
  'settings.agents.loadError': 'No se pudieron cargar los agentes',
  'settings.agents.empty': 'Todavía no hay agentes',
  'settings.agents.sourceDefault': 'incorporado',
  'settings.agents.sourceCustom': 'Personalizado',
  'settings.agents.enable': 'Habilitar agente',
  'settings.agents.disable': 'Desactivar agente',
  'settings.agents.edit': 'Editar',
  'settings.agents.delete': 'Borrar',
  'settings.agents.reset': 'Restablecer a predeterminado',
  'settings.agents.modelLabel': 'Modelo',
  'settings.agents.toolsLabel': 'Herramientas',
  'settings.agents.toolsAll': 'Todas las herramientas',
  'settings.agents.toolsCount': 'herramientas {count}',
  'settings.agents.actionFailed': 'No se pudo actualizar el agente',
  'settings.agents.orchestratorLocked': 'El orquestador siempre está habilitado.',
  'settings.agents.editor.createTitle': 'Nuevo agente',
  'settings.agents.editor.editTitle': 'Editar agente',
  'settings.agents.editor.id': 'ID',
  'settings.agents.editor.idHint': 'Solo letras minúsculas, números, _ y -.',
  'settings.agents.editor.name': 'Nombre',
  'settings.agents.editor.description': 'Descripción',
  'settings.agents.editor.model': 'Modelo (opcional)',
  'settings.agents.editor.modelPlaceholder':
    'por ejemplo, heredar, pista:rápido, o un id de modelo',
  'settings.agents.editor.systemPrompt': 'Indicador del sistema (opcional)',
  'settings.agents.editor.tools': 'Herramientas permitidas',
  'settings.agents.editor.toolsHint':
    'Un nombre de herramienta por línea. Usa * para todas las herramientas.',
  'settings.agents.editor.defaultsNote':
    'Editar un agente integrado guarda una anulación que puedes restablecer más tarde.',
  'settings.agents.editor.save': 'Guardar',
  'settings.agents.editor.create': 'Crear agente',
  'settings.agents.editor.saving': 'Guardando…',
  'nav.workflows': 'Workflows',
  'workflows.title': 'Flujos de trabajo',
  'workflows.subtitle':
    'Procedimientos reutilizables y ejecutables: un objetivo y los pasos para alcanzarlo. Crea uno, instala desde una URL o abre un flujo de trabajo para ejecutarlo.',
  'workflows.createNew': 'Nuevo flujo de trabajo',
  'workflows.listHeading': 'Workflows',
  'workflows.delete': 'Eliminar flujo de trabajo',
  'workflows.deleteError': 'No se pudo eliminar el flujo de trabajo',
  'workflows.warnings': '{count} advertencia(s)',
  'workflows.empty.title': 'Aún no hay flujos de trabajo',
  'workflows.empty.body':
    'Crea un flujo de trabajo para definir reglas y scripts para las fases del ciclo de vida de tareas.',
  'workflows.create.title': 'Nuevo flujo de trabajo',
  'workflows.create.subtitle':
    'Define un conjunto de reglas vinculado al ciclo de vida del agente.',
  'workflows.create.name': 'Name',
  'workflows.create.namePlaceholder': 'ej. Flujo de trabajo de proyecto Python',
  'workflows.create.description': 'Description',
  'workflows.create.descriptionPlaceholder': '¿Qué hace este flujo de trabajo?',
  'workflows.create.whenToUse': 'Cuándo usar',
  'workflows.create.whenToUsePlaceholder': '¿Cuándo debería el agente usar este flujo de trabajo?',
  'workflows.create.optional': '(opcional)',
  'workflows.create.createBtn': 'Crear flujo de trabajo',
  'workflows.create.creating': 'Creating…',
  'workflows.create.createError': 'No se pudo crear el flujo de trabajo',
  'workflows.create.successTitle': 'Flujo de trabajo creado',
  'workflows.create.successMessage': 'se creó exitosamente.',
  'workflows.deleteConfirm.title': 'Eliminar flujo de trabajo',
  'workflows.deleteConfirm.body': '¿Eliminar "{name}"? Esto no se puede deshacer.',
  'workflows.detail.tags': 'Tags',
  'workflows.detail.location': 'Location',
  'workflows.detail.warnings': 'Warnings',
  'workflows.detail.phases': 'Phases',
  'workflows.detail.noPhases': 'No hay fases definidas.',
  'workflows.detail.loadError': 'No se pudo cargar el flujo de trabajo completo',
  'workflows.phase.rules': 'Rules',
  'workflows.phase.rules.empty': 'Sin reglas.',
  'workflows.phase.scripts': 'Scripts',
  'workflows.phase.scripts.empty': 'Sin scripts.',
  'workflows.phase.toolScope': 'Alcance de herramientas',
  'workflows.phase.toolScope.allow': 'Allow',
  'workflows.phase.toolScope.deny': 'Deny',
  'workflows.phase.toolScope.inherited': 'Heredado del flujo de trabajo predeterminado.',
  'workflows.phase.toolScope.empty': 'Sin restricciones de herramientas.',
  'workflows.phase.context': 'Context',
  'workflows.phase.context.empty': 'Sin proveedores de contexto.',
  'settings.agentsSection.title': 'Agents',
  'settings.agentsSection.description':
    'Administra tus agentes, su autonomía y a qué pueden acceder en este equipo.',
  'settings.agentsSection.menuDesc': 'Registro, autonomía y acceso al SO',
  'settings.cryptoSection.title': 'Cripto',
  'settings.cryptoSection.description':
    'Gestiona tu frase de recuperación y consulta los saldos de tus cuentas de monedero.',
  'settings.cryptoSection.menuDesc': 'Frase de recuperación y saldos del monedero',
  'settings.notificationsHub.title': 'Notificaciones',
  'settings.notificationsHub.description':
    'Consulta tu bandeja de alertas y gestiona las preferencias de notificación y el enrutamiento.',
  'settings.notificationsHub.menuDesc': 'Bandeja de alertas y preferencias de notificación',
  'settings.notificationsHub.settingsItem': 'Ajustes de notificaciones',
  'settings.notificationsHub.settingsItemDesc': 'Preferencias y enrutamiento',
  'settings.agents.editor.notFound': 'Agente no encontrado.',
  'settings.agents.editor.modelInherit': 'Heredar (predeterminado de la plataforma)',
  'settings.agents.editor.modelHints': 'Sugerencias de enrutamiento',
  'settings.agents.editor.modelTiers': 'Niveles de modelo',
  'settings.agents.editor.modelCustom': 'ID de modelo personalizado…',
  'settings.agents.editor.modelCustomPlaceholder': 'ej. anthropic/claude-sonnet-4',
  'settings.agents.editor.selectTools': 'Agregar herramientas',
  'settings.agents.editor.toolsAllSelected': 'Todas las herramientas',
  'settings.agents.editor.toolsNoneSelected': 'Ninguna herramienta seleccionada',
  'settings.agents.editor.removeToolAria': 'Eliminar {tool}',
  'settings.agents.editor.toolsModalTitle': 'Herramientas permitidas',
  'settings.agents.editor.toolsSelectedCount': '{count} seleccionadas',
  'settings.agents.editor.toolsSearchPlaceholder': 'Buscar herramientas…',
  'settings.agents.editor.toolsAllowAll': 'Permitir todas las herramientas (*)',
  'settings.agents.editor.toolsAllowAllHint':
    'Este agente puede usar todas las herramientas disponibles.',
  'settings.agents.editor.toolsLoading': 'Cargando herramientas…',
  'settings.agents.editor.toolsLoadError': 'No se pudieron cargar las herramientas',
  'settings.agents.editor.toolsEmpty': 'Ninguna herramienta coincide con tu búsqueda.',
  'settings.agents.editor.toolsDone': 'Done',
  'settings.agents.editor.builtInReadonly':
    'Los agentes integrados no se pueden editar. Puedes activarlos, desactivarlos o restablecerlos desde la lista de agentes.',
  // Chat: agent-generated artifacts (#2779)
  'chat.artifact.aria': 'Artefacto: {title}',
  'chat.artifact.generating': 'Generando {kind}…',
  'chat.artifact.ready': 'Listo',
  'chat.artifact.failed': 'Error al generar',
  'chat.artifact.download': 'Descargar',
  'chat.artifact.downloading': 'Descargando…',
  'chat.artifact.downloaded': 'Guardado en {path}',
  'chat.artifact.download_failed': 'Error al descargar: {reason}',
  'chat.artifact.retry': 'Reintentar',
  'chat.artifact.reveal': 'Mostrar en la carpeta',
  'chat.artifact.show_more': 'Ver más',
  'chat.artifact.show_less': 'Ver menos',

  // Chat: files panel (#3024)
  'chat.files.chip.aria.one': '{count} archivo en este chat',
  'chat.files.chip.aria.other': '{count} archivos en este chat',
  'chat.files.panel.aria': 'Archivos en este chat',
  'chat.files.panel.title': 'Archivos ({count})',
  'chat.files.panel.empty': 'Aún no hay archivos. Pídele al agente que genere uno.',
  'chat.files.panel.close': 'Cerrar panel de archivos',
  'chat.files.delete.aria': 'Eliminar {title}',
  'chat.files.delete.confirm': '¿Eliminar este archivo?',
  'chat.files.delete.cancel': 'Cancelar',
  'chat.files.delete.action': 'Eliminar',
  'chat.files.delete.failed': 'No se pudo eliminar el archivo. Inténtalo de nuevo.',
  'chat.files.error.not_desktop': 'Las descargas solo están disponibles en la app de escritorio.',
  'chat.files.error.missing_artifact_id': 'Falta el id del artefacto.',
  'chat.files.error.missing_artifact_path':
    'Falta la ruta del artefacto en la respuesta del núcleo.',
  'chat.files.error.resolve_failed': 'No se pudo resolver el artefacto. Inténtalo de nuevo.',
  'chat.files.error.download_failed': 'La descarga falló. Inténtalo de nuevo.',
  'chat.files.error.delete_failed': 'No se pudo eliminar el archivo. Inténtalo de nuevo.',
  'memory.tab.council': 'Council',
  'activity.tabs.automations': 'Automatizaciones',
  'activity.tabs.automationsDescription':
    'Procedimientos reutilizables y ejecutables: un objetivo y los pasos para alcanzarlo.',
  'activity.tabs.backgroundActivity': 'Subconsciente',
  'activity.tabs.alerts': 'Alertas',

  'intelligence.agents.title': 'Biblioteca de agentes',
  'intelligence.agents.subtitle':
    'Revisa especialistas ejecutables y envía una tarea a un agente concreto.',
  'intelligence.agents.refresh': 'Actualizar',
  'intelligence.agents.loading': 'Cargando agentes…',
  'intelligence.agents.failedToLoad': 'No se pudieron cargar los agentes',
  'intelligence.agents.empty': 'No hay agentes ejecutables disponibles.',
  'intelligence.agents.readOnly': 'Solo lectura',
  'intelligence.agents.writeCapable': 'Puede escribir',
  'intelligence.agents.allTools': 'Todas las herramientas',
  'intelligence.agents.toolCountOne': '{count} herramienta',
  'intelligence.agents.toolCountOther': '{count} herramientas',
  'intelligence.agents.subagentCountOne': '{count} subagente',
  'intelligence.agents.subagentCountOther': '{count} subagentes',
  'intelligence.agents.startChat': 'Iniciar chat',
  'intelligence.agents.startChatPrompt':
    'Inicia un chat con este agente. Presenta tu especialidad, pregunta qué necesitas saber y espera mi tarea.',
  'intelligence.agents.copyId': 'Copiar ID',
  'intelligence.agents.copied': 'Copiado',
  'intelligence.agents.taskPlaceholder': 'Tarea para este agente',
  'intelligence.agents.runTask': 'Ejecutar tarea',
  'intelligence.agents.running': 'Ejecutando…',
  'intelligence.agents.runFailed': 'No se pudo iniciar el agente seleccionado',
  'intelligence.agents.model.inherit': 'Heredar',
  'intelligence.agents.tier.chat': 'Chat',
  'intelligence.agents.tier.reasoning': 'Razonamiento',
  'intelligence.agents.tier.worker': 'Trabajador',
  'graphCohesion.brokerBadge': 'intermediario',
  'graphCohesion.brokerTitle':
    'Hueco estructural: los vecinos de esta entidad no están conectados entre sí: ella es el único enlace entre ellos.',
  'graphCohesion.colCohesion': 'Cohesión',
  'graphCohesion.colEntity': 'Entidad',
  'graphCohesion.colLinks': 'Enlaces',
  'graphCohesion.colRank': '#',
  'graphCohesion.empty': 'Aún no hay grafo de conocimiento.',
  'graphCohesion.emptyHint':
    'A medida que el asistente registra hechos conectados sobre usted, su estructura de agrupamiento aparecerá aquí.',
  'graphCohesion.errorPrefix': 'No se pudo cargar el grafo:',
  'graphCohesion.intro':
    'Cuán estrechamente tejido está el vecindario de cada entidad. Los intermediarios (entidades cuyos vecinos no están conectados entre sí) son los puntos únicos que mantienen unidos grupos que de otro modo estarían separados, algo que un orden por frecuencia o PageRank no puede revelar.',
  'graphCohesion.loading': 'Calculando cohesión…',
  'graphCohesion.metricConnections': 'Conexiones',
  'graphCohesion.metricEntities': 'Entidades',
  'graphCohesion.metricTriangles': 'Triángulos',
  'graphCohesion.namespaceAll': 'Todos los espacios de nombres',
  'graphCohesion.namespaceLabel': 'Espacio de nombres',
  'graphCohesion.noBrokers': 'Aún no hay entidades con dos o más conexiones.',
  'graphCohesion.rankedHeading': 'Intermediarios: vecindarios más sueltos',
  'graphCohesion.retry': 'Reintentar',
  'graphCohesion.summaryCaption': 'Agrupamiento promedio {avg} · transitividad {transitivity}',
  'graphCohesion.title': 'Cohesión del grafo',
  'memory.tab.cohesion': 'Cohesion',

  'harnessInit.title': 'Preparando todo',

  'announcement.gotIt': 'Entendido',
  'harnessInit.subtitle':
    'OpenHuman está preparando los componentes que necesita en el primer inicio.',
  'harnessInit.stepPython': 'Entorno de ejecución de Python',
  'harnessInit.stepSpacy': 'Modelo de lenguaje',
  'harnessInit.stepNode': 'Entorno de ejecución de Node.js',
  'harnessInit.statePending': 'En espera',
  'harnessInit.stateRunning': 'Instalando…',
  'harnessInit.stateDone': 'Listo',
  'harnessInit.stateSkipped': 'Omitido',
  'harnessInit.stateFailed': 'Error',
  'harnessInit.failedMessage':
    'Algunos pasos de la configuración no se completaron. Puedes reintentar o continuar: OpenHuman usará una alternativa integrada.',
  'harnessInit.retry': 'Reintentar',
  'harnessInit.continueAnyway': 'Continuar de todos modos',
  'harnessInit.runInBackground': 'Ejecutar en segundo plano',
  'harnessInit.backgroundHint': 'Puedes seguir usando OpenHuman mientras esto termina.',

  'keyring.consent.title': 'Almacenamiento seguro no disponible',
  'keyring.consent.description':
    'El llavero de su sistema operativo no está accesible. OpenHuman necesita su permiso para almacenar secretos usando almacenamiento local cifrado.',
  'keyring.consent.reasonPrefix': 'Motivo:',
  'keyring.consent.showDetails': '¿Qué significa esto?',
  'keyring.consent.hideDetails': 'Ocultar detalles',
  'keyring.consent.tradeoffTitle': 'Compromiso de seguridad',
  'keyring.consent.tradeoffBody':
    'Con el almacenamiento local cifrado, sus secretos se cifran en disco usando una clave maestra almacenada junto a los datos. Esto es menos seguro que el llavero del SO, que usa protección respaldada por hardware. Las copias de seguridad o la sincronización de archivos pueden incluir los datos cifrados.',
  'keyring.consent.consentButton': 'Usar almacenamiento local cifrado',
  'keyring.consent.retryButton': 'Reintentar OS Keychain',
  'keyring.consent.declineButton': 'Rechazar',
  'keyring.consent.retrying': 'Reintentando…',
  'keyring.consent.error': 'No se pudo guardar la preferencia. Inténtelo de nuevo.',
  'keyring.consent.retryFailed': 'El llavero sigue sin estar disponible.',
  'keyring.settings.title': 'Seguridad',
  'keyring.settings.storageMode': 'Modo de almacenamiento de secretos',
  'keyring.settings.mode.osKeychain': 'Llavero del SO',
  'keyring.settings.mode.encryptedFile': 'Local cifrado',
  'keyring.settings.mode.consentPending': 'No configurado',
  'keyring.settings.mode.declined': 'Rechazado',
  'keyring.settings.availability': 'Disponibilidad del llavero',
  'keyring.settings.available': 'El llavero del SO está disponible',
  'keyring.settings.unavailable': 'El llavero del SO no está disponible',
  'keyring.settings.backend': 'Motor',
  'keyring.settings.retryButton': 'Reintentar detección del llavero',
  'keyring.settings.retryFailed': 'Reintento fallido. El llavero sigue sin estar disponible.',
  'keyring.settings.consentTitle': 'Consentimiento de almacenamiento',
  'keyring.settings.consentDescription':
    'Elija cómo se almacenan los secretos cuando el llavero del SO no está disponible.',
  'keyring.settings.grantConsent': 'Permitir almacenamiento local cifrado',
  'keyring.settings.revokeConsent': 'Rechazar almacenamiento local',
  'pages.settings.account.security': 'Seguridad',
  'pages.settings.account.securityDesc': 'Modo de almacenamiento de secretos y estado del llavero',
  // #002 memory-pipeline-hardening: degraded badges + typed remediation.
  'memoryTree.status.statusDegraded': 'Degradado',
  'memoryTree.status.statusBudgetExhausted': 'En pausa: se alcanzó el límite de embeddings',
  'memoryTree.status.degradedRecall': 'Recuperación semántica desactivada',
  'memoryTree.status.degradedStructure': 'Estructura de la wiki incompleta',
  'memoryTree.status.extractionCoverage':
    'Cobertura de extracción: {pct}% de los fragmentos tienen estructura',
  'memory.health.remediation.budget_exhausted':
    'Los embeddings de memoria agotaron el presupuesto gestionado. Configura embeddings locales de Ollama (Conexiones → Claves de API → Incrustaciones) o añade tu propia clave de API de embeddings para seguir construyendo la memoria.',
  'memory.health.remediation.auth_missing':
    'No se encontraron credenciales de embeddings. Inicia sesión en OpenHuman o configura embeddings locales de Ollama en Conexiones → Claves de API → Incrustaciones.',
  'memory.health.remediation.auth_invalid':
    'Tus credenciales de embeddings fueron rechazadas. Vuelve a autenticarte o cambia a embeddings locales de Ollama en Conexiones → Claves de API → Incrustaciones.',
  'memory.health.remediation.embeddings_unconfigured':
    'No hay ningún proveedor de embeddings configurado, por lo que la recuperación semántica está desactivada. Configura embeddings locales de Ollama (recomendado) o añade una clave de embeddings en Conexiones → Claves de API → Incrustaciones.',
  'memory.health.remediation.embedding_dim_mismatch':
    'El modelo de embeddings devuelve un tamaño de vector incorrecto (la memoria espera 1024 dimensiones). Elige un modelo de 1024 dimensiones o solicita 1024 dimensiones a tu proveedor.',
  'memory.health.remediation.local_model_unavailable':
    'No hay disponible un modelo local requerido. Instala/ejecuta Ollama y descarga el modelo, o cambia esta carga de trabajo a un proveedor en la nube en Conexiones → Claves de API.',
  'memory.health.remediation.extraction_timeout':
    'El modelo de extracción de memoria está agotando el tiempo de espera, por lo que la wiki tiene poca estructura. Cambia el modelo de extracción de memoria por uno más rápido en Conexiones → Claves de API → LLM.',
  'memory.health.remediation.summarizer_unavailable':
    'No hay ningún proveedor de resúmenes disponible para Crear árboles de resumen. Activa la IA local (Ollama), o configura memory_tree.cloud_summarization_opt_in=true y un proveedor LLM en Conexiones → Claves de API → LLM.',
  'memory.health.remediation.empty_input_refused':
    'Se omitió un elemento de memoria porque su texto estaba vacío. No se requiere ninguna acción: los elementos nuevos siguen incrustándose con normalidad.',
  'memory.health.remediation.storage_unavailable':
    'OpenHuman no puede escribir en su almacenamiento de memoria: el disco o la tarjeta SD parece estar fallando, lleno o de solo lectura. Revisa la unidad y libera espacio; el procesamiento de la memoria se reanudará automáticamente cuando el almacenamiento vuelva a permitir escritura.',
  'memory.health.remediation.transient':
    'Un error temporal interrumpió el procesamiento de la memoria. Se reintentará automáticamente.',
  'memory.health.remediation.unknown':
    'El procesamiento de la memoria encontró un problema. Comprueba Conexiones → Claves de API para la configuración.',
  // Chat: agent-generated artifacts (#2779)

  // Chat composer toolbar
  'composer.attachFile': 'Adjuntar archivo',
  'composer.modelSelector': 'Modelo',
  'composer.voiceMode': 'Modo de voz',
  'composer.qualityHigh': 'Alto',
  // Agent activity level
  'activityLevel.title': 'Nivel de actividad del agente',
  'activityLevel.description':
    'Controla qué tan proactivo es tu agente. Los niveles más altos usan más tokens.',
  'activityLevel.off': 'Desactivado',
  'activityLevel.offDesc':
    'Sin procesamiento en segundo plano. Sincroniza solo al presionar el botón.',
  'activityLevel.minimal': 'Mínimo',
  'activityLevel.minimalDesc': 'Sincroniza fuentes una vez al día. Sin mensajes proactivos.',
  'activityLevel.moderate': 'Moderado',
  'activityLevel.moderateDesc': 'Sincroniza cada hora. Resumen diario. Sugiere acciones.',
  'activityLevel.active': 'Activo',
  'activityLevel.activeDesc':
    'Sincroniza cada 10 min. Monitorea canales, prioriza y redacta respuestas.',
  'activityLevel.alwaysOn': 'Siempre activo',
  'activityLevel.alwaysOnDesc':
    'Sincronización en tiempo real. Autonomía total dentro de los límites.',
  'activityLevel.currentMonth': 'Este mes: ${amount}',
  'activityLevel.saved': 'Nivel de actividad actualizado.',
  'activityLevel.default': 'predeterminado',
  'activityLevel.costFree': '$0',
  'activityLevel.costRange': '~${min}–${max}/mes',

  // Sync budget dialog
  'syncBudget.title': 'Presupuesto de sincronización',
  'syncBudget.maxTokens': 'Tokens máximos por sincronización',
  'syncBudget.maxTokensHelp': 'Detener la sincronización al consumir este número de tokens.',
  'syncBudget.maxCost': 'Costo máximo por sincronización (USD)',
  'syncBudget.maxCostHelp': 'Límite absoluto en dólares por ejecución de sincronización.',
  'syncBudget.syncDepth': 'Profundidad de sincronización',
  'syncBudget.syncDepthHelp': 'Solo obtener elementos de esta ventana de tiempo.',
  'syncBudget.days7': 'Últimos 7 días',
  'syncBudget.days30': 'Últimos 30 días',
  'syncBudget.days90': 'Últimos 90 días',
  'syncBudget.allTime': 'Todo el tiempo',
  'syncBudget.unlimited': 'Ilimitado',
  'syncBudget.saved': 'Presupuesto guardado.',

  // Sync confirm dialog
  'syncConfirm.title': 'Confirmar sincronización',
  'syncConfirm.message':
    'Esta sincronización procesará ~{items} elementos (~{tokens} tokens, est. ${cost}).',
  'syncConfirm.budgetNote': 'Límite de presupuesto: ${max}',
  'syncConfirm.proceed': 'Proceder',
  'syncConfirm.cancel': 'Cancelar',
  'syncConfirm.estimating': 'Calculando costo...',

  // Monthly cost badge
  'monthlyCost.badge': '${amount} este mes',
  'monthlyCost.noData': 'Sin sincronizaciones este mes',

  // Onboarding: Custom > Activity
  'onboarding.custom.stepperActivity': 'Actividad',
  'onboarding.custom.stepperVault': 'Bóveda',
  'onboarding.custom.activity.title': 'Actividad del agente',
  'onboarding.custom.activity.subtitle':
    'Qué tan proactivamente monitorea y actúa tu agente en segundo plano.',
  'onboarding.custom.activity.defaultDesc':
    'Actividad moderada: sincronización por hora, resumen diario.',
  'onboarding.custom.activity.configureDesc':
    'Elige tu propio nivel de actividad. Configurar en Ajustes › Nivel de actividad del agente.',

  // Onboarding: Custom > Vault
  'onboarding.custom.vault.title': 'Configuración de memoria y bóveda',
  'onboarding.custom.vault.subtitle':
    'Confirma dónde se escriben las notas de memoria, cómo se leen los datos de origen y si el flujo de bóveda está en buen estado.',
  'onboarding.custom.vault.defaultDesc':
    'Usa los valores predeterminados de memoria administrada por OpenHuman. La ruta de la bóveda y el estado de sincronización se pueden revisar más adelante.',
  'onboarding.custom.vault.configureDesc':
    'Revisa la propiedad de la bóveda, ejecuta comprobaciones de estado y ajusta los controles de memoria ahora.',
  'onboarding.custom.vault.localDisabledReason':
    'La configuración administrada requiere inicio de sesión en OpenHuman y no está disponible en modo local.',
  'onboarding.custom.vault.exitError':
    'No se pudo completar el proceso de incorporación. Por favor, inténtalo de nuevo.',

  // Vault Health
  'vaultHealth.title': 'Lista de verificación de salud de la bóveda',
  'vaultHealth.setupTitle': 'Estado de configuración de la bóveda',
  'vaultHealth.workspaceVault': 'Bóveda del espacio de trabajo:',
  'vaultHealth.refresh': 'Actualizar',
  'vaultHealth.refreshing': 'Actualizando…',
  'vaultHealth.revealFolder': 'Mostrar carpeta',
  'vaultHealth.openInObsidian': 'Abrir en Obsidian',
  'vaultHealth.installObsidian': 'Instalar Obsidian',
  'vaultHealth.openObsidianError': 'No se pudo abrir Obsidian',
  'vaultHealth.revealError': 'No se pudo mostrar la carpeta de la bóveda',
  'vaultHealth.downloadError': 'No se pudo abrir la página de descarga de Obsidian',
  'vaultHealth.loadError': 'No se pudo cargar el estado de la bóveda:',
  'vaultHealth.lastSync': 'Última sincronización:',
  'vaultHealth.passed': 'Superado',
  'vaultHealth.needsAttention': 'Requiere atención',
  'vaultHealth.existsLabel': 'La ruta de la bóveda del espacio de trabajo existe',
  'vaultHealth.existsRecovery':
    'La carpeta de la bóveda no existe. Inicia una sincronización o crea esta carpeta y luego actualiza esta lista.',
  'vaultHealth.writableLabel': 'OpenHuman puede escribir en la bóveda',
  'vaultHealth.writableRecovery':
    'OpenHuman aún no puede escribir en esta bóveda. Concede permisos de escritura y actualiza.',
  'vaultHealth.obsidianLabel': 'La bóveda está registrada en Obsidian',
  'vaultHealth.obsidianRecovery':
    'En Obsidian, elige "Abrir carpeta como bóveda" para esta ruta y luego actualiza esta lista.',
  'vaultHealth.pipelineLabel': 'El flujo de memoria está en buen estado',
  'vaultHealth.pipelineRecovery':
    'El flujo de memoria está pausado o en error. Vuelve a habilitar la sincronización automática en el estado del árbol de memoria y reintenta.',
  'vaultHealth.timeNever': 'Nunca',
  'vaultHealth.timeJustNow': 'ahora mismo',
  'vaultHealth.timeMinAgo': 'hace {n} min',
  'vaultHealth.timeHrAgo': 'hace {n} h',
  'vaultHealth.timeDayAgo': 'hace {n} día',
  'vaultHealth.timeDaysAgo': 'hace {n} días',

  // Memory Data
  'memoryData.howItWorks': 'Cómo funciona el almacenamiento de memoria',
  'memoryData.workspaceVault': 'Bóveda del espacio de trabajo · escritura',
  'memoryData.workspaceVaultDesc':
    'OpenHuman escribe las notas de memoria generadas en memory_tree/content.',
  'memoryData.connectedSources': 'Fuentes conectadas · lectura',
  'memoryData.connectedSourcesDesc':
    'Carpetas, buzones, chats y repositorios se importan para la indexación de memoria; sus archivos originales nunca se reescriben.',
  'memoryData.internalFiles': 'Archivos internos del árbol de memoria',
  'memoryData.internalFilesDesc':
    'Los índices, el estado de la cola y los resúmenes son administrados por OpenHuman para mantener en buen estado la recuperación y la sincronización.',
  'memoryData.windowError': 'Ventana de memoria',
  'memoryData.windowUpdated': 'Ventana de memoria actualizada',
  'memoryData.windowUpdatedMsg': 'Establecida en {window}.',
  'skills.create.whenToUse': 'Cuándo usar',
  'skills.create.whenToUsePlaceholder':
    'p. ej., cuando el usuario pide organizar su bandeja de entrada',
  'skills.create.whenToUseHelp':
    'El desencadenante que un agente reconoce para decidir ejecutar este flujo de trabajo. Déjalo en blanco para reutilizar la descripción.',
  'skills.create.inputs.row.descriptionError': 'Se requiere una descripción para cada entrada.',
  'skills.detail.run': 'Ejecutar',
  'skills.detail.runAriaLabel': 'Ejecutar este flujo de trabajo',
  'skills.run.title': 'Flujo de trabajo',
  'workflows.installFromUrl': 'Instalar desde URL',
  // Security banner (approval-gate host-aware boot state)
  'security.approvalGateDisabled.title': 'Puerta de aprobación desactivada',
  'security.approvalGateDisabled.body':
    'OPENHUMAN_APPROVAL_GATE=0 está configurado en tu entorno. Las herramientas con efectos externos se ejecutarán sin pedir confirmación.',
  'security.approvalGateOverrideIgnored.title': 'Anulación bloqueada',
  'security.approvalGateOverrideIgnored.body':
    'Se detectó una anulación OPENHUMAN_APPROVAL_GATE=0, pero se ignoró: la aplicación de escritorio mantiene siempre activa la puerta de aprobación.',

  // Run queue
  'runQueue.mode.interrupt': 'Interrumpir',
  'runQueue.mode.steer': 'Dirigir',
  'runQueue.mode.followup': 'Seguimiento',
  'runQueue.mode.collect': 'Añadir contexto',
  'runQueue.queued': 'Mensaje en cola',
  'runQueue.steerHint': 'Dirigir el turno actual',
  'runQueue.followupHint': 'Poner en cola como seguimiento',
  'runQueue.collectHint': 'Añadir como contexto adicional',
  'runQueue.status': '{total} en cola',
  'runQueue.cleared': 'Cola vaciada',
  'notch.ready': 'Listo',
  'notch.processing': 'Procesando…',
  'notch.listening': 'Escuchando…',
  'notch.thinking': 'Pensando…',
  'notch.speaking': 'Hablando…',
  'notch.transcribing': 'Transcribiendo…',
  'notch.executing': 'Ejecutando…',
  'memory.tab.orchestration': 'Orquestación',
  'memory.tab.orchestrationDescription':
    'Ejecuta flujos de trabajo con múltiples agentes: distribuye una pregunta entre agentes paralelos, contrasta sus hallazgos y observa cómo cada fase culmina en una única respuesta sintetizada.',
  'orchestration.subtitle':
    'Inicia un flujo de trabajo con múltiples agentes, observa el avance de sus fases y lee el resultado sintetizado.',
  'orchestration.loading': 'Cargando flujos de trabajo…',
  'orchestration.failedToLoad': 'No se pudieron cargar los flujos de trabajo',
  'orchestration.definitions': 'Flujos de trabajo disponibles',
  'orchestration.noDefinitions': 'No hay definiciones de flujos de trabajo disponibles.',
  'orchestration.approvalRequired': 'Aprobación requerida',
  'orchestration.start': 'Iniciar',
  'orchestration.confirmStart': 'Iniciar ejecución',
  'orchestration.starting': 'Iniciando…',
  'orchestration.questionLabel': 'Pregunta de investigación (opcional)',
  'orchestration.questionPlaceholder': '¿Qué deben investigar los agentes?',
  'orchestration.runProgress': 'Progreso de la ejecución',
  'orchestration.recentRuns': 'Ejecuciones recientes',
  'orchestration.noRuns': 'Aún no hay ejecuciones de flujos de trabajo.',
  'orchestration.close': 'Cerrar',
  'orchestration.tier.readOnly': 'Solo lectura',
  'orchestration.tier.standard': 'Estándar',
  'orchestration.tier.editCapable': 'Con capacidad de edición',
  'orchestration.approval.title': 'Aprobar esta ejecución del flujo de trabajo',
  'orchestration.approval.body':
    'Esta es una ejecución de alto costo o alta concurrencia y necesita tu aprobación explícita antes de iniciar:',
  'orchestration.approval.reason.tier':
    'Sus agentes pueden realizar acciones más allá de la investigación de solo lectura.',
  'orchestration.approval.reason.concurrency': 'Ejecuta muchos agentes al mismo tiempo.',
  'orchestration.approval.reason.children': 'Puede generar una gran cantidad de agentes en total.',
  'orchestration.approval.tier': 'Nivel de seguridad',
  'orchestration.approval.concurrency': 'Concurrencia',
  'orchestration.approval.maxChildren': 'Máx. de agentes',
  'orchestration.approval.approve': 'Aprobar e iniciar',
  'orchestration.approval.starting': 'Iniciando…',
  'orchestration.approval.cancel': 'Cancelar',
  'orchestration.runStatus.pending': 'Pendiente',
  'orchestration.runStatus.running': 'En ejecución',
  'orchestration.runStatus.completed': 'Completada',
  'orchestration.runStatus.failed': 'Fallida',
  'orchestration.runStatus.cancelled': 'Cancelada',
  'orchestration.runStatus.interrupted': 'Interrumpida',
  'orchestration.phaseStatus.pending': 'Pendiente',
  'orchestration.phaseStatus.running': 'En ejecución',
  'orchestration.phaseStatus.completed': 'Completada',
  'orchestration.phaseStatus.failed': 'Fallida',
  'orchestration.detail.stop': 'Detener',
  'orchestration.detail.resume': 'Reanudar',
  'orchestration.detail.agents': 'agentes',
  'orchestration.detail.childRefs': 'Agentes secundarios',
  'orchestration.detail.synthesis': 'Síntesis final',
  // ── Agent Profiles ───────────────────────────────────────────────────────
  'settings.profiles.title': 'Perfiles de agente',
  'settings.profiles.subtitle':
    'Agentes con personalidad: cada uno con su propia alma, memoria, conectores y habilidades.',
  'settings.profiles.menuDesc': 'Crea y gestiona perfiles de agente',
  'settings.profiles.new': 'Nuevo perfil',
  'settings.profiles.empty': 'Aún no hay perfiles de agente',
  'settings.profiles.loadError': 'No se pudieron cargar los perfiles',
  'settings.profiles.active': 'Activo',
  'settings.profiles.setActive': 'Establecer como activo',
  'settings.profiles.sourceBuiltIn': 'Integrado',
  'settings.profiles.sourceCustom': 'Personalizado',
  'settings.profiles.deleteConfirm': '¿Eliminar este perfil? Esta acción no se puede deshacer.',
  'settings.profiles.editor.createTitle': 'Nuevo perfil',
  'settings.profiles.editor.editTitle': 'Editar perfil',
  'settings.profiles.editor.name': 'Nombre',
  'settings.profiles.editor.id': 'Identificador',
  'settings.profiles.editor.idHint': 'Solo letras minúsculas, números y guiones.',
  'settings.profiles.editor.description': 'Descripción',
  'settings.profiles.editor.soul': 'Alma (SOUL.md)',
  'settings.profiles.editor.soulHint':
    'Identidad personalizada de este perfil. Si se deja vacío, se usa el SOUL.md del espacio de trabajo.',
  'settings.profiles.editor.baseAgent': 'Agente base',
  'settings.profiles.editor.baseAgentHint':
    'Con qué definición de agente se ejecuta este perfil (por ejemplo, orchestrator).',
  'settings.profiles.editor.model': 'Modelo',
  'settings.profiles.editor.modelHint':
    'Anulación de modelo opcional. Si se deja vacío, hereda el predeterminado.',
  'settings.profiles.editor.temperature': 'Temperatura',
  'settings.profiles.editor.systemPromptSuffix': 'Sufijo del mensaje del sistema',
  'settings.profiles.editor.agentConversations': 'Recordar conversaciones del agente',
  'settings.profiles.editor.agentConversationsHint':
    'Incluir memoria de chats anteriores y entre chats en el contexto de este perfil.',
  'settings.profiles.editor.memorySources': 'Fuentes de memoria',
  'settings.profiles.editor.memorySourcesHint':
    'Fuentes de memoria de las que recuerda este perfil.',
  'settings.profiles.editor.connectors': 'Conectores',
  'settings.profiles.editor.connectorsHint':
    'Kits de herramientas de Composio que puede usar este perfil.',
  'settings.profiles.editor.skills': 'Habilidades',
  'settings.profiles.editor.skillsHint':
    'Flujos de trabajo que este perfil puede listar y ejecutar.',
  'settings.profiles.editor.mcpServers': 'Servidores MCP',
  'settings.profiles.editor.mcpServersHint': 'Servidores MCP a los que puede acceder este perfil.',
  'settings.profiles.editor.dedicatedMemory': 'Memoria dedicada',
  'settings.profiles.editor.dedicatedMemoryHint':
    'Dale a este perfil su propia memoria en lugar de compartir la memoria predeterminada.',
  'settings.profiles.editor.dedicatedWorkspace': 'Espacio de trabajo dedicado',
  'settings.profiles.editor.dedicatedWorkspaceHint':
    'Dale a este perfil su propio directorio de trabajo para operaciones de archivos y herramientas.',
  'settings.profiles.editor.soulMdFile': 'Archivo SOUL.md',
  'settings.profiles.editor.workspaceDir': 'Directorio de trabajo',
  'settings.profiles.editor.skillsDir': 'Directorio de habilidades',
  'settings.profiles.editor.skillsDirHint':
    'Las habilidades basadas en SKILL.md colocadas aquí son privadas de este perfil.',
  'settings.profiles.editor.all': 'Todos',
  'settings.profiles.editor.selected': 'Seleccionados',
  'settings.profiles.editor.addPlaceholder': 'Escribe un identificador y pulsa Intro',
  'settings.profiles.editor.removeAria': 'Quitar {item}',
  'settings.profiles.editor.notFound': 'Perfil no encontrado',
  'settings.profiles.editor.saving': 'Guardando…',
  'settings.profiles.editor.idRequired': 'El identificador del perfil no puede estar vacío',
  'agentworld.jobs.applyModal.title': 'Solicitar trabajo',
  'agentworld.jobs.applyModal.successHeading': '¡Propuesta enviada con éxito!',
  'agentworld.jobs.applyModal.successBody': 'El publicador del trabajo revisará tu solicitud.',
  'agentworld.jobs.applyModal.coverLetterLabel': 'Carta de presentación',
  'agentworld.jobs.applyModal.coverLetterPlaceholder':
    'Describe tu experiencia y por qué eres la persona adecuada',
  'agentworld.jobs.applyModal.bidAmountLabel': 'Monto de la oferta',
  'agentworld.jobs.applyModal.bidAmountPlaceholder': 'ej. 450 USDC',
  'agentworld.jobs.applyModal.deliveryLabel': 'Entrega estimada',
  'agentworld.jobs.applyModal.deliveryPlaceholder': 'ej. 2 semanas',
  'agentworld.feed.live': 'En vivo',
  'agentworld.jobs.applyModal.cancel': 'Cancelar',
  'agentworld.jobs.applyModal.submit': 'Enviar solicitud',
  'agentworld.jobs.applyModal.submitting': 'Enviando…',
  'agentworld.messaging.live': 'En vivo',
  'agentworld.messaging.missingSignalBundle':
    'Este usuario aún no ha activado la mensajería cifrada. Pídele que abra Agent World y active los DM seguros antes de enviarle un mensaje.',
  'agentworld.messaging.notAContact':
    'No puedes enviar mensajes a esta persona hasta que sea un contacto. Envía una solicitud de contacto e inténtalo de nuevo cuando la acepte.',
  'agentworld.messaging.sendContactRequest': 'Enviar solicitud de contacto',
  'agentworld.messaging.contactRequestSending': 'Enviando solicitud…',
  'agentworld.messaging.contactRequestSent':
    'Solicitud de contacto enviada. Podrás enviarle mensajes cuando la acepte.',
  'agentworld.messaging.contactRequestFailed':
    'No se pudo enviar la solicitud de contacto. Inténtalo de nuevo.',

  // User-actionable runtime errors (#3931)
  'userErrors.title': 'Acción necesaria',
  'userErrors.dismiss': 'Descartar',
  'userErrors.action.openBilling': 'Abrir facturación',
  'userErrors.action.openProviderSettings': 'Configuración del proveedor',
  'userErrors.action.openEmbeddingsSettings': 'Configurar embeddings',
  'userErrors.budgetExceeded.title': 'Presupuesto gestionado agotado',
  'userErrors.budgetExceeded.body':
    'Tu presupuesto de IA gestionado se ha agotado. Añade presupuesto o cambia de plan.',
  'userErrors.insufficientCredits.title': 'Se requieren créditos del proveedor',
  'userErrors.insufficientCredits.body':
    'Tu proveedor de IA se quedó sin créditos. Recárgalo o actualiza su clave de API.',
  'userErrors.apiKeyMissing.title': 'Se requiere clave de API',
  'userErrors.apiKeyMissing.body':
    'Tu proveedor de IA no tiene una clave de API configurada. Añade una en los ajustes del proveedor para continuar.',
  'userErrors.localModelUnavailable.title': 'Modelo local no disponible',
  'userErrors.localModelUnavailable.body':
    'No se puede acceder a Ollama en el punto de conexión configurado, o el modelo necesario no está instalado allí. Inicia Ollama y descarga el modelo en ese punto de conexión, o cambia este trabajo a un proveedor en la nube.',
  'userErrors.scope.chat': 'Chat',
  'userErrors.scope.cron': 'Tarea programada',
  'userErrors.scope.workspace': 'Espacio de trabajo',
  'userErrors.memoryBudgetExhausted.title': 'La memoria dejó de crecer',
  'userErrors.memoryBudgetExhausted.body':
    'Tu presupuesto de embeddings se agotó, así que el contenido nuevo ya no se añade a la memoria. Configura embeddings locales o añade tu propia clave de API para reanudar.',
  'memoryBudget.approachingTitle': 'La memoria se acerca a su límite de embeddings',
  'memoryBudget.approachingMessage':
    'Has usado el {pct}% de tu presupuesto de embeddings. Configura embeddings locales o añade tu propia clave de API para que la memoria siga creciendo sin interrupciones.',
  'memoryBudget.exhaustedTitle': 'La memoria dejó de crecer',
  'memoryBudget.exhaustedMessage':
    'Tu presupuesto de embeddings se agotó, así que el contenido nuevo ya no se añade a la memoria. Configura embeddings locales o añade tu propia clave de API para reanudar.',
  'memoryBudget.cta': 'Configurar embeddings',
  'userErrors.scope.memory': 'Memoria',
  // Agent World: Identity trading (confirm-before-spend + balance gate)
  'agentWorld.trading.amountLabel': 'Importe',
  'agentWorld.trading.networkLabel': 'Red',
  'agentWorld.trading.balanceLabel': 'Tu saldo',
  'agentWorld.trading.walletLabel': 'Billetera',
  'agentWorld.trading.balanceUnknown': 'Desconocido',
  'agentWorld.trading.cancel': 'Cancelar',
  'agentWorld.trading.addFunds': 'Añadir fondos',
  'agentWorld.trading.confirmPay': 'Confirmar y pagar',
  'agentWorld.trading.confirmCommit': 'Confirmar',
  'agentWorld.trading.continue': 'Continuar',
  'agentWorld.trading.submitting': 'Enviando…',
  'agentWorld.trading.placeBid': 'Pujar',
  'agentWorld.trading.submitOffer': 'Enviar oferta',
  'agentWorld.trading.bidTitlePrefix': 'Pujar por',
  'agentWorld.trading.offerTitlePrefix': 'Oferta por',
  'agentWorld.trading.bidReviewTitlePrefix': 'Confirmar puja por',
  'agentWorld.trading.offerReviewTitlePrefix': 'Confirmar oferta por',
  'agentWorld.trading.spendInsufficient':
    'Saldo insuficiente para completar este pago. Añade fondos a tu billetera para continuar.',
  'agentWorld.trading.spendBroadcastNote': 'Tu billetera firmará y transmitirá este pago en',
  'agentWorld.trading.commitInsufficientWarning':
    'Tu saldo podría no cubrir esto si se acepta el compromiso. Aún puedes enviarlo: los fondos solo se mueven al aceptarse.',
  'agentWorld.trading.commitSettleNote':
    'Este es un compromiso firmado: los fondos solo se mueven si se acepta.',
  'agentWorld.trading.commitReviewSubtitle': 'Revisa tu compromiso antes de enviarlo.',
  'agentWorld.trading.balanceUnverified':
    'No pudimos verificar el saldo de tu billetera. Aún puedes continuar: el pago se comprueba al enviarlo.',
  'agentWorld.trading.amountTooManyDecimals': 'Este importe tiene demasiados decimales.',
  'agentWorld.trading.amountMustBePositive': 'Introduce un importe mayor que cero.',
  'agentWorld.trading.amountInvalid': 'Introduce un importe válido.',

  // Code block chrome
  'codeBlock.copy': 'Copiar',
  'codeBlock.copied': '¡Copiado!',
  'flows.editor.undo': 'Deshacer',
  'flows.editor.redo': 'Rehacer',
  'flows.editor.onboardingTitle': 'Crea tu flujo de trabajo',
  'flows.editor.onboardingBody':
    'Añade un nodo desde la paleta de la izquierda y luego arrastra entre los puntos de cada tarjeta para conectarlos.',
  'flows.palette.search': 'Buscar nodos…',
  'flows.palette.noResults': 'No hay nodos coincidentes',
  'flows.palette.group.triggers': 'Disparadores',
  'flows.palette.group.actions': 'Acciones',
  'flows.palette.group.logic': 'Lógica',
  'flows.list.duplicate': 'Duplicar',
  'flows.list.duplicated': 'Flujo de trabajo duplicado',
  'flows.list.delete': 'Eliminar',
  'flows.list.deleted': 'Flujo de trabajo eliminado',
  'flows.list.moreActions': 'Más acciones',
  'flows.delete.title': '¿Eliminar el flujo de trabajo?',
  'flows.delete.body':
    '"{name}" y su historial de ejecuciones se eliminarán de forma permanente. Esta acción no se puede deshacer.',
  'flows.delete.cancel': 'Cancelar',
  'flows.delete.confirm': 'Eliminar',
  'flows.delete.deleting': 'Eliminando…',
  'flows.canvas.renameLabel': 'Cambiar el nombre del flujo de trabajo',
  'memorySources.codingSessions.title': 'Sesiones de agentes de programación',
  'memorySources.codingSessions.description':
    'Convierte tus decisiones y correcciones de Codex y Claude Code en memoria privada de personalidad.',
  'memorySources.codingSessions.importAll': 'Importar todas las sesiones',
  'memorySources.codingSessions.draining': 'Importando… lote {passes}',
  'memorySources.codingSessions.stop': 'Detener',
  'memorySources.codingSessions.progress':
    '{processed} sesiones importadas · {observations} observaciones',
  'memorySources.codingSessions.remaining': 'quedan unas {remaining}',
  'memorySources.codingSessions.stopped': 'Importación en pausa',
  'memorySources.codingSessions.stoppedMessage':
    'Se importaron {processed} sesiones. Ejecuta la importación de nuevo para continuar con las {remaining} restantes.',
  'memorySources.codingSessions.claude': 'Historial de Claude Code',
  'memorySources.codingSessions.codex': 'Codex',
  'memorySources.codingSessions.counts': '{files} sesiones · {evidence} intervenciones humanas',
  'memorySources.codingSessions.notFound': 'No se encontró historial local',
  'memorySources.codingSessions.scanning': 'Buscando historial local de sesiones…',
  'memorySources.codingSessions.truncated':
    'El análisis se limitó a los primeros 1000 archivos de sesión.',
  'memorySources.codingSessions.complete': 'Sesiones de programación ingeridas',
  'memorySources.codingSessions.completeMessage':
    '{processed} sesiones produjeron {observations} observaciones de personalidad.',
  'memorySources.codingSessions.partialFailure':
    'Fallaron {failed} sesiones mientras se procesaron {processed}. Ejecuta la ingesta de nuevo para reintentarlas.',
  'memorySources.codingSessions.failed': 'Falló la ingesta de sesiones de programación',
  'flows.canvas.sidePanelToggle': 'Panel lateral',
  'flows.canvas.legendTab': 'Manual',

  // Privacy status pill + per-action egress disclosure (#4437 / S3)
  'privacy.status.ariaLabel': 'Estado de privacidad',
  'privacy.status.external': 'Fuera del dispositivo',
  'privacy.status.local': 'En el dispositivo',
  // Data Sync layered pipeline status (GH-4690)
  'sync.pipeline.ingestedOnly': 'Solo ingerido',
  'sync.pipeline.storedWithoutVectors':
    'Almacenado sin vectores. La búsqueda semántica no está disponible.',
  'sync.pipeline.signInToEnable': 'Inicia sesión para activar',
  'sync.pipeline.extractionFailed':
    'Error al extraer la estructura de memoria. Es posible que el wiki esté incompleto.',
  'sync.pipeline.treeDegraded':
    'Árbol de memoria degradado. La recuperación puede devolver resultados obsoletos.',
  'sync.pipeline.viewHealth': 'Ver estado de la memoria',
  'notifications.configRecovered.title': 'Se recuperó el archivo de configuración',
  'notifications.configRecovered.body':
    'No se pudo leer tu archivo de configuración, por lo que se restauró desde una copia de seguridad o se restableció a los valores predeterminados. El archivo ilegible se conservó con el sufijo ".corrupted" por si lo necesitas.',
};

export default messages;
